<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <!-- START of New Agent created successfully pop up modal -->
        <div v-if="bool_afterAdd">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["AG"]["S"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAfterAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="sectionBg">
                                        <CRow>
                                            <CCol col="6">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["GN"]}} : </label>
                                                <br>
                                                <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.BN}}</label>
                                            </CCol>
                                            <CCol col="6">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["PC"]}} :</label>
                                                <br>
                                                <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.PC}}</label>
                                            </CCol>
                                        </CRow>
                                    </div>

                                    <div class='sectionDivider subHeaderHR'></div>
                                    <div class="sectionBg">
                                        <CRow>
                                            <CCol col="6">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["UU"]}} :</label>
                                                <br>
                                                <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.AGU}}</label>
                                                <br>
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["UUP"]}} :</label>
                                                <br>
                                                <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.AGP}}</label>
                                            </CCol>
                                        </CRow>
                                    </div>

                                    <div class='sectionDivider subHeaderHR' v-if="obj_BrandDetail.CSU != null && obj_BrandDetail.CSU != ''"></div>
                                    <div class="sectionBg" v-if="obj_BrandDetail.CSU != null && obj_BrandDetail.CSU != ''">
                                        <CRow>
                                            <CCol col="6">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["CSU"]}} :</label>
                                                <br>
                                                <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.CSU}}</label>
                                                <br>
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["CSP"]}} :</label>
                                                <br>
                                                <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.CSP}}</label>
                                            </CCol>
                                            <CCol col="6">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["MKU"]}} :</label>
                                                <br>
                                                <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.MKU}}</label>
                                                <br>
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["MKP"]}} :</label>
                                                <br>
                                                <label class="col-form-label-sm DetailsText">{{obj_BrandDetail.MKP}}</label>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>
        <!-- END of New agent created successfully pop up modal -->
        <!--Unknown-->
        <div v-if="previewImgUrl">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="previewImgUrl = ''">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <div class="text-right">
                                        <a class="btn btn-primary mb-3" href="https://afbgg.info/template.php" target="_blank" v-if="previewImgUrl.includes('-home.jpg')">{{this.getLanguage["DB"]["MORE"]}}</a>
                                    </div>
                                    <img :src="previewImgUrl" class="img-fluid" loading="lazy" :width="previewImgUrl.includes('SportOdd') ? 500 : 'auto'" />
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!--main domain-->
        <div v-if="bool_isDomain">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["DM"][bool_isEditDomain? "EDM": "ADM"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeDomain">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <CRow>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['DN'] }}<span class="required" /> :</label><br>
                                                    <CInput :placeholder="getLanguage['DM']['DN']"
                                                            size="sm"
                                                            :value="obj_Domain.DN"
                                                            @change="v => obj_Domain.DN = v"
                                                            maxlength="50"
                                                            ref="DN"></CInput>
                                                    <span class="ErrMsg">{{ ValidationDomainErrMsg('DN') }}</span>
                                                </CCol>

                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['RT'] }} :</label>
                                                    <CButton style="width: 80px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="resetField('RT')">
                                                        <span class='plusIcon cil-reload'></span>{{this.getLanguage["DM"]["RST"]}}
                                                    </CButton><br>
                                                    <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="5" :placeholder="getDefaultRobotsTxt(1)" @change="TextValueChange('RT',$event)" :value="obj_Domain.RT" :key="rtKey" />
                                                </CCol>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['CNNC'] }} :</label>
                                                    <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="1" @change="TextValueChange('CN',$event)" :value="obj_Domain.CN" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <CRow>
                                                <CCol col="12">
                                                    <div class="d-flex">
                                                        <label class="col-form-label-sm">{{this.getLanguage["DM"]["UCF"]}}? :</label>
                                                        <input type="checkbox" class="ml-2" :disabled="obj_Domain.I > 0" :checked="obj_Domain.UCF" @change="checkUseCloudFlareMainDomain">
                                                    </div>
                                                    <label class="form-control form-control-sm" :class="(obj_Domain.UCF && obj_Domain.I > 0 && obj_Domain.CFStatus) ? 'visible':'invisible'" style="border: none; padding: 0.375rem 0;">{{this.getLanguage["DM"]["CFS"]}} : <span :class="(obj_Domain.CFStatus=='pending') ? 'text-red' : 'text-green'">{{ obj_Domain.CFStatus }}</span></label>
                                                    <span class="ErrMsg"></span>
                                                </CCol>

                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">Sitemap XML :</label>
                                                    <CButton style="width: 80px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="resetField('FSXML')">
                                                        <span class='plusIcon cil-reload'></span>{{this.getLanguage["DM"]["RST"]}}
                                                    </CButton><br>
                                                    <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="5" @change="TextValueChange('FSXML',$event)" :value="obj_Domain.FSXML" :key="fsxmlKey" />
                                                </CCol>
                                            </CRow>
                                        </CCol>

                                        <CCol col="12" v-if="(obj_Domain.UCF && obj_Domain.I > 0) || (obj_Domain.I > 0 && !obj_Domain.UCF)">
                                            <div class="my-3 subHeaderHR"></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <div v-if="obj_Domain.UCF && obj_Domain.I > 0">
                                                        <label class="col-form-label-sm">{{this.getLanguage["DM"]["EDNS"]}} :</label>
                                                        <table class="custom-table custom-table-inPopUp  afb-blue">
                                                            <thead>
                                                                <tr>
                                                                    <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                                    <th>{{this.getLanguage['DM']['DNS']}}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            <td colspan="100%" v-if="obj_Domain.DomainNameServer.length == 0 || !obj_Domain.DomainNameServer">{{this.getLanguage['GL']['NR']}}</td>
                                                            <tr v-for="(data,index) in obj_Domain.DomainNameServer">
                                                                <td>{{ index+1 }}</td>
                                                                <td>{{ data.DNS }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <div v-if="obj_Domain.I > 0 && !obj_Domain.UCF">
                                                        <label class="col-form-label-sm">{{this.getLanguage["DM"]["UYDNSTNDSN"]}}</label>
                                                        <table class="custom-table custom-table-inPopUp afb-blue">
                                                            <thead>
                                                                <tr>
                                                                    <th style="width: 30px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                                    <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                                    <th>{{this.getLanguage['DM']['DNS']}}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                            <td colspan="100%" v-if="obj_Domain.DomainNameServer.length == 0 || !obj_Domain.DomainNameServer">{{this.getLanguage['GL']['NR']}}</td>
                                                            <tr v-for="(data,index) in obj_Domain.DomainNameServer">
                                                                <td>
                                                                    <span id="actionBtnCol">
                                                                        <span class="custom-tooltip">
                                                                            <i class="cil-trash" @click='removePDomainNameServer(index)'></i>
                                                                            <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                                        </span>
                                                                    </span>
                                                                </td>
                                                                <td>{{ index+1 }}</td>
                                                                <td>{{ data.DNS }}</td>
                                                            </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CCol>
                                            </CRow>
                                        </CCol>

                                        <CCol col="12" v-if="obj_Domain.I > 0 && obj_Domain.UCF">
                                            <div class="my-3 subHeaderHR"></div>
                                            <CRow>
                                                <CCol col="6">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DMV']['RR'] }} :</label><br>
                                                    <CInput :placeholder="getLanguage['DMV']['RDT']" size="sm" :value="obj_Domain.RTD" @change="v => obj_Domain.RTD = v" ref="DN"></CInput>
                                                    <span class="ErrMsg">{{ ValidationDomainErrMsg('DN') }}</span>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveDomain()">
                                        <span class='fa fa-save mr-2'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!--alternate domain-->
        <div v-if="bool_isAlternateDomain">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard style="height:100%; overflow: hidden auto;">
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["DM"][bool_isEditDomain? "EALTDM": "AALTDM"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAlternateDomain">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>

                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6" class="form-group">
                                            <CRow>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['ALTDM'] }}<span class="required" /> :</label><br>
                                                    <CInput :placeholder="getLanguage['DM']['ALTDM']"
                                                            size="sm"
                                                            :value="obj_ADomain.DN"
                                                            @change="v => obj_ADomain.DN = v"
                                                            maxlength="50"
                                                            ref="DN"></CInput>
                                                    <span class="ErrMsg">{{ ValidationAlternateDomainErrMsg('DN') }}</span>
                                                </CCol>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['RT'] }} :</label>
                                                    <CButton style="width: 80px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="resetField('RTAD')">
                                                        <span class='plusIcon cil-reload'></span>{{this.getLanguage["DM"]["RST"]}}
                                                    </CButton><br>
                                                    <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="5" :placeholder="getDefaultRobotsTxt()" @change="TextValueChange('RTAD',$event)" :value="obj_ADomain.RT" :key="rtAltKey" />
                                                </CCol>
                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['CNNC'] }} :</label>
                                                    <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="1" @change="TextValueChange('CNAD',$event)" :value="obj_ADomain.CN" />
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                        <CCol col="6" class="form-group">
                                            <CRow>
                                                <CCol col="12">
                                                    <div class="d-flex">
                                                        <label class="col-form-label-sm">{{this.getLanguage["DM"]["UCF"]}}? :</label>
                                                        <input type="checkbox" class="ml-2" :disabled="obj_ADomain.I > 0" :checked="obj_ADomain.UCF" @change="checkUseCloudFlare">
                                                    </div>
                                                    <label class="form-control form-control-sm" :class="(obj_ADomain.UCF && obj_ADomain.I > 0 && obj_ADomain.CFStatus) ? 'visible':'invisible'" style="border: none; padding: 0.375rem 0;">{{this.getLanguage["DM"]["CFS"]}} : <span :class="(obj_ADomain.CFStatus=='pending') ? 'text-red' : 'text-green'">{{ obj_ADomain.CFStatus }}</span></label>
                                                    <span class="ErrMsg"></span>
                                                </CCol>

                                                <CCol col="12" v-if="bool_showPreloadSEO_AD">
                                                    <label class="col-form-label-sm">{{this.getLanguage["DM"]["DSEOM"]}}:</label>
                                                    <label class="switch">
                                                        <input type="checkbox" v-model="obj_ADomain.PSEO" true-value="1" false-value="2">
                                                        <span class="slider round STYLE_unlock"></span>
                                                    </label>
                                                </CCol>

                                                <CCol col="12">
                                                    <label class="col-form-label-sm" style="margin-right: 20px;">Sitemap XML :</label>
                                                    <CButton style="width: 80px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="resetField('FSXMLAD')">
                                                        <span class='plusIcon cil-reload'></span>{{this.getLanguage["DM"]["RST"]}}
                                                    </CButton><br>
                                                    <textarea v-shortkey.avoid class="form-control form-control-sm" vertical="" rows="5" @change="TextValueChange('FSXMLAD',$event)" :value="obj_ADomain.FSXML" :key="fsxmlAltKey" />
                                                </CCol>
                                            </CRow>
                                        </CCol>

                                        <CCol col="12" v-if="(obj_ADomain.CFStatus=='pending' && obj_ADomain.UCF && obj_ADomain.I > 0) || !(obj_ADomain.UCF && obj_ADomain.I == 0)">
                                            <div class="my-3 subHeaderHR"></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <div v-if="obj_ADomain.CFStatus=='pending' && obj_ADomain.UCF && obj_ADomain.I > 0">
                                                        <label class="col-form-label-sm">{{this.getLanguage["DM"]["EADNS"]}} :</label>
                                                        <table class="custom-table custom-table-inPopUp  afb-blue">
                                                            <thead>
                                                                <tr>
                                                                    <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                                    <th>{{this.getLanguage['DM']['DNS']}}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(data,index) in obj_ADomain.CFCurNameServers">
                                                                    <td>{{ index+1 }}</td>
                                                                    <td>{{ data }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <div v-if="!(obj_ADomain.UCF && obj_ADomain.I == 0)">
                                                        <label class="col-form-label-sm">{{this.getLanguage["DM"]["UYDNSTNDSN"]}}</label>
                                                        <table class="custom-table custom-table-inPopUp afb-blue">
                                                            <thead>
                                                                <tr>
                                                                    <th v-if="!obj_ADomain.UCF" style="width: 30px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                                    <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                                    <th>{{this.getLanguage['DM']['DNS']}}</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-if="obj_ADomain.DomainNameServer.length == 0 || !obj_ADomain.DomainNameServer">
                                                                    <td colspan="100%">{{this.getLanguage['GL']['NR']}}</td>
                                                                </tr>
                                                                <tr v-for="(data,index) in obj_ADomain.DomainNameServer">
                                                                    <td v-if="!obj_ADomain.UCF">
                                                                        <span id="actionBtnCol">
                                                                            <i class="cil-trash" @click='removeADomainNameServer(index)'></i> here Remove
                                                                        </span>
                                                                    </td>
                                                                    <td>{{ index+1 }}</td>
                                                                    <td>{{ data.DNS }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </CCol>
                                            </CRow>
                                        </CCol>

                                        <CCol col="12" v-if="(obj_ADomain.I > 0 && obj_ADomain.UCF)">
                                            <div class="my-3 subHeaderHR"></div>
                                            <CRow>
                                                <CCol col="6" class="form-group">
                                                    <label class="col-form-label-sm">{{this.getLanguage["DMV"]["RF"]}} :</label><br />
                                                    <CInput class="" :placeholder="getLanguage['DMV']['RF']" size="sm" :value="obj_ADomain.RF" @change="v => obj_ADomain.RF = v" disabled></CInput>
                                                    <label class="col-form-label-sm inline inline60">{{this.getLanguage["DMV"]["RDT"]}} :</label><br />
                                                    <CInput class="inline inline60" :placeholder="getLanguage['DMV']['RDT']" size="sm" :value="obj_ADomain.RDT" @change="v => obj_ADomain.RDT = v"></CInput>
                                                    <CButton style="margin-top:5px;" color="outline-dark" size="sm" class="btn-small inline inline40" @click="redirectAltDomain()">
                                                        <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                                    </CButton>
                                                </CCol>
                                                <CCol col="6" class="form-group">
                                                    <table class="custom-table custom-table-inPopUp afb-blue">
                                                        <thead>
                                                            <tr>
                                                                <th style="width: 20px;">{{this.getLanguage['GL']['ACT']}}</th>
                                                                <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                                <th style="width: 50%;">{{this.getLanguage['DMV']['RF']}}</th>
                                                                <th style="width: 50%;">{{this.getLanguage['DMV']['RDT']}}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-if="!obj_Domain.RedirectTo || obj_Domain.RedirectTo.length == 0">
                                                                <td colspan="4">{{this.getLanguage['GL']['NR']}}</td>
                                                            </tr>
                                                            <tr v-for="(data,index) in obj_Domain.RedirectTo">
                                                                <td style="width: 20px;">
                                                                    <span class="custom-tooltip">
                                                                        <i class="cil-trash align-center" @click='removeredirectAltDomain(index)'></i>
                                                                        <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                                    </span>
                                                                </td>
                                                                <td style="width: 30px;">{{ index+1 }}</td>
                                                                <td style="width: 50%;">{{ data.RF }}</td>
                                                                <td style="width: 50%;">{{ data.RDT }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </CCol>
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveAlternateDomain()">
                                        <span class='fa fa-save mr-2'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!--Customize Registration-->
        <div v-if="bool_isPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width:360px">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ getLanguage["AG"]["VRCUZ"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closePreview()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow class="registerPage">
                                        <CCol col="12">
                                            <div class="row justify-content-start align-items-start">
                                                <div class="col-2 pr-0 dropdown-single">
                                                </div>
                                                <div class="col-8 px-0 model-h3 text-center">
                                                    {{getLanguage["RCUZ"]["CAA"]}}
                                                    <small> {{getLanguage["RCUZ"]["DESC1"]}}</small>
                                                </div>
                                            </div>
                                        </CCol>
                                        <div class="col-12"
                                             v-for="element in arry_cr.VTCRegisterDraggeBase"
                                             :key="element.name">
                                            <template v-if="element.id == 'UN' && element.RS == 2">
                                                <div class="did-floating-label-content userNameID" v-if="arry_CrOnOff.REGWPHONE.CV == false">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 21.3" fill="currentColor">
                                                        <path d="M14,12.5c1.2,0,2.3-0.5,3.1-1.3c0.8-0.8,1.3-1.9,1.3-3.1S17.9,5.9,17.1,5c-0.8-0.8-1.9-1.3-3.1-1.3
S11.7,4.2,10.9,5C10.1,5.9,9.6,7,9.6,8.1s0.5,2.3,1.3,3.1C11.7,12,12.8,12.5,14,12.5z"></path>
                                                        <path d="M3.5,0.2c-0.9,0-1.8,0.4-2.5,1C0.4,1.8,0,2.7,0,3.7v14c0,0.9,0.4,1.8,1,2.5c0.7,0.7,1.5,1,2.5,1h21
c0.9,0,1.8-0.4,2.5-1c0.7-0.7,1-1.5,1-2.5v-14c0-0.9-0.4-1.8-1-2.5c-0.7-0.7-1.5-1-2.5-1H3.5z M22.4,19.4c-0.8-2.2-3.1-5.2-8.4-5.2
c-5.3,0-7.6,3-8.4,5.2H3.5c-0.5,0-0.9-0.2-1.2-0.5s-0.5-0.8-0.5-1.2v-14c0-0.5,0.2-0.9,0.5-1.2C2.6,2.1,3,1.9,3.5,1.9h21
c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.8,0.5,1.2v14c0,0.5-0.2,0.9-0.5,1.2s-0.8,0.5-1.2,0.5H22.4z"></path>
                                                    </svg>
                                                    <input type="text" name="username" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                    <label v-if="array_ui[langCode] != undefined && array_ui[langCode] !='' " for="RegisterFocusTextBox" class="did-floating-label">{{array_ui[langCode]}}</label>
                                                    <label v-else for="RegisterFocusTextBox" class="did-floating-label">{{getLanguage["RCUZ"]["UI"]}}</label>

                                                </div>

                                                <div class="did-floating-label-content registerPhone" v-if="arry_CrOnOff.REGWPHONE.CV == true">
                                                    <svg viewBox="0 0 17 28" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 26.3048C0 18.1041 0 9.90411 0 1.70337C0.0131471 1.67969 0.0363479 1.65676 0.0394414 1.63234C0.142298 0.750332 1.01078 -0.00588499 2.13215 3.45199e-05C6.38254 0.0214927 10.6329 0.00817384 14.8841 0.0103937C15.0542 0.0103937 15.229 0.0126135 15.3937 0.0466506C16.3898 0.249394 16.9977 1.01079 16.9985 2.05188C17 7.44529 16.9985 12.8394 16.9985 18.2329C16.9985 20.8019 16.9985 23.3717 16.9985 25.9408C16.9985 26.4676 16.8608 26.9434 16.4981 27.3548C16.205 27.6878 15.8044 27.8402 15.4046 28H1.59776C1.34642 27.8824 1.07961 27.7869 0.846056 27.6419C0.345692 27.3304 0.126831 26.8413 0 26.3056V26.3048ZM15.5809 24.492V3.03082H1.42221V24.492H15.5809ZM9.47521 26.1065C9.47521 25.5923 9.03284 25.1676 8.5 25.169C7.96638 25.1705 7.52789 25.5952 7.52866 26.1102C7.52943 26.6311 7.96019 27.0426 8.50387 27.0411C9.04754 27.0396 9.47598 26.6282 9.47521 26.1065ZM8.50232 1.81732C9.15658 1.81732 9.81162 1.81732 10.4659 1.81732C10.6252 1.81732 10.7915 1.81584 10.7977 1.61236C10.8046 1.4 10.6422 1.37262 10.4651 1.37262C9.15581 1.3741 7.84651 1.3741 6.53721 1.37262C6.36011 1.37262 6.19771 1.4 6.20544 1.61236C6.2124 1.8151 6.3779 1.81732 6.53798 1.81732C7.19225 1.81584 7.84728 1.81732 8.50155 1.81732H8.50232Z" />
                                                    </svg>
                                                    <input type="tel" name="required_phone" placeholder="" class="did-floating-input register_required_phone r7" autocomplete="off" disabled>
                                                    <label v-if="array_pn[langCode] != undefined && array_pn[langCode] !='' " for="refferal" class="did-floating-label required">{{array_pn[langCode]}}</label>
                                                    <label v-else for="refferal" class="did-floating-label required">{{getLanguage["RCUZ"]["PHNO"]}}</label>
                                                </div>
                                            </template>
                                            <template v-else-if="element.id == 'NAME' && element.RS == 2">
                                                <div class="did-floating-label-content userNameID">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 21.3" fill="currentColor">
                                                        <path d="M14,12.5c1.2,0,2.3-0.5,3.1-1.3c0.8-0.8,1.3-1.9,1.3-3.1S17.9,5.9,17.1,5c-0.8-0.8-1.9-1.3-3.1-1.3
S11.7,4.2,10.9,5C10.1,5.9,9.6,7,9.6,8.1s0.5,2.3,1.3,3.1C11.7,12,12.8,12.5,14,12.5z" />
                                                        <path d="M3.5,0.2c-0.9,0-1.8,0.4-2.5,1C0.4,1.8,0,2.7,0,3.7v14c0,0.9,0.4,1.8,1,2.5c0.7,0.7,1.5,1,2.5,1h21
c0.9,0,1.8-0.4,2.5-1c0.7-0.7,1-1.5,1-2.5v-14c0-0.9-0.4-1.8-1-2.5c-0.7-0.7-1.5-1-2.5-1H3.5z M22.4,19.4c-0.8-2.2-3.1-5.2-8.4-5.2
c-5.3,0-7.6,3-8.4,5.2H3.5c-0.5,0-0.9-0.2-1.2-0.5s-0.5-0.8-0.5-1.2v-14c0-0.5,0.2-0.9,0.5-1.2C2.6,2.1,3,1.9,3.5,1.9h21
c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.8,0.5,1.2v14c0,0.5-0.2,0.9-0.5,1.2s-0.8,0.5-1.2,0.5H22.4z" />
                                                    </svg>
                                                    <input type="text" name="fullname" placeholder="" class="register_fullname did-floating-input" autocomplete="off" disabled>
                                                    <label v-if="array_fn[langCode] != undefined && array_fn[langCode] !='' " class="did-floating-label" :class="arry_CrOnOff.FNM.CV == true ? 'required': ''">{{array_fn[langCode]}}</label>
                                                    <label v-else class="did-floating-label" :class="arry_CrOnOff.FNM.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["FN"]}}</label>
                                                </div>
                                            </template>
                                            <!-- Password -->
                                            <template v-else-if="element.id == 'PW' && element.RS == 2">
                                                <div class="did-floating-label-content registerPasswordIco">
                                                    <svg viewBox="0 0 23 31" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M20.5884 31H2.41502C2.34791 30.976 2.2825 30.946 2.21369 30.928C1.1833 30.6604 0.492687 30.0198 0.146107 29.0019C0.0891934 28.8347 0.0484193 28.6624 0 28.4917C0 24.0325 0 19.5733 0 15.1141C0.0203871 15.0678 0.0518171 15.0224 0.0603117 14.9735C0.272677 13.7832 1.08136 12.924 2.24173 12.665C2.4439 12.6195 2.65117 12.5989 2.87288 12.5646C2.87288 11.6154 2.85844 10.6841 2.87712 9.75278C2.89241 8.97242 2.86778 8.1792 2.99605 7.41599C3.59067 3.8795 5.59965 1.53414 8.95501 0.391895C9.50886 0.203237 10.1009 0.127773 10.6752 0C11.2256 0 11.7769 0 12.3274 0C12.386 0.0205809 12.4429 0.0531674 12.5024 0.0591701C13.8292 0.199806 15.0618 0.630291 16.1686 1.37549C18.5131 2.95422 19.8663 5.16409 20.0685 8.01884C20.167 9.40462 20.1144 10.8015 20.1288 12.1942C20.1305 12.3194 20.1288 12.4446 20.1288 12.5801C20.3335 12.6024 20.5026 12.6067 20.6657 12.6401C22.0715 12.9317 22.9864 14.049 22.9932 15.5129C23.0034 17.6447 22.9958 19.7765 22.9958 21.9084C22.9958 23.9656 23.0025 26.022 22.9932 28.0792C22.9864 29.4461 22.1735 30.5292 20.9103 30.8954C20.8016 30.9271 20.6946 30.9657 20.5867 31.0009L20.5884 31ZM11.5068 14.5344C8.85903 14.5344 6.21126 14.5344 3.56349 14.5344C3.33074 14.5344 3.09713 14.5267 2.86438 14.5378C2.30544 14.5644 1.98689 14.886 1.95291 15.4443C1.94611 15.5515 1.94611 15.6586 1.94611 15.7658C1.94611 19.7851 1.94611 23.8053 1.94611 27.8245C1.94611 27.9635 1.94781 28.1032 1.96056 28.2422C1.99793 28.6478 2.25617 28.9411 2.64862 29.0139C2.80322 29.0431 2.96377 29.0542 3.12177 29.0542C8.70272 29.056 14.2845 29.056 19.8655 29.056C20.7574 29.056 21.0539 28.761 21.0539 27.87C21.0547 23.8181 21.0547 19.7663 21.0539 15.7144C21.0539 14.8388 20.7523 14.5344 19.8935 14.5344C17.0979 14.5344 14.3015 14.5344 11.5059 14.5344H11.5068ZM4.82154 12.5681H18.1674C18.1734 12.472 18.1827 12.3974 18.1827 12.3237C18.1827 11.0374 18.1937 9.75192 18.1717 8.46562C18.164 8.03084 18.108 7.58835 18.0077 7.16473C17.1718 3.63853 13.938 1.46982 10.3957 2.04523C7.70036 2.48343 5.55377 4.52437 4.97274 7.22647C4.881 7.65181 4.83343 8.09516 4.82749 8.53079C4.8088 9.86855 4.82069 11.2072 4.82069 12.5681H4.82154Z" />
                                                        <path d="M10.5452 24.2589C10.5452 24.2272 10.5418 24.1946 10.5452 24.1629C10.6242 23.4983 10.5019 23.042 9.81553 22.6459C8.66196 21.9796 8.32133 20.424 8.86159 19.1505C9.37466 17.9406 10.6922 17.2305 11.9766 17.4723C13.2711 17.7159 14.186 18.6497 14.35 19.8932C14.5292 21.2541 13.8963 22.3972 12.6502 22.9975C12.5593 23.0412 12.4684 23.1947 12.4658 23.2993C12.448 23.9202 12.4616 24.5419 12.4557 25.1636C12.4497 25.7793 12.0734 26.1678 11.4983 26.1661C10.9249 26.1643 10.5546 25.775 10.5461 25.1585C10.5418 24.8583 10.5461 24.5582 10.5452 24.2589ZM11.5 21.2944C12.0709 21.2944 12.4625 20.8982 12.454 20.3279C12.4455 19.7705 12.0573 19.3864 11.5017 19.3864C10.9428 19.3864 10.5588 19.7645 10.5486 20.3254C10.5384 20.8956 10.93 21.2944 11.5 21.2944Z" />
                                                    </svg>
                                                    <input type="password" name="password" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                    <label v-if="array_pw[langCode] != undefined && array_pw[langCode] !='' " for="register_password" class="did-floating-label required">{{array_pw[langCode]}}</label>
                                                    <label v-else for="register_password" class="did-floating-label required">{{getLanguage["RCUZ"]["PASS"]}}</label>
                                                    <span toggle="#register_password" class="pw-eye-slash toggle-password"></span>
                                                </div>
                                                <div class="did-floating-label-content registerPasswordIco">
                                                    <svg viewBox="0 0 23 31" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M20.5884 31H2.41502C2.34791 30.976 2.2825 30.946 2.21369 30.928C1.1833 30.6604 0.492687 30.0198 0.146107 29.0019C0.0891934 28.8347 0.0484193 28.6624 0 28.4917C0 24.0325 0 19.5733 0 15.1141C0.0203871 15.0678 0.0518171 15.0224 0.0603117 14.9735C0.272677 13.7832 1.08136 12.924 2.24173 12.665C2.4439 12.6195 2.65117 12.5989 2.87288 12.5646C2.87288 11.6154 2.85844 10.6841 2.87712 9.75278C2.89241 8.97242 2.86778 8.1792 2.99605 7.41599C3.59067 3.8795 5.59965 1.53414 8.95501 0.391895C9.50886 0.203237 10.1009 0.127773 10.6752 0C11.2256 0 11.7769 0 12.3274 0C12.386 0.0205809 12.4429 0.0531674 12.5024 0.0591701C13.8292 0.199806 15.0618 0.630291 16.1686 1.37549C18.5131 2.95422 19.8663 5.16409 20.0685 8.01884C20.167 9.40462 20.1144 10.8015 20.1288 12.1942C20.1305 12.3194 20.1288 12.4446 20.1288 12.5801C20.3335 12.6024 20.5026 12.6067 20.6657 12.6401C22.0715 12.9317 22.9864 14.049 22.9932 15.5129C23.0034 17.6447 22.9958 19.7765 22.9958 21.9084C22.9958 23.9656 23.0025 26.022 22.9932 28.0792C22.9864 29.4461 22.1735 30.5292 20.9103 30.8954C20.8016 30.9271 20.6946 30.9657 20.5867 31.0009L20.5884 31ZM11.5068 14.5344C8.85903 14.5344 6.21126 14.5344 3.56349 14.5344C3.33074 14.5344 3.09713 14.5267 2.86438 14.5378C2.30544 14.5644 1.98689 14.886 1.95291 15.4443C1.94611 15.5515 1.94611 15.6586 1.94611 15.7658C1.94611 19.7851 1.94611 23.8053 1.94611 27.8245C1.94611 27.9635 1.94781 28.1032 1.96056 28.2422C1.99793 28.6478 2.25617 28.9411 2.64862 29.0139C2.80322 29.0431 2.96377 29.0542 3.12177 29.0542C8.70272 29.056 14.2845 29.056 19.8655 29.056C20.7574 29.056 21.0539 28.761 21.0539 27.87C21.0547 23.8181 21.0547 19.7663 21.0539 15.7144C21.0539 14.8388 20.7523 14.5344 19.8935 14.5344C17.0979 14.5344 14.3015 14.5344 11.5059 14.5344H11.5068ZM4.82154 12.5681H18.1674C18.1734 12.472 18.1827 12.3974 18.1827 12.3237C18.1827 11.0374 18.1937 9.75192 18.1717 8.46562C18.164 8.03084 18.108 7.58835 18.0077 7.16473C17.1718 3.63853 13.938 1.46982 10.3957 2.04523C7.70036 2.48343 5.55377 4.52437 4.97274 7.22647C4.881 7.65181 4.83343 8.09516 4.82749 8.53079C4.8088 9.86855 4.82069 11.2072 4.82069 12.5681H4.82154Z" />
                                                        <path d="M10.5452 24.2589C10.5452 24.2272 10.5418 24.1946 10.5452 24.1629C10.6242 23.4983 10.5019 23.042 9.81553 22.6459C8.66196 21.9796 8.32133 20.424 8.86159 19.1505C9.37466 17.9406 10.6922 17.2305 11.9766 17.4723C13.2711 17.7159 14.186 18.6497 14.35 19.8932C14.5292 21.2541 13.8963 22.3972 12.6502 22.9975C12.5593 23.0412 12.4684 23.1947 12.4658 23.2993C12.448 23.9202 12.4616 24.5419 12.4557 25.1636C12.4497 25.7793 12.0734 26.1678 11.4983 26.1661C10.9249 26.1643 10.5546 25.775 10.5461 25.1585C10.5418 24.8583 10.5461 24.5582 10.5452 24.2589ZM11.5 21.2944C12.0709 21.2944 12.4625 20.8982 12.454 20.3279C12.4455 19.7705 12.0573 19.3864 11.5017 19.3864C10.9428 19.3864 10.5588 19.7645 10.5486 20.3254C10.5384 20.8956 10.93 21.2944 11.5 21.2944Z" />
                                                    </svg>
                                                    <input type="password" name="password" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                    <label v-if="array_cpw[langCode] != undefined && array_cpw[langCode] !='' " for="register_password" class="did-floating-label required">{{array_cpw[langCode]}}</label>
                                                    <label v-else for="register_password" class="did-floating-label required">{{getLanguage["RCUZ"]["CPASS"]}}</label>
                                                    <span toggle="#register_password" class="pw-eye-slash toggle-password"></span>
                                                </div>
                                            </template>
                                            <!-- Currency -->
                                            <template v-if="element.id == 'CUR' && element.RS == 2">
                                                <div class="selectCustom registerCurrencySelect">
                                                    <svg id="ddSVgIcon" class=" " viewBox="0 0 26 26" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12.1367 0C12.7125 0 13.2875 0 13.8633 0C13.9452 0.0165039 14.0264 0.0374512 14.1089 0.048877C14.6345 0.123779 15.1677 0.164404 15.6857 0.276123C18.4082 0.865185 20.7219 2.1855 22.6002 4.24341C24.2918 6.09629 25.3697 8.26084 25.7981 10.7396C25.8781 11.203 25.9333 11.6708 26 12.1367V13.8633C25.9841 13.9363 25.9625 14.008 25.9524 14.0816C25.894 14.5247 25.8648 14.9735 25.7785 15.4108C25.1405 18.6316 23.5276 21.2621 20.9428 23.2838C19.2645 24.5965 17.3678 25.4401 15.2629 25.7981C14.7983 25.8769 14.3305 25.9333 13.8639 26H12.1374C12.0555 25.9835 11.9742 25.9625 11.8917 25.9511C11.3661 25.8762 10.8329 25.8356 10.3149 25.7239C7.59243 25.1348 5.27871 23.8145 3.40044 21.7566C1.70879 19.9037 0.630957 17.7392 0.20249 15.2604C0.121875 14.797 0.0666504 14.3292 0 13.8633C0 13.2875 0 12.7125 0 12.1367C0.0158691 12.0637 0.0374512 11.992 0.0476074 11.9184C0.106006 11.4753 0.135205 11.0265 0.221533 10.5892C0.859473 7.36836 2.47241 4.73789 5.05718 2.71616C6.73613 1.40347 8.63218 0.559863 10.7377 0.201855C11.2023 0.123145 11.6702 0.0666504 12.1367 0ZM13.007 1.625C6.75772 1.61484 1.62627 6.74248 1.625 12.9987C1.62373 19.2455 6.71519 24.3674 12.9797 24.368C19.2639 24.3693 24.3375 19.3312 24.3712 13.0127C24.4048 6.76914 19.2683 1.63452 13.007 1.62437V1.625Z" />
                                                        <path d="M12.1881 7.36265C12.1881 7.0478 12.1843 6.76914 12.1888 6.48985C12.197 6.03408 12.5461 5.68941 12.9955 5.68814C13.4456 5.68687 13.8004 6.02901 13.8106 6.48159C13.8157 6.70122 13.822 6.92212 13.8087 7.14175C13.7979 7.31504 13.8449 7.39058 14.0302 7.42739C14.7012 7.5607 15.3143 7.83047 15.8539 8.26148C16.2874 8.60806 16.382 9.08985 16.0773 9.47642C15.7771 9.85728 15.2972 9.88965 14.8637 9.55767C13.881 8.80484 12.3595 8.74326 11.3109 9.41421C10.3245 10.0452 10.3429 11.1255 11.3464 11.7343C11.9076 12.0745 12.5252 12.1729 13.1663 12.1913C14.1565 12.2205 15.0649 12.5049 15.8469 13.1219C16.5756 13.697 17.0415 14.4301 17.0593 15.3886C17.0765 16.2951 16.6848 17.0181 16.0189 17.6071C15.4489 18.1111 14.7799 18.4165 14.0416 18.5796C13.9686 18.5955 13.8963 18.617 13.8112 18.6386C13.8112 18.9287 13.8138 19.2074 13.8112 19.486C13.8061 19.9621 13.4634 20.3119 13.0038 20.3131C12.543 20.315 12.1951 19.9672 12.1875 19.4949C12.185 19.3426 12.1875 19.1902 12.1875 19.0379C12.1875 18.624 12.1856 18.631 11.7705 18.532C11.1185 18.3771 10.5346 18.0813 10.0268 17.6439C9.69096 17.3545 9.65224 16.8676 9.92265 16.5249C10.1931 16.1827 10.6812 16.0938 11.0303 16.3725C11.568 16.801 12.1742 17.0244 12.8496 17.0447C13.7052 17.0708 14.5057 16.8892 15.1004 16.2164C15.6044 15.6463 15.5232 14.9773 14.936 14.4809C14.319 13.9591 13.5821 13.8392 12.807 13.8081C11.6137 13.7611 10.5568 13.3694 9.72397 12.4839C8.56615 11.2531 8.70644 9.43325 10.0172 8.35987C10.5923 7.88887 11.2372 7.58291 11.9571 7.42232C12.0301 7.40581 12.1024 7.38487 12.1875 7.36328L12.1881 7.36265Z" />
                                                    </svg>
                                                    <div v-if="array_sc[langCode] != undefined && array_sc[langCode] !='' " class="custom-select-dd did-floating-select position-relative">{{array_sc[langCode]}}</div>
                                                    <div v-else class="custom-select-dd did-floating-select position-relative">{{getLanguage['RCUZ']['SC']}}</div>
                                                </div>
                                            </template>
                                            <!-- Bank -->
                                            <template v-if="element.id == 'BANK' && element.RS == 2">
                                                <div class="selectCustom registerBankSelect">
                                                    <svg id="ddSVgIcon" class=" " viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M24.9997 15.8203C24.902 16.1094 24.8363 16.4147 24.7008 16.6842C24.1598 17.7598 23.2712 18.321 22.07 18.3522C21.2178 18.3744 20.3643 18.3568 19.4951 18.3568V16.3952C19.7152 16.3952 19.932 16.3952 20.1488 16.3952C20.7673 16.3952 21.3857 16.4004 22.0036 16.3932C22.6247 16.3861 23.0361 15.9863 23.0374 15.3691C23.0426 12.6602 23.0394 9.95052 23.0387 7.24154C23.0387 7.21745 23.0335 7.19336 23.0277 7.14909H1.95866C1.95866 7.23828 1.95866 7.32552 1.95866 7.41276C1.95866 10.0247 1.95866 12.6361 1.95866 15.248C1.95866 16.0189 2.33887 16.3952 3.11686 16.3958C3.92155 16.3958 4.72689 16.3958 5.55046 16.3958V18.3262C5.54199 18.3327 5.52897 18.3503 5.5166 18.3503C4.50879 18.3405 3.49447 18.3971 2.49512 18.3001C1.24642 18.1784 0.28418 17.1868 0.0485026 15.9525C0.0400391 15.9076 0.0159505 15.8652 -0.000976562 15.8216C-0.000325521 11.3932 -0.000325521 6.96615 -0.000325521 2.53906C0.0152995 2.50326 0.038737 2.46875 0.0458984 2.43099C0.187174 1.64193 0.570638 0.988281 1.23991 0.555339C1.61816 0.310547 2.07064 0.181641 2.48991 0C9.16309 0 15.8363 0 22.5094 0C22.5524 0.0169271 22.5947 0.0403646 22.6397 0.0501302C23.6331 0.276693 24.3473 0.848958 24.7568 1.78255C24.8623 2.02344 24.9202 2.28581 24.9997 2.53841V15.8203ZM23.0407 4.18229C23.0407 3.81315 23.0407 3.45703 23.0407 3.10156C23.0394 2.33203 22.6579 1.95247 21.8838 1.95247C15.6266 1.95247 9.36882 1.95247 3.11165 1.95247C3.04655 1.95247 2.98145 1.94987 2.91634 1.95378C2.43717 1.97852 2.04069 2.28971 1.99316 2.76628C1.94694 3.23047 1.9834 3.70247 1.9834 4.18229H23.0407Z" />
                                                        <path d="M12.5 25C11.4616 23.957 10.4232 22.9141 9.38411 21.8717C8.76432 21.25 8.14258 20.6302 7.5332 20.0208C7.99609 19.5586 8.44857 19.1055 8.89909 18.6549C9.73893 19.498 10.5918 20.3535 11.444 21.209C11.4668 21.1973 11.4902 21.1855 11.513 21.1738V13.3359H13.4648V21.2018C14.3444 20.3216 15.2122 19.4525 16.0775 18.5866C16.5781 19.0996 17.0299 19.5618 17.513 20.0573C17.4694 20.0911 17.3841 20.1432 17.3151 20.2116C15.7839 21.7402 14.2539 23.2702 12.7253 24.8008C12.6628 24.8633 12.6074 24.9329 12.5488 24.9987H12.5V25Z" />
                                                        <path d="M16.2 8.60807V10.5319H3.34253V8.60807H16.2Z" />
                                                    </svg>
                                                    <div v-if="array_sbk[langCode] != undefined && array_sbk[langCode] !='' " class="custom-select-dd did-floating-select position-relative">{{array_sbk[langCode]}}</div>
                                                    <div v-else class="custom-select-dd did-floating-select position-relative">{{getLanguage['DCUZ']['PSDB']}}</div>
                                                </div>
                                                <div class="did-floating-label-content registerAccount">
                                                    <svg viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1.95328 24.9999C1.9808 22.8842 2.53058 20.9183 3.73104 19.1701C5.466 16.6442 7.8388 15.0721 10.8867 14.5939C13.4962 14.1848 15.9412 14.685 18.1544 16.1232C20.7014 17.7778 22.3037 20.1057 22.8553 23.1123C22.9691 23.7323 22.9856 24.3701 23.0473 24.9999H25C24.8141 19.2282 21.8823 15.3931 16.6756 13.1459C18.7378 11.5781 19.8306 9.49361 19.7126 6.84838C19.6288 4.96628 18.8803 3.35077 17.5251 2.04406C14.5364 -0.837197 10.0049 -0.570596 7.30859 2.2012C4.33708 5.25611 4.56702 10.4897 8.36962 13.1802C8.23936 13.234 8.12378 13.2823 8.00881 13.33C3.93102 15.014 1.34295 17.9851 0.301493 22.2789C0.168175 22.828 0.129648 23.4003 0.0452538 23.9616C0.0373039 24.016 0.0152893 24.068 0 24.1212V24.9999H1.95328ZM12.5012 1.95723C15.3847 1.95967 17.7538 4.32423 17.7721 7.21771C17.7899 10.0947 15.3865 12.5027 12.4988 12.5002C9.61534 12.4978 7.24621 10.1332 7.22786 7.23973C7.21013 4.36275 9.6135 1.95478 12.5012 1.95723Z" />
                                                    </svg>
                                                    <input type="text" name="register_bankaccname" placeholder="" class="did-floating-input" autocomplete="off" disabled>

                                                    <label v-if="array_anm[langCode] != undefined && array_anm[langCode] !='' " for="register_bankaccname" class="did-floating-label" :class="arry_CrOnOff.RWBA.CV == true ? 'required': ''">{{array_anm[langCode]}}</label>
                                                    <label v-else for="register_bankaccname" class="did-floating-label" :class="arry_CrOnOff.RWBA.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["BACCNAME"]}}</label>
                                                </div>
                                                <div class="did-floating-label-content registerBankAccno">
                                                    <svg viewBox="0 0 29 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M28.9925 10.3978C28.9811 8.51296 27.4124 6.97772 25.4951 6.97549C24.9561 6.97475 24.417 6.97401 23.878 6.97401H19.9157C19.915 6.59094 19.9157 6.20788 19.9157 5.82407C19.9157 5.13306 19.9165 4.44132 19.9142 3.75031C19.9127 3.22146 20.1002 2.75435 20.4706 2.36235C21.0868 1.71077 21.8889 1.39391 22.9217 1.39391C22.9867 1.39391 23.0524 1.3954 23.1182 1.39763C24.6567 1.4549 25.6637 2.32963 25.8815 3.79717C25.9336 4.15049 26.2315 4.4071 26.5883 4.4071C26.6034 4.4071 26.6186 4.40636 26.6337 4.40561C27.0019 4.3833 27.2778 4.10065 27.2884 3.73395C27.2929 3.59039 27.2929 3.40221 27.2574 3.21477C26.9958 1.84689 26.1204 0.8658 24.656 0.300501C24.4163 0.207524 24.1683 0.147275 23.9279 0.0885139C23.8213 0.0624804 23.7147 0.0364469 23.6096 0.00818196L23.5794 0H22.217L22.1898 0.00669433C22.1165 0.0245459 22.0424 0.0416536 21.9683 0.0587614C21.8073 0.0959521 21.641 0.13463 21.4769 0.180003C19.5816 0.697698 18.4944 2.09756 18.4937 4.02106V4.84744C18.4929 5.66489 18.4922 6.51061 18.4982 7.34294C18.499 7.43815 18.4884 7.46939 18.3893 7.5341C17.3687 8.20725 16.8191 9.15264 16.8002 10.2684C16.7654 12.3406 16.7684 14.1496 16.8085 15.8001C16.8486 17.4402 18.3334 18.9159 19.986 18.9591C21.0248 18.9859 22.0454 19 23.0192 19C23.9302 19 24.8306 18.9881 25.697 18.9643C26.5861 18.9405 27.4162 18.5708 28.0353 17.9244C28.6477 17.2848 28.9879 16.4457 28.9925 15.5613C29.0023 13.8208 29.0023 12.084 28.9925 10.3978ZM27.5779 15.426C27.5764 16.6875 26.6836 17.5749 25.4059 17.583C25.0876 17.5853 24.7694 17.586 24.4511 17.586C24.1902 17.586 23.9287 17.586 23.6678 17.586C23.407 17.5853 23.1462 17.5845 22.8846 17.5845C22.623 17.5845 22.3758 17.5853 22.121 17.5853C21.8587 17.586 21.5971 17.586 21.3348 17.586C21.0203 17.586 20.7058 17.586 20.3913 17.5838C19.0902 17.5763 18.2139 16.7157 18.2117 15.4408C18.2079 13.6185 18.2079 12.0037 18.2117 10.5056C18.2147 9.24859 19.1166 8.37015 20.4041 8.36866C21.1979 8.36791 21.991 8.36791 22.7848 8.36791C23.6452 8.36791 24.5047 8.36791 25.3651 8.36866C26.6874 8.3694 27.5764 9.24487 27.5779 10.5465C27.5795 12.1733 27.5795 13.8 27.5779 15.4267V15.426Z" />
                                                        <path d="M15.7223 17.8441C15.6693 18.1692 15.4433 18.3767 15.1023 18.4131C15.0509 18.4191 15.0018 18.4198 14.9647 18.4198H14.4756C13.6478 18.4198 12.8207 18.4206 11.9928 18.4213C11.165 18.4221 10.3372 18.4235 9.51009 18.4235C7.65785 18.4235 6.23503 18.4183 4.89537 18.4072C2.58196 18.3886 0.465876 16.5878 0.0772837 14.3088C-0.148765 12.9833 0.126425 11.6623 0.852956 10.5904C1.58024 9.51562 2.712 8.76213 4.04107 8.46684C4.45764 8.37386 4.89159 8.35824 5.29833 8.35527C5.89256 8.3508 6.54424 8.34857 7.3494 8.34857C7.76294 8.34857 8.17723 8.34857 8.59077 8.34932C8.99675 8.35006 9.40274 8.3508 9.80872 8.3508H12.2695C13.1412 8.3508 14.0129 8.3508 14.8846 8.34932H14.8861C15.0638 8.34932 15.466 8.35006 15.6656 8.73684C15.7661 8.93098 15.7676 9.15412 15.6716 9.34826C15.5703 9.55206 15.3783 9.69413 15.1447 9.73876C15.0638 9.75438 14.9859 9.75661 14.9209 9.75661C14.8975 9.75661 14.8113 9.75512 14.7909 9.75512H14.2155C13.3877 9.75512 12.5591 9.75513 11.7313 9.75438H9.247C7.62685 9.75438 6.31592 9.75513 5.12142 9.75884C3.34554 9.76331 1.92877 10.8731 1.5122 12.5868C1.27708 13.5493 1.47591 14.5847 2.05804 15.4267C2.63866 16.2687 3.54361 16.831 4.53929 16.9716C4.76609 17.0036 5.01104 17.02 5.26884 17.02C7.02733 17.0215 8.78583 17.0222 10.5443 17.0222C11.9717 17.0229 13.3983 17.0229 14.8256 17.0237C14.9783 17.0244 15.1409 17.0319 15.2906 17.0854C15.6195 17.2029 15.7805 17.4863 15.7223 17.8441Z" />
                                                        <path d="M11.8431 13.8558C11.3683 13.7301 10.9321 13.6178 10.4974 13.4995C10.1723 13.411 10.0022 13.1737 10.0687 12.9149C10.142 12.6307 10.4036 12.4901 10.7385 12.5712C11.2012 12.6835 11.6609 12.8063 12.1477 12.9305C12.1477 12.4396 12.1462 11.9851 12.1477 11.5314C12.1493 11.181 12.3322 10.9594 12.6195 10.9549C12.9174 10.9504 13.1086 11.1788 13.1102 11.5447C13.1117 11.962 13.1102 12.38 13.1102 12.8412C13.5381 12.6672 13.9365 12.4901 14.347 12.3451C14.4967 12.2923 14.7046 12.2543 14.8293 12.3176C14.9616 12.3853 15.0781 12.5705 15.1098 12.7222C15.1529 12.926 15.0214 13.0919 14.815 13.1767C14.3636 13.3626 13.913 13.5486 13.4292 13.7479C13.6734 14.038 13.9055 14.3132 14.1368 14.5892C14.2147 14.6822 14.2979 14.7722 14.3697 14.8696C14.5413 15.1002 14.5163 15.3754 14.3145 15.5427C14.1081 15.7138 13.8299 15.6975 13.6326 15.4773C13.315 15.1225 13.0134 14.7543 12.6807 14.3631C12.4509 14.7186 12.2362 15.0526 12.02 15.3858C11.9693 15.4639 11.9217 15.545 11.8635 15.6171C11.6964 15.8224 11.4174 15.8723 11.2073 15.7391C10.9903 15.6015 10.9124 15.3397 11.05 15.1061C11.2436 14.7774 11.4605 14.462 11.6669 14.1407C11.7214 14.0559 11.7735 13.9688 11.8438 13.8558H11.8431Z" />
                                                        <path d="M5.99306 14.3653C5.73375 14.767 5.49787 15.1359 5.25822 15.5018C5.06165 15.8031 4.76832 15.8961 4.52186 15.7421C4.26708 15.5829 4.23306 15.301 4.4334 14.9871C4.66852 14.6189 4.90667 14.2522 5.16145 13.8573C4.68516 13.7323 4.23533 13.614 3.7855 13.4958C3.55416 13.4348 3.3712 13.292 3.38178 13.0577C3.38859 12.9059 3.49292 12.7096 3.61766 12.627C3.73484 12.5489 3.9435 12.5601 4.09849 12.592C4.54529 12.685 4.98605 12.8077 5.45554 12.926C5.45554 12.4358 5.45402 11.9814 5.45554 11.5276C5.45705 11.1818 5.64605 10.9571 5.93258 10.9549C6.22138 10.9527 6.41492 11.1766 6.41719 11.5217C6.41946 11.9486 6.41719 12.3756 6.41719 12.8375C6.85568 12.662 7.26997 12.4924 7.68729 12.3302C7.98668 12.2142 8.22406 12.2804 8.3541 12.505C8.50908 12.7728 8.39492 13.0681 8.06984 13.2057C7.63815 13.3887 7.20118 13.5597 6.73698 13.7479C7.01595 14.0759 7.28131 14.3861 7.54516 14.6985C7.61169 14.7766 7.682 14.854 7.73417 14.941C7.86269 15.1567 7.80523 15.4178 7.60791 15.5613C7.39623 15.7146 7.13691 15.693 6.94791 15.4803C6.63114 15.1247 6.32798 14.758 5.99306 14.3653Z" />
                                                        <path d="M23.3761 12.9007C23.3761 13.2161 23.3814 13.5322 23.3746 13.8476C23.3678 14.157 23.175 14.3489 22.8885 14.3474C22.6012 14.346 22.416 14.1555 22.4145 13.8416C22.4107 13.2101 22.4107 12.5786 22.4145 11.9479C22.4167 11.6429 22.6163 11.4391 22.8938 11.4414C23.1667 11.4436 23.3685 11.6526 23.3746 11.9538C23.3806 12.2692 23.3761 12.5853 23.3761 12.9007Z" />
                                                    </svg>
                                                    <input type="text" name="registerBankAccno" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                    <label v-if="array_an[langCode] != undefined && array_an[langCode] !='' " for="registerBankAccno" class="did-floating-label" :class="arry_CrOnOff.RWBA.CV == true ? 'required': ''">{{array_an[langCode]}}</label>
                                                    <label v-else for="registerBankAccno" class="did-floating-label" :class="arry_CrOnOff.RWBA.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["BACCNO"]}}</label>
                                                </div>
                                            </template>
                                            <!-- Email -->
                                            <template v-if="element.id == 'EM' && element.RS == 2">
                                                <div class="did-floating-label-content registerEmail">
                                                    <svg viewBox="0 0 26 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 3.5C0 2.63805 0.34241 1.8114 0.951903 1.2019C1.5614 0.59241 2.38805 0.25 3.25 0.25H22.75C23.612 0.25 24.4386 0.59241 25.0481 1.2019C25.6576 1.8114 26 2.63805 26 3.5V16.5C26 17.362 25.6576 18.1886 25.0481 18.7981C24.4386 19.4076 23.612 19.75 22.75 19.75H3.25C2.38805 19.75 1.5614 19.4076 0.951903 18.7981C0.34241 18.1886 0 17.362 0 16.5V3.5ZM3.25 1.875C2.81902 1.875 2.4057 2.0462 2.10095 2.35095C1.7962 2.6557 1.625 3.06902 1.625 3.5V3.85262L13 10.6776L24.375 3.85262V3.5C24.375 3.06902 24.2038 2.6557 23.899 2.35095C23.5943 2.0462 23.181 1.875 22.75 1.875H3.25ZM24.375 5.74738L16.7245 10.338L24.375 15.0456V5.74738ZM24.3197 16.9209L15.1548 11.2805L13 12.5724L10.8452 11.2805L1.68025 16.9193C1.77259 17.265 1.97651 17.5707 2.26036 17.7887C2.5442 18.0067 2.89209 18.1249 3.25 18.125H22.75C23.1077 18.125 23.4554 18.0071 23.7392 17.7894C24.0231 17.5716 24.2271 17.2664 24.3197 16.9209ZM1.625 15.0456L9.2755 10.338L1.625 5.74738V15.0456Z" />
                                                    </svg>
                                                    <input type="email" name="required_email" placeholder="" class="did-floating-input register_required_email" autocomplete="off" disabled>
                                                    <label v-if="array_em[langCode] != undefined && array_em[langCode] !='' " for="email" class="did-floating-label" :class="arry_CrOnOff.REM.CV == true ? 'required': ''">{{array_em[langCode]}}</label>
                                                    <label v-else for="email" class="did-floating-label" :class="arry_CrOnOff.REM.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["EM"]}}</label>
                                                </div>
                                            </template>
                                            <!-- Phone Number -->
                                            <template v-if="element.id == 'REF' && element.RS == 2">
                                                <div class="did-floating-label-content" id="RCfilCol">
                                                    <svg viewBox="0 0 30 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M27.5131 7.5C27.5131 6.66466 28.1731 5.95564 28.9846 5.9188C29.4715 5.89624 29.7962 5.70827 29.9769 5.34211L30 5.29624V0.790226L29.9738 0.741354C29.7908 0.400753 29.5185 0.157144 29.1638 0.0165424L29.1215 9.53674e-07H23.4223L23.3708 0.0270681C23.3077 0.0601511 23.1885 0.123309 23.0862 0.225565C22.9531 0.357896 22.8477 0.55564 22.9277 0.837595C23.0677 1.33308 23.5577 1.33308 23.7423 1.33308C24.5208 1.33233 25.2946 1.33158 26.0685 1.33158H28.6577V4.62556C27.79 4.78572 27.1123 5.22256 26.6423 5.92556C26.2885 6.45489 26.1315 7.03158 26.1754 7.6406C26.2769 9.06241 27.1108 9.97895 28.6554 10.3669V13.6519H1.34692V10.3722C2.17077 10.2218 2.82615 9.81579 3.29692 9.16391C3.68231 8.63008 3.86077 8.03835 3.82769 7.40602C3.75308 5.97293 2.83154 4.94887 1.34923 4.63534V1.33233H21.3238C21.35 1.33158 21.3762 1.33158 21.4023 1.33233C21.4238 1.33308 21.4446 1.33308 21.4654 1.33308C21.8738 1.33308 22.1323 1.17068 22.2323 0.849625C22.3223 0.563159 22.2115 0.363158 22.0708 0.225565C21.9838 0.139851 21.8862 0.078948 21.8169 0.0353394L21.76 9.53674e-07H0.877692L0.835385 0.0165424C0.478462 0.159399 0.206154 0.40376 0.0261538 0.741354L0 0.790226V5.29549L0.0230769 5.34211C0.263077 5.82932 0.703846 5.90451 1.01538 5.9188C1.82692 5.95639 2.48692 6.66541 2.48692 7.5C2.48692 8.33459 1.82692 9.04511 1.01538 9.0812C0.703846 9.09549 0.262308 9.17068 0.0230769 9.65789L0 9.70451V14.2098L0.0261538 14.2586C0.206923 14.597 0.479231 14.8406 0.835385 14.9835L0.877692 15H29.1215L29.1631 14.9835C29.52 14.8429 29.7931 14.5985 29.9738 14.2579L30 14.209V9.70376L29.9769 9.65714C29.7954 9.29173 29.4708 9.10301 28.9846 9.0812C28.1731 9.04511 27.5131 8.33609 27.5131 7.5Z" />
                                                        <path d="M10.776 2.36917C10.4737 2.32256 10.1668 2.30151 9.86143 2.26842C7.20143 2.28872 4.92374 4.21805 4.57527 6.79775C4.37912 8.24963 4.7545 9.56993 5.67681 10.7331C5.90066 11.015 6.17297 11.0842 6.38758 10.9196C6.61527 10.7459 6.60912 10.503 6.37143 10.2053C4.39912 7.7391 5.59297 4.16241 8.67297 3.30677C11.2337 2.59624 13.8768 4.27444 14.2614 6.85714C14.6822 9.6782 12.2876 12.1429 9.40527 11.8278C8.92758 11.7752 8.46912 11.5699 7.99604 11.4609C7.82373 11.4203 7.60066 11.3917 7.45835 11.4647C7.15143 11.6241 7.21758 12.0361 7.55912 12.2008C8.31297 12.5647 9.11604 12.7353 9.95373 12.7105C12.646 12.6301 14.7684 10.7729 15.1576 8.17218C15.5622 5.47293 13.5414 2.79474 10.776 2.36917Z" />
                                                        <path d="M25.4768 5.45113C25.4699 5.96843 25.2215 6.20151 24.6907 6.20151C23.4991 6.20301 22.3076 6.20151 21.1161 6.20151C19.9245 6.20151 18.7138 6.20226 17.513 6.20151C17.0099 6.20076 16.7507 5.95339 16.7453 5.45941C16.7391 4.91504 16.7399 4.36993 16.7453 3.82557C16.7499 3.32858 17.0007 3.06993 17.5038 3.06918C19.9061 3.06392 22.3084 3.06392 24.7107 3.06843C25.2207 3.06918 25.4691 3.31655 25.4768 3.81655C25.4853 4.36166 25.4845 4.90677 25.4768 5.45113ZM24.573 3.9564H17.6615V5.3361H24.573V3.9564Z" />
                                                        <path d="M25.4378 9.57068C25.3463 9.34136 25.1509 9.2985 24.9224 9.29925C23.644 9.30376 22.3647 9.30151 21.0863 9.30151C19.8078 9.30151 18.5486 9.30301 17.2801 9.30001C17.0478 9.29925 16.8632 9.3564 16.7809 9.59173C16.6947 9.8361 16.8509 10.0977 17.114 10.1444C17.1609 10.1519 17.2093 10.1496 17.2578 10.1496C19.824 10.1496 22.3909 10.1504 24.9578 10.1496C25.337 10.1489 25.5609 9.87745 25.4378 9.57143V9.57068Z" />
                                                        <path d="M11.5116 10.3218C11.4678 10.1767 11.4486 10.0842 11.4124 9.99925C10.6501 8.2218 9.88933 6.44361 9.11395 4.67143C9.05395 4.53383 8.90779 4.39023 8.76856 4.3421C8.65779 4.30451 8.42394 4.37068 8.37318 4.46015C8.29394 4.6015 8.25702 4.82632 8.31471 4.97218C8.63702 5.78346 8.99241 6.5812 9.33702 7.38346C9.76318 8.37519 10.1863 9.36842 10.6163 10.3586C10.7486 10.6647 11.0139 10.7835 11.2516 10.6308C11.367 10.5571 11.4355 10.415 11.5116 10.3218Z" />
                                                        <path d="M23.1592 7.9391C23.1399 7.70076 22.9992 7.55489 22.7576 7.53309C22.5476 7.51354 22.3353 7.52181 22.1238 7.52181C21.393 7.52031 20.663 7.52106 19.9323 7.52106C19.0861 7.52106 18.2407 7.52031 17.3946 7.52256C17.2899 7.52256 17.1553 7.50226 17.0861 7.55565C16.9546 7.6564 16.7799 7.79926 16.7723 7.93309C16.7646 8.06692 16.9184 8.23234 17.0415 8.34211C17.1107 8.40377 17.2599 8.39174 17.373 8.39174C19.0938 8.39474 20.8146 8.39399 22.5346 8.39324C22.6115 8.39324 22.6899 8.39775 22.7653 8.38497C23.0092 8.34587 23.1769 8.15865 23.1592 7.9391Z" />
                                                        <path d="M8.26704 10.6962C7.52166 10.7 6.88704 10.0789 6.89089 9.34887C6.89396 8.62406 7.50627 8.0188 8.24473 8.01128C8.99781 8.00301 9.62781 8.60677 9.63243 9.34135C9.63627 10.0774 9.01781 10.6917 8.26704 10.6962ZM8.25242 8.87444C7.98089 8.88196 7.77396 9.1 7.78242 9.36993C7.79089 9.63384 7.98781 9.8188 8.26012 9.8203C8.5355 9.82181 8.75781 9.60827 8.75473 9.34737C8.75166 9.08722 8.51781 8.86767 8.25242 8.87444Z" />
                                                        <path d="M11.4562 6.98873C10.7008 6.98647 10.0939 6.38271 10.0969 5.63685C10.1 4.91279 10.7092 4.31279 11.4516 4.30377C12.1977 4.29474 12.8246 4.90677 12.8262 5.64662C12.8277 6.39023 12.2146 6.99174 11.4562 6.98873ZM11.4839 5.18046C11.2062 5.16993 10.9785 5.36918 10.9677 5.63309C10.9577 5.88722 11.1877 6.12256 11.4523 6.12707C11.7192 6.13234 11.9446 5.91429 11.9454 5.64963C11.9462 5.38722 11.7523 5.19023 11.4839 5.18046Z" />
                                                        <path d="M21.2277 11.509C21.2339 11.2293 21.0254 11.0632 20.6531 11.0617C20.0862 11.0594 19.5185 11.0609 18.9516 11.0609C18.3847 11.0609 17.8562 11.0586 17.3085 11.0624C16.967 11.0639 16.7477 11.2414 16.7493 11.5015C16.7508 11.7617 16.9647 11.9316 17.3147 11.9323C18.4293 11.9353 19.5447 11.9353 20.6593 11.9323C21.0224 11.9316 21.2216 11.7782 21.2277 11.509Z" />
                                                    </svg>
                                                    <input type="text" name="referral" placeholder="" class="did-floating-input register_referral" autocomplete="off" disabled>
                                                    <label v-if="array_rc[langCode] != undefined && array_rc[langCode] !='' " for="refferal" class="did-floating-label">{{array_rc[langCode]}}</label>
                                                    <label v-else for="refferal" class="did-floating-label">{{getLanguage["RCUZ"]["REF"]}}</label>
                                                </div>
                                            </template>
                                            <template v-if="element.id == 'PN' && element.RS == 2">
                                                <div class="did-floating-label-content registerPhone">
                                                    <svg viewBox="0 0 17 28" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M0 26.3048C0 18.1041 0 9.90411 0 1.70337C0.0131471 1.67969 0.0363479 1.65676 0.0394414 1.63234C0.142298 0.750332 1.01078 -0.00588499 2.13215 3.45199e-05C6.38254 0.0214927 10.6329 0.00817384 14.8841 0.0103937C15.0542 0.0103937 15.229 0.0126135 15.3937 0.0466506C16.3898 0.249394 16.9977 1.01079 16.9985 2.05188C17 7.44529 16.9985 12.8394 16.9985 18.2329C16.9985 20.8019 16.9985 23.3717 16.9985 25.9408C16.9985 26.4676 16.8608 26.9434 16.4981 27.3548C16.205 27.6878 15.8044 27.8402 15.4046 28H1.59776C1.34642 27.8824 1.07961 27.7869 0.846056 27.6419C0.345692 27.3304 0.126831 26.8413 0 26.3056V26.3048ZM15.5809 24.492V3.03082H1.42221V24.492H15.5809ZM9.47521 26.1065C9.47521 25.5923 9.03284 25.1676 8.5 25.169C7.96638 25.1705 7.52789 25.5952 7.52866 26.1102C7.52943 26.6311 7.96019 27.0426 8.50387 27.0411C9.04754 27.0396 9.47598 26.6282 9.47521 26.1065ZM8.50232 1.81732C9.15658 1.81732 9.81162 1.81732 10.4659 1.81732C10.6252 1.81732 10.7915 1.81584 10.7977 1.61236C10.8046 1.4 10.6422 1.37262 10.4651 1.37262C9.15581 1.3741 7.84651 1.3741 6.53721 1.37262C6.36011 1.37262 6.19771 1.4 6.20544 1.61236C6.2124 1.8151 6.3779 1.81732 6.53798 1.81732C7.19225 1.81584 7.84728 1.81732 8.50155 1.81732H8.50232Z" />
                                                    </svg>
                                                    <input type="tel" name="required_phone" placeholder="" class="did-floating-input register_required_phone r7" autocomplete="off" disabled>
                                                    <label v-if="array_pn[langCode] != undefined && array_pn[langCode] !='' " for="registerPhone" class="did-floating-label" :class="arry_CrOnOff.RPN.CV == true ? 'required': ''">{{array_pn[langCode]}}</label>
                                                    <label v-else for="registerPhone" class="did-floating-label" :class="arry_CrOnOff.RPN.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["PHNO"]}}</label>
                                                </div>
                                            </template>
                                            <!-- Wechat -->
                                            <template v-if="element.id == 'WC' && element.RS == 2">
                                                <div class="did-floating-label-content registerWechat">
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve" fill="currentColor">
                                                    <g>
                                                    <path d="M17.3,6.8C17,5.9,16.6,5.1,16,4.4c-1.6-1.8-3.6-2.8-6-3.1C7.9,1.2,6,1.6,4.2,2.6c-2.7,1.6-4.4,4.6-3.9,7.7
		        c0.3,1.5,1,2.9,2,4c0.4,0.4,0.8,0.7,1.3,1.1c-0.1,0.6-0.3,1.1-0.4,1.7c-0.1,0.3,0,0.6,0.3,0.8c0.3,0.2,0.6,0.2,0.9,0
		        c0.5-0.3,1-0.6,1.5-0.9c0.4-0.3,0.8-0.4,1.3-0.2c0.3,0.1,0.7,0.1,1.1,0.2c0-0.1,0-0.1,0-0.1C8,15.6,8,14.4,8.3,13.2
		        c1-3.4,4.1-5.7,7.6-6.1c0.5,0,0.9,0,1.4-0.1C17.4,6.9,17.4,6.9,17.3,6.8z M6.1,7.3C5.7,7.3,5.4,7,5.4,6.6c0-0.4,0.3-0.7,0.7-0.7
		        c0.4,0,0.7,0.3,0.7,0.7C6.8,7,6.5,7.3,6.1,7.3z M10.8,7.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7
		        C11.5,7,11.2,7.3,10.8,7.3z" />
                                                    <path d="M22.4,20c1.7-1.4,2.5-3.7,2.1-5.8c-0.5-2.9-3-5-5.8-5.6c-3.1-0.7-6.5,0.5-8.3,3.2c-0.6,1-1,2.2-1,3.3
		        c0,0.4,0,0.7,0.1,1.1c0.3,1.8,1.3,3.2,2.7,4.2c2.2,1.5,4.6,1.9,7.1,1.2c0.2-0.1,0.4-0.1,0.6,0c0.5,0.2,1,0.4,1.5,0.6
		        c0.3,0.1,0.6,0.1,0.8-0.1c0.2-0.2,0.3-0.5,0.2-0.8c-0.1-0.3-0.1-0.5-0.2-0.8C22.1,20.4,22.2,20.2,22.4,20z M14.4,14.1
		        c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7C15.1,13.8,14.8,14.1,14.4,14.1z M19.3,14.1
		        c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7C20,13.8,19.7,14.1,19.3,14.1z" />
        </g>
        </svg>
                                                    <input type="text" name="wechat_input" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                    <label v-if="array_wc[langCode] != undefined && array_wc[langCode] !='' " for="registerWechat" class="did-floating-label" :class="arry_CrOnOff.RWC.CV == true ? 'required': ''">{{array_wc[langCode]}}</label>
                                                    <label v-else for="registerWechat" class="did-floating-label" :class="arry_CrOnOff.RWC.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["WCID"]}}</label>
                                                </div>
                                            </template>
                                            <!-- Line -->
                                            <template v-if="element.id == 'LINE' && element.RS == 2">
                                                <div class="did-floating-label-content registerLine">
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve" fill="currentColor">
                                                    <g>
                                                    <path d="M24.4,8.8c-0.2-0.9-0.6-1.7-1.1-2.4c-0.8-1.1-1.7-2.1-2.8-2.8c-1-0.7-2.1-1.2-3.2-1.6c-1-0.3-2.1-0.6-3.2-0.7
		            c-0.5,0-0.9-0.1-1.3-0.1c-0.5,0-0.9,0-1.4,0c-0.5,0-0.9,0.1-1.4,0.2C9.2,1.5,8.4,1.7,7.6,2C6.8,2.3,6.1,2.6,5.4,3
		            c-1,0.6-1.9,1.3-2.7,2.1C2.1,5.7,1.6,6.4,1.2,7.2c-0.5,1-0.8,2-0.9,3c-0.1,0.7,0,1.4,0.1,2c0.1,0.7,0.4,1.5,0.7,2.1
		            c0.4,0.9,1,1.7,1.7,2.4c1,1,2.2,1.8,3.5,2.4c0.7,0.3,1.4,0.6,2.2,0.8c0.5,0.1,0.9,0.2,1.4,0.3c0.3,0,0.6,0.1,0.9,0.1
		            c0.4,0.1,0.8,0.5,0.9,0.9c0,0.3,0,0.7-0.1,1c-0.1,0.3-0.1,0.6-0.1,0.8c0,0.1,0,0.2,0,0.3c0,0.2,0.1,0.3,0.4,0.3
		            c0.2,0,0.4-0.1,0.6-0.1c0.5-0.2,1-0.4,1.5-0.7c0.9-0.5,1.8-1.1,2.7-1.7c1.2-0.8,2.4-1.7,3.5-2.7c0.5-0.4,0.9-0.8,1.4-1.2
		            c0.4-0.4,0.8-0.8,1.2-1.2c0.5-0.6,0.9-1.3,1.2-2c0.4-0.9,0.7-1.9,0.7-2.9C24.7,10.4,24.6,9.6,24.4,8.8z M8.2,13.9
		            c-0.1,0-0.2,0.1-0.2,0.1c0,0-0.1,0-0.1,0c-0.8,0-1.6,0-2.3,0c-0.2,0-0.3,0-0.4-0.1c-0.2-0.1-0.3-0.3-0.3-0.5c0,0,0,0,0-0.1
		            c0-1.5,0-3.1,0-4.6c0-0.3,0.1-0.5,0.3-0.6c0.3-0.2,0.8-0.1,1,0.4c0,0.1,0,0.2,0,0.2c0,1.3,0,2.5,0,3.8v0.1h0.1c0.5,0,1.1,0,1.6,0
		            c0.3,0,0.5,0.2,0.6,0.5C8.6,13.4,8.5,13.7,8.2,13.9z M10.4,13.2c0,0.1,0,0.2,0,0.2c-0.1,0.3-0.4,0.4-0.6,0.5
		            c-0.3,0-0.5-0.1-0.6-0.3C9.1,13.5,9,13.4,9,13.3c0-0.8,0-1.5,0-2.3V8.7c0-0.2,0.1-0.4,0.3-0.5C9.5,8,9.8,8,10,8.1
		            c0.2,0.1,0.3,0.3,0.3,0.6c0,0,0,0,0,0.1C10.4,10.2,10.4,11.7,10.4,13.2z M16.1,13.3c0,0.3-0.3,0.6-0.6,0.6c-0.1,0-0.2,0-0.3,0
		            c-0.1,0-0.2-0.1-0.3-0.2c-0.4-0.5-0.7-1-1.1-1.4c-0.4-0.5-0.8-1.1-1.2-1.6c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0v0.1c0,0.9,0,1.8,0,2.6
		            c0,0.3-0.2,0.5-0.5,0.6c-0.4,0.1-0.8-0.1-0.8-0.5c0,0,0-0.1,0-0.1c0-1.5,0-3.1,0-4.6c0-0.3,0.2-0.5,0.4-0.6c0.3-0.1,0.6,0,0.8,0.2
		            c0.7,0.9,1.4,1.9,2.1,2.8c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0-0.1,0-0.1c0-0.8,0-1.7,0-2.5c0-0.1,0-0.1,0-0.2C14.9,8.2,15.1,8,15.5,8
		            c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0.1,0,0.1C16.1,10.2,16.1,11.8,16.1,13.3z M20.6,13.5C20.6,13.8,20.3,14,20,14c-0.8,0-1.7,0-2.5,0
		            c-0.3,0-0.6-0.3-0.6-0.6c0,0,0,0,0-0.1c0-1.5,0-3,0-4.6c0-0.1,0-0.1,0-0.2C17,8.2,17.3,8,17.6,8c0.8,0,1.6,0,2.5,0
		            c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.1,0.6-0.4,0.7c-0.1,0-0.2,0-0.3,0c-0.5,0-1,0-1.6,0h-0.1v1c0,0,0.1,0,0.1,0c0.5,0,1,0,1.6,0
		            c0.1,0,0.2,0,0.2,0c0.3,0.1,0.5,0.3,0.5,0.6c0,0.3-0.2,0.6-0.5,0.7c-0.1,0-0.1,0-0.2,0c-0.5,0-1.1,0-1.6,0h-0.1c0,0.1,0,0.9,0,1
		            h0.1c0.5,0,1.1,0,1.6,0c0.1,0,0.3,0,0.4,0.1C20.6,12.9,20.7,13.2,20.6,13.5z" />
        </g>
        </svg>
                                                    <input type="text" name="line_input" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                    <label v-if="array_ln[langCode] != undefined && array_ln[langCode] !='' " for="registerLine" class="did-floating-label" :class="arry_CrOnOff.RLINE.CV == true ? 'required': ''">{{array_ln[langCode]}}</label>
                                                    <label v-else for="registerLine" class="did-floating-label" :class="arry_CrOnOff.RLINE.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["LINE"]}}</label>
                                                </div>
                                            </template>
                                            <!-- WhatsApp -->
                                            <template v-if="element.id == 'WSAP' && element.RS == 2">
                                                <div class="did-floating-label-content registerWhatsapp">
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve" fill="currentColor">
                                                    <g>
                                                    <path d="M1.5,23.5C2,22.3,2.4,21.1,2.9,20C3,19.5,3,19.2,2.7,18.7c-1.4-2.1-1.9-4.4-1.8-6.8C1.1,6.9,4.7,2.5,9.6,1.3
		        C16-0.4,22.4,3.6,23.8,9.9c1.4,6.1-2.3,12.2-8.4,13.8c-3.2,0.8-6.3,0.3-9.1-1.4c-0.2-0.1-0.3-0.1-0.4,0c-1.4,0.4-2.7,0.8-4.1,1.2
		        C1.7,23.5,1.6,23.5,1.5,23.5z M16,19c0.6,0,1.1-0.2,1.5-0.6c0.3-0.4,0.7-0.7,1-1c0.5-0.5,0.5-1.3,0-1.9c-0.6-0.6-1.2-1.2-1.8-1.8
		        c-0.7-0.6-1.6-0.4-2,0.4c-0.3,0.7-0.9,1-1.6,0.7c-1.5-0.6-2.5-1.6-3.2-3c-0.3-0.8-0.1-1.4,0.8-1.7c0.8-0.3,1-1.3,0.4-1.9
		        C10.7,7.5,10,6.9,9.4,6.3c-0.5-0.5-1.2-0.5-1.8,0C7.3,6.7,6.9,7.1,6.5,7.5C6.3,7.7,6.2,8,6.1,8.2C5.9,8.8,6,9.4,6.2,10
		        c0.4,1.5,1.2,2.7,2.2,3.9c1.4,1.7,3,3.2,5,4.2C14.2,18.6,15.1,19,16,19z" />
            </g>
        </svg>
                                                    <input type="text" name="whatsapp_input" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                    <label v-if="array_wa[langCode] != undefined && array_wa[langCode] !='' " for="registerWhatsapp" class="did-floating-label" :class="arry_CrOnOff.RWSAP.CV == true ? 'required': ''">{{array_wa[langCode]}}</label>
                                                    <label v-else for="registerWhatsapp" class="did-floating-label" :class="arry_CrOnOff.RWSAP.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["WSAP"]}}</label>
                                                </div>
                                            </template>
                                            <!-- Telegram -->
                                            <template v-if="element.id == 'TELE' && element.RS == 2">
                                                <div class="did-floating-label-content registerTelegram">
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve" fill="currentColor">
                                                    <g>
                                                    <path d="M13.4,18c-1,1-2,2-3,2.9c-0.2,0.2-0.3,0.3-0.5,0.2c-0.2-0.1-0.3-0.2-0.3-0.4c0.1-1.3,0.2-2.6,0.3-3.8
		            c0-0.3,0-0.7,0.1-1c0-0.1,0.1-0.3,0.2-0.4c2.6-2.4,5.3-4.9,7.9-7.3c0.6-0.5,1.2-1.1,1.8-1.6c0.1-0.1,0.3-0.2,0.1-0.3
		            c-0.1-0.1-0.3,0-0.3,0c-3.5,2.1-7,4.3-10.5,6.4c-0.8,0.5-1.5,0.9-2.3,1.4c-0.1,0.1-0.3,0.1-0.4,0.1c-1.7-0.6-3.5-1.2-5.2-1.8
		            c-0.4-0.1-0.6-0.4-0.6-0.7c0-0.4,0.2-0.6,0.6-0.8c3.7-1.4,7.4-2.8,11.1-4.2c3.5-1.3,7-2.7,10.5-4c0.9-0.3,1.7,0,1.9,0.9
		            c0.1,0.2,0,0.5,0,0.8c-1.3,5.8-2.5,11.5-3.8,17.3c-0.2,0.7-0.5,1.1-1.2,1c-0.2,0-0.4-0.1-0.6-0.3c-1.8-1.3-3.5-2.6-5.3-4
		            C13.5,18.1,13.5,18.1,13.4,18z" />
                </g>
            </svg>
                                                    <input type="text" name="telegram_input" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                    <label v-if="array_tg[langCode] != undefined && array_tg[langCode] !='' " for="registerTelegram" class="did-floating-label" :class="arry_CrOnOff.RTELE.CV == true ? 'required': ''">{{array_tg[langCode]}}</label>
                                                    <label v-else for="registerTelegram" class="did-floating-label" :class="arry_CrOnOff.RTELE.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["TGID"]}}</label>
                                                </div>
                                            </template>
                                            <!-- Zalo -->
                                            <template v-if="element.id == 'ZALO' && element.RS == 2">
                                                <div class="did-floating-label-content registerZalo">
                                                    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve" fill="currentColor">
                                                    <g>
                                                    <g>
                                                    <path d="M13.5,23.3c-1.2,0.1-2.4,0-3.6-0.2c-0.7-0.2-1.7-0.6-2.4-0.3c-1,0.3-1.9,0.9-2.8,1.4
			        c-0.2,0.1-0.3,0.2-0.5,0.1C4.1,24.1,4,24,4,23.8c-0.2-1.1,0.4-2.1,0.1-3.2c-0.2-1-1-1.6-1.6-2.3C-0.3,14.4,0,8.9,3,5.1
			        c0.8-1,1.7-1.9,2.8-2.6c5.4-3.4,13-2.2,16.7,3.1c4.2,6,1.2,14.5-5.6,16.9C15.8,22.9,14.7,23.2,13.5,23.3z M6.8,15.2
			        c0.7,0,1.3,0,2,0c0.2,0,0.3-0.1,0.4-0.1c0.3-0.1,0.3-0.6,0.1-0.8C9,14,8.4,14,8,14c-0.6,0-1.2,0-1.8,0c-0.4,0-0.1-0.5,0-0.7
			        c0.2-0.3,0.4-0.5,0.6-0.7c0.6-0.7,1.1-1.5,1.7-2.2c0.2-0.3,0.8-1,0.6-1.4C9,8.5,8.3,8.5,8,8.5c-0.9,0-1.8,0-2.6,0
			        c-0.2,0-0.4,0-0.7,0.1C4.5,8.7,4.3,8.8,4.2,9C4.1,9.5,4.6,9.6,5,9.6c0.6,0,1.3,0,2,0c0.1,0,0.1,0,0.2,0c0.3,0.1,0.1,0.4,0,0.6
			        c-0.4,0.6-0.9,1.2-1.4,1.7c-0.5,0.6-1,1.3-1.5,1.9C4,14.3,4.1,15,4.6,15.2c0.1,0,0.3,0,0.4,0C5.6,15.2,6.2,15.2,6.8,15.2z
			            M14.1,12.9c0-0.6,0-1.2,0-1.8c0-0.3-0.3-0.5-0.5-0.5c-0.2,0-0.5,0.1-0.5,0.3c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.2,0-0.2-0.1
			        c-0.3-0.4-1-0.5-1.5-0.4c-1.3,0.2-2,1.8-1.7,3c0.2,0.7,0.6,1.3,1.3,1.6c0.5,0.2,1.4,0.3,1.7-0.1c0.1-0.1,0.1-0.1,0.2-0.1
			        c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0.1c0,0.1,0.1,0.2,0.2,0.2c0.2,0,0.3,0,0.5-0.1c0.2-0.1,0.2-0.2,0.2-0.4
			        C14.1,14,14.1,13.5,14.1,12.9z M17.4,11c-0.7,0.7-1.1,1.8-0.7,2.8c0.3,0.7,0.9,1.2,1.7,1.4c1.5,0.3,2.9-1,2.8-2.6
			        c-0.1-1.2-1.3-2.3-2.6-2.1C18.2,10.5,17.8,10.7,17.4,11z M14.8,11.8c0,0.7,0,1.4,0,2.1c0,0.4-0.1,0.9,0.4,1.1
			        c0.4,0.2,0.8-0.1,0.8-0.5c0.1-1.8-0.1-3.5,0-5.3c0-0.2,0-0.3-0.1-0.5c-0.2-0.3-0.9-0.3-1.1,0.1c0,0.1,0,0.1,0,0.2
			        C14.8,10,14.8,10.9,14.8,11.8z" />
                                                    <path d="M12.9,12.8c0,0.1,0,0.3,0,0.4c-0.1,0.5-0.6,0.9-1.2,0.8c-0.4-0.1-0.8-0.5-0.8-0.9c-0.1-0.4,0-1,0.3-1.3
			        c0.3-0.3,0.9-0.3,1.2-0.1C12.7,12,12.9,12.4,12.9,12.8z" />
                                                    <path d="M19.9,12.9c0,0.1,0,0.2,0,0.3c-0.1,0.5-0.6,1-1.2,0.9c-0.6-0.1-0.9-0.8-0.9-1.4c0.1-0.6,0.5-1.2,1.2-1.1
			        C19.6,11.7,20,12.3,19.9,12.9z" />
	        </g>
        </g>
        </svg>
                                                    <input type="text" name="zalo_input" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                    <label v-if="array_zl[langCode] != undefined && array_zl[langCode] !='' " for="registerZalo" class="did-floating-label" :class="arry_CrOnOff.RWSAP.CV == true ? 'required': ''">{{array_zl[langCode]}}</label>
                                                    <label for="registerZalo" class="did-floating-label" :class="arry_CrOnOff.RWSAP.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["ZLID"]}}</label>
                                                </div>
                                            </template>
                                        </div>

                                        <CCol col="12">
                                            <p class="mandatory_Field mb-0 ">{{ getLanguage["MANDATORY"]["FIELDS"] }} </p>

                                            <div class="registrationCaptcha">
                                                <fieldset class="form-block">
                                                    <div class="fld-block">
                                                        <div class="captchaimage">
                                                            <img class="captcha-image" alt="" src="/src/assets/images/captchaetc.gif">
                                                        </div>
                                                        <div class="captchaInputRefresh">
                                                            <a class="text-dark captcha-refresh" href="javascript:void(0);"><span>Refresh</span><i class="fa fa-refresh"></i></a>
                                                            <input autocomplete="off" class="fld r8 l3 captcha-value" data-val="true" data-val-required="" id="RegisterCaptcha" name="RegisterCaptcha" required="required" type="text" value="">
                                                            <span class="field-validation-valid" data-valmsg-for="RegisterCaptcha" data-valmsg-replace="true"></span>
                                                        </div>
                                                    </div>
                                                </fieldset>
                                            </div>

                                            <button class="rgstButton w-100" type="submit"> {{getLanguage["MEM"]["RGT"]}}</button>
                                        </CCol>

                                        <div class="col-12 bottom text-center">
                                            <div class="sm-text mx-auto mb-3 mt-2">
                                                {{getLanguage["RCUZ"]["HAVEACC"]}} <a href="#" data-dismiss="modal" data-target="#loginModal" data-toggle="modal" class="ml-2"> {{getLanguage["MEM"]["LGN"]}}</a>
                                            </div>
                                        </div>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!--Customize Deposit-->
        <div v-if="bool_isPreviewCD">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{ getLanguage["AG"]["VDCUZ"] }}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closePreviewCD()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="depositPage">
                                        <div style="width: 100%; padding: 15px; background: #ececec;">
                                            <draggable class="h_nav-list nav inside-tab flex-nowrap text-nowrap overflow-auto deposit-tabs__list"
                                                       tag="ul"
                                                       @start="drag = true"
                                                       v-bind="dragOptions"
                                                       @end="(evt, originalEvent) => { drag = false; checkMove(evt, originalEvent); }"
                                                       :list="arry_cd.DepositDraggeBase"
                                                       group="people">
                                                <li class="h_nav-item nav-item inside-tab-item" v-for="(element, index) in arry_cd.DepositDraggeBase" :key="element.order" @click="paymentMtdSequence = element.id; (element.id == 'MD') ? showManualDeposit=true : showManualDeposit=false">
                                                    <a class="pointer" :class="(paymentMtdSequence == element.id) ? 'active': ''" data-toggle="tab" role="tab">
                                                        <div class="d-flex">
                                                            <svg v-if="element.id == 'MD'" class="mr-1 bi bi-cash-coin" style=" height: 30px; width: 30px; margin: auto; color: #2eb85c;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"> <path style="color: #F6BC1B" fill-rule="evenodd" d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z" /> <path style="color: #F6BC1B" d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z" /> <path style="color: #2eb85c" d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z" /> <path style="color: #2eb85c" d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z" /> </svg>
                                                            <svg v-else-if="element.id == 'AD'" class="mr-1" style="width:25px;height:25px;margin:auto;color: #FF4500 " xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"> <path d="M16 9.026v-1.651c-0.646 0.047-1.005 0.391-1.318 0.948l-6.854 13.969h3.286l-1.005-1.276 0.87-1.818 0.005 0.005 5.016-10.172zM14.036 17.495h3.927l-1.964-4.063zM10.979 19.219h0.021l-0.016-0.016zM17.964 17.495v0.005zM28.661 6.755l-10.979-6.344c-0.927-0.536-2.438-0.536-3.365 0l-10.979 6.344c-0.922 0.531-1.682 1.839-1.682 2.906v12.677c0 1.073 0.76 2.375 1.682 2.906l10.979 6.344c0.927 0.536 2.438 0.536 3.365 0l10.979-6.354c0.922-0.521 1.677-1.844 1.677-2.901v-12.672c0-1.068-0.755-2.375-1.677-2.906zM20.573 22.823l-0.917-1.849h-7.333l-0.896 1.849h-4.38l7.198-14.714c0.406-0.807 1.036-1.198 1.755-1.198s1.38 0.438 1.755 1.187l7.193 14.724zM16 9.026v3.297l3.359 6.901h-8.359l1.010 1.25h7.964l0.896 1.802h3.302l-2.276-1.318v0.052l-5.896-11.984z" fill="#FF4500 "></path> </svg>
                                                            <svg v-else-if="element.id == 'ADP'" class="mr-1" style="width:25px;height:25px;margin:auto;color: #e53636" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"> <path d="M16 9.026v-1.651c-0.646 0.047-1.005 0.391-1.318 0.948l-6.854 13.969h3.286l-1.005-1.276 0.87-1.818 0.005 0.005 5.016-10.172zM14.036 17.495h3.927l-1.964-4.063zM10.979 19.219h0.021l-0.016-0.016zM17.964 17.495v0.005zM28.661 6.755l-10.979-6.344c-0.927-0.536-2.438-0.536-3.365 0l-10.979 6.344c-0.922 0.531-1.682 1.839-1.682 2.906v12.677c0 1.073 0.76 2.375 1.682 2.906l10.979 6.344c0.927 0.536 2.438 0.536 3.365 0l10.979-6.354c0.922-0.521 1.677-1.844 1.677-2.901v-12.672c0-1.068-0.755-2.375-1.677-2.906zM20.573 22.823l-0.917-1.849h-7.333l-0.896 1.849h-4.38l7.198-14.714c0.406-0.807 1.036-1.198 1.755-1.198s1.38 0.438 1.755 1.187l7.193 14.724zM16 9.026v3.297l3.359 6.901h-8.359l1.010 1.25h7.964l0.896 1.802h3.302l-2.276-1.318v0.052l-5.896-11.984z" fill="#e53636"></path><sup style="font-weight:bold;font-size:14px;margin-left:-8px;top:-8px">+</sup> </svg>
                                                            <img v-else-if="element.id == 'HP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/h2p.webp" />
                                                            <img v-else-if="element.id == 'OP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/oopay.webp" />
                                                            <img v-else-if="element.id == 'EZP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/ezpay.webp" />
                                                            <img v-else-if="element.id == 'TUP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/truepay.webp" />
                                                            <img v-else-if="element.id == 'STP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/starpay.webp" />
                                                            <img v-else-if="element.id == 'FUP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/fupay.webp" />
                                                            <img v-else-if="element.id == 'SUREP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/surepay.webp" />
                                                            <svg v-else-if="element.id == 'CT'" class="mr-1" style="width: 25px; margin: auto; color: #F6BC1B" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_399_390)"> <path d="M11.3848 15.2749C12.4961 15.2709 14.9248 15.2622 14.8971 13.7167C14.8696 12.1362 12.5376 12.232 11.3997 12.2788C11.2725 12.284 11.1603 12.2886 11.0678 12.2902L11.1196 15.2769C11.1955 15.2755 11.2848 15.2752 11.3848 15.2749Z" fill="#F6BC1B" /> <path d="M11.2672 10.9218C12.1943 10.9208 14.2166 10.9188 14.1925 9.51381C14.1673 8.07687 12.2241 8.1623 11.275 8.20402C11.1683 8.20871 11.0741 8.21285 10.9967 8.21421L11.0439 10.923C11.1077 10.9219 11.1829 10.9218 11.2672 10.9218Z" fill="#F6BC1B" /> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.09602 23.641C15.5261 25.2441 22.0379 21.3317 23.6408 14.9031C25.2437 8.4741 21.3313 1.96185 14.9016 0.359098C8.47345 -1.24365 1.96163 2.6691 0.359461 9.09847C-1.24421 15.5267 2.66858 22.0382 9.09602 23.641ZM13.378 6.62195C15.1321 6.74481 16.5287 7.25928 16.7113 8.86344C16.8468 10.0372 16.3673 10.7515 15.5876 11.1658C16.8879 11.4541 17.7128 12.2095 17.5828 13.937C17.422 16.0824 15.8354 16.6849 13.5566 16.8555L13.5954 19.1058L12.2386 19.1296L12.2004 16.9095C11.8488 16.9159 11.4886 16.9193 11.1164 16.9181L11.1553 19.1485L9.79996 19.1719L9.76003 16.9177C9.63316 16.9191 9.50533 16.9199 9.37659 16.9208C9.18324 16.9221 8.98785 16.9234 8.79059 16.9266L7.02486 16.9575L7.26617 15.3326C7.26617 15.3326 8.27012 15.3307 8.25249 15.3156C8.63645 15.3082 8.73331 15.0307 8.75441 14.8573L8.69266 11.3002C8.72587 11.2994 8.75848 11.2989 8.78995 11.2984C8.8056 11.2981 8.82097 11.2978 8.83599 11.2976C8.77983 11.2909 8.73033 11.2902 8.6924 11.2906L8.64796 8.75147C8.59112 8.47708 8.40668 8.16117 7.85709 8.1706C7.87342 8.15186 6.87178 8.18845 6.87178 8.18845L6.84613 6.73946L8.71755 6.70744L8.71785 6.71434C8.99914 6.70925 9.28753 6.69876 9.58119 6.68763L9.54279 4.45939L10.8989 4.43577L10.9368 6.62026C11.299 6.60671 11.6634 6.5933 12.0201 6.58703L11.9822 4.41691L13.339 4.39309L13.378 6.62195Z" fill="#F6BC1B" /> </g> <defs> <clipPath id="clip0_399_390"> <rect width="24" height="24" fill="white" /> </clipPath> </defs> </svg>
                                                            <img v-else-if="element.id == 'XFU'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/xfuoo.webp" />
                                                            <img v-else-if="element.id == 'CPAY'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/cpay.webp" />
                                                            <img v-else-if="element.id == 'TMONEY'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/tmoney.webp" />
                                                            <img v-else-if="element.id == 'SMP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/smartpay.webp" />
                                                            <img v-else-if="element.id == 'U2P'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/u2pay.webp" />
                                                            <img v-else-if="element.id == 'LP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/luckypay.webp" />
                                                            <img v-else-if="element.id == 'BCP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/bcpay.webp" />
                                                            <img v-else-if="element.id == 'FPG'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/fpg.webp" />
                                                            <img v-else-if="element.id == 'PGA'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/mpay.webp" />
                                                            <img v-else-if="element.id == 'PP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/pompay.webp" />
                                                            <img v-else-if="element.id == 'DN'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/doitnow.webp" />
                                                            <img v-else-if="element.id == 'AGP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/agp.webp" />
                                                            <img v-else-if="element.id == 'P918'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/p918.webp" />
                                                            <img v-else-if="element.id == 'UP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/universepay.webp" />
                                                            <img v-else-if="element.id == 'OKP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/okayspay.webp" />
                                                            <img v-else-if="element.id == 'MGP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/megaspay.webp" />
                                                            <img v-else-if="element.id == 'VIP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/vip.webp" />
                                                            <img v-else-if="element.id == 'AFP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/alfapay.webp" />
                                                            <img v-else-if="element.id == 'ONEP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/onepay.webp" />
                                                            <img v-else-if="element.id == 'BLEUP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/bleupay.webp" />
                                                            <img v-else-if="element.id == 'E88P'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/easy88pay.webp" />
                                                            <img v-else-if="element.id == 'ECP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/ecpay.webp" />
                                                            <img v-else-if="element.id == 'ZPAY'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/zpay.webp" />
                                                            <img v-else-if="element.id == 'UPAY'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/upay.webp" />
                                                            <img v-else-if="element.id == 'DGPCNY'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/dgpay.webp" />
                                                            <img v-else-if="element.id == 'SUPER7VND'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/super7.webp" />
                                                            <!--<img v-else-if="element.id == 'PAYNGO'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/payngo.webp" />-->
                                                            <!--<img v-else-if="element.id == 'PPYP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/papayapay.webp" />-->
                                                            {{getLanguage["ACO"][element.name ]}}
                                                            <!--<input type="checkbox" class="ml-2" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">-->
                                                        </div>
                                                    </a>
                                                </li>
                                            </draggable>

                                            <div class="tab-content inside-tab-bg" v-if="showManualDeposit">
                                                <div :class="arry_CdOnOff.DPTB_DCUZ.CV ? 'payment-grid' : ''">
                                                    <div id="payment-transaction" class="payment-transaction" v-if="arry_CdOnOff.DPTB_DCUZ.CV">
                                                        <div class="d-flex justify-content-center align-items-center" v-if="arr_DepositbankTempalte.length <= 0" style=" border: 1px solid; background-color: inherit; border-color: rgba(0,0,21,0.125); height: 100%; border-radius: 0.25rem;">
                                                            {{this.getLanguage["DCUZ"]["NBLA"]}}
                                                        </div>
                                                        <div v-else>
                                                            <hr class="d-block d-lg-none mb-4" />
                                                            <template v-for="(data, dataIdx) in arr_DepositbankTempalte">
                                                                <h6 class="font-weight-bold mb-1" style="font-size:1em" v-if="data.PM ==10 && (dataIdx === 0 || arr_DepositbankTempalte[dataIdx - 1].PM != 10)"> {{getLanguage["DCUZ"]["EW"]}}</h6>
                                                                <h6 class="font-weight-bold mb-1" style="font-size:1em" v-else-if="data.PM ==40 && (dataIdx === 0 || arr_DepositbankTempalte[dataIdx - 1].PM != 40)"> {{getLanguage["DCUZ"]["CRYPT"]}} </h6>
                                                                <h6 class="font-weight-bold mb-1" style="font-size:1em" v-else-if="data.PM ==4 && (dataIdx === 0 || arr_DepositbankTempalte[dataIdx - 1].PM != 4)"> {{getLanguage["DCUZ"]["OD"]}}</h6>
                                                                <h6 class="font-weight-bold mb-1" style="font-size:1em" v-else-if="data.PM ==1 && (dataIdx === 0 || arr_DepositbankTempalte[dataIdx - 1].PM != 1)"> {{getLanguage["DCUZ"]["CD"]}}</h6>
                                                                <h6 class="font-weight-bold mb-1" style="font-size:1em" v-else-if="data.PM ==11 && (dataIdx === 0 || arr_DepositbankTempalte[dataIdx - 1].PM != 11)"> {{getLanguage["DCUZ"]["CBD"]}}</h6>

                                                                <div class="payment-item">
                                                                    <div class="d-flex align-items-center">
                                                                        <div class="payment-icon">
                                                                            <img :src="data.BL">
                                                                        </div>
                                                                        <div class="payment-content">
                                                                            <p class="text-white m-0">{{data.BN}}</p>
                                                                            <p class="text-white m-0 minInfo">{{ getLanguage["DCUZ"]["MIN"] }}: <span class="text-white">{{ formatNumber(data.MIND,2,arry_cd['ISOC'])}}</span></p>
                                                                            <p class="text-white m-0 maxInfo">{{ getLanguage["DCUZ"]["MAX"] }}: <span class="text-white">{{ formatNumber(data.MAXD,2,arry_cd['ISOC'])}}</span></p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div class="payment-form" style="max-width: 550px;">
                                                        <div class=""
                                                             v-for="element in arry_cd.VTCDepositDraggeBase"
                                                             v-if="showenLogic(element)"
                                                             :key="element.name">
                                                            <template v-if="element.id == 'DA'">
                                                                <div v-if="array_da[langCode] != undefined && array_da[langCode] !='' " class="mb-3 row w-100">
                                                                    <label class="col-sm-4 col-form-label pt-0 pr-0">
                                                                        {{array_da[langCode]}}<span class="required" />
                                                                        <span class="amountNote amountNoteInline" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                                    </label>
                                                                    <div class="col-sm-8">
                                                                        <div class="position-relative">
                                                                            <input onkeypress="WithDraWnoDecimalInput(event)" ondrop="return false;" onpaste="return false" id="depositAmount" type="text" name="depositAmount" onchange="currencyValueOnChange(event, true, false)" :placeholder="array_da[langCode]" class="form-control" autocomplete="false" required="" disabled>
                                                                            <div class="tip-container">
                                                                                <div class="help-tip">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div v-else class="mb-3 row w-100">
                                                                    <label class="col-sm-4 col-form-label pt-0 pr-0">
                                                                        {{getLanguage["MTA"]["DAMT"]}}<span class="required" />
                                                                        <span class="amountNote amountNoteInline" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                                    </label>
                                                                    <div class="col-sm-8">
                                                                        <div class="position-relative">
                                                                            <input onkeypress="WithDraWnoDecimalInput(event)" ondrop="return false;" onpaste="return false" id="depositAmount" type="text" name="depositAmount" onchange="currencyValueOnChange(event, true, false)" :placeholder="getLanguage['MTA']['DAMT']" class="form-control" autocomplete="false" required="" disabled>
                                                                            <div class="tip-container">
                                                                                <div class="help-tip">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-else-if="element.id == 'MB'">
                                                                <div class="mb-3 row w-100 ">
                                                                    <label v-if="array_cya[langCode] != undefined && array_cya[langCode] !='' " class="col-sm-4 col-form-label pt-0 pr-0 required">{{array_cya[langCode]}}</label>
                                                                    <label v-else class="col-sm-4 col-form-label pt-0 pr-0 required">{{getLanguage["DCUZ"]["PSYBA"]}}</label>

                                                                    <div class="col-sm-8">
                                                                        <div class="input-group">
                                                                            <select name="memberbank" id="memberbank" class="orderby custom-dropdown form-control"></select>
                                                                            <div class="input-group-append">
                                                                                <button type="button" class="input-group-text"><i class="fa fa-plus mr-1"></i>{{getLanguage["BANK"]["AB"]}}</button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </template>
                                                            <template v-else-if="element.id == 'DB'">
                                                                <div class="mb-3 row w-100">
                                                                    <label v-if="array_sb[langCode] != undefined && array_sb[langCode] !='' " class="col-sm-4 col-form-label pt-0 pr-0">{{array_sb[langCode]}}</label>
                                                                    <label v-else class="col-sm-4 col-form-label pt-0 pr-0">{{getLanguage["DCUZ"]["PSDB"]}}</label>
                                                                    <div class="col-sm-8">
                                                                        <select name="bank" id="bank" class="orderby custom-dropdown form-control" disabled>
                                                                            <option v-for="data in arr_DepositbankTempalte" :value="data" v-if="selectedDataPMI(data)">{{data.BA}} - {{ arry_OnOff.BankBackOfficeSetting.SHBAN.CV?data.BAN.slice(0, -4)+"xxxx":data.BAN}}</option>
                                                                        </select>

                                                                        <div class="card mt-2" id="dpt-info" v-if="arr_DepositbankTempalte !=null && arr_DepositbankTempalte.length>0">
                                                                            <div class="w-100 position-relative">
                                                                                <div class="card-header d-flex justify-content-lg-center p-2">
                                                                                    <img v-if="arr_DepositbankTempalte[0].BL" :src="arr_DepositbankTempalte[0].BL" id="banklogoImage" alt="depositbank" />
                                                                                    <img v-if="arr_DepositbankTempalte[0].QRCI" :src="arr_DepositbankTempalte[0].QRCI" id="qrcodeImage" alt="depositbank-qrcode">
                                                                                </div>
                                                                                <div class="card-body p-2">
                                                                                    <div class="row">
                                                                                        <div class="col-7">{{getLanguage["BA"]["BAN"]}} <div class="float-right">:</div></div>
                                                                                        <div class="col-5 pl-0"><span id="db-accname">{{ arr_DepositbankTempalte[0].BA }}</span></div>
                                                                                    </div>
                                                                                    <div class="row">
                                                                                        <div class="col-7">{{getLanguage["MEM"]["DUP3"]}} <div class="float-right">:</div></div>
                                                                                        <div class="col-5 pl-0">
                                                                                            <span class="bankno text-primary" id="db-accnum">{{ arr_DepositbankTempalte[0].BAN }}</span>

                                                                                            <button class="btn copy-bankno text-primary p-0" type="button">
                                                                                                <i class="fa-fw fa fa-clone" aria-hidden="true"></i>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div id="fromCSdiv" v-if="arr_DepositbankTempalte[0].CS || arr_DepositbankTempalte[0].ER">
                                                                                        <div class="row" id="db-from-cs" v-if="arr_DepositbankTempalte[0].CS">
                                                                                            <div class="col-7">{{ getLanguage["DCUZ"]["CS"] }} <div class="float-right">:</div></div>
                                                                                            <div class="col-5 pl-0"><span>{{arr_DepositbankTempalte[0].CS}}</span></div>
                                                                                        </div>
                                                                                        <div class="row" id="db-from-er" v-if="arr_DepositbankTempalte[0].ER">
                                                                                            <div class="col-7">{{ getLanguage["DCUZ"]["ER"] }} <div class="float-right">:</div></div>
                                                                                            <div class="col-5 pl-0"><span>{{arr_DepositbankTempalte[0].ER}}</span></div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div id="minMaxdiv" v-if="arr_DepositbankTempalte[0].MIND > 0 || arr_DepositbankTempalte[0].MAXD > 0">
                                                                                        <div class="row" id="minInfo" v-if="arr_DepositbankTempalte[0].MIND > 0">
                                                                                            <div class="col-7">{{ getLanguage["DCUZ"]["MIN"] }} <div class="float-right">:</div></div>
                                                                                            <div class="col-5 pl-0"> <span>{{arr_DepositbankTempalte[0].MIND}}</span></div>
                                                                                        </div>
                                                                                        <div class="row" id="maxInfo" v-if="arr_DepositbankTempalte[0].MAXD > 0">
                                                                                            <div class="col-7">{{ getLanguage["DCUZ"]["MAX"] }} <div class="float-right">:</div></div>
                                                                                            <div class="col-5 pl-0"> <span>{{arr_DepositbankTempalte[0].MAXD}}</span></div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-else-if="element.id == 'TI' && arry_CdOnOff.DTID_DCUZ.CV == true">
                                                                <div v-if="array_ti[langCode] != undefined && array_ti[langCode] !='' " class="mb-3 row w-100">
                                                                    <label class="col-sm-4 col-form-label pt-0 pr-0 transactionLabel">{{ array_ti[langCode] }}</label>
                                                                    <div class="col-sm-8">
                                                                        <input id="transactionId" type="text" name="transactionId" :placeholder="array_ti[langCode]" class="form-control" autocomplete="false" disabled>
                                                                    </div>
                                                                </div>
                                                                <div v-else class="mb-3 row w-100">
                                                                    <label class="col-sm-4 col-form-label pt-0 pr-0 transactionLabel">{{ getLanguage["MTA"]["TID"] }}</label>
                                                                    <div class="col-sm-8">
                                                                        <input id="transactionId" type="text" name="transactionId" :placeholder="getLanguage['MTA']['TID']" class="form-control" autocomplete="false" disabled>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-else-if="element.id == 'DT' && arry_CdOnOff.DDTOD_DCUZ.CV == true">
                                                                <div class="mb-3 row w-100">
                                                                    <label v-if="array_dtod[langCode] != undefined && array_dtod[langCode] !='' " class="col-sm-4 col-form-label pt-0 pr-0">{{ array_dtod[langCode] }}</label>
                                                                    <label v-else class="col-sm-4 col-form-label pt-0 pr-0">{{ getLanguage["DCUZ"]["THD"] }}</label>
                                                                    <div class="col-sm-8">
                                                                        <div class="row">
                                                                            <div class="col-6">
                                                                                <input type="date" name="depositDate" placeholder="@Resources.Language.DEPOSIT_DOD" class="form-control" autocomplete="false" disabled>
                                                                            </div>
                                                                            <div class="col-6">
                                                                                <input type="time" name="depositTime" placeholder="@Resources.Language.DEPOSIT_TOD" class="form-control" autocomplete="false" disabled>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-else-if="element.id == 'R' && arry_CdOnOff.DUR_DCUZ.CV == true">
                                                                <div class="mb-3 row w-100 form-group-choosefile fileinput">
                                                                    <label v-if="array_ur[langCode] != undefined && array_ur[langCode] !='' " class="col-sm-4 col-form-label pt-0 pr-0">{{ array_ur[langCode] }}</label>
                                                                    <label v-else class="col-sm-4 col-form-label pt-0 pr-0">{{ getLanguage["DCUZ"]["UREC"] }}</label>
                                                                    <div class="col-sm-8">
                                                                        <input type="file" id="receipt" accept="image/png, image/jpg, image/jpeg" class="form-control choose-file" disabled>
                                                                        <small class="text-red">{{ getLanguage["DCUZ"]["MAXFILE"] }}</small>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-else-if="element.id == 'PM'">
                                                                <div class="mb-3 row w-100 user-auto-promocode">
                                                                    <label v-if="array_p[langCode] != undefined && array_p[langCode] !='' " class="col-sm-4 col-form-label pt-0 pr-0">{{ array_p[langCode] }}</label>
                                                                    <label v-else class="col-sm-4 col-form-label pt-0 pr-0">{{ getLanguage["DCUZ"]["P"] }}</label>
                                                                    <div class="col-sm-8">
                                                                        <select class="form-control" id="depositPromoId" name="depositPromoId"></select>
                                                                        <a v-if="arry_CdOnOff.EPRL.CV" class="promotion-rules" href="#" target="_blank"><p class="mb-0">{{ getLanguage["DCUZ"]["PR"] }}<i class="fa fa-angle-double-right ml-2" aria-hidden="true"></i></p></a>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-else-if="element.id == 'NOTE' && arry_CdOnOff.DNOTE_DCUZ.CV == true">
                                                                <div v-if="array_n[langCode] != undefined && array_n[langCode] !='' " class="mb-3 row w-100">
                                                                    <label class="col-sm-4 col-form-label pt-0 pr-0 transactionLabel">{{ array_n[langCode] }}<span v-if="arry_CdOnOff.NOTEIRQ.CV" class="required" /></label>
                                                                    <div class="col-sm-8">
                                                                        <input type="text" :placeholder="array_n[langCode]" class="form-control" autocomplete="false" disabled>
                                                                    </div>
                                                                </div>
                                                                <div v-else class="mb-3 row w-100">
                                                                    <label class="col-sm-4 col-form-label pt-0 pr-0 transactionLabel">{{ getLanguage["DCUZ"]["NOTE"] }}<span v-if="arry_CdOnOff.NOTEIRQ.CV" class="required" /></label>
                                                                    <div class="col-sm-8">
                                                                        <input type="text" :placeholder="getLanguage['DCUZ']['NOTE']" class="form-control" autocomplete="false" disabled>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </div>

                                                        <p class="mandatory_Field mb-0 mt-3">{{ getLanguage["MANDATORY"]["FIELDS"] }} </p>
                                                        <button class="button button-regular afb01 w-100">{{ getLanguage["MTA"]["DPTR"] }}</button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row justify-content-center align-items-center mx-0 tab-content inside-tab-bg h-100" id="DepositTabContent" v-else>
                                                {{this.getLanguage["DCUZ"]["TPPMC"]}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <!-- Start of SSA Editing Container -->
        <div class="container-fluid" id="SSA">
            <CRow>
                <CCol class='pageHeader'>
                    <!-- Self Service Agent Title-->
                    <h2 id="titleHeight" class=" w-100">
                        {{getLanguage["AG"]["AGENTSS"]}}
                        <!-- if AgentType == 1 && Editing existing SM -->
                        <span v-if="obj_Group.AT == 1 && !$route.query.agt"> | {{ getLanguage["BTN"]["ED"] }} SM<i class="fas fa-user-alt gg-ico gg-ico-sa ml-1" style="font-size: .875rem;"></i></span>
                        <!-- if AgentType == 2 && Editing existing MA -->
                        <span v-else-if="obj_Group.AT == 2 && !$route.query.agt"> | {{ getLanguage["BTN"]["ED"] }} MA<i class="fa fa-user-friends gg-ico gg-ico-ma ml-1" style="font-size: .875rem;"></i></span>
                        <!-- if AgentType == 3 && Editing existing Agent -->
                        <span v-else-if="obj_Group.AT == 3 && !$route.query.agt"> | {{ getLanguage["BTN"]["ED"] }} {{ getLanguage["LOGRPT"]["AG"] }}<i class="fas fa-users gg-ico gg-ico-a ml-1" style="font-size: .875rem;"></i></span>
                        <!-- if AgentType == 1 && Adding new SM -->
                        <span v-else-if="obj_Group.AT == 1 || (!obj_Group.AT && $route.query.agt == 'sm')"> | {{ getLanguage["BTN"]["AD"] }} SM<i class="fas fa-user-alt gg-ico gg-ico-sa ml-1" style="font-size: .875rem;"></i></span>
                        <!-- if AgentType == 2 && Adding new MA -->
                        <span v-else-if="obj_Group.AT == 2 || (!obj_Group.AT && $route.query.agt == 'ma')"> | {{ getLanguage["BTN"]["AD"] }} MA<i class="fa fa-user-friends gg-ico gg-ico-ma ml-1" style="font-size: .875rem;"></i></span>
                        <!-- if AgentType == 3 && Adding new Agent -->
                        <span v-else-if="obj_Group.AT == 3 || (!obj_Group.AT && $route.query.agt == 'a')"> | {{ getLanguage["BTN"]["AD"] }} {{ getLanguage["LOGRPT"]["AG"] }}<i class="fas fa-users gg-ico gg-ico-a ml-1" style="font-size: .875rem;"></i></span>
                    </h2>
                    <!-- Hyperlink back to SSA Main Page -->
                    <span style=" float: right; width: 400px; text-align: right;">
                        <!-- Main page path -->
                        <span>
                            <router-link :to="{ path:'/AGS/AGD'}" v-if="checkModuleAccess('ASS', 'AGS', constAccessType.view)">
                                {{ getLanguage["AG"]["BTMP"] }}
                            </router-link><i class="fas fa-caret-right mx-2"></i>
                        </span>
                        <!-- Current path -->
                        <span>
                            <span style="cursor: default; pointer-events: none" v-if="obj_Group.AT == 1 && !$route.query.agt">{{ getLanguage["BTN"]["ED"] }} SM</span>
                            <span style="cursor: default; pointer-events: none" v-else-if="obj_Group.AT == 2 && !$route.query.agt">{{ getLanguage["BTN"]["ED"] }} MA</span>
                            <span style="cursor: default; pointer-events: none" v-else-if="obj_Group.AT == 3 && !$route.query.agt">{{ getLanguage["BTN"]["ED"] }} {{ getLanguage["LOGRPT"]["AG"] }}</span>
                            <span style="cursor: default; pointer-events: none" v-else-if="obj_Group.AT == 1 || (!obj_Group.AT && $route.query.agt == 'sm')">{{ getLanguage["BTN"]["AD"] }} SM</span>
                            <span style="cursor: default; pointer-events: none" v-else-if="obj_Group.AT == 2 || (!obj_Group.AT && $route.query.agt == 'ma')">{{ getLanguage["BTN"]["AD"] }} MA</span>
                            <span style="cursor: default; pointer-events: none" v-else-if="obj_Group.AT == 3 || (!obj_Group.AT && $route.query.agt == 'a')">{{ getLanguage["BTN"]["AD"] }} {{ getLanguage["LOGRPT"]["AG"] }}</span>
                        </span>
                    </span>
                </CCol>
            </CRow>

            <div class="table-wrapper p-0 pt-4 pb-2">
                <!-- Previously: Downline Setting (System Balance, PT & BO Account Setting) Title -->
                <!-- New (TT9384) New SM Brand Details -->
                <CRow class="mx-0">
                    <CCol col="12">
                        <h6 class="card-title section-title2"
                            data-section="ds"
                            @click="showSectionBasedRole('ds')"
                            :class="selectedSection === 'ds' ? 'bg-blue text-white' : ''">
                            <!-- Index number of Section -->
                            <!--<span :class="(!this.$v.obj_Group.$error && bool_groupCV) ? 'bg-success' : ''">-->
                            <span :class="getSectionClasses('ds', !$v.obj_Group.$error && bool_groupCV)">
                                {{ getSectionIndex(1) }}
                            </span>
                            <!-- Section Name -->
                            <template v-if="obj_Group.I == 0">

                                <!-- SM -->
                                <template v-if="obj_Group.AT == 1 || (!obj_Group.AT && $route.query.agt == 'sm')">
                                    {{ this.getLanguage["GLU"]["N"] }} {{this.getLanguage["AG"]["SM"]}} {{ this.getLanguage["HFS"]["BD"] }}

                                </template>

                                <!-- MA -->
                                <template v-if="obj_Group.AT == 2 || (!obj_Group.AT && $route.query.agt == 'ma')">
                                    {{ this.getLanguage["GLU"]["N"] }} {{this.getLanguage["AG"]["MA"]}} {{ this.getLanguage["HFS"]["BD"] }}

                                </template>

                                <!-- Agent -->
                                <template v-if="obj_Group.AT == 3 || (!obj_Group.AT && $route.query.agt == 'a')">
                                    {{ this.getLanguage["GLU"]["N"] }} {{this.getLanguage["AG"]["A"]}} {{ this.getLanguage["HFS"]["BD"] }}
                                </template>

                            </template>
                            <template v-else>
                                <!-- SM -->
                                <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '1'">
                                    {{this.getLanguage["AG"]["SM"]}} {{ this.getLanguage["HFS"]["BD"] }}
                                </template>

                                <!-- MA -->
                                <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '2'">
                                    {{this.getLanguage["AG"]["MA"]}} {{ this.getLanguage["HFS"]["BD"] }}
                                </template>

                                <!-- Agent -->
                                <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '3'">
                                    {{this.getLanguage["AG"]["A"]}} {{ this.getLanguage["HFS"]["BD"] }}
                                </template>
                            </template>
                            <!-- Collapse Section Button -->
                            <i :class="setCollapseExpandIcon('DL')"></i>
                        </h6>
                    </CCol>
                </CRow>
                <!-- Previously: Downline Setting (System Balance, PT & BO Account Setting) Template -->
                <!-- New (TT9384) New SM Brand Details -->
                <template v-if="bool_showDS">
                    <CRow class="mx-0">
                        <!-- OEM -->
                        <CCol col="2" class="form-group" v-if="bool_isSeniorMasterLv">
                            <label class="col-form-label-sm">OEM<span class="required" /> :</label>
                            <treeselect :multiple="false"
                                        :options="dd_oem"
                                        :clearable="false"
                                        :placeholder="this.utilGetDDLanguage('AG.PG')"
                                        v-model="obj_Group.OEMI"
                                        :disabled="obj_Group.I > 0"
                                        ref="PGI" />
                            <span class="ErrMsg">{{ ValidationGroupErrMsg('PGI', 'PG') }}</span>
                        </CCol>
                        <!-- Active Switch -->
                        <CCol col="3" class="form-group" v-if="obj_Group.I != 0 && bool_isAgentType">
                            <label class="col-form-label-sm">{{getLanguage["TNMT"]["ACT"]}} :</label><br>
                            <label class="switch">
                                <input type="checkbox" v-model="obj_Group.RS" true-value="2" false-value="1">
                                <span class="slider round darkGreenRound"></span>
                            </label>
                        </CCol>
                        <CCol col="4" class="form-group" v-if="obj_Group.I == 0 && bool_isAgentType">
                            <label class="col-form-label-sm">{{this.getLanguage["BTN"]["C"]}} {{this.getLanguage["GL"]["FR"]}} :</label>
                            <customtreeselect :multiple="false"
                                              :options="dd_agentgroup2"
                                              :flat="true"
                                              :defaultExpandLevel="Infinity"
                                              :placeholder="this.utilGetDDLanguage('DM.AGI')"
                                              v-model="obj_Group.CPGIT"
                                              @input="copyGroup"
                                              :disabled="obj_Group.I > 0"
                                              ref="AGI" />
                        </CCol>
                    </CRow>
                    <CRow class="mx-0">
                        <!-- Parent Brand Dropdownbox -->
                        <CCol col="4" class="form-group" v-if="this.getUserInfo.AT != 3">
                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["PG"]}}<span class="required" /> :</label>
                            <customtreeselect :multiple="false"
                                              :options="dd_agentgroup"
                                              :defaultExpandLevel="Infinity"
                                              :clearable="false"
                                              :placeholder="this.utilGetDDLanguage('AG.PG')"
                                              v-model="obj_Group.PGIT"
                                              @input="ParentGroupChange"
                                              :disabled="obj_Group.I > 0 || bool_isAutoPopulate"
                                              ref="PGI" />
                            <span class="ErrMsg">{{ ValidationGroupErrMsg('PGI', 'PG') }}</span>
                        </CCol>
                        <CCol col="4" class="form-group">
                            <!-- Brand -->
                            <!-- New (TT9384) Upline Brand -->
                            <!--<label class="col-form-label-sm">{{this.getLanguage["AG"]["GN"]}}<span class="required" /> :</label>-->
                            <label class="col-form-label-sm">
                                <template v-if="obj_Group.I == 0">

                                    <!-- SM -->
                                    <template v-if="obj_Group.AT == 1 || (!obj_Group.AT && $route.query.agt == 'sm')">
                                        {{ this.getLanguage["GLU"]["N"] }} {{this.getLanguage["AG"]["ULB"]}}

                                    </template>

                                    <!-- MA -->
                                    <template v-if="obj_Group.AT == 2 || (!obj_Group.AT && $route.query.agt == 'ma')">
                                        {{ this.getLanguage["GLU"]["N"] }} {{this.getLanguage["AG"]["MA"]}} {{this.getLanguage["AG"]["GN"]}}
                                    </template>

                                    <!-- Agent -->
                                    <template v-if="obj_Group.AT == 3 || (!obj_Group.AT && $route.query.agt == 'a')">
                                        {{ this.getLanguage["GLU"]["N"] }} {{this.getLanguage["AG"]["AB"]}}
                                    </template>

                                </template>
                                <template v-else>
                                    <!-- SM -->
                                    <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '1'">
                                        {{this.getLanguage["AG"]["ULB"]}}
                                    </template>
                                    <!-- MA -->
                                    <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '2'">
                                        {{this.getLanguage["AG"]["MA"]}} {{this.getLanguage["AG"]["GN"]}}
                                    </template>
                                    <!-- Agent -->
                                    <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '3'">
                                        {{this.getLanguage["AG"]["AB"]}}
                                    </template>
                                </template>

                                <span class="required" /> :
                            </label>
                            <CInput :placeholder="getLanguage['AG']['GN']"
                                    size="sm"
                                    :value="obj_Group.GN"
                                    @change="v => obj_Group.GN = v"
                                    ref="GN"
                                    :disabled="this.getUserInfo.AT === 3 ||
                                           (this.$route.query.agi &&
                                           ['1', '2'].includes(this.$route.query.agi.split('-')[0]) &&
                                           (this.getUserInfo.AGT === 1 || this.getUserInfo.AGT === 2))">
                            </CInput>

                            <span class="ErrMsg">{{ ValidationGroupErrMsg('GN')}}</span>
                        </CCol>
                        <CCol col="4" class="form-group">
                            <!-- Brand Prefix Code -->
                            <label class="col-form-label-sm full-width">{{this.getLanguage['AG']['BPC']}}<span class="required" /> : </label>
                            <CInput :placeholder="getLanguage['AG']['PCC']"
                                    size="sm"
                                    :value="obj_Group.PC"
                                    class="inline inline50 uppercase"
                                    @change="ValidatePrefixCode($event)"
                                    maxlength="4"
                                    :disabled="obj_Group.I > 0 "
                                    ref="PC"></CInput>
                            <CButton class="inline inline50" color="outline-info" size="sm" @click="GeneratePrefixCode()" :disabled="getUserInfo.AT === 3 || obj_Group.I > 0">
                                <span class='plusIcon cil-loop-circular'></span>
                                {{ getLanguage["BTN"]["GEN"] }}
                            </CButton>
                            <span class="ErrMsg">{{ValidationGroupErrMsg('PC')}}{{this.str_prefixError}}</span>
                        </CCol>

                        <CCol col="3" class="form-group">
                            <!-- Lock System Balance Dropdownbox -->
                            <label class="col-form-label-sm full-width">
                                {{this.getLanguage['AG']['LB']}}
                                <div class="custom-tooltip">
                                    <i class="fa fa-question-circle"></i>
                                    <span class="custom-tooltiptext2" style="width:175px;left:-1000%">{{getLanguage["AG"]["LBD"]}}</span>
                                </div> :
                            </label>
                            <treeselect :multiple="false"
                                        :options="dd_yesno"
                                        :clearable="false"
                                        :disabled="!bool_isAgentType || this.getUserInfo.AT === 3"
                                        :placeholder="getLanguage['AG']['LB']"
                                        v-model="obj_Group.LB" />
                        </CCol>
                        <CCol col="6" class="form-group">
                            <!-- Previously: System Balance -->
                            <!-- (New TT9384) SM Maximum Credit Limit -->
                            <label class="col-form-label-sm full-width">
                                <!--{{  getLanguageOEMI(this.getUserInfo.OEMI,"AG","SB") }}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>-->

                                <template v-if="obj_Group.I == 0">
                                    <!-- SM -->
                                    <template v-if="obj_Group.AT == 1 || (!obj_Group.AT && $route.query.agt == 'sm')">
                                        {{this.getLanguage["AG"]["SM"]}}
                                    </template>
                                    <!-- MA -->
                                    <template v-if="obj_Group.AT == 2 || (!obj_Group.AT && $route.query.agt == 'ma')">
                                        {{this.getLanguage["AG"]["MA"]}}

                                    </template>
                                    <!-- Agent -->
                                    <template v-if="obj_Group.AT == 3 || (!obj_Group.AT && $route.query.agt == 'a')">
                                        {{this.getLanguage["AG"]["A"]}}
                                    </template>
                                </template>
                                <template v-else>
                                    <!-- SM -->
                                    <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '1'">
                                        {{this.getLanguage["AG"]["SM"]}}
                                    </template>
                                    <!-- MA -->
                                    <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '2'">
                                        {{this.getLanguage["AG"]["MA"]}}

                                    </template>
                                    <!-- Agent -->
                                    <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '3'">
                                        {{this.getLanguage["AG"]["A"]}}
                                    </template>
                                </template>

                                {{  getLanguageOEMI(this.getUserInfo.OEMI,"AG","MCL") }}<span class="required" /> : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                <span class="float-right label-tooltip" style="padding-right:1%;" v-if="showAvailableBalance()">{{ this.getLanguage['AG']['SBAB']}} : {{ this.dec_availablebalance }}</span>
                                <span class="float-right label-tooltip" style="padding-right:1%;" v-if="showAvailableBalance()">{{ this.getLanguage['AG']['SBAIUSD']}} : {{ this.dec_availablebalanceusd }}</span>
                            </label>
                            <treeselect :multiple="false"
                                        :options="dd_currency"
                                        :placeholder="getLanguage['AG']['C']"
                                        @input="CurrencyChange"
                                        v-model="obj_Group.DCI"
                                        class="inline inline40"
                                        :clearable="false"
                                        :disabled="obj_Group.I > 0"
                                        ref="DCI" />
                            <CInput :placeholder="getLanguageOEMI(this.getUserInfo.OEMI,'AG','SB')"
                                    size="sm"
                                    class="inline inline60"
                                    :value="ThousandSeparator(obj_Group.TB, getThousandCurrency ? 3 : 2)"
                                    @change="v => obj_Group.TB = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"
                                    :disabled="obj_Group.I > 0"
                                    ref="TB"></CInput>
                            <span class="ErrMsg inline inline40">{{ ValidationGroupErrMsg('DCI', 'DC') }}</span>
                            <span class="ErrMsg inline inline60" v-if="obj_Group.I == 0">{{ ValidationGroupErrMsg('TB', 'SB') }}</span>
                        </CCol>
                        <CCol col="3" class="form-group">
                            <!-- Position Taking -->
                            <label class="col-form-label-sm full-width">
                                {{ this.getLanguage["AG"]["PT"] }} (%)<span class="required" /> :
                                <span class="float-right label-tooltip" style="padding-right:1%;">{{ this.str_ptrange }}</span>
                            </label>
                            <CInput :placeholder="getLanguage['AG']['PT']"
                                    size="sm"
                                    :value="ThousandSeparator(obj_Group.DPT, 2)"
                                    @change="v => obj_Group.DPT = RemoveThousandSeparator(v, 2)"
                                    :disabled="obj_Group.I > 0 && this.getUserInfo.AT != 0"
                                    ref="PT"></CInput>
                            <span class="ErrMsg">{{ ValidationGroupErrMsg('PT') }}</span>
                        </CCol>
                        <CCol col="12" class="form-group">
                            <!-- White List IP -->
                            <label class="col-form-label-sm inline inline60">{{this.getLanguage["AG"]["WL"]}} :</label>
                            <CButton style="margin-top:5px;"
                                     color="outline-dark"
                                     size="sm"
                                     class="btn-small inline inline40"
                                     @click="addMyIP()"
                                     :disabled="this.$route.query.agi && ['1', '2'].includes(this.$route.query.agi.split('-')[0]) && (getUserInfo.AT === 1 || getUserInfo.AT === 2)">
                                <span class='plusIcon cil-plus'></span>{{ this.getLanguage["DM"]["MIP"] }}
                            </CButton>

                            <CInput class="inline inline60"
                                    :placeholder="getLanguage['AG']['WL']"
                                    size="sm"
                                    :value="obj_Group.WLIPS"
                                    @change="v => obj_Group.WLIPS = v"
                                    :disabled="this.$route.query.agi && ['1', '2'].includes(this.$route.query.agi.split('-')[0]) && (getUserInfo.AT === 1 || getUserInfo.AT === 2)">
                            </CInput>

                            <CButton style="margin-top:5px;"
                                     color="outline-dark"
                                     size="sm"
                                     class="btn-small inline inline40"
                                     @click="addWhiteListIP()"
                                     :disabled="this.$route.query.agi && ['1', '2'].includes(this.$route.query.agi.split('-')[0]) && (getUserInfo.AT === 1 || getUserInfo.AT === 2)">
                                <span class='plusIcon cil-plus'></span>{{ this.getLanguage["BTN"]["AD"] }}
                            </CButton>

                            <CRow style="padding-top: 20px;padding-left: 15px;display: block;">
                                <table class="custom-table custom-table-inPopUp afb-blue">
                                    <thead>
                                        <tr>
                                            <th style="width: 30px;">{{this.getLanguage['GL']['ACT']}}</th>
                                            <th style="width: 30px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                            <th>{{this.getLanguage['AG']['WL']}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <td colspan="100%" v-if="obj_Group.WhiteListIP == 0 || !obj_Group.WhiteListIP">{{this.getLanguage['GL']['NR']}}</td>
                                    <tr v-for="(data,index) in obj_Group.WhiteListIP">
                                        <td>
                                            <span id="actionBtnCol">
                                                <i class="cil-trash" @click='removeWhiteListIP(index)'></i> <!--here Remove -->
                                            </span>
                                        </td>
                                        <td>{{ index+1 }}</td>
                                        <td>{{ data.WLIPS }}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </CRow>
                        </CCol>
                        <!-- Save Button for Downline Setting -->
                        <CCol col="12">
                            <div style="text-align:center;margin-top:20px" v-if="(this.$route.query.agi !== undefined && this.$route.query.di !== undefined && this.$route.query.lci !== undefined && this.$route.query.acsi !== undefined && this.$route.query.bai !== undefined)">
                                <!--<CButton color="outline-info" size="sm" @click="saveSelfService('ds')">-->
                                <CButton color="outline-info" size="sm" @click="saveDownlineConfig()">
                                    <span class='fa fa-save mr-2'></span>
                                    {{ getLanguage["BTN"]["SV"] }}
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                </template>

                <!-- Previously: Agent Admin Account Setting -->
                <!-- (New TT9384) New SM Admin Account -->
                <CRow class="mx-0" v-if="obj_Group.I==0">
                    <CCol col="12">
                        <h6 class="card-title section-title2"
                            data-section="boac"
                            @click="showSectionBasedRole('boac')"
                            :class="selectedSection === 'boac' ? 'bg-blue text-white' : ''">
                            <!--<span :class="(!this.$v.obj_Group.$error && !this.$v.obj_Group.Agent.$error && bool_groupCV) ? 'bg-success' : ''">-->
                            <span :class="getSectionClasses('boac', !$v.obj_Group.$error && bool_groupCV)">
                                {{ getSectionIndex(2) }}
                            </span>

                            <!--{{this.getLanguage["AG"]["BOAS"]}}-->
                        <template v-if="obj_Group.I == 0">
                            <!-- SM -->
                            <template v-if="obj_Group.AT == 1 || (!obj_Group.AT && $route.query.agt == 'sm')">

                                {{ this.getLanguage["GLU"]["N"] }} {{ this.getLanguage["AG"]["SM"] }} {{this.getLanguage["AG"]["ADACC"]}}

                            </template>

                            <!-- MA -->
                            <template v-if="obj_Group.AT == 2 || (!obj_Group.AT && $route.query.agt == 'ma')">

                                {{ this.getLanguage["GLU"]["N"] }} {{ this.getLanguage["AG"]["MA"] }} {{this.getLanguage["AG"]["ADACC"]}}

                            </template>

                            <!-- Agent -->
                            <template v-if="obj_Group.AT == 3 || (!obj_Group.AT && $route.query.agt == 'a')">

                                {{ this.getLanguage["GLU"]["N"] }} {{ this.getLanguage["AG"]["A"] }} {{this.getLanguage["AG"]["ADACC"]}}
                            </template>

                        </template>
                            <template v-else>
                                <!-- SM -->
                                <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '1'">
                                    {{ this.getLanguage["AG"]["SM"] }} {{this.getLanguage["AG"]["ADACC"]}}
                                </template>

                                <!-- MA -->
                                <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '2'">
                                    {{ this.getLanguage["AG"]["MA"] }} {{this.getLanguage["AG"]["ADACC"]}}
                                </template>

                                <!-- Agent -->
                                <template v-if="this.$route.query.agi && this.$route.query.agi.split('-')[0] === '3'">
                                    {{ this.getLanguage["AG"]["A"] }} {{this.getLanguage["AG"]["ADACC"]}}
                                </template>
                            </template>
                            <i :class="setCollapseExpandIcon('BOA')"></i>
                        </h6>
                    </CCol>
                </CRow>
                <!-- Agent Admin Account Template -->
                <template v-if="bool_showBOAC && obj_Group.I==0">
                    <CRow class="mx-0">
                        <CCol col="6" class="form-group">
                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["UU"]}}<span class="required" /> :</label>
                            <CInput :placeholder="getLanguage['AG']['UU']"
                                    size="sm"
                                    :value="obj_Group.Agent.U"
                                    @change="v => obj_Group.Agent.U = v" autocomplete="off"></CInput>
                            <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.U', 'UU') }}</span>
                        </CCol>
                        <CCol col="6" class="form-group">
                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["UDN"]}}<span class="required" /> :</label>
                            <CInput :placeholder="getLanguage['AG']['UDN']"
                                    size="sm"
                                    :value="obj_Group.Agent.DN"
                                    @change="v => obj_Group.Agent.DN = v"
                                    ref="Agent.UP" autocomplete="off"></CInput>
                            <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.DN', 'UDN') }}</span>
                        </CCol>
                        <CCol col="6" class="form-group">
                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["UUP"]}}<span class="required" />
                                <div class="custom-tooltip" style="position: unset;">
                                    <i class="fa fa-question-circle"></i>
                                    <span class="custom-tooltiptext" style="width: 350px; left: unset; margin-left: -10%">{{getLanguage["AG"]["UPF"]}}</span>
                                </div>:
                            </label>
                            <CInput type="password"
                                    :placeholder="getLanguage['AG']['UUP']"
                                    size="sm"
                                    :value="obj_Group.Agent.UP"
                                    @change="v => obj_Group.Agent.UP = v"
                                    ref="Agent.UP" autocomplete="off"></CInput>
                            <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.UP', 'UUP') }}</span>
                        </CCol>
                        <CCol col="6" class="form-group">
                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["UCUP"]}}<span class="required" /> :</label>
                            <CInput type="password"
                                    :placeholder="getLanguage['AG']['UCUP']"
                                    size="sm"
                                    :value="obj_Group.Agent.CUP"
                                    @change="v => obj_Group.Agent.CUP = v"
                                    ref="Agent.CUP" autocomplete="off"></CInput>
                            <span class="ErrMsg">{{ ValidationGroupErrMsg('Agent.CUP', 'UCUP') }}</span>
                        </CCol>

                        <CCol col="12">
                            <div style="text-align:center;margin-top:20px" v-if="(this.$route.query.agi !== undefined && this.$route.query.di !== undefined && this.$route.query.lci !== undefined && this.$route.query.acsi !== undefined && this.$route.query.bai !== undefined)">
                                <CButton color="outline-info" size="sm" @click="saveSelfService('boac')">
                                    <span class='fa fa-save mr-2'></span>
                                    {{ getLanguage["BTN"]["SV"] }}
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                </template>

                <!-- Language & Currency & Game Provider Setting Title -->
                <CRow class="mx-0" v-if="bool_isAgentType">
                    <CCol col="12">
                        <h6 class="card-title section-title2"
                            data-section="dss"
                            @click="showSectionBasedRole('dss')"
                            :class="selectedSection === 'dss' ? 'bg-blue text-white' : ''">
                            <!--<span :class="(!this.$v.obj_Group.$error && bool_groupCV) ? 'bg-success' : ''">-->
                            <span :class="getSectionClasses('dss', !$v.obj_Group.$error && bool_groupCV)">
                                {{ getSectionIndex(3) }}
                            </span>
                            {{this.getLanguage["AG"]["DSS"]}}
                            <i :class="setCollapseExpandIcon('DS')"></i>
                        </h6>
                    </CCol>
                </CRow>
                <!-- Language & Currency & Game Provider Setting Template -->
                <template v-if="bool_showDSS && bool_isAgentType">
                    <CRow class="mx-0">
                        <!-- Languages -->
                        <CCol col="12" class="form-group">
                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["L"]}} <span class="badge badge-success mx-2" style="background: #027202" v-if="obj_Group.Language.length > 0">{{obj_Group.Language.length}}</span>:</label>
                            <div class="card p-2 tempScrollbar" style="height: 100px; overflow: hidden scroll;">
                                <div class="row">
                                    <!-- Select All Languages -->
                                    <div class="col-md-2 text-red">
                                        <div class="d-flex">
                                            <input type="checkbox" id="alllang" class="inline custom-checkbox" v-model="btnLang_checkedAll" @change="selectLangAll()" :disabled="!bool_isAgentType" />
                                            <label for="alllang" class="col-form-label-sm font-weight-bold ml-2">{{getLanguage["GL"]["ALL2"]}}</label>
                                        </div>
                                    </div>

                                    <!-- Supported Languages -->
                                    <div class="col-md-2" v-for="lang in dd_language_wall[0].children">
                                        <div class="d-flex">
                                            <input type="checkbox" :id="'lang'+lang.id" class="inline custom-checkbox" v-model="obj_Group.Language" :value="lang.id" :disabled="lang.id == 'en' || !bool_isAgentType" @change="checkSelectAllLangButton(lang.id)" />
                                            <label :for="'lang'+lang.id" class="col-form-label-sm font-weight-bold ml-2">{{lang.label}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="ErrMsg">{{ ValidationGroupErrMsg('L') }}</span>
                        </CCol>
                        <!-- Currency -->
                        <CCol col="12" class="form-group">
                            <label class="col-form-label-sm">{{this.getLanguage["AG"]["C"]}}<span class="required" /> <span class="badge badge-success mx-2" style="background: #027202" v-if="obj_Group.CurrencyIds.length > 0">{{obj_Group.CurrencyIds.length}}</span>:</label>
                            <div class="card p-2 tempScrollbar" style="height: 100px; overflow: hidden scroll;">
                                <div class="row">
                                    <!-- Select All Currency -->
                                    <div class="col-md-2 text-red">
                                        <div class="d-flex">
                                            <input type="checkbox" id="allcur" class="inline custom-checkbox" @change="selectCurAll()" v-model="btnCur_checkedAll" :disabled="!bool_isAgentType " />
                                            <label for="allcur" class="col-form-label-sm font-weight-bold ml-2">{{getLanguage["GL"]["ALL2"]}} </label>
                                        </div>
                                    </div>

                                    <!-- Supported Currency -->
                                    <div class="col-md-2" v-for="cur in dd_currency_wall[0].children">
                                        <div class="d-flex">
                                            <input type="checkbox" :id="'cur'+cur.id" class="inline custom-checkbox" v-model="obj_Group.CurrencyIds" :value="cur.id" :disabled="!bool_isAgentType " @change="checkSelectAllCurButton" />
                                            <label :for="'cur'+cur.id" class="col-form-label-sm font-weight-bold ml-2">{{cur.label}}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="ErrMsg">{{ ValidationGroupErrMsg('CI', 'C') }}</span>
                        </CCol>
                        <CCol col="12" class="form-group">
                            <label class="col-form-label-sm">
                                <!-- Game Provider -->
                                {{this.getLanguage["AG"]["GP"]}}
                                <div class="custom-tooltip">
                                    <i class="fa fa-question-circle"></i>
                                    <span class="custom-tooltiptext2" style="width: 150px; bottom: -5px; left: 20px;">
                                        <span class="mandatory_Field">**</span> = {{getLanguage["WLRPT"]["SA"]}} {{getLanguage["AFF"]["BN"]}}
                                        <span v-if="checkSpecialProviders"><br /><span class="special_Function">*</span> = {{getLanguage["AG"]["SP"]}} </span>
                                    </span>
                                </div>
                                <span class="required" />
                                <span class="badge badge-success mx-2" style="background: #027202" v-if="obj_Group.GameProviderIds.length > 0">{{obj_Group.GameProviderIds.length}}</span>:

                                <div class="ml-2 d-inline-block text-red float-right">
                                    <div class="d-flex">
                                        <input type="checkbox" id="SAGP" v-model="btnGP2_checkedAll" @click="selectGPAll()">
                                        <label class="ml-2 font-weight-bold" for="SAGP">{{getLanguage["TORPT"]["SA"]}} {{getLanguage["AG"]["GP"]}}</label>
                                    </div>
                                </div>
                            </label>

                            <!-- Game Provider Category -->
                            <div class="nav nav-tabs" id="nav-tab" role="tablist" style="font-size:12px">
                                <button :class="(selectedGPCat == '0-'+item.id)? 'p-2 nav-link active' : 'p-2 nav-link'" @click="selectedGPCat = '0-'+item.id" v-for="(item, index) in dd_gameprovider_cat" :key="index">{{renderCategoryName(item.label)}}</button>
                            </div>

                            <!-- Game Provider List -->
                            <div class="card tab-content p-2 tempScrollbar" style="height: 150px; overflow: hidden scroll;">
                                <div :class="item.id == selectedGPCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'" :id="'gp0-'+catIdx" v-for="(item, catIdx) in dd_gameprovider">
                                    <div class="row">
                                        <div class="col-md-4 text-red">
                                            <div class="d-flex">
                                                <input type="checkbox" :id="'gpcat'+item.id" class="inline custom-checkbox" @click="selectGPCatAll(catIdx)" v-model="btnGP_checkedAll[catIdx]" :disabled="!bool_isAgentType" />
                                                <label :for="'gpcat'+item.id" class="col-form-label-sm font-weight-bold ml-2">{{getLanguage["GL"]["ALL2"]}} </label>
                                            </div>
                                        </div>

                                        <!-- House Brand -->
                                        <div class="col-md-4" v-for="gp in item.children" v-if="constHouseBrand.includes(gp.id)">
                                            <div class="d-flex">
                                                <input type="checkbox" :id="'gp'+gp.id" class="inline custom-checkbox" v-model="obj_Group.GameProviderIds" :value="gp.id" disabled />
                                                <label :for="'gp'+gp.id" class="col-form-label-sm font-weight-bold ml-2">{{gp.label}} </label><span class="mandatory_Field">**</span>
                                                <label v-if="bool_isAgentType && obj_Group.I == 0" class="col-form-label-sm font-weight-bold ml-2" style='color: #3c4b64; font-size: smaller; font-weight: 600;'>{{ formatEstimatePT(gp.id, obj_Group.DPT == null || obj_Group.DPT == "" ? obj_Group.MaxPT : obj_Group.DPT) }} </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4" v-for="gp in item.children" v-if="SpecialProviders.includes(gp.id)">
                                            <div class="d-flex">
                                                <input type="checkbox" :id="'gp'+gp.id" class="inline custom-checkbox" v-model="obj_Group.GameProviderIds" :value="gp.id" @change="checkSelectAllGPButton" />
                                                <label :for="'gp'+gp.id" class="col-form-label-sm font-weight-bold ml-2" style='color: green;'>{{gp.label}} </label><span class="special_Function">*</span>
                                                <label v-if="bool_isAgentType && obj_Group.I == 0" class="col-form-label-sm font-weight-bold ml-2" style='color: #3c4b64; font-size: smaller; font-weight: 600;'>{{ formatEstimatePT(gp.id, obj_Group.DPT == null || obj_Group.DPT == "" ? obj_Group.MaxPT : obj_Group.DPT) }} </label>
                                            </div>
                                        </div>
                                        <div class="col-md-4" v-for="gp in item.children" v-if="!constHouseBrand.includes(gp.id) && !SpecialProviders.includes(gp.id)">
                                            <div class="d-flex">
                                                <input type="checkbox" :id="'gp'+gp.id" class="inline custom-checkbox" v-model="obj_Group.GameProviderIds" :value="gp.id" :disabled="!bool_isAgentType" @change="checkSelectAllGPButton" />
                                                <label :for="'gp'+gp.id" class="col-form-label-sm font-weight-bold ml-2">{{gp.label}} </label>
                                                <label v-if="bool_isAgentType && obj_Group.I == 0" class="col-form-label-sm font-weight-bold ml-2" style='color: #3c4b64; font-size: smaller; font-weight: 600;'>{{ formatEstimatePT(gp.id, obj_Group.DPT == null || obj_Group.DPT == "" ? obj_Group.MaxPT : obj_Group.DPT) }} </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="ErrMsg">{{ ValidationGroupErrMsg('GPI', 'GP') }}</span>
                        </CCol>

                        <CCol col="12" class="form-group" v-if="obj_Group.I > 0">
                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["PG"]}}:</label>
                            <div class="nav nav-tabs" id="nav-tab" role="tablist" style="font-size:12px">
                                <button :class="(selectedPGCat == item)? 'nav-link active' : 'nav-link'" @click="selectedPGCat = item" v-for="(item, index) in dd_paymentgateway_cat" :key="index">{{item}}</button>
                            </div>
                            <div class="card tab-content p-2 tempScrollbar payment-gateway" style="height: 300px; overflow: hidden scroll;">
                                <!-- Help2Pay Payment Method -->
                                <div :class="'Help2pay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && (checkCurrencyID('MYR') || checkCurrencyID('THB') || checkCurrencyID('VND') || checkCurrencyID('IDR'))">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['H2PU'] + ' :'"
                                                        :placeholder="getLanguage['AG']['H2PU']"
                                                        size="sm"
                                                        :value="obj_Group.H2PU"
                                                        @change="v => obj_Group.H2PU = v"
                                                        ref="H2PU"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('H2PU') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{this.getLanguage["AG"]["H2PCC"]}} :</label>
                                                <treeselect :multiple="true"
                                                            :options="dd_currency_h2p"
                                                            :defaultExpandLevel="1"
                                                            valueConsistsOf="LEAF_PRIORITY"
                                                            :placeholder="getLanguage['AG']['H2PCC']"
                                                            v-model="obj_Group.H2PCurrencyCodes" />
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['H2PMC'] + ' :'"
                                                        :placeholder="getLanguage['AG']['H2PMC']"
                                                        size="sm"
                                                        :value="obj_Group.H2PMC"
                                                        @change="v => obj_Group.H2PMC = v"
                                                        ref="H2PMC"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('H2PMC') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['H2PSC'] + ' :'"
                                                        :placeholder="getLanguage['AG']['H2PSC']"
                                                        size="sm"
                                                        :value="obj_Group.H2PSC"
                                                        @change="v => obj_Group.H2PSC = v"
                                                        ref="H2PSC"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('H2PSC') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- OOP Payment Method -->
                                <div :class="'OOPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('THB')">
                                        <CRow>
                                            <CCol col="12" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPTHMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPTHMN']"
                                                        size="sm"
                                                        :value="obj_Group.OOPTHMN"
                                                        @change="v => obj_Group.OOPTHMN = v"
                                                        ref="OOPTHMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPTHMN') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPTHAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPTHAS']"
                                                        size="sm"
                                                        :value="obj_Group.OOPTHAS"
                                                        @change="v => obj_Group.OOPTHAS = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPTHAS') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPTHSK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPTHSK']"
                                                        size="sm"
                                                        :value="obj_Group.OOPTHSK"
                                                        @change="v => obj_Group.OOPTHSK = v"
                                                        ref="OOPTHSK"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPTHSK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('VND')">
                                        <CRow>
                                            <CCol col="12" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPVIMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPVIMN']"
                                                        size="sm"
                                                        :value="obj_Group.OOPVIMN"
                                                        @change="v => obj_Group.OOPVIMN = v"
                                                        ref="OOPVIMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPVIMN') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPVIAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPVIAS']"
                                                        size="sm"
                                                        :value="obj_Group.OOPVIAS"
                                                        @change="v => obj_Group.OOPVIAS = v"
                                                        ref="OOPVIAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPVIAS') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPVISK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPVISK']"
                                                        size="sm"
                                                        :value="obj_Group.OOPVISK"
                                                        @change="v => obj_Group.OOPVISK = v"
                                                        ref="OOPVISK"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPVISK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('IDR')">
                                        <CRow>
                                            <CCol col="12" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPIDMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPIDMN']"
                                                        size="sm"
                                                        :value="obj_Group.OOPIDMN"
                                                        @change="v => obj_Group.OOPIDMN = v"
                                                        ref="OOPIDMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPIDMN') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPIDAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPIDAS']"
                                                        size="sm"
                                                        :value="obj_Group.OOPIDAS"
                                                        @change="v => obj_Group.OOPIDAS = v"
                                                        ref="OOPIDAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPIDAS') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['OOPIDSK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['OOPIDSK']"
                                                        size="sm"
                                                        :value="obj_Group.OOPIDSK"
                                                        @change="v => obj_Group.OOPIDSK = v"
                                                        ref="OOPIDSK"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('OOPIDSK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- EZPay Payment Method -->
                                <div :class="'EZPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('USD')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPUSDMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPUSDMN']"
                                                        size="sm"
                                                        :value="obj_Group.EZPUSDMN"
                                                        @change="v => obj_Group.EZPUSDMN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPUSDMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPUSDAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPUSDAS']"
                                                        size="sm"
                                                        :value="obj_Group.EZPUSDAS"
                                                        @change="v => obj_Group.EZPUSDAS = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPUSDAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('IDR')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPIDRMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPIDRMN']"
                                                        size="sm"
                                                        :value="obj_Group.EZPIDRMN"
                                                        @change="v => obj_Group.EZPIDRMN = v"
                                                        ref="EZPIDRMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPIDRMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPIDRAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPIDRAS']"
                                                        size="sm"
                                                        :value="obj_Group.EZPIDRAS"
                                                        @change="v => obj_Group.EZPIDRAS = v"
                                                        ref="EZPIDRAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPIDRAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('MYR')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPMYRMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPMYRMN']"
                                                        size="sm"
                                                        :value="obj_Group.EZPMYRMN"
                                                        @change="v => obj_Group.EZPMYRMN = v"
                                                        ref="EZPMYRMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPMYRMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPMYRAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPMYRAS']"
                                                        size="sm"
                                                        :value="obj_Group.EZPMYRAS"
                                                        @change="v => obj_Group.EZPMYRAS = v"
                                                        ref="EZPMYRAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPMYRAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('THB')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPTHBMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPTHBMN']"
                                                        size="sm"
                                                        :value="obj_Group.EZPTHBMN"
                                                        @change="v => obj_Group.EZPTHBMN = v"
                                                        ref="EZPTHBMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPTHBMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPTHBAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPTHBAS']"
                                                        size="sm"
                                                        :value="obj_Group.EZPTHBAS"
                                                        @change="v => obj_Group.EZPTHBAS = v"
                                                        ref="EZPTHBAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPTHBAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('VND')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPVNDMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPVNDMN']"
                                                        size="sm"
                                                        :value="obj_Group.EZPVNDMN"
                                                        @change="v => obj_Group.EZPVNDMN = v"
                                                        ref="EZPVNDMN"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPVNDMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['EZPVNDAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['EZPVNDAS']"
                                                        size="sm"
                                                        :value="obj_Group.EZPVNDAS"
                                                        @change="v => obj_Group.EZPVNDAS = v"
                                                        ref="EZPVNDAS"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('EZPVNDAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- TruePay Payment Method -->
                                <div :class="'TruePay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('VND')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['TUPVNDMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['TUPVNDMN']"
                                                        size="sm"
                                                        :value="obj_Group.TUPVNDMN"
                                                        @change="v => obj_Group.TUPVNDMN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('TUPVNDMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['TUPVNDAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['TUPVNDAS']"
                                                        size="sm"
                                                        :value="obj_Group.TUPVNDAS"
                                                        @change="v => obj_Group.TUPVNDAS = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('TUPVNDAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('MYR')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['TUPMYRMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['TUPMYRMN']"
                                                        size="sm"
                                                        :value="obj_Group.TUPMYRMN"
                                                        @change="v => obj_Group.TUPMYRMN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('TUPMYRMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['TUPMYRAS'] + ' :'"
                                                        :placeholder="getLanguage['AG']['TUPMYRAS']"
                                                        size="sm"
                                                        :value="obj_Group.TUPMYRAS"
                                                        @change="v => obj_Group.TUPMYRAS = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('TUPMYRAS') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- XFuoo Payment Method -->
                                <div :class="'XFuoo' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('THB')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFTHN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFTHN']"
                                                        size="sm"
                                                        :value="obj_Group.XFTHN"
                                                        @change="v => obj_Group.XFTHN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFTHN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFTHK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFTHK']"
                                                        size="sm"
                                                        :value="obj_Group.XFTHK"
                                                        @change="v => obj_Group.XFTHK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFTHK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('VND')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFVIN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFVIN']"
                                                        size="sm"
                                                        :value="obj_Group.XFVIN"
                                                        @change="v => obj_Group.XFVIN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFVIN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFVIK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFVIK']"
                                                        size="sm"
                                                        :value="obj_Group.XFVIK"
                                                        @change="v => obj_Group.XFVIK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFVIK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('MYR')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFMYRN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFMYRN']"
                                                        size="sm"
                                                        :value="obj_Group.XFMYRN"
                                                        @change="v => obj_Group.XFMYRN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFMYRN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFMYRK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFMYRK']"
                                                        size="sm"
                                                        :value="obj_Group.XFMYRK"
                                                        @change="v => obj_Group.XFMYRK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFMYRK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('USD')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFUSDTN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFUSDTN']"
                                                        size="sm"
                                                        :value="obj_Group.XFUSDTN"
                                                        @change="v => obj_Group.XFUSDTN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFUSDTN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFUSDTK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFUSDTK']"
                                                        size="sm"
                                                        :value="obj_Group.XFUSDTK"
                                                        @change="v => obj_Group.XFUSDTK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFUSDTK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('IDR')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFIDRN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFIDRN']"
                                                        size="sm"
                                                        :value="obj_Group.XFIDRN"
                                                        @change="v => obj_Group.XFIDRN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFIDRN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['XFIDRK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['XFIDRK']"
                                                        size="sm"
                                                        :value="obj_Group.XFIDRK"
                                                        @change="v => obj_Group.XFIDRK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('XFIDRK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- StarPay Payment Method -->
                                <div :class="'StarPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1) && checkCurrencyID('IDR')">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['SPMN'] + ' :'"
                                                        :placeholder="getLanguage['AG']['SPMN']"
                                                        size="sm"
                                                        :value="obj_Group.SPMN"
                                                        @change="v => obj_Group.SPMN = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('SPMN') }}</span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <CInput :label="getLanguage['AG']['SPAK'] + ' :'"
                                                        :placeholder="getLanguage['AG']['SPAK']"
                                                        size="sm"
                                                        :value="obj_Group.SPAK"
                                                        @change="v => obj_Group.SPAK = v"></CInput>
                                                <span class="ErrMsg">{{ ValidationGroupErrMsg('SPAK') }}</span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- SurePay Payment Method -->
                                <div :class="'SurePay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1)  && checkCurrencyID('MYR') && obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='20'" v-for="(pmgw,index) in obj_Group.PMGW">
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUMYRCN'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUMYRCN']"
                                                            size="sm"
                                                            :value="obj_Group.SUMYRCN"
                                                            @change="v => obj_Group.SUMYRCN = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUMYRCN') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUMYRMN'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUMYRMN']"
                                                            size="sm"
                                                            :value="obj_Group.SUMYRMN"
                                                            @change="v => obj_Group.SUMYRMN = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUMYRMN') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUMYRAK'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUMYRAK']"
                                                            size="sm"
                                                            :value="obj_Group.SUMYRAK"
                                                            @change="v => obj_Group.SUMYRAK = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUMYRAK') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <!--<CInput :label="getLanguage['AG']['SUMYRPOAK'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUMYRPOAK']"
                                                            size="sm"
                                                            :value="obj_Group.SUMYRPOAK"
                                                            @change="v => obj_Group.SUMYRPOAK = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUMYRPOAK') }}</span>-->

                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUMYRPOAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUMYRPOAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>

                                                </CCol>
                                            </CRow>
                                        </div>
                                        <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1)  && checkCurrencyID('THB') && obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='27'" v-for="(pmgw,index) in obj_Group.PMGW">
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUTHBCN'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUTHBCN']"
                                                            size="sm"
                                                            :value="obj_Group.SUTHBCN"
                                                            @change="v => obj_Group.SUTHBCN = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUTHBCN') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUTHBMN'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUTHBMN']"
                                                            size="sm"
                                                            :value="obj_Group.SUTHBMN"
                                                            @change="v => obj_Group.SUTHBMN = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUTHBMN') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUTHBAK'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUTHBAK']"
                                                            size="sm"
                                                            :value="obj_Group.SUTHBAK"
                                                            @change="v => obj_Group.SUTHBAK = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUTHBAK') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUTHBPOAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUTHBPOAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>

                                                    <!--<CInput :label="getLanguage['AG']['SUTHBPOAK'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUTHBPOAK']"
                                                            size="sm"
                                                            :value="obj_Group.SUTHBPOAK"
                                                            @change="v => obj_Group.SUTHBPOAK = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUTHBPOAK') }}</span>-->
                                                </CCol>
                                            </CRow>
                                        </div>
                                        <div v-if="!obj_Group.ICT && bool_isAgentType && checkModuleAccess('ASS', 'AGS', 1)  && checkCurrencyID('SGD')">
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUSGDCN'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUSGDCN']"
                                                            size="sm"
                                                            :value="obj_Group.SUSGDCN"
                                                            @change="v => obj_Group.SUSGDCN = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUSGDCN') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUSGDMN'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUSGDMN']"
                                                            size="sm"
                                                            :value="obj_Group.SUSGDMN"
                                                            @change="v => obj_Group.SUSGDMN = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUSGDMN') }}</span>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <CInput :label="getLanguage['AG']['SUSGDAK'] + ' :'"
                                                            :placeholder="getLanguage['AG']['SUSGDAK']"
                                                            size="sm"
                                                            :value="obj_Group.SUSGDAK"
                                                            @change="v => obj_Group.SUSGDAK = v"></CInput>
                                                    <span class="ErrMsg">{{ ValidationGroupErrMsg('SUSGDAK') }}</span>
                                                </CCol>
                                            </CRow>
                                        </div>
                                        <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='44' && checkCurrencyID('IDR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                            <CRow>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUIDRCN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUIDRCN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV1"
                                                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUIDRMN"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUIDRMN']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV2"
                                                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUIDRAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUIDRAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV3"
                                                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                                </CCol>
                                                <CCol col="4" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["AG"]["SUIDRPOAK"]}}:</label>
                                                    <CInput :placeholder="getLanguage['AG']['SUIDRPOAK']"
                                                            size="sm"
                                                            :value="obj_Group.PMGW[index].SV4"
                                                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                                </CCol>
                                            </CRow>
                                        </div>
                                    </div>
                                <!-- CPay Payment Method -->
                                <div :class="'CPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='30' && (checkCurrencyID('USD') || checkCurrencyID('MYR') || checkCurrencyID('IDR') || checkCurrencyID('KHR') || checkCurrencyID('THB')|| checkCurrencyID('VND')|| checkCurrencyID('HKD')|| checkCurrencyID('AED')|| checkCurrencyID('MMK')|| checkCurrencyID('INR'))" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["CPAYMI"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['CPAYMI']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["CPAYMK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['CPAYMK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- FUPay Payment Method -->
                                <div :class="'FuPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='31' && checkCurrencyID('INR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["FUPMN"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['FUPMN']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["FUPAK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['FUPAK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- Truemoney Payment Method -->
                                <div :class="'TrueMoney' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='32' && checkCurrencyID('THB')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["TMONEYMI"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['TMONEYMI']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["TMONEYAK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['TMONEYAK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- SmartPay Payment Method -->
                                <div :class="'SmartPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='33' && checkCurrencyID('THB')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SMPMC"]}}</label>
                                                <CInput :placeholder="getLanguage['AG']['SMPMC']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SMPKY"]}}</label>
                                                <CInput :placeholder="getLanguage['AG']['SMPKY']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='45' && checkCurrencyID('IDR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SMPIDRMC"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SMPIDRMC']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SMPIDRKY"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SMPIDRKY']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- U2pay Payment Method -->
                                <div :class="'U2Pay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='34' && checkCurrencyID('IDR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRGMN"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['U2PIDRGMN']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRGAS"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['U2PIDRGAS']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRGK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['U2PIDRGK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV3"
                                                        @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRDMN"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['U2PIDRDMN']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV4"
                                                        @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                            </CCol>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRDAS"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['U2PIDRDAS']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV5"
                                                        @change="v => obj_Group.PMGW[index].SV5 = v"></CInput>
                                            </CCol>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDRDK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['U2PIDRDK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV6"
                                                        @change="v => obj_Group.PMGW[index].SV6 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDROMN"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['U2PIDROMN']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV7"
                                                        @change="v => obj_Group.PMGW[index].SV7 = v"></CInput>
                                            </CCol>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDROAS"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['U2PIDROAS']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV8"
                                                        @change="v => obj_Group.PMGW[index].SV8 = v"></CInput>
                                            </CCol>
                                            <CCol col="4" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["U2PIDROK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['U2PIDROK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV9"
                                                        @change="v => obj_Group.PMGW[index].SV9 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- LuckyPay Payment Method -->
                                <div :class="'LuckyPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='39' && checkCurrencyID('THB')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["LPTHBCC"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['LPTHBCC']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["LPTHBPK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['LPTHBPK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- BCPay Payment Method -->
                                <div :class="'BCPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='43' && checkCurrencyID('BRL')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["BCPDA"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['BCPDA']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["BCPDK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['BCPDK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["BCPWA"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['BCPWA']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV3"
                                                        @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["BCPWK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['BCPWK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV4"
                                                        @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- FPG Payment Method -->
                                <div :class="'FPG' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='46' && checkCurrencyID('MYR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["FPGSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['FPGSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["FPGSV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['FPGSV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- PGAuto Payment Method -->
                                <div :class="'MPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='47' && checkCurrencyID('IDR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["PGASV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['PGASV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["PGASV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['PGASV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='47' && checkCurrencyID('IDR2')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["PGASV1IDR2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['PGASV1IDR2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["PGASV2IDR2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['PGASV2IDR2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- AD3P Payment Method -->
                                <div :class="'AutoDepo(Ext)' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='50' && checkCurrencyID('THB')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PAG"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AD3PAG']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV3"
                                                        @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PDM"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AD3PDM']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PAK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AD3PAK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PDURL"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AD3PDURL']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV5"
                                                        @change="v => obj_Group.PMGW[index].SV5 = v"></CInput>
                                            </CCol>
                                            <CCol col="12" class="form-group">
                                                <label class="col-form-label-sm mr-2">{{getLanguage["AG"]["AD3PWT"]}} ?</label>
                                                <br />
                                                <label class="switch">
                                                    <input type="checkbox" :checked="obj_Group.PMGW[index].SV4.toLowerCase() == 'true'" @change="v => obj_Group.PMGW[index].SV4 = v.target.checked" />
                                                    <span class="slider round"></span>
                                                </label>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PWURL"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AD3PWURL']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV6"
                                                        @change="v => obj_Group.PMGW[index].SV6 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PREFURL"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AD3PREFURL']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV10"
                                                        @change="v => obj_Group.PMGW[index].SV10 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PSBL"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AD3PSBL']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV8"
                                                        @change="v => obj_Group.PMGW[index].SV8 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PSBAL"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AD3PSBAL']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV9"
                                                        @change="v => obj_Group.PMGW[index].SV9 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AD3PSB"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AD3PSB']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV7"
                                                        @change="v => obj_Group.PMGW[index].SV7 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- Pompay/Chapter B Payment Method -->
                                <div :class="'Chapter B' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='49' && checkCurrencyID('THB')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["PPCI"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['PPCI']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["PPCS"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['PPCS']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- DoitNow Payment Method -->
                                <div :class="'DoitNow' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='51' && checkCurrencyID('MYR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["DNCI"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['DNCI']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["DNCS"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['DNCS']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- AgogoPay Payment Method -->
                                <div :class="'AgogoPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='52' && checkCurrencyID('VND')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AGPSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AGPSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AGPSV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AGPSV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- 918Pay Payment Method -->
                                <div :class="'918Pay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='53' && checkCurrencyID('VND')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["918PVNDMN"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['918PVNDMN']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["918PVNDSK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['918PVNDSK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["918PVNDPPK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['918PVNDPPK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV3"
                                                        @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["918PVNDMPK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['918PVNDMPK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV4"
                                                        @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- UniversePay Payment Method -->
                                <div :class="'UniversePay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='55' && checkCurrencyID('VND')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["UPSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['UPSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["UPSV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['UPSV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- Okayspay Payment Method -->
                                <div :class="'Okayspay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='56' && checkCurrencyID('THB')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["OKPTHBAK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['OKPTHBAK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["OKPTHBSK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['OKPTHBSK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='58' && checkCurrencyID('IDR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["OKPIDRAK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['OKPIDRAK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["OKPIDRSK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['OKPIDRSK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='59' && checkCurrencyID('VND')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["OKPVNDAK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['OKPVNDAK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["OKPVNDSK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['OKPVNDSK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- Megaspay Payment Method -->
                                <div :class="'Megaspay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='57' && checkCurrencyID('MYR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["MGPMYRAK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['MGPMYRAK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["MGPMYRSK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['MGPMYRSK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                                <span class="ErrMsg"></span>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- VIP Payment Method -->
                                <div :class="'VIP' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='60' && checkCurrencyID('IDR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["VIPC"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['VIPC']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["VIPMUID"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['VIPMUID']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["VIPCK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['VIPCK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV3"
                                                        @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- AlfaPay Payment Method -->
                                <div :class="'AlfaPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='61' && checkCurrencyID('PHP')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AFPGCAT"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AFPGCAT']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AFPGCCT"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AFPGCCT']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AFPPMAT"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AFPPMAT']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV3"
                                                        @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["AFPPMCT"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['AFPPMCT']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV4"
                                                        @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- OnePay Payment Method -->
                                <div :class="'OnePay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='63' && checkCurrencyID('NPR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ONEPMK"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ONEPMK']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ONEPAES"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ONEPAES']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ONEPPC"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ONEPPC']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV3"
                                                        @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- ECPay Payment Method -->
                                <div :class="'ECPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='67' && checkCurrencyID('BDT')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ECPSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ECPSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ECPSV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ECPSV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ECPSV3"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ECPSV3']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV3"
                                                        @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- BleuPay Payment Method -->
                                <div :class="'BleuPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='64' && checkCurrencyID('MMK')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["BLEUPAPI"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['BLEUPAPI']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["BLEUPSALT"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['BLEUPSALT']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- Easy88Pay Payment Method -->
                                <div :class="'Easy88Pay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='62' && checkCurrencyID('BDT')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["E88PMN"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['E88PMN']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["E88PT"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['E88PT']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- PapayaPay Payment Method -->
                                <!--
                                <div :class="'PapayaPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='66' && checkCurrencyID('THB')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["PPYPMN"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['PPYPMN']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["PPYPAPI"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['PPYPAPI']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                -->
                                <!-- ZPay Payment Method -->
                                <div :class="'ZPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='70' && checkCurrencyID('THB')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYTHBSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ZPAYTHBSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYTHBSV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ZPAYTHBSV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='71' && checkCurrencyID('INR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYINRSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ZPAYINRSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYINRSV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ZPAYINRSV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='72' && checkCurrencyID('BRL')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYBRLSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ZPAYBRLSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYBRLSV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ZPAYBRLSV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='73' && checkCurrencyID('VND')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYVNDSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ZPAYVNDSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYVNDSV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ZPAYVNDSV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='74' && checkCurrencyID('MYR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYMYRSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ZPAYMYRSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["ZPAYMYRSV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['ZPAYMYRSV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- UPay Payment Method -->
                                <div :class="'UPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='75' && checkCurrencyID('MYR')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["UPAYSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['UPAYSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- DGPay Payment Method -->
                                <div :class="'DGPay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='68' && checkCurrencyID('CNY')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["DGPCNYSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['DGPCNYSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["DGPCNYSV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['DGPCNYSV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- SUPER7VND Payment Method -->
                                <div :class="'Super7Pay' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
                                    <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='69' && checkCurrencyID('VND')" v-for="(pmgw,index) in obj_Group.PMGW">
                                        <CRow>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV1"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV1']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV1"
                                                        @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV2"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV2']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV2"
                                                        @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV3"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV3']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV3"
                                                        @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV4"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV4']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV4"
                                                        @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV5"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV5']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV5"
                                                        @change="v => obj_Group.PMGW[index].SV5 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV6"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV6']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV6"
                                                        @change="v => obj_Group.PMGW[index].SV6 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV7"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV7']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV7"
                                                        @change="v => obj_Group.PMGW[index].SV7 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV8"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV8']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV8"
                                                        @change="v => obj_Group.PMGW[index].SV8 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV9"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV9']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV9"
                                                        @change="v => obj_Group.PMGW[index].SV9 = v"></CInput>
                                            </CCol>
                                            <CCol col="6" class="form-group">
                                                <label class="col-form-label-sm">{{getLanguage["AG"]["SUPER7VNDSV10"]}}:</label>
                                                <CInput :placeholder="getLanguage['AG']['SUPER7VNDSV10']"
                                                        size="sm"
                                                        :value="obj_Group.PMGW[index].SV10"
                                                        @change="v => obj_Group.PMGW[index].SV10 = v"></CInput>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </div>
                                <!-- Pay'N Go Payment Method -->
                                <!--<div :class="'PayNGo' == selectedPGCat ? 'tab-pane p-0 fade active show': 'tab-pane p-0 fade'">
        <div v-if="obj_Group.PMGW != null && obj_Group.PMGW.length > 0 && pmgw.PGI=='76' && checkCurrencyID('IDR')" v-for="(pmgw,index) in obj_Group.PMGW">
            <CRow>
                <CCol col="6" class="form-group">
                    <label class="col-form-label-sm">{{getLanguage["AG"]["PNGCI"]}}:</label>
                    <CInput :placeholder="getLanguage['AG']['PNGCI']"
                            size="sm"
                            :value="obj_Group.PMGW[index].SV1"
                            @change="v => obj_Group.PMGW[index].SV1 = v"></CInput>
                </CCol>
                <CCol col="6" class="form-group">
                    <label class="col-form-label-sm">{{getLanguage["AG"]["PNGCS"]}}:</label>
                    <CInput :placeholder="getLanguage['AG']['PNGCS']"
                            size="sm"
                            :value="obj_Group.PMGW[index].SV2"
                            @change="v => obj_Group.PMGW[index].SV2 = v"></CInput>
                </CCol>
            </CRow>
            <CRow>
                <CCol col="6" class="form-group">
                    <label class="col-form-label-sm">{{getLanguage["AG"]["PNGAK"]}}:</label>
                    <CInput :placeholder="getLanguage['AG']['PNGAK']"
                            size="sm"
                            :value="obj_Group.PMGW[index].SV3"
                            @change="v => obj_Group.PMGW[index].SV3 = v"></CInput>
                </CCol>
                <CCol col="6" class="form-group">
                    <label class="col-form-label-sm">{{getLanguage["AG"]["PNGSK"]}}:</label>
                    <CInput :placeholder="getLanguage['AG']['PNGSK']"
                            size="sm"
                            :value="obj_Group.PMGW[index].SV4"
                            @change="v => obj_Group.PMGW[index].SV4 = v"></CInput>
                </CCol>
            </CRow>
        </div>
    </div>-->
                            </div>
                        </CCol>

                        <CCol col="12">
                            <div style="text-align:center;margin-top:20px" v-if="(this.$route.query.agi !== undefined && this.$route.query.di !== undefined && this.$route.query.lci !== undefined && this.$route.query.acsi !== undefined && this.$route.query.bai !== undefined)">
                                <!--<CButton color="outline-info" size="sm" @click="saveSelfService('dss')">-->
                                <CButton color="outline-info" size="sm" @click="saveDownlineConfig()">
                                    <span class='fa fa-save mr-2'></span>
                                    {{ getLanguage["BTN"]["SV"] }}
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                </template>

                <!-- Domain & Member Setting -->
                <CRow class="mx-0" v-if="bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT >= 2)">
                    <CCol col="12">
                        <h6 class="card-title section-title2"
                            data-section="dmss"
                            @click="showSectionBasedRole('dmss')"
                            :class="selectedSection === 'dmss' ? 'bg-blue text-white' : ''">
                            <!--<span :class="(!this.$v.obj_Domain.$error && bool_groupCV) ? 'bg-success' : ''">-->
                            <span :class="getSectionClasses('dmss', !$v.obj_Domain.$error && bool_groupCV)">
                                {{ getSectionIndex(4) }}
                            </span>
                            {{this.getLanguage["DM"]["D"]}} & {{getLanguage["ACU"]["MSS"]}}
                            <i :class="setCollapseExpandIcon('T')"></i>
                        </h6>
                    </CCol>
                </CRow>
                <template v-if="bool_showDMSS && bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT >= 2)">
                    <CRow class="mx-0">
                        <CCol col="12">
                            <div class="my-2 d-flex" v-if="obj_Domain.I == 0">
                                <input type="checkbox" id="DID" v-model="bool_disableInsertDomain">
                                <label class="ml-2" for="DID">{{getLanguage["AG"]["NRFD"]}}</label>

                                <div class="custom-tooltip ml-2">
                                    <i class="fa fa-question-circle"></i>
                                    <span class="custom-tooltiptext2" style="width: 280px; white-space: pre-line;left: 50%; ">{{getLanguage["AG"]["NRFDD"]}}</span>
                                </div>
                            </div>
                        </CCol>

                        <!--<CCol col="12" v-if="obj_Domain.I == 0">
                            <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['DN'] }}<span class="required" /> :</label>
                            <CInput :placeholder="getLanguage['DM']['DN']" size="sm" :value="obj_Domain.DN" @change="changeDomainName($event, obj_Domain.I)" :disabled="bool_disableInsertDomain"></CInput>
                            <span class="ErrMsg">{{ ValidationDomainErrMsg('DN') }}</span>
                        </CCol>-->

                        <CCol md="3" class="font-weight-bold" v-if="obj_Domain.I != 0">
                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["MT"]}} <i class="fa-sharp fa-solid fa-screwdriver-wrench"></i> :</label>
                            <label class="switch domainMaintain">
                                <input type="checkbox" v-model="obj_Domain.RS" true-value="1" false-value="2">
                                <span class="slider round STYLE_unlock"></span>
                            </label>
                        </CCol>
                        <CCol md="3" class="font-weight-bold" v-if="obj_Domain.I != 0">
                            <label class="col-form-label-sm">{{this.getLanguage["BTN"]["CCACHE"]}} :</label>
                            <label class="">
                                <i class="cil-sync" @click="clearCache(obj_Domain)"></i>
                            </label>
                        </CCol>
                        <CCol md="3" v-if="obj_Domain.I == 0">
                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["PSR"]}}:</label>
                            <label class="switch">
                                <input type="checkbox" v-model="obj_Domain.PRBT" true-value="1" false-value="2" :disabled="bool_disableInsertDomain">
                                <span class="slider round STYLE_unlock"></span>
                            </label>
                        </CCol>
                        <CCol md="3" v-if="bool_showPreloadSEO">
                            <label class="col-form-label-sm">{{this.getLanguage["DM"]["PSEO"]}}:</label>
                            <label class="switch">
                                <input type="checkbox" v-model="obj_Domain.PSEO" true-value="1" false-value="2" :disabled="bool_disableInsertDomain">
                                <span class="slider round STYLE_unlock"></span>
                            </label>
                        </CCol>
                    </CRow>
                    <CRow class="mx-0 mt-3">
                        <CCol col="12">
                            <label class="col-form-label-sm inline inline80">{{getLanguage['DM']['DML'] }} : <span style="margin-left: 20px;"><i class="fa-solid fa-globe text-info mr-2"></i>{{getLanguage['DM']['MDD'] }} / <i class="fa-solid fa-globe mr-2"></i> {{getLanguage['DM']['ALTDM'] }}</span></label>

                            <CButton color="outline-dark" size="sm" class="btn-small inline inline20" @click="addDomain()" :disabled="bool_disableInsertDomain" v-if="obj_Domain.I == 0 && obj_Domain.DN == ''">
                                <span class='plusIcon cil-plus'></span>
                                <span>{{this.getLanguage["BTN"]["AD"]}} {{getLanguage['DM']['MDD'] }}</span>
                            </CButton>
                            <CButton color="outline-dark" size="sm" class="btn-small inline inline20" @click="addAlternateDomain()" :disabled="bool_disableInsertDomain" v-if="obj_Domain.I > 0">
                                <span class='plusIcon cil-plus'></span>
                                <span>{{this.getLanguage["BTN"]["AD"]}} {{getLanguage['DM']['ALTDM'] }}</span>
                            </CButton>

                            <CRow style="padding-top: 10px; padding-bottom: 30px; padding-left: 15px; padding-right: 15px; display: block;">
                                <table class="custom-table custom-table-inPopUp afb-blue" :key="dmKey">
                                    <thead>
                                        <tr>
                                            <th style="width: 5%;">{{this.getLanguage["GL"]["NO"]}}</th>
                                            <th style="width: 5%;">{{this.getLanguage['GL']['ACT']}}</th>
                                            <th style="width: 10%;">{{this.getLanguage['DM']['DN']}}</th>
                                            <th style="width: 10%;">{{this.getLanguage['DM']['NS']}}</th>
                                            <th style="width: 10%;">{{this.getLanguage['DM']['DRT']}}</th>
                                            <th style="width: 15%;">{{this.getLanguage['DM']['AMPRD']}}</th>
                                            <th style="width: 10%;">{{this.getLanguage['DM']['RT']}}</th>
                                            <th style="width: 10%;">{{this.getLanguage['DM']['CN']}}</th>
                                            <th style="width: 15%;">{{this.getLanguage['DM']['TH']}}</th>
                                            <th style="width: 10%;">{{this.getLanguage['DM']['CFS']}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="(!obj_Domain.DALT || obj_Domain.DALT.length == 0) && (obj_Domain.DN == '')">
                                            <td colspan="10">{{this.getLanguage['GL']['NR']}}</td>
                                        </tr>
                                        <tr v-if="(obj_Domain.DN != '')">
                                            <td>1</td>
                                            <td>
                                                <span class="custom-tooltip">
                                                    <i class="cil-color-border" @click='editDomain()'></i>
                                                    <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                                </span>
                                            </td>
                                            <td>
                                                <i class="fa-solid fa-house theme-outlet" v-if="obj_Domain.IOL"></i>
                                                <i class="fa-solid fa-globe text-info mr-2"></i>
                                                {{ obj_Domain.DN }}
                                            </td>
                                            <td>
                                                <i v-if="obj_Domain.UCF" class="cib-cloudflare"></i>
                                                <span v-if="obj_Domain.DomainNameServer!=null && obj_Domain.DomainNameServer.length > 0">
                                                    <span v-for="item in obj_Domain.DomainNameServer" class="grid-line">
                                                        {{ displayDNSLine(item.DNS) }}
                                                    </span>
                                                </span>
                                                <span v-else>
                                                    {{ getLanguage["DLSS"]["NA"]}}
                                                </span>
                                            </td>
                                            <td>{{ obj_Domain.RTD ? obj_Domain.RTD : getLanguage["DLSS"]["NA"]}}</td>

                                            <td>{{ obj_Domain.AMPURL }}</td>
                                            <td :class="getRobotsTxtClass(obj_Domain.RT)">{{ checkRobotsTxt(obj_Domain.RT) }}</td>
                                            <td>{{ obj_Domain.CN }}</td>
                                            <td>
                                                <span class="grid-line">{{ obj_Domain.TN }}</span>
                                                <span class="grid-line">{{ obj_Domain.SN }}</span>
                                            </td>
                                            <td>
                                                <span v-if="(!obj_Domain.CFStatus && !obj_Domain.UCF)">{{ getLanguage["DLSS"]["NA"]}}</span>
                                                <span v-else :class="(obj_Domain.CFStatus=='pending') ? 'text-red' : (obj_Domain.CFStatus=='active'?'text-green':'')" style="text-transform:capitalize">{{ obj_Domain.CFStatus?obj_Domain.CFStatus:getLanguage["DLSS"]["NA"] }}</span>
                                            </td>
                                        </tr>
                                        <tr v-for="(data,index) in obj_Domain.DALT">
                                            <td>{{ index+2 }}</td>
                                            <td>
                                                <span class="custom-tooltip">
                                                    <i class="cil-color-border" @click='editAlternateDomain(index)'></i>
                                                    <span class="custom-tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                                </span>
                                                <span class="custom-tooltip">
                                                    <i class="cil-trash" @click='removeAlternateDomain(index)'></i>
                                                    <span class="custom-tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                                </span>
                                            </td>
                                            <td>
                                                <i class="fa-solid fa-globe mr-2"></i>
                                                {{ data.DN }}
                                            </td>
                                            <td>
                                                <i v-if="data.UCF" class="cib-cloudflare"></i>
                                                <span v-if="data.DNS != ''">
                                                    <span v-for="dns in data.DNS.split(',')" class="grid-line">
                                                        {{ displayDNSLine(dns) }}
                                                    </span>
                                                </span>
                                                <span v-else>
                                                    {{ getLanguage["DLSS"]["NA"]}}
                                                </span>
                                            </td>
                                            <!--<td>{{ data.RTD ? data.RTD : getLanguage["DLSS"]["NA"]}}</td>-->
                                            <td>
                                                <span v-if="data.RTD != ''">
                                                    <span v-for="rtd in data.RTD.split(',')" class="grid-line">
                                                        {{ displayDNSLine(rtd) }}
                                                    </span>
                                                </span>
                                                <span v-else>
                                                    {{ getLanguage["DLSS"]["NA"]}}
                                                </span>
                                            </td>
                                            <td></td>
                                            <td :class="getRobotsTxtClass(data.RT)">{{ checkRobotsTxt(data.RT) }}</td>
                                            <td>{{ data.CN }}</td>
                                            <td></td>
                                            <td>
                                                <span v-if="(!data.CFStatus && !data.UCF)">{{ getLanguage["DLSS"]["NA"]}}</span>
                                                <span v-else :class="(data.CFStatus=='pending') ? 'text-red' : (data.CFStatus=='active'?'text-green':'')" style="text-transform:capitalize">{{ data.CFStatus?data.CFStatus:getLanguage["DLSS"]["NA"] }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <span class="ErrMsg" v-if="!obj_Domain.DN">{{ String.format(this.utilGetErrorLanguage('1001'), this.getLanguage['DM']['MDD']) }}</span>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow class="mx-0 mt-3">
                        <CCol col="12">
                            <CRow>
                                <CCol col="12">
                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['CTAB']['UL'] }} :</label>
                                    <CTabs variant='tabs' id="imageURLTab">
                                        <CTab :title="getLanguage['CTAB']['USL']" :active="obj_Domain.SLBL === false ? true: false">
                                            <div class="custom-file">
                                                <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileLogoSelected" :disabled="bool_disableInsertDomain" required>
                                                <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFile === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedFile.name}}</label>
                                                <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                            </div>
                                            <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 300 x 130</label>
                                            <CCard v-if="obj_Domain['SL']">
                                                <CCardBody class="modal-body p-2">
                                                    <img width="300" height="130" :src="getImgUrl(obj_Domain['SL'])" />
                                                </CCardBody>
                                            </CCard>
                                        </CTab>
                                        <CTab :title="getLanguage['CTAB']['UMSL']" :active="obj_Domain.MSLBL === false ? true: false">
                                            <div class="custom-file">
                                                <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileMLogoSelected" :disabled="bool_disableInsertDomain" required>
                                                <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFileMsl === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedFileMsl.name}}</label>
                                                <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                            </div>
                                            <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 100 x 100</label>
                                            <CCard v-if="obj_Domain['MSL']">
                                                <CCardBody class="modal-body p-2">
                                                    <img width="100" height="100" :src="getImgUrl(obj_Domain['MSL'])" />
                                                </CCardBody>
                                            </CCard>
                                        </CTab>
                                        <CTab :title="getLanguage['CTAB']['UF']" :active="obj_Domain.SIBL === false ? true: false">
                                            <div class="custom-file">
                                                <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onFileIcoSelected" :disabled="bool_disableInsertDomain" required>
                                                <label class="custom-file-label" for="validatedCustomFile" v-if="selectedFileIco === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                                <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedFileIco.name}}</label>
                                                <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                            </div>
                                            <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 25 X 25</label>
                                            <CCard v-if="obj_Domain['SI']">
                                                <CCardBody class="modal-body p-2">
                                                    <img width="25" height="25" :src="getImgUrl(obj_Domain['SI'])" />
                                                </CCardBody>
                                            </CCard>
                                        </CTab>
                                    </CTabs>
                                </CCol>

                                <CCol col="6" v-if="obj_Domain.I > 0">
                                    <label class="col-form-label-sm">{{this.getLanguage["DM"]["ADN"]}} :</label>
                                    <treeselect :multiple="false"
                                                :options="dd_dofs"
                                                :placeholder="this.utilGetDDLanguage('DM.ADN')"
                                                :disabled="bool_disableInsertDomain"
                                                v-model="obj_Domain.ADI" />
                                </CCol>

                                <CCol col="6">
                                    <label class="col-form-label-sm">{{getLanguage['DM']['AMPSU'] }} :</label>
                                    <CInput size="sm" :value="obj_Domain.AMPSU" @change="v => obj_Domain.AMPSU = v" :disabled="bool_disableInsertDomain"></CInput>
                                </CCol>

                                <CCol col="6">
                                    <label class="col-form-label-sm" style="margin-right: 20px;">{{getLanguage['DM']['DIP'] }} :</label>
                                    <CInput :placeholder="getLanguage['DM']['DIP']" size="sm" :value="obj_Domain.SIP" @change="v => obj_Domain.SIP = v" :disabled="bool_disableInsertDomain"></CInput>
                                </CCol>
                            </CRow>
                        </CCol>
                    </CRow>
                    <CRow class="mx-0 mt-3" id="webTempSetting">
                        <CCol col="5">
                            <div class="my-2 d-flex">
                                <input type="checkbox" id="DLFIP" v-model="obj_Domain.DLFIP" :disabled="bool_disableInsertDomain">
                                <label class="ml-2" for="DLFIP">{{getLanguage["DM"]["DLBIP"]}}</label>
                                <div class="custom-tooltip ml-2">
                                    <i class="fa fa-question-circle"></i>
                                    <span class="custom-tooltiptext2" style="width: 280px; white-space: pre-line;left: 50%; ">{{getLanguage["DM"]["DLBIPD"]}}</span>
                                </div>
                                <span class="ErrMsg">{{ ValidationDomainErrMsg('L') }} {{ ValidationDomainErrMsg('DL') }}</span>
                            </div>
                        </CCol>
                        <CCol col="7" class="text-right">
                            <div class="my-2 d-flex justify-content-end">
                                <span class="mr-3" style="font-size:12px">

                                    <!-- Selected Default Language -->
                                    <img src="/src/assets/icons/defaultlanguage-active.svg" class="mr-2" style="width: 15px;" />{{getLanguage["DM"]["SDL"]}}
                                    <span class="custom-tooltip ml-1">
                                        <i class="fa fa-question-circle"></i>
                                        <!-- Update Default Language -->
                                        <span class="custom-tooltiptext2" style="width: 210px; white-space: pre-line;right: 50%;left:-100px; ">{{getLanguage["DM"]["SDLD"]}}</span>
                                    </span>
                                </span>
                                <!-- Deselected Default Language -->
                                <span style="font-size:12px"><img src="/src/assets/icons/defaultlanguage.svg" class="mr-2" style="width: 15px;" />{{getLanguage["DM"]["NSDL"]}}</span>
                            </div>
                        </CCol>

                        <div class="col-md-2">
                            <div class="nav flex-column nav-pills h-100" aria-orientation="vertical">
                                <div :style="(!setting.LE) ? 'display:none' : ''" v-for="(setting, index) in obj_Domain.DS" :key="setting.L" @click="(setting.TC && bool_multiTemplateOneDomain) ? selectedLangIndex = index : ''">
                                    <a :class="(selectedLangIndex == index) ? 'd-flex align-items-center nav-link px-2 active' : 'd-flex align-items-center nav-link px-2'" :style="(!bool_multiTemplateOneDomain ? 'cursor:default': (setting.TC ? 'cursor:pointer' : 'cursor:default') ) ">
                                        <input type="checkbox"
                                               @click="tickSettingCheckbox($event, setting)"
                                               v-model="setting.TC"
                                               :disabled="bool_disableInsertDomain"
                                               ref="L" />
                                        <label class="d-flex align-items-center ml-2">
                                            <span class="flagClass mr-2" :class="mapLanguageFlag(setting.L)"></span>
                                            <span class="font-weight-bold" style="font-size:10px;">{{ setting.LN }}</span>
                                        </label>
                                        <img src="/src/assets/icons/defaultlanguage-active.svg" class="ml-2" style="width:15px;" v-if="obj_Domain.DL == setting.L && setting.TC" />
                                        <img src="/src/assets/icons/defaultlanguage.svg" class="ml-2 pointer" style="width:15px;" v-if="obj_Domain.DL != setting.L && setting.TC" @click="obj_Domain.DL = setting.L" />
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-10 pl-md-0">
                            <div class="tab-content h-100" style="background: #F0F0F1;">
                                <div :class="(selectedLangIndex == index) ? 'tab-pane fade show active' : 'tab-pane fade'" v-for="(setting, index) in obj_Domain.DS" :key="setting.L">
                                    <div class="">
                                        <div class="p-2">
                                            <CRow>
                                                <CCol col="12">
                                                    <h6 class="card-title section-title font-weight-bold" v-if="!bool_multiTemplateOneDomain"> {{getLanguage["DM"]["T"]}} <span class="required" /></h6>
                                                    <h6 class="card-title section-title font-weight-bold" v-else> {{getLanguage["DM"]["T"]}} <span class="required" /> - {{ setting.LN }}</h6>
                                                </CCol>
                                                <CCol col="12" class="form-group">
                                                    <label class="col-form-label-sm"> {{getLanguage["DM"]["C"]}}<span class="required" />:</label>
                                                    <treeselect :multiple="true"
                                                                :options="dd_currency_selectlabel"
                                                                :defaultExpandLevel="1"
                                                                valueConsistsOf="LEAF_PRIORITY"
                                                                :disabled="bool_disableInsertDomain || (getUserInfo.AT > 3)"
                                                                :placeholder="getLanguage['DM']['C']"
                                                                v-model="setting.CurrencyCodes"
                                                                @input="DSCurrencyChange"
                                                                :limit="12"
                                                                :limitText="count => `+${count}`"
                                                                ref="DS.$each.CC" />
                                                    <span class="ErrMsg">{{ ValidationDomainErrMsg('CC', 'C', index) }}</span>
                                                </CCol>
                                            </CRow>

                                            <div class="card p-2" :class="setting.EETAD == 0 ? 'active':''">
                                                <CRow>
                                                    <div class="col-7">
                                                        <label class="col-form-label-sm">{{getLanguage["DM"]["TDD"]}}</label>
                                                        <CRow>
                                                            <CCol col="4" class="d-flex pr-0" style="gap:10px">
                                                                <div class="form-group">
                                                                    <label class="col-form-label-sm">{{ getLanguage["GS"]["D"] }} </label>
                                                                    <input type="radio" value="0" :id="'defaultUseExtraTemplate'+index" :name="'defaultUseExtraTemplate'+index" v-model="setting.EETAD" :disabled="bool_disableInsertDomain || (getUserInfo.AT >= 3 && setting.TI > 0) || !setting.E2SSIM" :checked="setting.EETAD === 0">
                                                                </div>

                                                                <div class="form-group">
                                                                    <label class="col-form-label-sm">{{getLanguage["MEM"]["DN"]}} <span class="required" /></label>
                                                                    <input type="text" v-model="setting.DSN1" class="form-control form-control-sm" :disabled="bool_disableInsertDomain || !setting.E2SSIM || getUserInfo.AT == 3" />
                                                                    <span class="ErrMsg">{{ ValidationDomainErrMsg('DSN1', 'DN', index) }}</span>
                                                                </div>
                                                            </CCol>
                                                            <CCol col="8">
                                                                <div class="form-group">
                                                                    <div class="input-group input-group-sm" style="flex-wrap: nowrap; gap: 5px; display: grid; grid-template-columns: auto auto 30px;">
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["T"]}} {{getLanguage["GAME"]["NM"]}}  <span class="required" /></label>
                                                                            <treeselect :multiple="false"
                                                                                        :options="dd_template"
                                                                                        :placeholder="getLanguage['DM']['T']"
                                                                                        :disabled="bool_disableInsertDomain || (getUserInfo.AT>= 3 && setting.TI > 0)"
                                                                                        @input="TemplateChange($event,index)"
                                                                                        v-model="setting.TI" />
                                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('TI', 'T', index) }}</span>
                                                                        </div>
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["CTO"]}}  <span class="required" /></label>
                                                                            <treeselect :multiple="false"
                                                                                        :key="setting.TI+index"
                                                                                        :options="dd_templateskins[setting.TI]"
                                                                                        :placeholder="getLanguage['DM']['CTO']"
                                                                                        :disabled="bool_disableInsertDomain || !setting.TI || setting.TI == 0 || (getUserInfo.AT == 3 && setting.TSI >= 0)"
                                                                                        v-model="setting.TSI" />
                                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('TSI', 'CTO', index) }}</span>
                                                                        </div>
                                                                        <div class="input-group-append" @click="previewImgUrl = getTemplateUrl(setting.TI, 'img', 'desktop')" :style="(setting.TI > 0 && setting.TSI >= 0) ? '' : 'visibility:hidden ' " style="height: calc(1.5em + .4rem + 2px) !important;font-size: .76563rem;margin-top: 28px;">
                                                                            <label class="input-group-text pointer" style=" border-radius: 5px !important;"><i class="fa fa-eye"></i></label>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="form-group" v-if="getUserInfo.AT == 0">
                                                                    <div class="input-group input-group-sm" style="flex-wrap: nowrap; gap: 5px ;display: grid; grid-template-columns: auto auto 30px;">
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["CURL"]}} <span class="mandatory_Field">**</span></label>
                                                                            <input type="text" v-model="setting.CURL" class="form-control form-control-sm" list="dd_imageList" :disabled="bool_disableInsertDomain" />
                                                                            <datalist id="dd_imageList">
                                                                                <option v-for="(data,index) in dd_imageList">{{ data }}</option>
                                                                            </datalist>
                                                                        </div>
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["GCURL"]}} <span class="mandatory_Field">**</span></label>
                                                                            <input type="text" v-model="setting.GCURL" class="form-control form-control-sm" list="dd_GPimageList" :disabled="bool_disableInsertDomain" />
                                                                            <datalist id="dd_GPimageList">
                                                                                <option v-for="(data,index) in dd_GPimageList">{{ data }}</option>
                                                                            </datalist>
                                                                        </div>

                                                                        <div class="input-group-append" style="height: calc(1.5em + .4rem + 2px) !important; font-size: .76563rem; margin-top: 28px; visibility: hidden">
                                                                            <label class="input-group-text pointer" style=" border-radius: 5px !important;"><i class="fa fa-eye"></i></label>
                                                                        </div>
                                                                    </div>

                                                                    <div class="mt-2" v-if="setting.GCURL  == 'lobby01_light/' || setting.GCURL  == 'lobby01_black/'|| setting.GCURL  == 'lobby02/'|| setting.GCURL  == 'lobby03/'|| setting.GCURL  == 'lobby04/'|| setting.GCURL  == 'lobby05/' || setting.GCURL  == 'lobby06/'">
                                                                        <label class="col-form-label-sm">{{getLanguage["DM"]["GCURL"]}} {{getLanguage["GL"]["P"]}}</label>
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby01_light/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .GCURL == 'lobby01_light/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby01_black/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .GCURL == 'lobby01_black/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby02/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .GCURL == 'lobby02/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby03/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .GCURL == 'lobby03/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby04/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .GCURL == 'lobby04/' ? 'display:block' : 'display:none' " />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby05/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .GCURL == 'lobby05/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby06/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .GCURL == 'lobby06/' ? 'display:block' : 'display:none'" />
                                                                    </div>
                                                                </div>
                                                            </CCol>
                                                        </CRow>
                                                    </div>
                                                    <div class="col-5">
                                                        <div class="d-flex">
                                                            <input type="checkbox" :id="'AMT'+index" v-model="setting.AMT" :disabled="bool_disableInsertDomain || (getUserInfo.AT == 3)">
                                                            <label class="col-form-label-sm ml-1" :for="'AMT'+index">{{getLanguage["DM"]["TMD"]}}</label>
                                                        </div>
                                                        <CRow :style="setting.AMT  ? '' : 'display:none'">
                                                            <CCol col="11" class="pr-0">
                                                                <div class="form-group">
                                                                    <div class="input-group input-group-sm" style="flex-wrap: nowrap; gap: 5px; display: grid; grid-template-columns: auto auto 30px; ">
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["MTEP"]}} {{getLanguage["GAME"]["NM"]}}<span class="required" /></label>
                                                                            <treeselect :multiple="false"
                                                                                        :options="dd_mtemplate"
                                                                                        :placeholder="getLanguage['DM']['MTEP']"
                                                                                        :disabled="bool_disableInsertDomain || (getUserInfo.AT>= 3 && setting.MTI > 0)"
                                                                                        @input="MobileTemplateChange($event,index)"
                                                                                        v-model="setting.MTI" />
                                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('MTI', 'MTEP', index) }}</span>
                                                                        </div>
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["CTO"]}} <span class="required" /></label>
                                                                            <treeselect :multiple="false"
                                                                                        :key="setting.MTI+index"
                                                                                        :options="dd_mtemplateskins[setting.MTI]"
                                                                                        :placeholder="getLanguage['DM']['CTO']"
                                                                                        :disabled="bool_disableInsertDomain || !setting.MTI || setting.MTI == 0 || (getUserInfo.AT == 3 && setting.MTSI >= 0)"
                                                                                        v-model="setting.MTSI" />
                                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('MTSI', 'CTO', index) }}</span>
                                                                        </div>
                                                                        <div class="input-group-append" @click="previewImgUrl = getTemplateUrl(setting.MTI, 'img', 'mobile')" :style="(setting.MTI > 0 && setting.MTSI >= 0) ? '' : 'visibility:hidden ' " style="height: calc(1.5em + .4rem + 2px) !important;font-size: .76563rem;margin-top: 28px;">
                                                                            <label class="input-group-text pointer"  style=" border-radius: 5px !important;"><i class="fa fa-eye"></i></label>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="form-group" v-if="getUserInfo.AT == 0">
                                                                    <div class="input-group input-group-sm" style="flex-wrap: nowrap; gap: 5px;; display: grid; grid-template-columns: auto auto 30px;">
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["CURL"]}} <span class="mandatory_Field">**</span></label>
                                                                            <input type="text" v-model="setting.MCURL" class="form-control form-control-sm" list="dd_imageList" :disabled="bool_disableInsertDomain" />
                                                                            <datalist id="dd_imageList">
                                                                                <option v-for="(data,index) in dd_imageList">{{ data }}</option>
                                                                            </datalist>
                                                                        </div>
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["GCURL"]}} <span class="mandatory_Field">**</span></label>
                                                                            <input type="text" v-model="setting.MGCURL" class="form-control form-control-sm" list="dd_GPimageList" :disabled="bool_disableInsertDomain" />
                                                                            <datalist id="dd_GPimageList">
                                                                                <option v-for="(data,index) in dd_GPimageList">{{ data }}</option>
                                                                            </datalist>
                                                                        </div>
                                                                        <div class="input-group-append" style="height: calc(1.5em + .4rem + 2px) !important; font-size: .76563rem; margin-top: 28px; visibility: hidden">
                                                                            <label class="input-group-text pointer" style=" border-radius: 5px !important;"><i class="fa fa-eye"></i></label>
                                                                        </div>
                                                                    </div>

                                                                    <div class="mt-2" v-if="setting.MGCURL  == 'lobby01_light/' || setting.GCURL  == 'lobby01_black/'|| setting.GCURL  == 'lobby02/'|| setting.GCURL  == 'lobby03/'|| setting.GCURL  == 'lobby04/'|| setting.GCURL  == 'lobby05/' || setting.GCURL  == 'lobby06/'">
                                                                        <label class="col-form-label-sm">{{getLanguage["DM"]["GCURL"]}} {{getLanguage["GL"]["P"]}}</label>
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby01_light/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .MGCURL == 'lobby01_light/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby01_black/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .MGCURL == 'lobby01_black/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby02/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .MGCURL == 'lobby02/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby03/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .MGCURL == 'lobby03/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby04/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .MGCURL == 'lobby04/' ? 'display:block' : 'display:none' " />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby05/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .MGCURL == 'lobby05/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby06/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .MGCURL == 'lobby06/' ? 'display:block' : 'display:none'" />
                                                                    </div>
                                                                </div>
                                                            </CCol>
                                                        </CRow>
                                                    </div>
                                                </CRow>
                                            </div>

                                            <CRow class="mt-3">
                                                <CCol col="12" class="d-flex">
                                                    <input type="checkbox" :id="'E2SSIM'+index" v-model="setting.E2SSIM" :disabled="bool_disableInsertDomain || (getUserInfo.AT == 3)">
                                                    <label class="col-form-label-sm ml-1" :for="'E2SSIM'+index">{{getLanguage["DM"]["E2SSIM"]}}</label>
                                                </CCol>
                                            </CRow>
                                            <div class="card p-2" :class="setting.EETAD == 1 ? 'active':''" :style="setting .E2SSIM ? '' : 'display:none'">
                                                <CRow>
                                                    <div class="col-7">
                                                        <label class="col-form-label-sm">{{getLanguage["DM"]["ATDD"]}}</label>
                                                        <CRow>
                                                            <CCol col="4" class="d-flex pr-0" style="gap:10px">
                                                                <div class="form-group" v-if="setting.E2SSIM">
                                                                    <label class="col-form-label-sm">{{ getLanguage["GS"]["D"] }} </label>
                                                                    <input type="radio" value="1" :id="'defaultUseExtraTemplate'+index" :name="'defaultUseExtraTemplate'+index" v-model="setting.EETAD" :disabled="bool_disableInsertDomain || (getUserInfo.AT >= 3 && setting.TI > 0)" :checked="setting.EETAD === 1">
                                                                </div>

                                                                <div class="form-group">
                                                                    <label class="col-form-label-sm">{{getLanguage["MEM"]["DN"]}} <span class="required" /></label>
                                                                    <input type="text" v-model="setting.DSN2" class="form-control form-control-sm" :disabled="bool_disableInsertDomain || getUserInfo.AT == 3" />
                                                                    <span class="ErrMsg">{{ ValidationDomainErrMsg('DSN2', 'DN', index) }}</span>
                                                                </div>
                                                            </CCol>
                                                            <CCol col="8">
                                                                <div class="form-group">
                                                                    <div class="input-group input-group-sm" style="flex-wrap: nowrap; gap: 5px; display: grid; grid-template-columns: auto auto 30px;">
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["T"]}} {{getLanguage["GAME"]["NM"]}}  <span class="required" /></label>
                                                                            <treeselect :multiple="false"
                                                                                        :options="dd_template"
                                                                                        :placeholder="getLanguage['DM']['T']"
                                                                                        :disabled="bool_disableInsertDomain || (getUserInfo.AT>= 3 && setting.TIALT > 0)"
                                                                                        @input="AlternateTemplateChange($event,index)"
                                                                                        v-model="setting.TIALT" />
                                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('TIALT', 'T', index) }}</span>
                                                                        </div>
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["CTO"]}}  <span class="required" /></label>
                                                                            <treeselect :multiple="false"
                                                                                        :key="setting.TIALT+index"
                                                                                        :options="dd_templateskins[setting.TIALT]"
                                                                                        :placeholder="getLanguage['DM']['CTO']"
                                                                                        :disabled="bool_disableInsertDomain || !setting.TIALT || setting.TIALT == 0 || (getUserInfo.AT == 3 && setting.TSIALT >= 0)"
                                                                                        v-model="setting.TSIALT" />
                                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('TSIALT', 'CTO', index) }}</span>
                                                                        </div>
                                                                        <div class="input-group-append" @click="previewImgUrl = getTemplateUrl(setting.TIALT, 'img', 'desktop')" :style="(setting.TIALT > 0 && setting.TSIALT >= 0) ? '' : 'visibility:hidden ' " style="height: calc(1.5em + .4rem + 2px) !important;font-size: .76563rem;margin-top: 28px;">
                                                                            <label class="input-group-text pointer"  style=" border-radius: 5px !important;"><i class="fa fa-eye"></i></label>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="form-group" v-if="getUserInfo.AT == 0">
                                                                    <div class="input-group input-group-sm" style="flex-wrap: nowrap; gap: 5px; display: grid; grid-template-columns: auto auto 30px;">
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["CURL"]}} <span class="mandatory_Field">**</span></label>
                                                                            <input type="text" v-model="setting.ALTCURL" class="form-control form-control-sm" list="dd_imageList" :disabled="bool_disableInsertDomain" />
                                                                            <datalist id="dd_imageList">
                                                                                <option v-for="(data,index) in dd_imageList">{{ data }}</option>
                                                                            </datalist>
                                                                        </div>
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["GCURL"]}} <span class="mandatory_Field">**</span></label>
                                                                            <input type="text" v-model="setting.ALTGCURL" class="form-control form-control-sm" list="dd_GPimageList" :disabled="bool_disableInsertDomain" />
                                                                            <datalist id="dd_GPimageList">
                                                                                <option v-for="(data,index) in dd_GPimageList">{{ data }}</option>
                                                                            </datalist>
                                                                        </div>
                                                                        <div class="input-group-append"  style="height: calc(1.5em + .4rem + 2px) !important; font-size: .76563rem; margin-top: 28px; visibility: hidden">
                                                                            <label class="input-group-text pointer" style=" border-radius: 5px !important;"><i class="fa fa-eye"></i></label>
                                                                        </div>
                                                                    </div>

                                                                    <div class="mt-2" v-if="setting.ALTGCURL  == 'lobby01_light/' || setting.GCURL  == 'lobby01_black/'|| setting.GCURL  == 'lobby02/'|| setting.GCURL  == 'lobby03/'|| setting.GCURL  == 'lobby04/'|| setting.GCURL  == 'lobby05/' || setting.GCURL  == 'lobby06/'">
                                                                        <label class="col-form-label-sm">{{getLanguage["DM"]["GCURL"]}} {{getLanguage["GL"]["P"]}}</label>
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby01_light/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTGCURL == 'lobby01_light/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby01_black/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTGCURL == 'lobby01_black/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby02/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTGCURL == 'lobby02/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby03/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTGCURL == 'lobby03/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby04/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTGCURL == 'lobby04/' ? 'display:block' : 'display:none' " />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby05/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTGCURL == 'lobby05/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby06/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTGCURL == 'lobby06/' ? 'display:block' : 'display:none'" />
                                                                    </div>
                                                                </div>
                                                            </CCol>
                                                        </CRow>
                                                    </div>
                                                    <div class="col-5">
                                                        <div class="d-flex">
                                                            <input type="checkbox" :id="'AMTALT'+index" v-model="setting.AMTALT" :disabled="bool_disableInsertDomain  || (getUserInfo.AT == 3)">
                                                            <label class="col-form-label-sm ml-1" :for="'AMTALT'+index">{{getLanguage["DM"]["ATMD"]}}</label>
                                                        </div>
                                                        <CRow :style="setting .AMTALT ? '' : 'display:none'">
                                                            <CCol col="11" class="pr-0">
                                                                <div class="form-group">
                                                                    <div class="input-group input-group-sm" style="flex-wrap: nowrap; gap: 5px; display: grid; grid-template-columns: auto auto 30px;">
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["MTEP"]}} {{getLanguage["GAME"]["NM"]}}  <span class="required" /></label>
                                                                            <treeselect :multiple="false"
                                                                                        :options="dd_mtemplate"
                                                                                        :placeholder="getLanguage['DM']['MTEP']"
                                                                                        :disabled="bool_disableInsertDomain || (getUserInfo.AT>= 3 && setting.MTIALT > 0)"
                                                                                        @input="AlternateMobileTemplateChange($event,index)"
                                                                                        v-model="setting.MTIALT" />
                                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('MTIALT', 'MTEP', index) }}</span>
                                                                        </div>
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["CTO"]}} <span class="required" /></label>
                                                                            <treeselect :multiple="false"
                                                                                        :key="setting.MTIALT+index"
                                                                                        :options="dd_mtemplateskins[setting.MTIALT]"
                                                                                        :placeholder="getLanguage['DM']['CTO']"
                                                                                        :disabled="bool_disableInsertDomain || !setting.MTIALT || setting.MTIALT == 0 || (getUserInfo.AT == 3 && setting.MTSIALT >= 0)"
                                                                                        v-model="setting.MTSIALT" />
                                                                            <span class="ErrMsg">{{ ValidationDomainErrMsg('MTSIALT', 'CTO', index) }}</span>
                                                                        </div>
                                                                        <div class="input-group-append" @click="previewImgUrl = getTemplateUrl(setting.MTIALT, 'img', 'mobile')" :style="(setting.MTIALT > 0 && setting.MTSIALT >= 0) ? '' : 'visibility:hidden ' " style="height: calc(1.5em + .4rem + 2px) !important;font-size: .76563rem;margin-top: 28px;">
                                                                            <label class="input-group-text pointer"  style=" border-radius: 5px !important;"><i class="fa fa-eye"></i></label>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="form-group" v-if="getUserInfo.AT == 0">
                                                                    <div class="input-group input-group-sm" style="flex-wrap: nowrap; gap: 5px; display: grid; grid-template-columns: auto auto 30px;">
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["CURL"]}} <span class="mandatory_Field">**</span></label>
                                                                            <input type="text" v-model="setting.ALTMCURL" class="form-control form-control-sm" list="dd_imageList" :disabled="bool_disableInsertDomain" />
                                                                            <datalist id="dd_imageList">
                                                                                <option v-for="(data,index) in dd_imageList">{{ data }}</option>
                                                                            </datalist>
                                                                        </div>
                                                                        <div>
                                                                            <label class="col-form-label-sm">{{getLanguage["DM"]["GCURL"]}} <span class="mandatory_Field">**</span></label>
                                                                            <input type="text" v-model="setting.ALTMGCURL" class="form-control form-control-sm" list="dd_GPimageList" :disabled="bool_disableInsertDomain" />
                                                                            <datalist id="dd_GPimageList">
                                                                                <option v-for="(data,index) in dd_GPimageList">{{ data }}</option>
                                                                            </datalist>
                                                                        </div>
                                                                        <div class="input-group-append" style="height: calc(1.5em + .4rem + 2px) !important; font-size: .76563rem; margin-top: 28px; visibility: hidden">
                                                                            <label class="input-group-text pointer" style=" border-radius: 5px !important;"><i class="fa fa-eye"></i></label>
                                                                        </div>
                                                                    </div>

                                                                    <div class="mt-2" v-if="setting.ALTMGCURL  == 'lobby01_light/' || setting.GCURL  == 'lobby01_black/'|| setting.GCURL  == 'lobby02/'|| setting.GCURL  == 'lobby03/'|| setting.GCURL  == 'lobby04/'|| setting.GCURL  == 'lobby05/' || setting.GCURL  == 'lobby06/'">
                                                                        <label class="col-form-label-sm">{{getLanguage["DM"]["GCURL"]}} {{getLanguage["GL"]["P"]}}</label>
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby01_light/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTMGCURL == 'lobby01_light/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby01_black/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTMGCURL == 'lobby01_black/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby02/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTMGCURL == 'lobby02/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby03/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTMGCURL == 'lobby03/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby04/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTMGCURL == 'lobby04/' ? 'display:block' : 'display:none' " />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby05/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTMGCURL == 'lobby05/' ? 'display:block' : 'display:none'" />
                                                                        <img src="https://d2lcoivv20vty7.cloudfront.net/Content/media/game/lobby/lobby06/bo_preview.webp" class="img-fluid" loading="lazy" :style="setting .ALTMGCURL == 'lobby06/' ? 'display:block' : 'display:none'" />
                                                                    </div>
                                                                </div>
                                                            </CCol>
                                                        </CRow>
                                                    </div>
                                                </CRow>
                                            </div>


                                            <CRow>
                                                <CCol col="12">
                                                    <div class="sectionDivider subHeaderHR"></div>
                                                    <h6 class="card-title section-title font-weight-bold">{{getLanguage["AFB1188"]["AFB1188"]}} {{getLanguage["DM"]["T"]}}</h6>
                                                </CCol>
                                            </CRow>
                                            <CRow>
                                                <CCol col="3">
                                                    <div class="form-group">
                                                        <label class="col-form-label-sm">{{getLanguage["DM"]["AFB1188SW1"]}}</label>
                                                        <div class="input-group input-group-sm" style="flex-wrap: nowrap;gap:5px">
                                                            <treeselect :multiple="false"
                                                                        :options="dd_1188SW"
                                                                        :placeholder="getLanguage['DM']['T']"
                                                                        :disabled="bool_disableInsertDomain || (getUserInfo.AT>= 3 && setting.AFB1188SW != '')"
                                                                        v-model="setting.AFB1188SW" />
                                                            <div class="input-group-append pointer" @click="previewImgUrl = getAFBSportsTemplateUrl(setting.AFB1188SW, 'desktop')">
                                                                <span class="input-group-text"  style=" border-radius: 5px !important;"> <i class="fa fa-eye"></i></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CCol>
                                                <CCol col="3">
                                                    <div class="form-group">
                                                        <label class="col-form-label-sm">{{getLanguage["DM"]["AFB1188SM1"]}}</label>
                                                        <div class="input-group input-group-sm" style="flex-wrap: nowrap;gap:5px">
                                                            <treeselect :multiple="false"
                                                                        :options="dd_1188SM"
                                                                        :placeholder="getLanguage['DM']['MTEP']"
                                                                        :disabled="bool_disableInsertDomain || (getUserInfo.AT>= 3 && setting.AFB1188SM != '')"
                                                                        v-model="setting.AFB1188SM" />
                                                            <div class="input-group-append pointer" @click="previewImgUrl = getAFBSportsTemplateUrl(setting.AFB1188SM, 'mobile')">
                                                                <span class="input-group-text" style=" border-radius: 5px !important;"> <i class="fa fa-eye"></i></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </CCol>
                                                <CCol col="3" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["DM"]["AFB1188OS"]}}</label>
                                                    <div class="custom-tooltip ml-2">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2" style="width: 280px; white-space: pre-line; right: 50%; left: auto; ">{{getLanguage["DM"]["OSD"]}}</span>
                                                    </div>

                                                    <treeselect :multiple="false"
                                                                :options="dd_1188OS"
                                                                v-model="setting.AFB1188OS" :disabled="bool_disableInsertDomain" />
                                                </CCol>
                                                <CCol col="3" class="form-group">
                                                    <label class="col-form-label-sm">{{getLanguage["DM"]["AFB1188OM"]}}</label>
                                                    <div class="custom-tooltip ml-2">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2" style="width: 360px; white-space: pre-line; right: 50%; left: auto;">{{getLanguage["DM"]["OMD"]}}</span>
                                                    </div>
                                                    <treeselect :multiple="false"
                                                                :options="dd_1188OM"
                                                                v-model="setting.AFB1188OM" :disabled="bool_disableInsertDomain" />
                                                </CCol>
                                                <CCol col="3" class="form-group" v-if="getUserInfo.AT == 0">
                                                    <label class="col-form-label-sm">{{getLanguage["DM"]["AFB1188SBAPI"]}}</label>
                                                    <treeselect :multiple="false"
                                                                :options="dd_1188API"
                                                                v-model="obj_Domain.AFB1188SBAPI" :disabled="bool_disableInsertDomain" />
                                                </CCol>
                                            </CRow>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </CRow>

                    <CRow>
                        <CCol col="12">
                            <div style="text-align:center;margin-top:20px" v-if="(this.$route.query.agi !== undefined && this.$route.query.di !== undefined && this.$route.query.lci !== undefined && this.$route.query.acsi !== undefined && this.$route.query.bai !== undefined)">
                                <!--<CButton color="outline-info" size="sm" @click="saveSelfService('dmss')">-->
                                <CButton color="outline-info" size="sm" @click="saveDomainConfig()">
                                    <span class='fa fa-save mr-2'></span>
                                    {{ getLanguage["BTN"]["SV"] }}
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                </template>

                <!-- Website Configuration Setting -->
                <CRow class="mx-0" v-if="bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT > 2)">
                    <CCol col="12">
                        <h6 class="card-title section-title2"
                            data-section="acs"
                            @click="showSectionBasedRole('acs')"
                            :class="selectedSection === 'acs' ? 'bg-blue text-white' : ''">
                            <!--<span :class="(!this.$v.obj_bankacc.$error && bool_groupCV) ? 'bg-success' : ''">-->
                            <span :class="getSectionClasses('acs', !$v.obj_bankacc.$error && bool_groupCV)">
                                {{ getSectionIndex(5) }}
                            </span>
                            {{this.getLanguage["ACU"]["ACF"]}} {{this.getLanguage["ACU"]["ST"]}}
                            <i :class="setCollapseExpandIcon('AC')"></i>
                        </h6>
                    </CCol>
                </CRow>
                <template v-if="bool_showACS && bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT > 2)">
                    <CRow class="mx-0">
                        <CCol col="12">
                            <table>
                                <tr>
                                    <td><CButton @click="showAgentConfig(1)" color="primary" :class="agentconfig_LS ? 'mb-2 active' : 'mb-2'">{{this.getLanguage["ACU"]["LS"]}}</CButton></td>
                                    <!--<td><CButton @click="showAgentConfig(2)" color="primary" :class="agentconfig_RS ? 'mb-2 active' : 'mb-2'">{{this.getLanguage["ACU"]["RS"]}}</CButton></td>-->
                                    <!--<td v-if="(this.$route.query.cri == 0 || this.$route.query.cri == undefined)"><CButton @click="showAgentConfig(2)" color="primary" :class="agentconfig_RS ? 'mb-2 active' : 'mb-2'">{{this.getLanguage["ACU"]["RS"]}}</CButton></td>-->
                                    <td><CButton @click="showAgentConfig(3)" color="primary" :class="agentconfig_MSS ? 'mb-2 active' : 'mb-2'">{{this.getLanguage["ACU"]["MSS"]}}</CButton></td>
                                    <td><CButton @click="showAgentConfig(4)" color="primary" :class="agentconfig_BBOS ? 'mb-2 active' : 'mb-2'">{{this.getLanguage["ACU"]["BBOS"]}}</CButton></td>
                                    <td><CButton @click="showAgentConfig(5)" color="primary" :class="agentconfig_CS ? 'mb-2 active' : 'mb-2'">{{this.getLanguage["ACU"]["CS"]}}</CButton></td>
                                </tr>
                            </table>

                            <div>
                                <!--LOGIN SETTING DIV-->
                                <CCollapse :show="agentconfig_LS">
                                    <CCard body-wrapper>
                                        <CRow>
                                            <CCol col="12" class="mb-2">
                                                <p class="h6">
                                                    {{this.getLanguage["ACU"]["LS"]}}
                                                </p>
                                                <div class='subHeaderHR'></div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch">
                                                    <input type="checkbox" :checked="arry_OnOff.LoginSetting.SL.CV" @change="handleToggleChange('LoginSetting','SL')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SL"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SL"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid" v-if="this.getUserInfo.AT == 0">
                                                <label class="switch">
                                                    <input type="checkbox" :checked="arry_OnOff.LoginSetting.LD.CV" @change="handleToggleChange('LoginSetting','LD')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["ELD"]}} <span class="mandatory_Field">**</span></label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["ELD"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6">
                                                <div class="flexcontainer">
                                                    <label class="col-form-label p-0">{{this.getLanguage["ACU"]["CO"]}} :</label>
                                                    <div>
                                                        <!-- For Loop to generate all captcha options -->
                                                        <div v-for="option in captchaOptions" :key="option.value" class="flex-item agentcus-grid">
                                                            <input type="radio"
                                                                   name="radioCaptcha"
                                                                   v-model="str_WebConfigCaptchaOption"
                                                                   :value="option.value"
                                                                   :checked="option.value === str_WebConfigCaptchaOption"
                                                                   :style="renderStyle()" />
                                                            <label>{{ getLanguage["ACO"][option.languageKey] }}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"][option.languageKey] }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>

                                            <!--=========== disable member site action =========-->
                                            <CCol xl="6" v-if="this.getUserInfo.AT == 0">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <input type="checkbox" :checked="bool_DMSA" @change="v=>disableMemberSite(v.target.checked)">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DMSA"]}}<span class="mandatory_Field">**</span></label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DMSA"]}}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="flex-item agentcus-grid">
                                                            <label class="switch">
                                                                <!--<input type="checkbox" :checked="arry_OnOff.DMAL.CV" :disabled="!bool_DMSA" @change="v => arry_OnOff.DMAL.CV = v.target.checked">-->
                                                                <input type="checkbox" :checked="arry_OnOff.LoginSetting.DMAL.CV" :disabled="!bool_DMSA" @change="handleToggleChange('LoginSetting','DMAL')">
                                                                <span class="slider round" :style="[!bool_DMSA ?{'cursor':'not-allowed'}:{}]"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DMAL"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DMAL"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <label class="switch">
                                                                <!--<input type="checkbox" :checked="arry_OnOff.DMAR.CV" :disabled="!bool_DMSA" @change="v => arry_OnOff.DMAR.CV = v.target.checked">-->
                                                                <input type="checkbox" :checked="arry_OnOff.LoginSetting.DMAR.CV" :disabled="!bool_DMSA" @change="handleToggleChange('LoginSetting','DMAR')">
                                                                <span class="slider round" :style="[!bool_DMSA ?{'cursor':'not-allowed'}:{}]"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DMAR"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DMAR"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <label class="switch">
                                                                <!--<input type="checkbox" :checked="arry_OnOff.DMAD.CV" :disabled="!bool_DMSA" @change="v => arry_OnOff.DMAD.CV = v.target.checked">-->
                                                                <input type="checkbox" :checked="arry_OnOff.LoginSetting.DMAD.CV" :disabled="!bool_DMSA" @change="handleToggleChange('LoginSetting','DMAD')">
                                                                <span class="slider round" :style="[!bool_DMSA ?{'cursor':'not-allowed'}:{}]"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DMAD"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DMAD"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <label class="switch">
                                                                <!--<input type="checkbox" :checked="arry_OnOff.DMAW.CV" :disabled="!bool_DMSA" @change="v => arry_OnOff.DMAW.CV = v.target.checked">-->
                                                                <input type="checkbox" :checked="arry_OnOff.LoginSetting.DMAW.CV" :disabled="!bool_DMSA" @change="handleToggleChange('LoginSetting','DMAW')">
                                                                <span class="slider round" :style="[!bool_DMSA ?{'cursor':'not-allowed'}:{}]"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DMAW"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DMAW"]}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>

                                            <!--=========== Enable Forgot Password Link =========-->
                                            <CCol xl="6">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.EFPL.CV" @change="v => arry_OnOff.EFPL.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.LoginSetting.EFPL.CV" @change="handleToggleChange('LoginSetting','EFPL')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{ getLanguage["ACO"]["EFPL"] }}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["EFPL"] }}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="arry_OnOff.LoginSetting.EFPL.CV">
                                                        <div class="flex-item agentcus-grid">
                                                            <input type="radio"
                                                                   name="ForgotPasswordLinkOption"
                                                                   v-model="str_ForgotPasswordLinkOption"
                                                                   value="FPDTMB"
                                                                   :style="renderStyle()" />
                                                            <label>{{ getLanguage["ACO"]["DTMB"] }}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DTMB"] }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <input type="radio"
                                                                   name="ForgotPasswordLinkOption"
                                                                   v-model="str_ForgotPasswordLinkOption"
                                                                   value="FPDT"
                                                                   :style="renderStyle()" />
                                                            <label>{{ getLanguage["ACO"]["DT"] }}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DT"] }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <input type="radio"
                                                                   name="ForgotPasswordLinkOption"
                                                                   v-model="str_ForgotPasswordLinkOption"
                                                                   value="FPMB"
                                                                   :style="renderStyle()" />
                                                            <label>{{ getLanguage["ACO"]["MB"] }}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["MB"] }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                        </CRow>
                                    </CCard>
                                </CCollapse>
                                <!--LOGIN SETTING DIV END-->
                                <!--REGISTRATION SETTING DIV-->
                                <CCollapse :show="agentconfig_RS">
                                    <CCard body-wrapper>
                                        <CRow>
                                            <CCol col="12" class="mb-2">
                                                <p class="h6">
                                                    {{this.getLanguage["ACU"]["RS"]}}
                                                </p>
                                                <div class='subHeaderHR'></div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.RFWMP.CV" @change="v => arry_OnOff.RFWMP.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.RFWMP.CV" @change="handleToggleChange('RegistrationSetting','RFWMP')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RFWMP"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RFWMP"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.RWBA.CV" @change="v => arry_OnOff.RWBA.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.RWBA.CV" @change="handleToggleChange('RegistrationSetting','RWBA')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RWBA"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RWBA"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.RWEA.CV" @change="v => arry_OnOff.RWEA.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.RWEA.CV" @change="handleToggleChange('RegistrationSetting','RWEA')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RWEA"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RWEA"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.CDBACC.CV" @change="v => arry_OnOff.CDBACC.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.CDBACC.CV" @change="handleToggleChange('RegistrationSetting','CDBACC')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["CDBACC"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CDBACC"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.CDPNO.CV" @change="v => arry_OnOff.CDPNO.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.CDPNO.CV" @change="handleToggleChange('RegistrationSetting','CDPNO')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["CDPNO"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CDPNO"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.RPN.CV" @change="v => arry_OnOff.RPN.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.RPN.CV" @change="handleToggleChange('RegistrationSetting','RPN')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RPN"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RPN"]}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="arry_OnOff.RegistrationSetting.RPN.CV == true">
                                                        <div class="flex-item agentcus-grid">
                                                            <label :style="renderStyle()">
                                                                <!--<input type="checkbox" :checked="arry_OnOff.DOTPV.CV" @change="v => arry_OnOff.DOTPV.CV = v.target.checked">-->
                                                                <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.DOTPV.CV" @change="handleToggleChange('RegistrationSetting','DOTPV')">
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{ this.getLanguage["ACO"]["DOTPV"] }}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{ this.getLanguage["ACU"]["DOTPV"] }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <!--<input type="radio" name="captcha" :checked="arry_OnOff.REGWPHONE.CV" value="true" @change="v => arry_OnOff.REGWPHONE.CV = true" :style="renderStyle()">-->
                                                            <input type="radio" name="radioRegWPhone" :checked="arry_OnOff.RegistrationSetting.REGWPHONE.CV" value="true" @change="handleToggleChange('RegistrationSetting','REGWPHONE')" :style="renderStyle()">
                                                            <label for="html">{{this.getLanguage["ACO"]["REGWPHONE"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["REGWPHONE"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <!--<input type="radio" name="captcha" :checked="!arry_OnOff.REGWPHONE.CV" value="false" @change="v => arry_OnOff.REGWPHONE.CV = false" :style="renderStyle()">-->
                                                            <input type="radio" name="radioRegWPhone" :checked="!arry_OnOff.RegistrationSetting.REGWPHONE.CV" value="false" @change="handleToggleChange('RegistrationSetting','REGWPHONE')" :style="renderStyle()">
                                                            <label for="html">{{this.getLanguage["ACO"]["UANAU"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["UANAU"]}}</span>
                                                            </div>
                                                        </div>
                                                        <br />
                                                        <!--LOCALIZED-->
                                                        <div class="flex-item agentcus-grid">
                                                            <label class="switch" :style="renderStyle()">
                                                                <!--<input type="checkbox" :checked="arry_OnOff.ULPN.CV" @change="v => arry_OnOff.ULPN.CV = v.target.checked">-->
                                                                <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.ULPN.CV" @change="handleToggleChange('RegistrationSetting','ULPN')">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{ this.getLanguage["ACO"]["ULPN"] }}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{ this.getLanguage["ACU"]["ULPN"] }}</span>
                                                            </div>
                                                        </div>

                                                        <!--PREFIX-->
                                                        <div class="flex-item agentcus-grid" v-if="arry_OnOff.RegistrationSetting.ULPN.CV == true">
                                                            <label class="switch" :style="renderStyle()">
                                                                <!--<input type="checkbox" :checked="arry_OnOff.UPCODE.CV" @change="v => arry_OnOff.UPCODE.CV = v.target.checked">-->
                                                                <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.UPCODE.CV" @change="handleToggleChange('RegistrationSetting','UPCODE')">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{ this.getLanguage["ACO"]["UPCODE"] }}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{ this.getLanguage["ACU"]["UPCODE"] }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item" v-if="arry_OnOff.RegistrationSetting.ULPN.CV == true">
                                                            <CInput class="inline inline30" :placeholder="getLanguage['ACO']['CCODE']" size="sm" :value="arry_aac.E_CC" @change="v => arry_aac.E_CC = v"></CInput>
                                                            <CInput style="margin-left: 3px;" class="inline inline30" :placeholder="getLanguage['ACO']['PCODE']" size="sm" :value="arry_aac.E_PC" @change="v => arry_aac.E_PC = v"></CInput>
                                                            <CButton style="margin-left: 15px; margin-top: 0px;" color="outline-dark" size="sm" class="btn-small inline inline10" @click="addPrefix()">
                                                                <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                                            </CButton>
                                                        </div>
                                                        <br />
                                                        <div class="flex-item" v-if="arry_OnOff.RegistrationSetting.ULPN.CV == true">
                                                            <table class="custom-table custom-table-inPopUp afb-blue" style="width: 85% !important">
                                                                <thead>
                                                                    <tr>
                                                                        <th v-if="!bool_isView" style="width: 30px;">{{ this.getLanguage['GL']['ACT'] }}</th>
                                                                        <th style="width: 50% !important">{{ this.getLanguage['ACO']['CCODE'] }}</th>
                                                                        <th>{{ this.getLanguage["ACO"]["PCODE"] }}</th>
                                                                        <th>{{ this.getLanguage["ACO"]["LDZ"] }}</th>
                                                                        <th>{{ this.getLanguage["ACO"]["PS"] }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                <td colspan="100%" v-if="arry_aac.LocalisedList == 0 || !arry_aac.LocalisedList">{{ this.getLanguage['GL']['NR'] }}</td>
                                                                <tr v-for="(data,index) in arry_aac.LocalisedList" class="">
                                                                    <td v-if="!bool_isView">
                                                                        <span id="actionBtnCol"> <i class="cil-trash" @click='removeLocaliseList(index)'></i> </span>
                                                                    </td>
                                                                    <td>+{{ data.CC }}</td>
                                                                    <td>{{ data.PC }}</td>
                                                                    <td>
                                                                        <input type="checkbox" v-if="data.PC != ''" :checked="data.LZ > 0" @click="tickLeadinZero($event, data, data.LZ, CountItem(index+1))" :style="renderStyle()" />
                                                                    </td>
                                                                    <td>+{{ data.PN }}</td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <br />
                                                    </div>
                                                </div>
                                            </CCol>

                                            <!--BLOCK-->
                                            <!--<CCol xl="6">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <input type="checkbox" :checked="arry_OnOff.REGWPHONE.CV" @change="v => arry_OnOff.REGWPHONE.CV = v.target.checked">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["REGWPHONE"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["REGWPHONE"]}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>-->
                                            <!--LOCAL-->
                                            <CCol xl="6">
                                                <div class="agentcus-grid">
                                                    <label class="switch" :style="renderStyle()">
                                                        <!--<input type="checkbox" :checked="arry_OnOff.FNM.CV" @change="v => arry_OnOff.FNM.CV = v.target.checked">-->
                                                        <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.FNM.CV" @change="handleToggleChange('RegistrationSetting','FNM')">
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["FNM"]}}</label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["FNM"]}}</span>
                                                    </div>
                                                </div>
                                            </CCol>

                                            <!--Hide Currency Dropdown If Having Only One Option-->
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HCDIHO.CV" @change="v => arry_OnOff.HCDIHO.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.HCDIHO.CV" @change="handleToggleChange('RegistrationSetting','HCDIHO')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HCDIHO"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HCDIHO"]}}</span>
                                                </div>
                                            </CCol>

                                            <!--=== Enable UserID Numeric ==-->
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.EUN.CV" @change="v => arry_OnOff.EUN.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.EUN.CV" @change="handleToggleChange('RegistrationSetting','EUN')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["UN"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["UN"]}}</span>
                                                </div>
                                            </CCol>

                                            <!--=== Show referral code in member register form ==-->
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.SRC.CV" @change="v => arry_OnOff.SRC.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.SRC.CV" @change="handleToggleChange('RegistrationSetting','SRC')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SRC"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["SRC"]}}</span>
                                                </div>
                                            </CCol>
                                            <!--=== Block All Black Listed Bank Account ==-->
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.BABLBA.CV" @change="v => arry_OnOff.BABLBA.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.BABLBA.CV" @change="handleToggleChange('RegistrationSetting','BABLBA')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["BABLBA"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["BABLBA"]}}</span>
                                                </div>
                                            </CCol>
                                            <!--=== Social Media ==-->
                                            <CCol xl="6">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.SM.CV" @change="v => arry_OnOff.SM.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.RegistrationSetting.SM.CV" @change="handleToggleChange('RegistrationSetting','SM')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SM"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["SM"]}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="arry_OnOff.RegistrationSetting.SM.CV == true">
                                                        <!--=== wechat, line, whatsapp, telegram, zalo  ==-->
                                                        <div class="flex-item agentcus-grid">
                                                            <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.WCID.CV" @change="v => arry_OnOff.WCID.CV = v.target.checked" :style="renderStyle()">-->
                                                            <input type="checkbox" name="radioSocialMedia" :checked="arry_OnOff.RegistrationSetting.WCID.CV" @change="handleToggleChange('RegistrationSetting','WCID')" :style="renderStyle()">
                                                            <label for="html">{{this.getLanguage["ACO"]["WC"]}} <span class="mandatory_Field">*</span></label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["WC"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.LID.CV" @change="v => arry_OnOff.LID.CV = v.target.checked" :style="renderStyle()">-->
                                                            <input type="checkbox" name="radioSocialMedia" :checked="arry_OnOff.RegistrationSetting.LID.CV" @change="handleToggleChange('RegistrationSetting','LID')" :style="renderStyle()">
                                                            <label for="html">{{this.getLanguage["ACO"]["LID"]}} <span class="mandatory_Field">*</span></label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["LID"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.WAID.CV" @change="v => arry_OnOff.WAID.CV = v.target.checked" :style="renderStyle()">-->
                                                            <input type="checkbox" name="radioSocialMedia" :checked="arry_OnOff.RegistrationSetting.WAID.CV" @change="handleToggleChange('RegistrationSetting','WAID')" :style="renderStyle()">
                                                            <label for="html">{{this.getLanguage["ACO"]["WAID"]}} <span class="mandatory_Field">*</span></label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["WAID"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.TGID.CV" @change="v => arry_OnOff.TGID.CV = v.target.checked" :style="renderStyle()">-->
                                                            <input type="checkbox" name="radioSocialMedia" :checked="arry_OnOff.RegistrationSetting.TGID.CV" @change="handleToggleChange('RegistrationSetting','TGID')" :style="renderStyle()">
                                                            <label for="html">{{this.getLanguage["ACO"]["TGID"]}} <span class="mandatory_Field">*</span></label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["TGID"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.ZLID.CV" @change="v => arry_OnOff.ZLID.CV = v.target.checked" :style="renderStyle()">-->
                                                            <input type="checkbox" name="radioSocialMedia" :checked="arry_OnOff.RegistrationSetting.ZLID.CV" @change="handleToggleChange('RegistrationSetting','ZLID')" :style="renderStyle()">
                                                            <label for="html">{{this.getLanguage["ACO"]["ZLID"]}} <span class="mandatory_Field">*</span></label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["ZLID"]}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                        </CRow>
                                    </CCard>
                                </CCollapse>
                                <!--REGISTRATION SETTING DIV END-->
                                <!-- ========================== -->
                                <!--MEMBER SITE SETTING DIV-->
                                <CCollapse :show="agentconfig_MSS">
                                    <CCard body-wrapper>
                                        <CRow>
                                            <CCol col="12" class="mb-2">
                                                <p class="h6">
                                                    {{this.getLanguage["ACU"]["MSS"]}}
                                                </p>
                                                <div class='subHeaderHR'></div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.LMIAA.CV" @change="v => arry_OnOff.LMIAA.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.LMIAA.CV" @change="handleToggleChange('MemberSiteSetting','LMIAA')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["LMIAA"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["LMIAA"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HSCM.CV" @change="v => arry_OnOff.HSCM.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HSCM.CV" @change="handleToggleChange('MemberSiteSetting','HSCM')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HSCM"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HSCM"]}}</span>
                                                </div>
                                            </CCol>
                                            <!--Enable Floating Left QR Code-->
                                            <CCol xl="6" v-if='ShowFullAgentConfig'>
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <input type="checkbox" :checked="bool_HFLQRC" @change="v=> bool_HFLQRC = v.target.checked">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HSQRCM"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HSQRCM"]}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="bool_HFLQRC">
                                                        <div class="flex-item agentcus-grid">
                                                            <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HQRCBL.CV" @change="handleToggleChange('MemberSiteSetting','HQRCBL')">
                                                            <label>{{this.getLanguage["PV"]["DBL"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["PV"]["DBL"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HSQRCM.CV" @change="handleToggleChange('MemberSiteSetting','HSQRCM')">
                                                            <label>{{this.getLanguage["PV"]["DAL"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["PV"]["DAL"]}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                           
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.SQRCSM.CV" @change="v => arry_OnOff.SQRCSM.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.SQRCSM.CV" @change="handleToggleChange('MemberSiteSetting','SQRCSM')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SQRCSM"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SQRCSM"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HICSM.CV" @change="v => arry_OnOff.HICSM.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HICSM.CV" @change="handleToggleChange('MemberSiteSetting','HICSM')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HICSM"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HICSM"]}}</span>
                                                </div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HBLPU.CV" @change="v => arry_OnOff.HBLPU.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HBLPU.CV" @change="handleToggleChange('MemberSiteSetting','HBLPU')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HBLPU"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HBLPU"]}}</span>
                                                </div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid" v-if="this.getUserInfo.AT == 0">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.DWOTT.CV" @change="v => arry_OnOff.DWOTT.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.DWOTT.CV" @change="handleToggleChange('MemberSiteSetting','DWOTT')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["TAW"]}} <span class="mandatory_Field">**</span></label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["TAW"]}}</span>
                                                </div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid" v-if="ShowFullAgentConfig">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.DODDS.CV" @change="v => arry_OnOff.DODDS.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.DODDS.CV" @change="handleToggleChange('MemberSiteSetting','DODDS')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["ESOMS"]}} </label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["ESOMS"]}}</span>
                                                </div>

                                                <div v-if="arry_OnOff.MemberSiteSetting.DODDS.CV">
                                                    <div class="flex-item" style="display: grid; grid-template-columns: 140px 180px; gap: 5px;">
                                                        <label class="ACUZ_DO col-form-label">
                                                            {{this.getLanguage["ACO"]["SOT"]}}
                                                        </label>
                                                        <customtreeselect v-model="selectedSOTValue"
                                                                          :options="sportOddsTypeOptions"
                                                                          :multiple="false"
                                                                          :flat="true"
                                                                          @input="selectedTOValue = null"
                                                                          :placeholder="getLanguage['ACO']['SOT']" />
                                                    </div>
                                                    <div class="flex-item" style="display: grid; grid-template-columns: 140px 180px 45px; gap: 5px;">
                                                        <label class="ACUZ_DO col-form-label">
                                                            {{this.getLanguage["ACO"]["TO"]}}
                                                        </label>
                                                        <customtreeselect v-model="selectedTOValue"
                                                                          :options="filteredThemeOptions"
                                                                          :multiple="false"
                                                                          :flat="true"
                                                                          :placeholder="getLanguage['ACO']['TO']" />
                                                        <div class="input-group-append" @click="previewImgUrl = 'https://media.afb.gg/SportOdd/'+selectedSOTValue+selectedTOValue+'.png'" :style="(selectedTOValue && sportOddsTypeOptions) ? '' : 'visibility:hidden ' " style="height: calc(1.5em + .4rem + 2px) !important;font-size: .76563rem;">
                                                            <label class="input-group-text pointer" style=" border-radius: 5px !important;"><i class="fa fa-eye"></i></label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.EAFBFHP.CV" @change="v => arry_OnOff.EAFBFHP.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.EAFBFHP.CV" @change="handleToggleChange('MemberSiteSetting','EAFBFHP')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EAFBFHP"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["EAFBFHP"]}}</span>
                                                </div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.DDNF.CV" @change="v => arry_OnOff.DDNF.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.DDNF.CV" @change="handleToggleChange('MemberSiteSetting','DDNF')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DDNF"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["DDNF"]}}</span>
                                                </div>
                                            </CCol>

                                            <!--=== Mask Downline Member Name in Affiliate ==-->
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.MDMIA.CV" @change="v => arry_OnOff.MDMIA.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.MDMIA.CV" @change="handleToggleChange('MemberSiteSetting','MDMIA')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["MDMIA"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["MDMIA"]}}</span>
                                                </div>
                                            </CCol>
                                            <!--=== Hide Main Affiliate Name ==-->
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HMAN.CV" @change="v => arry_OnOff.HMAN.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HMAN.CV" @change="handleToggleChange('MemberSiteSetting','HMAN')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HMAN"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HMAN"]}}</span>
                                                </div>
                                            </CCol>
                                            <!--=== Hide Affiliate Tiering Table ==-->
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HATT.CV" @change="v => arry_OnOff.HATT.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HATT.CV" @change="handleToggleChange('MemberSiteSetting','HATT')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HATT"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HATT"]}}</span>
                                                </div>
                                            </CCol>
                                            <!--=== Allow free trial on top 5 games ==-->
                                            <CCol xl="6">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.AFTTFG.CV" @change="v => arry_OnOff.AFTTFG.CV = v.target.checked" :style="renderStyle()" @click="AFTTFG(!arry_OnOff.AFTTFG.CV)">-->
                                                            <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.AFTTFG.CV" @change="handleToggleChange('MemberSiteSetting','AFTTFG')" :style="renderStyle()" @click="AFTTFG(!arry_OnOff.MemberSiteSetting.AFTTFG.CV)">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["AFTTFG"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["AFTTFG"]}}</span>
                                                        </div>
                                                    </div>

                                                    <div v-if="arry_OnOff.MemberSiteSetting.AFTTFG.CV == true">
                                                        <div class="flex-item agentcus-grid">
                                                            <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.HFTGBL.CV" @change="v => arry_OnOff.HFTGBL.CV = v.target.checked" :style="renderStyle()">-->
                                                            <input type="checkbox" name="radioFreeTrial" :checked="arry_OnOff.MemberSiteSetting.HFTGBL.CV" @change="handleToggleChange('MemberSiteSetting','HFTGBL')" :style="renderStyle()">
                                                            <label for="html">{{this.getLanguage["ACO"]["HFTGBL"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HFTGBL"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <!--<input type="checkbox" name="captcha" :checked="arry_OnOff.HFTGAL.CV" @change="v => arry_OnOff.HFTGAL.CV = v.target.checked" :style="renderStyle()">-->
                                                            <input type="checkbox" name="radioFreeTrial" :checked="arry_OnOff.MemberSiteSetting.HFTGAL.CV" @change="handleToggleChange('MemberSiteSetting','HFTGAL')" :style="renderStyle()">
                                                            <label for="html">{{this.getLanguage["ACO"]["HFTGAL"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HFTGAL"]}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>

                                            <!--=== Disable System Auto Block ==-->
                                            <CCol xl="6" v-if="this.getUserInfo.AT == 0">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.DSAB.CV" @change="v => arry_OnOff.DSAB.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.DSAB.CV" @change="handleToggleChange('MemberSiteSetting','DSAB')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["DSAB"]}} <span class="mandatory_Field">**</span></label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DSAB"]}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="arry_OnOff.MemberSiteSetting.DSAB.CV == false">
                                                        <div class="flex-item" style="display: grid; grid-template-columns: 140px auto; ">
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACU"]["ID"]}}</label>
                                                            <CInput class="inline inline30" :placeholder="getLanguage['ACU']['ID']" size="sm" :value="arry_aac.InactiveDays" @change="v => arry_aac.InactiveDays = v" :style="renderStyle()"></CInput>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.DDLS.CV" @change="v => arry_OnOff.DDLS.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.DDLS.CV" @change="handleToggleChange('MemberSiteSetting','DDLS')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DDLS"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["DDLS"]}}</span>
                                                </div>
                                            </CCol>

                                            <!--=== launch a game in iframe or in new tab ==-->
                                            <CCol xl="6">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.GLIF.CV" @change="v => arry_OnOff.GLIF.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.GLIF.CV" @change="handleToggleChange('MemberSiteSetting','GLIF')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["GLIF"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["GLIF"]}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="arry_OnOff.MemberSiteSetting.GLIF.CV == true && this.getUserInfo.AT == 0">
                                                        <div class="flex-item agentcus-grid">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.GLIFSW.CV" @change="v => arry_OnOff.GLIFSW.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.GLIFSW.CV" @change="handleToggleChange('MemberSiteSetting','GLIFSW')">
                                                            <label for="html">{{this.getLanguage["ACO"]["GLIFSW"]}} <span class="mandatory_Field">**</span></label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["GLIFSW"]}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                            <!--=== hide last5 game history ==-->
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HL5GH.CV" @change="v => arry_OnOff.HL5GH.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HL5GH.CV" @change="handleToggleChange('MemberSiteSetting','HL5GH')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HL5GH"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HL5GH"]}}</span>
                                                </div>
                                            </CCol>
                                            <!--=== hide top5 ranking tournament (langding page)==-->
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HTR.CV" @change="v => arry_OnOff.HTR.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HTR.CV" @change="handleToggleChange('MemberSiteSetting','HTR')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HTR"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HTR"]}}</span>
                                                </div>
                                            </CCol>

                                            <!--=========== Enable Tournament Bottom Navigation =========-->
                                            <CCol xl="6">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.ETBN.CV" @change="v => arry_OnOff.ETBN.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.ETBN.CV" @change="handleToggleChange('MemberSiteSetting','ETBN')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["ETBN"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["ETBN"]}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="arry_OnOff.MemberSiteSetting.ETBN.CV">
                                                        <div class="flex-item agentcus-grid">
                                                            <input type="radio"
                                                                   name="TournamentNavOption"
                                                                   v-model="str_TournamentNavOption"
                                                                   value="DTMB"
                                                                   :style="renderStyle()" />
                                                            <label>{{ getLanguage["ACO"]["DTMB"] }}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DTMB"] }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <input type="radio"
                                                                   name="TournamentNavOption"
                                                                   v-model="str_TournamentNavOption"
                                                                   value="DT"
                                                                   :style="renderStyle()" />
                                                            <label>{{ getLanguage["ACO"]["DT"] }}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DT"] }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <input type="radio"
                                                                   name="TournamentNavOption"
                                                                   v-model="str_TournamentNavOption"
                                                                   value="MB"
                                                                   :style="renderStyle()" />
                                                            <label>{{ getLanguage["ACO"]["MB"] }}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["MB"] }}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>

                                            <!--=========== Enable Tournament Bottom Navigation End =========-->
                                            <!--=== Disable Game Provider Lobbies ===-->
                                            <CCol xl="6" style="display: none;">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.DGPL.CV" @change="onDisableGameProviderLobbiessChanged($event)">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["DGPL"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["DGPL"]}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="arry_OnOff.MemberSiteSetting.DGPL.CV == false">
                                                        <div class="flex-item">
                                                            <treeselect :multiple="true"
                                                                        :options="dd_gameprovider"
                                                                        :placeholder="getLanguage['GL']['ALL']"
                                                                        v-model="arry_aac.DisabledProviderLobbies"
                                                                        :defaultExpandLevel="1"
                                                                        valueConsistsOf="LEAF_PRIORITY" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>

                                            <!--=== Disable System Auto Block ==-->
                                            <CCol xl="6" v-if="this.getUserInfo.AT == 0">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.EASF.CV" @change="v => arry_OnOff.EASF.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.EASF.CV" @change="handleToggleChange('MemberSiteSetting','EASF')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["EASF"]}} <span class="mandatory_Field">**</span></label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EASF"]}}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                            <!--=== Enable full membersite version ===-->
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.EFV.CV" @change="v => arry_OnOff.EFV.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.EFV.CV" @change="handleToggleChange('MemberSiteSetting','EFV')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EFV"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["EFV"]}}</span>
                                                </div>
                                            </CCol>

                                            <!--=== Enable Game Provider lobby (only for Live Casino) ==-->
                                            <CCol xl="6">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.EGPLL.CV" @change="v => arry_OnOff.EGPLL.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.EGPLL.CV" @change="handleToggleChange('MemberSiteSetting','EGPLL')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EGPLL"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["EGPLL"]}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="arry_OnOff.MemberSiteSetting.EGPLL.CV == true">
                                                        <div class="flex-item agentcus-grid">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.DLGFML.CV" @change="v => arry_OnOff.DLGFML.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.DLGFML.CV" @change="handleToggleChange('MemberSiteSetting','DLGFML')">
                                                            <label for="html">{{this.getLanguage["ACO"]["DLGFML"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DLGFML"]}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                            <!--=== Enable Userful Link ===-->
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.EUL.CV" @change="handleToggleChange('MemberSiteSetting','EUL')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EUL"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["EUL"]}}</span>
                                                </div>
                                            </CCol>
                                            <!--=== Home Page Top 5 Game Setting ===-->
                                            <CCol col="12" class="my-2" v-if='ShowFullAgentConfig'>
                                                <p class="h6">
                                                    {{this.getLanguage["ACU"]["HPT5GS"]}}
                                                </p>
                                                <div class='subHeaderHR'></div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HT5J.CV" @change="v => arry_OnOff.HT5J.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HT5J.CV" @change="handleToggleChange('MemberSiteSetting','HT5J')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HT5J"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HT5J"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HT5S.CV" @change="v => arry_OnOff.HT5S.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HT5S.CV" @change="handleToggleChange('MemberSiteSetting','HT5S')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HT5S"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HT5S"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HT5LC.CV" @change="v => arry_OnOff.HT5LC.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HT5LC.CV" @change="handleToggleChange('MemberSiteSetting','HT5LC')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HT5LC"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HT5LC"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HT5SES.CV" @change="v => arry_OnOff.HT5SES.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HT5SES.CV" @change="handleToggleChange('MemberSiteSetting','HT5SES')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HT5SES"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HT5SES"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.HT5DG.CV" @change="v => arry_OnOff.HT5DG.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.MemberSiteSetting.HT5DG.CV" @change="handleToggleChange('MemberSiteSetting','HT5DG')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HT5DG"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HT5DG"]}}</span>
                                                </div>
                                            </CCol>
                                        </CRow>
                                    </CCard>
                                </CCollapse>
                                <!--MEMBER SITE SETTING DIV END-->
                                <!--BANK & BACK-OFFICE SETTING DIV-->
                                <CCollapse :show="agentconfig_BBOS">
                                    <CCard body-wrapper>
                                        <CRow>
                                            <CCol col="12" class="mb-2">
                                                <!--=== Bank Setting ===-->
                                                <p class="h6">
                                                    {{this.getLanguage["ACU"]["BST"]}}
                                                </p>
                                                <div class='subHeaderHR'></div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.NADBABA.CV" @change="v => arry_OnOff.NADBABA.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.NADBABA.CV" @change="handleToggleChange('BankBackOfficeSetting','NADBABA')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["NADBABA"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NADBABA"]}}</span>
                                                </div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.DDB.CV" @change="v => arry_OnOff.DDB.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.DDB.CV" @change="handleToggleChange('BankBackOfficeSetting','DDB')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["DDB"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DDB"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.NAABA.CV" @change="v => arry_OnOff.NAABA.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.NAABA.CV" @change="handleToggleChange('BankBackOfficeSetting','NAABA')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["NAABA"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NAABA"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.NADBA.CV" @change="v => arry_OnOff.NADBA.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.NADBA.CV" @change="handleToggleChange('BankBackOfficeSetting','NADBA')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["NADBA"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NADBA"]}}</span>
                                                </div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.NBRWD.CV" @change="v => arry_OnOff.NBRWD.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.NBRWD.CV" @change="handleToggleChange('BankBackOfficeSetting','NBRWD')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["NBRWD"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NBRWD"]}}</span>
                                                </div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.OWB.CV" @change="v => arry_OnOff.OWB.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.OWB.CV" @change="handleToggleChange('BankBackOfficeSetting','OWB')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["OWB"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["OWB"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.SSMRB.CV" @change="v => arry_OnOff.SSMRB.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.SSMRB.CV" @change="handleToggleChange('BankBackOfficeSetting','SSMRB')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SSMRB"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SSMRB"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.SHBAN.CV" @change="v => arry_OnOff.SHBAN.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.SHBAN.CV" @change="handleToggleChange('BankBackOfficeSetting','SHBAN')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SHBAN"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SHBAN"]}}</span>
                                                </div>
                                            </CCol>

                                            <!---START---- Hide Manual Deposit Option ------------>
                                            <!--<CCol xl="6" class="agentcus-grid">
    <label class="switch" :style="renderStyle()">-->
                                            <!--<input type="checkbox" :checked="arry_OnOff.HMDO.CV" @change="v => arry_OnOff.HMDO.CV = v.target.checked">-->
                                            <!--<input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.HMDO.CV" @change="handleToggleChange('BankBackOfficeSetting','HMDO')">
            <span class="slider round"></span>
        </label>
        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HMDO"]}}</label>
        <div class="custom-tooltip ACUZ_TT">
            <i class="fa fa-question-circle"></i>
            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HMDO"]}}</span>
        </div>
    </CCol>-->
                                            <!--<CCol xl="6" v-if='ShowFullAgentConfig'>
    <div class="flexcontainer">
        <div class="agentcus-grid">
            <label class="switch" :style="renderStyle()">-->
                                            <!--<input type="checkbox" :checked="arry_OnOff.PDO.CV" @change="v => arry_OnOff.PDO.CV = v.target.checked">-->
                                            <!--<input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.PDO.CV" @change="handleToggleChange('BankBackOfficeSetting','PDO')">
            <span class="slider round"></span>
        </label>
        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["PDO"]}}</label>
        <div class="custom-tooltip ACUZ_TT">
            <i class="fa fa-question-circle"></i>
            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["PDO"]}}</span>
        </div>
    </div>-->
                                            <!-- Deposit Options -->
                                            <!-- For Loop to generate Radio List, check depositOptions data array -->
                                            <!--<div v-if="arry_OnOff.BankBackOfficeSetting.PDO.CV">
                <div v-for="option in depositOptions" :key="option.value" class="flex-item agentcus-grid">
                    <input type="radio"
                           name="radioPrefDeposit"
                           v-model="str_PreferredDepositOption"
                           :value="option.value"
                           :style="renderStyle()" />
                    <label>{{ getLanguage["ACO"][option.languageKey] }}</label>
                    <div class="custom-tooltip ACUZ_TT">
                        <i class="fa fa-question-circle"></i>
                        <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"][option.languageKey] }}</span>
                    </div>
                </div>
            </div>
        </div>

    </CCol>-->
                                            <CCol xl="6" v-if="arry_OnOff.RegistrationSetting.FNM.CV == true">
                                                <div class="agentcus-grid">
                                                    <label class="switch" :style="renderStyle()">
                                                        <!--<input type="checkbox" :checked="arry_OnOff.FNABAN.CV" @change="v => arry_OnOff.FNABAN.CV = v.target.checked">-->
                                                        <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.FNABAN.CV" @change="handleToggleChange('BankBackOfficeSetting','FNABAN')">
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["FNABAN"]}}</label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["FNABAN"]}}</span>
                                                    </div>
                                                </div>
                                            </CCol>

                                            <CCol xl="6">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <!--<input type="checkbox" :checked="arry_OnOff.CBTU.CV" @change="v => arry_OnOff.CBTU.CV = v.target.checked">-->
                                                            <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.CBTU.CV" @change="handleToggleChange('BankBackOfficeSetting','CBTU')">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["CBTU"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CBTU"]}}</span>
                                                        </div>
                                                    </div>
                                                    <!-- Deposit Rate -->
                                                    <div v-if="arry_OnOff.BankBackOfficeSetting.CBTU.CV == true">
                                                        <div class="flex-item" style=" display: grid; grid-template-columns: 140px auto;">
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACU"]["RATE"]}}</label>
                                                            <CInput class="inline inline30" :placeholder="getLanguage['ACU']['RATE']" size="sm" :value="arry_aac.Rate" @change="v => arry_aac.Rate = v"></CInput>
                                                        </div>
                                                    </div>
                                                </div>

                                            </CCol>

                                            <!--=== Enable Bank Account in Numeric ==-->
                                            <!--<CCol xl="6" class="agentcus-grid">
        <label class="switch" :style="renderStyle()">-->
                                            <!--<input type="checkbox" :checked="arry_OnOff.EBAIN.CV" @change="v => arry_OnOff.EBAIN.CV = v.target.checked">-->
                                            <!--<input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.EBAIN.CV" @change="handleToggleChange('BankBackOfficeSetting','EBAIN')">
            <span class="slider round"></span>
        </label>
        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["BAIN"]}}</label>
        <div class="custom-tooltip ACUZ_TT">
            <i class="fa fa-question-circle"></i>
            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["BAIN"]}}</span>
        </div>
    </CCol>-->
                                            <!--===========Member Bank Account Number Validation =========-->
                                            <CCol xl="6">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <input type="checkbox" :checked="bool_EMBANS" @change="v=> bool_EMBANS = v.target.checked">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EMBANS"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EMBANS"]}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="bool_EMBANS">
                                                        <div class="flex-item agentcus-grid">
                                                            <label class="switch">
                                                                <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.MAANE.CV" @change="handleToggleChange('BankBackOfficeSetting','MAANE')">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["AANE"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AANE"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <label class="switch">
                                                                <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.MAEWAS.CV" @change="handleToggleChange('BankBackOfficeSetting','MAEWAS')">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["AEWAS"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AEWAS"]}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                            <!--=== Use Register Bank Account Name ==-->
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.RBAN.CV" @change="v => arry_OnOff.RBAN.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.RBAN.CV" @change="handleToggleChange('BankBackOfficeSetting','RBAN')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RBAN"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["RBAN"]}}</span>
                                                </div>
                                            </CCol>

                                            <CCol col="12" class="my-2">
                                                <!--=== Back Office Setting ===-->
                                                <p class="h6">
                                                    {{this.getLanguage["ACU"]["BOS"]}}
                                                </p>
                                                <div class='subHeaderHR'></div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.EPDN.CV" @change="v => arry_OnOff.EPDN.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.EPDN.CV" @change="handleToggleChange('BankBackOfficeSetting','EPDN')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EPDN"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EPDN"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.EPWN.CV" @change="v => arry_OnOff.EPWN.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.EPWN.CV" @change="handleToggleChange('BankBackOfficeSetting','EPWN')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EPWN"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EPWN"]}}</span>
                                                </div>
                                            </CCol>
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.EPPN.CV" @change="v => arry_OnOff.EPPN.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.EPPN.CV" @change="handleToggleChange('BankBackOfficeSetting','EPPN')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EPPN"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EPPN"]}}</span>
                                                </div>
                                            </CCol>
                                            <!--=== Company Account Details ==-->
                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.CAD.CV" @change="v => arry_OnOff.CAD.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.CAD.CV" @change="handleToggleChange('BankBackOfficeSetting','CAD')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["CAD"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CAD"]}}</span>
                                                </div>
                                            </CCol>
                                            <!--=========== Bank Account Number Validation =========-->
                                            <CCol xl="6">
                                                <div class="flexcontainer">
                                                    <div class="agentcus-grid">
                                                        <label class="switch" :style="renderStyle()">
                                                            <input type="checkbox" :checked="bool_EBANS" @change="v=> bool_EBANS = v.target.checked">
                                                            <span class="slider round"></span>
                                                        </label>
                                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["EBANS"]}}</label>
                                                        <div class="custom-tooltip ACUZ_TT">
                                                            <i class="fa fa-question-circle"></i>
                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EBANS"]}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="bool_EBANS">
                                                        <div class="flex-item agentcus-grid">
                                                            <label class="switch">
                                                                <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.AANE.CV" @change="handleToggleChange('BankBackOfficeSetting','AANE')">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["AANE"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AANE"]}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="flex-item agentcus-grid">
                                                            <label class="switch">
                                                                <input type="checkbox" :checked="arry_OnOff.BankBackOfficeSetting.AEWAS.CV" @change="handleToggleChange('BankBackOfficeSetting','AEWAS')">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["AEWAS"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AEWAS"]}}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                        </CRow>
                                    </CCard>
                                </CCollapse>
                                <!--BANK & BACK-OFFICE SETTING DIV END-->
                                <!--CRYPTO SETTING DIV-->
                                <CCollapse :show="agentconfig_CS">
                                    <CCard body-wrapper>
                                        <CRow>
                                            <CCol col="12" class="mb-2">
                                                <!--=== Crypto Setting ==-->
                                                <p class="h6">
                                                    {{this.getLanguage["ACU"]["CS"]}}
                                                </p>
                                                <div class='subHeaderHR'></div>
                                            </CCol>

                                            <CCol xl="6" class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <!--<input type="checkbox" :checked="arry_OnOff.ECF.CV" @change="v => arry_OnOff.ECF.CV = v.target.checked">-->
                                                    <input type="checkbox" :checked="arry_OnOff.CryptoSetting.ECF.CV" @change="handleToggleChange('CryptoSetting','ECF')">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["ECF"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["ECF"]}}</span>
                                                </div>
                                            </CCol>
                                        </CRow>
                                    </CCard>
                                </CCollapse>
                                <!--CRYPTO SETTING DIV END-->
                            </div>

                            <CCol col="12">
                                <div style="text-align:center;margin-top:20px" v-if="(this.$route.query.agi !== undefined && this.$route.query.di !== undefined && this.$route.query.lci !== undefined && this.$route.query.acsi !== undefined && this.$route.query.bai !== undefined)">
                                    <!--<CButton color="outline-info" size="sm" @click="saveSelfService('acs')">-->
                                    <CButton color="outline-info" size="sm" @click="saveWebsiteConfig()">
                                        <span class='fa fa-save mr-2'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                            </CCol>
                        </CCol>
                    </CRow>
                </template>

                <!-- LiveChat Setting -->
                <CRow class="mx-0" v-if="bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_Group.I > 0">
                    <CCol col="12">
                        <h6 class="card-title section-title2"
                            data-section="lcs"
                            @click="showSectionBasedRole('lcs')"
                            :class="selectedSection === 'lcs' ? 'bg-blue text-white' : ''">
                            <!--<span :class="(!this.$v.obj_livechat.$error && bool_groupCV) ? 'bg-success' : ''">-->
                            <span :class="getSectionClasses('lcs', !$v.obj_livechat.$error && bool_groupCV)">
                                {{ getSectionIndex(6) }}
                            </span>
                            {{this.getLanguage["AG"]["LCS"]}}
                            <i :class="setCollapseExpandIcon('LC')"></i>
                        </h6>
                    </CCol>
                </CRow>
                <template v-if="bool_showLCS && bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_Group.I > 0">
                    <CRow class="mx-0">
                        <CCol col="12">
                            <div class="my-2 d-flex" v-if="obj_livechat.I == 0">
                                <input type="checkbox" id="DILC" v-model="bool_disableInsertLiveChat" :disabled="obj_livechat.DI < 0">
                                <label class="ml-2" for="DILC">{{getLanguage["AG"]["NRFLC"]}}</label>

                                <div class="custom-tooltip ml-2">
                                    <i class="fa fa-question-circle"></i>
                                    <span class="custom-tooltiptext2" style="width: 280px; white-space: pre-line;left: 50%; ">{{getLanguage["AG"]["NRFLCD"]}}</span>
                                </div>
                            </div>
                        </CCol>
                        <CCol col="3">
                            <label class="col-form-label-sm">{{this.getLanguage["LC"]["LCP"]}}<span class="required" /> :</label>
                            <CInput vertical size="sm" v-model="obj_livechat.LCPI" ref="LCPI" :disabled="bool_disableInsertLiveChat" />
                            <span class="ErrMsg">{{ ValidationLiveChatErrMsg('LCPI','LCP') }}</span>
                        </CCol>
                        <CCol col="3">
                            <label class="col-form-label-sm">{{this.getLanguage["LC"]["LK"]}}<span class="required" /> :</label>
                            <CInput vertical size="sm" :value="obj_livechat.LK" @change="v => obj_livechat.LK = v" ref="LK" :disabled="bool_disableInsertLiveChat" />
                            <span class="ErrMsg">{{ ValidationLiveChatErrMsg('LK','LK') }}</span>
                        </CCol>

                        <CCol col="3">
                            <label class="col-form-label-sm">{{this.getLanguage['LC']["L"]}}<span class="required" /> :</label>
                            <treeselect :multiple="true"
                                        :options="dd_language_select"
                                        :placeholder="this.utilGetDDLanguage('LC.L')"
                                        valueConsistsOf="LEAF_PRIORITY"
                                        :defaultExpandLevel="1"
                                        v-model="obj_livechat['arry_holdLang']"
                                        :disabled="bool_disableInsertLiveChat"
                                        ref="arry_holdLang" />
                            <span class="ErrMsg">{{ ValidationLiveChatErrMsg('arry_holdLang','L') }}</span>
                        </CCol>

                        <CCol col="3">
                            <label class="col-form-label-sm">{{getLanguage["LC"]["CF"]}} :</label>
                            <div class="custom-file">
                                <input type="file" class="custom-file-input" id="validatedCustomFile" name="file" accept="application/JSON" @change="onScriptFileSelected" :disabled="bool_disableInsertLiveChat" required>
                                <label class="custom-file-label" for="validatedCustomFile" v-if="selectedScriptFile === null">{{ getLanguage['CTAB']['CAI'] }}.</label>
                                <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedScriptFile.name}}</label>
                            </div>
                        </CCol>

                        <CCol col="12">
                            <label class="col-form-label-sm">{{this.getLanguage["LC"]["S"]}}<span class="required" /> :</label>
                            <textarea vertical=""
                                      rows="6"
                                      class="form-control form-control-sm"
                                      :value="obj_livechat.S"
                                      @change="TextValueChange('S',$event)"
                                      v-shortkey.avoid
                                      :disabled="bool_disableInsertLiveChat"
                                      ref="S" />
                            <span class="ErrMsg">{{ ValidationLiveChatErrMsg('S','S') }}</span>
                        </CCol>

                        <CCol col="12">
                            <label class="col-form-label-sm">{{this.getLanguage["LC"]["LCURLOFM"]}} :</label>
                            <div class="custom-tooltip">
                                <i class="fa fa-question-circle"></i>
                                <span class="custom-tooltiptext2">{{this.getLanguage["LC"]["LCURLTT"]}}</span>
                            </div>
                            <CInput vertical size="sm" v-model="obj_livechat.LCURL" ref="LCURL" :disabled="bool_disableInsertLiveChat" />
                        </CCol>

                        <CCol col="12">
                            <div style="text-align:center;margin-top:20px" v-if="(this.$route.query.agi !== undefined && this.$route.query.di !== undefined && this.$route.query.lci !== undefined && this.$route.query.acsi !== undefined && this.$route.query.bai !== undefined)">
                                <!--<CButton color="outline-info" size="sm" @click="saveSelfService('lcs')">-->
                                <CButton color="outline-info" size="sm" @click="saveLivechatConfig()">
                                    <span class='fa fa-save mr-2'></span>
                                    {{ getLanguage["BTN"]["SV"] }}
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                </template>

                <!-- Bank Account Setting -->
                <CRow class="mx-0" v-if="bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_Group.I > 0">
                    <CCol col="12">
                        <h6 class="card-title section-title2"
                            data-section="bs"
                            @click="showSectionBasedRole('bs')"
                            :class="selectedSection === 'bs' ? 'bg-blue text-white' : ''">
                            <!--<span :class="(!this.$v.obj_bankacc.$error && bool_groupCV) ? 'bg-success' : ''">-->
                            <span :class="getSectionClasses('bs', !$v.obj_bankacc.$error && bool_groupCV)">
                                {{ getSectionIndex(7) }}
                            </span>
                            {{this.getLanguage["AG"]["PGBS"]}}
                            <i :class="setCollapseExpandIcon('PGB')"></i>
                        </h6>
                    </CCol>
                </CRow>
                <template v-if="bool_showBS && bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_Group.I > 0">
                    <CRow class="mx-0">
                        <CCol col="12">
                            <div class="my-2 d-flex" v-if="obj_bankacc.I == 0">
                                <input type="checkbox" id="DIB" v-model="bool_disableInsertBank">
                                <label class="ml-2" for="DIB">{{getLanguage["AG"]["NRFPGB"]}}</label>

                                <div class="custom-tooltip ml-2">
                                    <i class="fa fa-question-circle"></i>
                                    <span class="custom-tooltiptext2" style="width: 280px; white-space: pre-line;left: 50%; ">{{getLanguage["AG"]["NRFPGBD"]}}</span>
                                </div>
                            </div>
                        </CCol>

                        <CCol col="6" class="form-group">
                            <label class="col-form-label-sm">{{this.getLanguage["BAL"]["CC"]}}<span class="required" /> :</label>
                            <treeselect :multiple="false"
                                        :options="dd_cc"
                                        :clearable="false"
                                        v-model="obj_bankacc['CC']"
                                        :flat="true"
                                        :defaultExpandLevel="Infinity"
                                        @input="CountryCodeChange"
                                        :disabled="obj_bankacc.I > 0 || bool_disableInsertBank"
                                        ref="CC" />
                            <span class="ErrMsg">{{ ValidationBankAccountErrMsg('CC','CC') }}</span>

                        </CCol>
                        <CCol col="6">
                            <label class="col-form-label-sm"> {{getLanguage["BAL"]["BN"]}}<span class="required" /> :</label>
                            <treeselect :multiple="false"
                                        :options="dd_bank"
                                        @input="BankChange"
                                        v-model="obj_bankacc['BI']"
                                        :disabled="obj_bankacc.I > 0 || bool_disableInsertBank"
                                        ref="BI" />
                            <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BI','BN') }}</span>
                        </CCol>
                        <CCol col="6">
                            <label class="col-form-label-sm"> {{getLanguage["BAL"]["AT"]}}<span class="required" /> :</label>
                            <treeselect :multiple="false"
                                        :options="arry_accType"
                                        :clearable="false"
                                        @input="setAT_add"
                                        v-model="obj_bankacc['AT']"
                                        :disabled="bool_disableInsertBank"
                                        ref="AT" />
                            <span class="ErrMsg">{{ ValidationBankAccountErrMsg('AT','AT') }}</span>
                        </CCol>
                        <CCol col="6">
                        </CCol>

                        <CCol col="2">
                            <label class="col-form-label-sm"> {{getLanguage["BAL"]["C"]}}<span class="required" /> :</label>
                            <treeselect :multiple="false"
                                        @input="CurrencyChange"
                                        v-model="obj_bankacc['CI']"
                                        :options="dd_currency"
                                        :disabled="obj_bankacc.I > 0"
                                        ref="CI" />
                            <span class="ErrMsg">{{ ValidationErrMsg('CI','C') }}</span>
                        </CCol>
                        <CCol col="4">
                            <label class="col-form-label-sm">{{getLanguage["BAL"]["DC"]}} :</label><br>
                            <label class="switch">
                                <input type="checkbox" :checked="bool_obj_bankaccDC" @change="v => bool_obj_bankaccDC = v.target.checked">
                                <span class="slider round"></span>
                            </label>
                        </CCol>
                        <CCol col="6" v-show="bool_obj_bankaccDC">
                            <div style="display: grid; gap: 5px; grid-template-columns: 1fr .1fr 1fr;">
                                <div>
                                    <label class='col-form-label-sm'>{{ this.getLanguage['PM']['F'] }} (Currency/Amount)<span class="required" /> :</label>
                                    <div style=" display: grid; grid-template-columns: 2fr 4fr;">
                                        <div>
                                            <CInput size="sm"
                                                    vertical
                                                    :value="(bool_obj_bankaccDC ? obj_bankacc.FCS : '').toUpperCase()"
                                                    @change="v => obj_bankacc.FCS = v"
                                                    :disabled="obj_bankacc.FCS == currencySymbol"
                                                    ref="FCS" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('FCS','AC') }}</span>
                                        </div>
                                        <div>
                                            <CInput size="sm"
                                                    vertical
                                                    :value="bool_obj_bankaccDC ? obj_bankacc.ER : ''"
                                                    @change="v => obj_bankacc.ER = v"
                                                    :disabled="obj_bankacc.ER === 1"
                                                    ref="ER" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('ER','ER') }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17" aria-hidden="true" width="20" height="20" style="margin-top: 30px; background: #ebedef; padding: 4px; border-radius: 50%; border: solid 1px #d8dbe0; box-shadow: 1px 1px #313030;cursor:pointer" @click="switchCurrencySymbol();" v-show="obj_bankacc.FCS && obj_bankacc.TCS">
                                        <path fill="currentColor" fill-rule="evenodd" d="M11.726 1.273l2.387 2.394H.667V5h13.446l-2.386 2.393.94.94 4-4-4-4-.94.94zM.666 12.333l4 4 .94-.94L3.22 13h13.447v-1.333H3.22l2.386-2.394-.94-.94-4 4z" clip-rule="evenodd"></path>
                                    </svg>
                                </div>
                                <div>
                                    <label class='col-form-label-sm'>{{ this.getLanguage['PM']['T'] }} (Currency/Amount)<span class="required" /> :</label>
                                    <div style=" display: grid; grid-template-columns: 2fr 4fr;">
                                        <div>
                                            <CInput size="sm"
                                                    vertical
                                                    :value="(bool_obj_bankaccDC ? obj_bankacc.TCS : '').toUpperCase()"
                                                    @change="v => obj_bankacc.TCS = v"
                                                    :disabled="obj_bankacc.TCS == currencySymbol"
                                                    ref="TCS" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('TCS','AC') }}</span>
                                        </div>
                                        <div>
                                            <CInput size="sm"
                                                    vertical
                                                    :value="bool_obj_bankaccDC ? obj_bankacc.TER : ''"
                                                    :placeholder="this.getLanguage['PM']['A']"
                                                    @change="v => obj_bankacc.TER = v"
                                                    ref="TER" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('TER','ER') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CCol>

                        <CCol col="6">
                            <label class="col-form-label-sm"> {{getLanguage["BAL"]["BANM"]}}<span class="required" /> :</label>
                            <CInput vertical
                                    size="sm"
                                    :value="obj_bankacc.BA"
                                    @change="v => obj_bankacc.BA = v"
                                    :disabled="obj_bankacc.I > 0 || bool_disableInsertBank"
                                    ref="BA" />
                            <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BA','BANM') }}</span>
                        </CCol>
                        <CCol col="6">
                            <label class="col-form-label-sm"> {{getLanguage["BAL"]["BANO"]}}<span class="required" /> :</label>
                            <CInput vertical
                                    size="sm"
                                    :value="obj_bankacc.BAN"
                                    @change="v => obj_bankacc.BAN = v"
                                    :disabled="obj_bankacc.I > 0 || bool_disableInsertBank"
                                    ref="BAN" />
                            <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BAN','BANO') }}</span>
                        </CCol>
                        <CCol col="6">
                            <label class="col-form-label-sm">{{getLanguage["BAL"]["VIP"]}} :</label><br>
                            <label class="switch">
                                <input type="checkbox" :checked="obj_bankacc.VIPBA" v-model="obj_bankacc.VIPBA" :disabled="bool_disableInsertBank" />
                                <span class="slider round"></span>
                            </label>
                        </CCol>
                        <CCol col="6" v-show="!obj_bankacc.VIPBA"></CCol>
                        <CCol col="6" v-show="obj_bankacc.VIPBA">
                            <label class='col-form-label-sm'>{{this.getLanguage['MEM']['MTI']}}<span class="required" /> :</label>
                            <treeselect :multiple="true"
                                        :options="ddEditMemberTypeList"
                                        :defaultExpandLevel="1"
                                        valueConsistsOf="LEAF_PRIORITY"
                                        :placeholder="this.utilGetDDLanguage('MEM.MTI')"
                                        :disabled="bool_disableInsertBank"
                                        v-model="obj_bankacc.MTV" />
                            <span class="ErrMsg">{{ ValidationBankAccountErrMsg('MTV','MTI') }}</span>
                        </CCol>
                        <CCol col="6" v-if="bool_isD">
                            <label class="col-form-label-sm">{{getLanguage["BANK"]["MIND"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.MIND, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['MIND']" @change="v => obj_bankacc.MIND = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" :disabled="bool_disableInsertBank"></CInput>
                        </CCol>
                        <CCol col="6" v-if="bool_isD">
                            <label class="col-form-label-sm">{{getLanguage["BANK"]["MAXD"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.MAXD, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['MAXD']" @change="v => obj_bankacc.MAXD = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" :disabled="bool_disableInsertBank"></CInput>
                            <span class="ErrMsg">{{ checkMinMax(1) }}</span>
                        </CCol>
                        <CCol col="6" v-if="bool_isD">
                            <label class="col-form-label-sm">{{getLanguage["BANK"]["MAXDACCT"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.TD, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['MAXDACCT']" @change="v => obj_bankacc.TD = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" :disabled="bool_disableInsertBank"></CInput>
                        </CCol>
                        <CCol col="6" v-if="bool_isD">
                            <label class="col-form-label-sm">{{getLanguage["BANK"]["ADEPAMT"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                            <CButton size="sm" color="outline-info" style="float: right;" @click="confirmreset(obj_bankacc.I, obj_bankacc.TUD)">{{this.getLanguage["BTN"]["RS"]}}</CButton>
                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.TUD, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['ADEPAMT']" :disabled="obj_bankacc.BA != null || bool_disableInsertBank" @change="v => obj_bankacc.TUD = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)"></CInput>
                            <span class="ErrMsg">{{ checkMinMax(1) }}</span>
                        </CCol>

                        <CCol col="6" v-if="bool_isW">
                            <label class="col-form-label-sm">{{getLanguage["BANK"]["MINW"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.MINW, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['MINW']" @change="v => obj_bankacc.MINW = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" :disabled="bool_disableInsertBank"></CInput>
                        </CCol>
                        <CCol col="6" v-if="bool_isW">
                            <label class="col-form-label-sm">{{getLanguage["BANK"]["MAXW"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.MAXW, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['MAXW']" @change="v => obj_bankacc.MAXW = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" :disabled="bool_disableInsertBank"></CInput>
                            <span class="ErrMsg">{{ checkMinMax(2) }}</span>
                        </CCol>
                        <CCol col="6" v-if="bool_isW">
                            <label class="col-form-label-sm">{{getLanguage["BANK"]["TW"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                            <CInput size="sm" vertical :value="ThousandSeparator(obj_bankacc.TW, getThousandCurrency ? 3 : 2)" :placeholder="getLanguage['BANK']['TW']" @change="v => obj_bankacc.TW = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" :disabled="bool_disableInsertBank"></CInput>
                        </CCol>

                        <div v-if="bool_isAutoDepositBank > 0" class="sectionDivider subHeaderHR"></div>
                        <CCol col="12" v-if="bool_isAutoDepositBank > 0">
                            <h6 class="card-title section-title" style="display:inline-block;">
                                {{getLanguage["BANK"]["AD"]}}
                            </h6>
                        </CCol>
                        <CCol col="6" v-if="bool_isAutoDepositBank > 0">
                            <label class="col-form-label-sm" style="display:block">
                                {{getLanguage["BANK"]["ADTY"]}} :
                                <div class="custom-tooltip" style="float:right">
                                    <i class="fa fa-question-circle"></i>
                                    <span class="custom-tooltiptext2 time-claim">{{getLanguage["HELP"]["ADTY"]}}</span>
                                </div>
                            </label>
                            <treeselect :multiple="false"
                                        :options="dd_adty"
                                        :flat="true"
                                        :defaultExpandLevel="Infinity"
                                        :disabled="bool_disableInsertBank"
                                        @input="isAutoDepositChange"
                                        v-model="obj_bankacc['IA']" />
                        </CCol>

                        <CCol col="6" v-if="bool_obj_isAutoDeposit == 1 || bool_obj_isAutoDeposit == 2">
                            <label class="col-form-label-sm">{{getLanguage["BAL"]["IBU"]}} :</label>
                            <CInput vertical size="sm" :value="obj_bankacc.BU" :placeholder="getLanguage['BANK']['IBU']" @change="v => obj_bankacc.BU = v" />
                            <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BU', 'IBU') }}</span>
                        </CCol>
                        <CCol col="6" v-if="bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12">
                            <label class="col-form-label-sm" style="display: block;">&nbsp;</label>
                            <CButton color="outline-info" size="sm" @click="setupAutoDepositAPP()">
                                <span class='plusIcon cil-plus'></span>
                                {{this.getLanguage["BAL"]["ADSACC"]}}
                            </CButton>
                        </CCol>



                        <CCol col="6" v-if="bool_isAutoDepositBank > 0 && (bool_obj_isAutoDeposit == 1 || bool_obj_isAutoDeposit == 2)">
                            <label class="col-form-label-sm full-width">
                                {{getLanguage["BAL"]["IBP"]}} :
                                <span v-if="obj_bankacc.LPUTS != null && !isEmptyDate(obj_bankacc.LPUTS)" class="float-right label-tooltip">{{getLanguage["BAL"]["LU"]}} : {{ formatDateTime(obj_bankacc.LPUTS) }}</span>
                            </label>
                            <CInput type="password" vertical size="sm" :value="obj_bankacc.BP" :placeholder="getLanguage['BANK']['IBP']" @change="v => obj_bankacc.BP = v" :disabled="bool_disableInsertBank" />
                            <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BP', 'IBP') }}</span>
                        </CCol>
                        <CCol col="6" v-if="bool_isAutoDepositBank > 0 && (bool_obj_isAutoDeposit == 1 || bool_obj_isAutoDeposit == 2)">
                            <label class="col-form-label-sm">{{getLanguage["BAL"]["IBPC"]}} :</label>
                            <CInput type="password"
                                    vertical size="sm"
                                    :value="obj_bankacc.BPC"
                                    :placeholder="getLanguage['BANK']['IBPC']"
                                    @change="v => obj_bankacc.BPC = v"
                                    :disabled="bool_disableInsertBank"
                                    ref="BPC" />
                            <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BPC', 'IBPC') }}</span>
                        </CCol>

                        <CCol col="6" v-if="bool_isAutoDepositBank > 0 && bool_obj_isAutoDeposit==2">
                            <label class="col-form-label-sm">{{getLanguage["BAL"]["ADS"]}} :</label>
                            <CInput vertical size="sm" :value="obj_bankacc.ADS" :placeholder="getLanguage['BANK']['ADS']" @change="v => obj_bankacc.ADS = v" :disabled="bool_disableInsertBank" />
                        </CCol>
                        <CCol col="6" v-if="bool_isAutoDepositBank > 0 && bool_obj_isAutoDeposit==2">
                            <label class="col-form-label-sm">{{getLanguage["BAL"]["ADR"]}} :</label>
                            <div class="custom-tooltip" v-on:click="copyLink()">
                                <i class="fa fa-question-circle"></i>
                                <span class="custom-tooltiptext2 time-claim">{{getLanguage["BAL"]["ADRQ1"]}}</span><br />
                                <span class="custom-tooltiptext2 time-claim">{{getLanguage["BAL"]["ADRQ2"]}}</span>
                            </div>
                            <CInput vertical size="sm" :value="obj_bankacc.ADR" :placeholder="getLanguage['BANK']['ADR']" @change="v => obj_bankacc.ADR = v" :disabled="bool_disableInsertBank" />
                        </CCol>
                        <CCol col="12" v-if="bool_obj_bankaccRS & bool_isAutoDepositBank > 0 && (bool_obj_isAutoDeposit == 1 || bool_obj_isAutoDeposit == 2)">
                            <label class="col-form-label-sm mandatory_Field">{{ getLanguage["BAL"]["TIP"] }}</label>
                        </CCol>


                        <!--<CRow v-if="bool_obj_bankaccRS & bool_isAutoDepositBank > 0 && (bool_obj_isAutoDeposit == 1 || bool_obj_isAutoDeposit == 2)">
        <CCol col="12">
            <label class="col-form-label-sm mandatory_Field">{{ getLanguage["BAL"]["TIP"] }}</label>
        </CCol>
    </CRow>-->
                        <!-- SCB APP auto deposit -->
                        <CRow v-if="bool_isAutoDepositBank > 0 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12)">
                            <CCol col="6">
                                <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BCT']}} :</label>
                                <treeselect :multiple="false"
                                            :options="dd_adbct"
                                            :flat="true"
                                            :disabled="true"
                                            :defaultExpandLevel="Infinity"
                                            v-model="obj_bankacc['BCT']" />
                                <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BCT', 'BCT') }}</span>
                            </CCol>
                            <CCol col="6">
                                <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BICN']}} :</label>
                                <CInput vertical size="sm" :value="obj_bankacc.BICN" :placeholder="getLanguage['BAL']['BICN']" :readonly="true" />
                                <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BICN', 'BICN') }}</span>
                            </CCol>
                        </CRow>
                        <CRow v-if="bool_isAutoDepositBank > 0 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12)">
                            <CCol col="6">
                                <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BDOB']}} :</label>
                                <CInput vertical size="sm" :value="getADDOB()" :placeholder="getLanguage['BAL']['BDOB']" :readonly="true" />
                                <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BDOB', 'BDOB') }}</span>
                            </CCol>
                            <CCol col="6">
                                <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BMN']}} :</label>
                                <CInput vertical size="sm" :value="obj_bankacc.BMN" :placeholder="getLanguage['BAL']['BMN']" :readonly="true" />
                                <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BMN', 'BMN') }}</span>
                            </CCol>
                        </CRow>
                        <CRow v-if="bool_isAutoDepositBank > 0 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12)">
                            <CCol col="6">
                                <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BAPIN']}} :</label>
                                <CInput vertical size="sm" :value="obj_bankacc.BAPIN" :placeholder="getLanguage['BAL']['BAPIN']" :readonly="true" />
                                <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BAPIN', 'BAPIN') }}</span>
                            </CCol>
                            <CCol col="6">
                                <label class="col-form-label-sm full-width">{{getLanguage['BAL']['BDI']}} :</label>
                                <CInput vertical size="sm" :value="obj_bankacc.BDI" :placeholder="getLanguage['BAL']['BDI']" :readonly="true" />
                                <span class="ErrMsg">{{ ValidationBankAccountErrMsg('BDI', 'BDI') }}</span>
                            </CCol>
                        </CRow>
                        <CRow v-if="bool_obj_bankaccRS & bool_isAutoDepositBank > 0 && (bool_obj_isAutoDeposit == 11 || bool_obj_isAutoDeposit == 12)">
                            <CCol col="12">
                                <label class="col-form-label-sm mandatory_Field">{{ getLanguage["BAL"]["ADTIP"] }}</label>
                            </CCol>
                        </CRow>


                        <CCol col="12">
                            <label class="col-form-label-sm">{{getLanguage["QRC"]["CI"]}} :</label>
                            <CTabs variant='tabs' id="imageURLTab3">
                                <CTab :title="getLanguage['CTAB']['UI']" :active="obj_bankacc.IUT === false ? true: false">
                                    <img v-if="obj_bankacc['I'] > 0 && obj_bankacc['QRCI']"
                                         width="auto"
                                         height="150"
                                         class="mb-2"
                                         :src="getImgUrl(obj_bankacc['QRCI'])" />
                                    <div class="custom-file">
                                        <input type="file" class="custom-file-input" id="validatedCustomFile" name="pic" accept="image/*" @change="onBankFileSelected" :disabled="bool_disableInsertBank" required>
                                        <label class="custom-file-label" for="validatedCustomFile" v-if="selectedBankFile === null">{{ getLanguage['CTAB']['CAI'] }}</label>
                                        <label class="custom-file-label" for="validatedCustomFile" v-else>{{selectedBankFile.name}}</label>
                                        <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                    </div>
                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 200 x 200</label>
                                </CTab>
                                <CTab :title="getLanguage['CTAB']['U']" :active="obj_bankacc.IUT === true ? true: false">
                                    <img v-if="obj_bankacc['I'] > 0 && obj_bankacc['QRCI']"
                                         width="auto"
                                         height="150"
                                         class="mb-2"
                                         :src="getImgUrl(obj_bankacc['QRCI'])" />
                                    <label class="sr-only" for="inlineFormInputGroupUsername">{{ getLanguage['CTAB']['U'] }}</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">{{ getLanguage['CTAB']['U'] }}</div>
                                        </div>
                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_bankacc.QRCI" :disabled="bool_disableInsertBank">
                                    </div>
                                    <label class="col-form-label-sm">{{getLanguage["RIZ"]["IZ"]}} : 200 x 200</label>
                                </CTab>
                            </CTabs>
                        </CCol>

                        <CCol col="12">
                            <div style="text-align:center;margin-top:20px" v-if="(this.$route.query.agi !== undefined && this.$route.query.di !== undefined && this.$route.query.lci !== undefined && this.$route.query.acsi !== undefined && this.$route.query.bai !== undefined)">
                                <!--<CButton color="outline-info" size="sm" @click="saveSelfService('bs')">-->
                                <CButton color="outline-info" size="sm" @click="saveBankAccountConfig()">
                                    <span class='fa fa-save mr-2'></span>
                                    {{ getLanguage["BTN"]["SV"] }}
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                </template>

                <!--Customize Register-->
                <CRow class="mx-0" v-if="bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_Group.I > 0">
                    <CCol col="12">
                        <h6 class="card-title section-title2"
                            data-section="cr"
                            @click="showSectionBasedRole('cr')"
                            :class="selectedSection === 'cr' ? 'bg-blue text-white' : ''">
                            <!--<span :class="(!this.$v.obj_bankacc.$error && bool_groupCV) ? 'bg-success' : ''">-->
                            <span :class="getSectionClasses('cr', !$v.obj_bankacc.$error && bool_groupCV)">
                                {{ getSectionIndex(8) }}
                            </span>
                            {{this.getLanguage["SMB"]["RCUZ"]}}
                            <i :class="setCollapseExpandIcon('CR')"></i>
                        </h6>
                    </CCol>
                </CRow>
                <template v-if="bool_showCR && bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_Group.I > 0">
                    <!--<CRow class="mx-0">
                        <CCol col="4">
                            <label class="col-form-label">{{this.getLanguage["MT"]["BN"]}}<span class="required" /> :</label>
                            <customtreeselect :multiple="true"
                                              :limit="1"
                                              :clearable="false"
                                              valueConsistsOf="LEAF_PRIORITY"
                                              :options="dd_agentgroup"
                                              :defaultExpandLevel="Infinity"
                                              :disable-branch-nodes="false"
                                              :disabled="arry_aac.I > 0"
                                              v-model="searchAgent"
                                              @input="selectAgentOptions"
                                              :placeholder="getLanguage['MT']['BN']"
                                              :limitText="count => `+${count}`" />
                            <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                        </CCol>
                    </CRow>-->
                    <CRow class="mx-0" style="font-size:12px;">
                        <CCol col="7">
                            <div class="agentcus-grid">
                                <label class="switch" :style="renderStyle()">
                                    <input type="checkbox" :checked="arry_CrOnOff.RFWMP.CV" @change="v => arry_CrOnOff.RFWMP.CV = v.target.checked">
                                    <span class="slider round"></span>
                                </label>
                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RFWMP"]}}<br /></label>
                                <div class="custom-tooltip ACUZ_TT">
                                    <i class="fa fa-question-circle"></i>
                                    <span class="custom-tooltiptext2 turnover-requirement" style="left:0% !important">{{getLanguage["ACU"]["RFWMP"]}}</span>
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                    <!--Display Label Language Setting-->
                    <CRow id="webTempSetting" class="mx-0 mb-3" v-if="this.dd_language_select.length > 0 && !arry_CrOnOff.RFWMP.CV">
                        <CCol>
                            <h6 @click="visible = !visible" class="card-title section-title2 px-2 m-0">
                                <template>
                                    <template v-if="visible">
                                        {{this.getLanguage["BTN"]["HD"]}}
                                    </template>
                                    <template v-else>
                                        {{this.getLanguage["BTN"]["V"]}}
                                    </template>
                                    {{this.getLanguage["AG"]["DLLS"]}}
                                </template>
                                <i class="chevron-container chevron-up" v-if="visible"></i>
                                <i class="chevron-container" v-else></i>
                            </h6>
                            <div v-show="visible">
                                <div class="row mx-0 my-3">
                                    <div class="col-md-2 px-0">
                                        <div class="nav flex-column nav-pills tempScrollbar" aria-orientation="vertical" style="max-height: 584px; overflow: hidden scroll; padding: 0; flex-wrap: nowrap ">
                                            <a class="" :class="(selectedLangLabel == item.id)? 'nav-link active' : 'nav-link'" @click="selectedLangLabel = item.id;langCode = item.id" v-for="(item, index) in dd_language_select" :key="index" style="border-radius: 0px; padding: 0.5rem 0.5rem; font-size: smaller;">
                                                <div class="d-flex align-items-center">
                                                    <span class="flagClass mr-2" :class="mapLanguageFlag(item.id)"></span>
                                                    <span>{{ item.label }}</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-md-10 pr-0">
                                        <div class="tab-content">
                                            <div class="card tab-content p-2">
                                                <div :class="item.id == selectedLangLabel ? 'tab-pane fade active show': 'tab-pane fade'" :id="'lang-'+item.id" v-for="(item, index) in dd_language">
                                                    <CRow class="row">
                                                        <CCol col="12">
                                                            <label class="col-form-label-sm font-weight-bold">{{ item.label }}</label>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["UI"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['UI']" size="sm" :value="array_ui[item.id]" v-model="array_ui[item.id]" ref="UI"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["FN"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['FN']" size="sm" :value="array_fn[item.id]" v-model="array_fn[item.id]" ref="FN"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["PASS"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['PASS']" size="sm" :value="array_pw[item.id]" v-model="array_pw[item.id]" ref="PW"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["CPASS"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['CPASS']" size="sm" :value="array_cpw[item.id]" v-model="array_cpw[item.id]" ref="CPW"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["SC"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['SC']" size="sm" :value="array_sc[item.id]" v-model="array_sc[item.id]" ref="SC"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["DCUZ"]["PSDB"]}}:</label>
                                                            <CInput :placeholder="getLanguage['DCUZ']['PSDB']" size="sm" :value="array_sbk[item.id]" v-model="array_sbk[item.id]" ref="SBK"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["BACCNAME"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['BACCNAME']" size="sm" :value="array_anm[item.id]" v-model="array_anm[item.id]" ref="ANM"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["BACCNO"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['BACCNO']" size="sm" :value="array_an[item.id]" v-model="array_an[item.id]" ref="AN"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["EM"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['EM']" size="sm" :value="array_em[item.id]" v-model="array_em[item.id]" ref="EM"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["REF"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['REF']" size="sm" :value="array_rc[item.id]" v-model="array_rc[item.id]" ref="RC"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["PHNO"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['PHNO']" size="sm" :value="array_pn[item.id]" v-model="array_pn[item.id]" ref="PN"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["WCID"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['WCID']" size="sm" :value="array_wc[item.id]" v-model="array_wc[item.id]" ref="WC"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["LINE"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['LINE']" size="sm" :value="array_ln[item.id]" v-model="array_ln[item.id]" ref="LN"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["WSAP"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['WSAP']" size="sm" :value="array_wa[item.id]" v-model="array_wa[item.id]" ref="WA"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["TGID"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['TGID']" size="sm" :value="array_tg[item.id]" v-model="array_tg[item.id]" ref="TG"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["RCUZ"]["ZLID"]}}:</label>
                                                            <CInput :placeholder="getLanguage['RCUZ']['ZLID']" size="sm" :value="array_zl[item.id]" v-model="array_zl[item.id]" ref="ZL"></CInput>
                                                        </CCol>
                                                    </CRow>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </CRow>

                    <CRow class="mx-0 registerPage">
                        <!--Settings for Customize Registration (Multipage Registration)-->
                        <CCol col="12" v-if="arry_CrOnOff.RFWMP.CV">
                            <div style="width: 99%; float: left; padding: 15px; background: #ececec;">
                                <CRow>
                                    <!--Require Bank Account-->
                                    <CCol xl="6" class="agentcus-grid">
                                        <label class="switch" :style="renderStyle()">
                                            <input type="checkbox" :checked="arry_CrOnOff.RWBA.CV" @change="v => arry_CrOnOff.RWBA.CV = v.target.checked">
                                            <span class="slider round"></span>
                                        </label>
                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RWBA"]}}</label>
                                        <div class="custom-tooltip ACUZ_TT">
                                            <i class="fa fa-question-circle"></i>
                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RWBA"]}}</span>
                                        </div>
                                    </CCol>
                                    <!--Require Email Address-->
                                    <CCol xl="6" class="agentcus-grid">
                                        <label class="switch" :style="renderStyle()">
                                            <input type="checkbox" :checked="arry_CrOnOff.RWEA.CV" @change="v => arry_CrOnOff.RWEA.CV = v.target.checked">
                                            <span class="slider round"></span>
                                        </label>
                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RWEA"]}}</label>
                                        <div class="custom-tooltip ACUZ_TT">
                                            <i class="fa fa-question-circle"></i>
                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RWEA"]}}</span>
                                        </div>
                                    </CCol>
                                    <!--Check Duplicate Bank Account-->
                                    <CCol xl="6" class="agentcus-grid">
                                        <label class="switch" :style="renderStyle()">
                                            <input type="checkbox" :checked="arry_CrOnOff.CDBACC.CV" @change="v => arry_CrOnOff.CDBACC.CV = v.target.checked">
                                            <span class="slider round"></span>
                                        </label>
                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["CDBACC"]}}</label>
                                        <div class="custom-tooltip ACUZ_TT">
                                            <i class="fa fa-question-circle"></i>
                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CDBACC"]}}</span>
                                        </div>
                                    </CCol>
                                    <!--Check Duplicate Phone Number-->
                                    <CCol xl="6" class="agentcus-grid">
                                        <label class="switch" :style="renderStyle()">
                                            <input type="checkbox" :checked="arry_CrOnOff.CDPNO.CV" @change="v => arry_CrOnOff.CDPNO.CV = v.target.checked">
                                            <span class="slider round"></span>
                                        </label>
                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["CDPNO"]}}</label>
                                        <div class="custom-tooltip ACUZ_TT">
                                            <i class="fa fa-question-circle"></i>
                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CDPNO"]}}</span>
                                        </div>
                                    </CCol>
                                    <!--Require Phone No-->
                                    <CCol xl="6">
                                        <div class="flexcontainer">
                                            <div class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <input type="checkbox" :checked="arry_CrOnOff.RPN.CV" @change="v => arry_CrOnOff.RPN.CV = v.target.checked">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["RPN"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RPN"]}}</span>
                                                </div>
                                            </div>
                                            <div v-if="arry_CrOnOff.RPN.CV == true">
                                                <!--Disable OTP Validation-->
                                                <div class="flex-item agentcus-grid">
                                                    <label :style="renderStyle()">
                                                        <input type="checkbox" :checked="arry_CrOnOff.DOTPV.CV" @change="v => arry_CrOnOff.DOTPV.CV = v.target.checked">
                                                    </label>
                                                    <label class="ACUZ_DO col-form-label">{{ this.getLanguage["ACO"]["DOTPV"] }}</label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{ this.getLanguage["ACU"]["DOTPV"] }}</span>
                                                    </div>
                                                </div>
                                                <!--Use PhoneNumber as Username-->
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="captcha" :checked="arry_CrOnOff.REGWPHONE.CV" value="true" @change="v => arry_CrOnOff.REGWPHONE.CV = true" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["REGWPHONE"]}}</label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["REGWPHONE"]}}</span>
                                                    </div>
                                                </div>
                                                <!--Use Alphanumeric as Username-->
                                                <div class="flex-item agentcus-grid">
                                                    <input type="radio" name="captcha" :checked="!arry_CrOnOff.REGWPHONE.CV" value="false" @change="v => arry_CrOnOff.REGWPHONE.CV = false" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["UANAU"]}}</label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["UANAU"]}}</span>
                                                    </div>
                                                </div>
                                                <br />
                                                <!--Localized Country Code-->
                                                <div class="flex-item agentcus-grid">
                                                    <label class="switch" :style="renderStyle()">
                                                        <input type="checkbox" :checked="arry_CrOnOff.ULPN.CV" @change="v => arry_CrOnOff.ULPN.CV = v.target.checked">
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <label class="ACUZ_DO col-form-label">{{ this.getLanguage["ACO"]["ULPN"] }}</label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{ this.getLanguage["ACU"]["ULPN"] }}</span>
                                                    </div>
                                                </div>
                                                <!--Enable Prefix Code-->
                                                <div class="flex-item agentcus-grid" v-if="arry_CrOnOff.ULPN.CV == true">
                                                    <label class="switch" :style="renderStyle()">
                                                        <input type="checkbox" :checked="arry_CrOnOff.UPCODE.CV" @change="v => arry_CrOnOff.UPCODE.CV = v.target.checked">
                                                        <span class="slider round"></span>
                                                    </label>
                                                    <label class="ACUZ_DO col-form-label">{{ this.getLanguage["ACO"]["UPCODE"] }}</label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{ this.getLanguage["ACU"]["UPCODE"] }}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item" v-if="arry_CrOnOff.ULPN.CV == true">
                                                    <!--Country Code TextBox-->
                                                    <CInput class="inline inline30" :placeholder="getLanguage['ACO']['CCODE']" size="sm" :value="arry_aac.E_CC" @change="v => arry_aac.E_CC = v"></CInput>
                                                    <!--Prefix Code TextBox-->
                                                    <CInput style="margin-left: 3px;" class="inline inline30" :placeholder="getLanguage['ACO']['PCODE']" size="sm" :value="arry_aac.E_PC" @change="v => arry_aac.E_PC = v"></CInput>
                                                    <!--Add Button-->
                                                    <CButton style="margin-left: 15px; margin-top: 0px;" color="outline-dark" size="sm" class="btn-small inline inline10" @click="addPrefix()">
                                                        <span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AD"]}}
                                                    </CButton>
                                                </div>
                                                <br />
                                                <!--Table-->
                                                <div class="flex-item" v-if="arry_CrOnOff.ULPN.CV == true">
                                                    <table class="custom-table custom-table-inPopUp afb-blue" style="width: 85% !important">
                                                        <thead>
                                                            <tr>
                                                                <th v-if="!bool_isView" style="width: 30px;">{{ this.getLanguage['GL']['ACT'] }}</th>
                                                                <th style="width: 50% !important">{{ this.getLanguage['ACO']['CCODE'] }}</th>
                                                                <th>{{ this.getLanguage["ACO"]["PCODE"] }}</th>
                                                                <th>{{ this.getLanguage["ACO"]["LDZ"] }}</th>
                                                                <th>{{ this.getLanguage["ACO"]["PS"] }}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        <td colspan="100%" v-if="arry_aac.LocalisedList == 0 || !arry_aac.LocalisedList">{{ this.getLanguage['GL']['NR'] }}</td>
                                                        <tr v-for="(data,index) in arry_aac.LocalisedList" class="">
                                                            <td v-if="!bool_isView">
                                                                <span id="actionBtnCol"> <i class="cil-trash" @click='removeLocaliseList(index)'></i> </span>
                                                            </td>
                                                            <td>+{{ data.CC }}</td>
                                                            <td>{{ data.PC }}</td>
                                                            <td>
                                                                <input type="checkbox" v-if="data.PC != ''" :checked="data.LZ > 0" @click="tickLeadinZero($event, data, data.LZ, CountItem(index+1))" :style="renderStyle()" />
                                                            </td>
                                                            <td>+{{ data.PN }}</td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <br />
                                            </div>
                                        </div>
                                    </CCol>
                                    <!--Full Name Mandatory-->
                                    <CCol xl="6">
                                        <div class="agentcus-grid">
                                            <label class="switch" :style="renderStyle()">
                                                <input type="checkbox" :checked="arry_CrOnOff.FNM.CV" @change="v => arry_CrOnOff.FNM.CV = v.target.checked">
                                                <span class="slider round"></span>
                                            </label>
                                            <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["FNM"]}}</label>
                                            <div class="custom-tooltip ACUZ_TT">
                                                <i class="fa fa-question-circle"></i>
                                                <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["FNM"]}}</span>
                                            </div>
                                        </div>
                                    </CCol>
                                    <!--Hide Currency Option-->
                                    <CCol xl="6" class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                        <label class="switch" :style="renderStyle()">
                                            <input type="checkbox" :checked="arry_CrOnOff.HCDIHO.CV" @change="v => arry_CrOnOff.HCDIHO.CV = v.target.checked">
                                            <span class="slider round"></span>
                                        </label>
                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["HCDIHO"]}}</label>
                                        <div class="custom-tooltip ACUZ_TT">
                                            <i class="fa fa-question-circle"></i>
                                            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["HCDIHO"]}}</span>
                                        </div>
                                    </CCol>
                                    <!--Allow UserID starting with Numeric-->
                                    <CCol xl="6" class="agentcus-grid">
                                        <label class="switch" :style="renderStyle()">
                                            <input type="checkbox" :checked="arry_CrOnOff.EUN.CV" @change="v => arry_CrOnOff.EUN.CV = v.target.checked">
                                            <span class="slider round"></span>
                                        </label>
                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["UN"]}}</label>
                                        <div class="custom-tooltip ACUZ_TT">
                                            <i class="fa fa-question-circle"></i>
                                            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["UN"]}}</span>
                                        </div>
                                    </CCol>
                                    <!--Show Referral Code in Register Form-->
                                    <CCol xl="6" class="agentcus-grid">
                                        <label class="switch" :style="renderStyle()">
                                            <input type="checkbox" :checked="arry_CrOnOff.SRC.CV" @change="v => arry_CrOnOff.SRC.CV = v.target.checked">
                                            <span class="slider round"></span>
                                        </label>
                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SRC"]}}</label>
                                        <div class="custom-tooltip ACUZ_TT">
                                            <i class="fa fa-question-circle"></i>
                                            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["SRC"]}}</span>
                                        </div>
                                    </CCol>
                                    <!--Block All Black Listed Bank Account-->
                                    <CCol xl="6" class="agentcus-grid">
                                        <label class="switch" :style="renderStyle()">
                                            <input type="checkbox" :checked="arry_CrOnOff.BABLBA.CV" @change="v => arry_CrOnOff.BABLBA.CV = v.target.checked">
                                            <span class="slider round"></span>
                                        </label>
                                        <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["BABLBA"]}}</label>
                                        <div class="custom-tooltip ACUZ_TT">
                                            <i class="fa fa-question-circle"></i>
                                            <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["BABLBA"]}}</span>
                                        </div>
                                    </CCol>
                                    <!--Social Media-->
                                    <CCol xl="6">
                                        <div class="flexcontainer">
                                            <div class="agentcus-grid">
                                                <label class="switch" :style="renderStyle()">
                                                    <input type="checkbox" :checked="arry_CrOnOff.SM.CV" @change="v => arry_CrOnOff.SM.CV = v.target.checked">
                                                    <span class="slider round"></span>
                                                </label>
                                                <label class="ACUZ_DO col-form-label">{{this.getLanguage["ACO"]["SM"]}}</label>
                                                <div class="custom-tooltip ACUZ_TT">
                                                    <i class="fa fa-question-circle"></i>
                                                    <span class="custom-tooltiptext2 turnover-requirement">{{this.getLanguage["ACU"]["SM"]}}</span>
                                                </div>
                                            </div>
                                            <div v-if="arry_CrOnOff.SM.CV == true">
                                                <!--=== wechat, line, whatsapp, telegram, zalo  ==-->
                                                <div class="flex-item agentcus-grid">
                                                    <input type="checkbox" name="captcha" :checked="arry_CrOnOff.WCID.CV" @change="v => arry_CrOnOff.WCID.CV = v.target.checked" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["WC"]}} <span class="mandatory_Field">*</span></label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["WC"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="checkbox" name="captcha" :checked="arry_CrOnOff.LID.CV" @change="v => arry_CrOnOff.LID.CV = v.target.checked" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["LID"]}} <span class="mandatory_Field">*</span></label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["LID"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="checkbox" name="captcha" :checked="arry_CrOnOff.WAID.CV" @change="v => arry_CrOnOff.WAID.CV = v.target.checked" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["WAID"]}} <span class="mandatory_Field">*</span></label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["WAID"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="checkbox" name="captcha" :checked="arry_CrOnOff.TGID.CV" @change="v => arry_CrOnOff.TGID.CV = v.target.checked" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["TGID"]}} <span class="mandatory_Field">*</span></label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["TGID"]}}</span>
                                                    </div>
                                                </div>
                                                <div class="flex-item agentcus-grid">
                                                    <input type="checkbox" name="captcha" :checked="arry_CrOnOff.ZLID.CV" @change="v => arry_CrOnOff.ZLID.CV = v.target.checked" :style="renderStyle()">
                                                    <label for="html">{{this.getLanguage["ACO"]["ZLID"]}} <span class="mandatory_Field">*</span></label>
                                                    <div class="custom-tooltip ACUZ_TT">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["ZLID"]}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CCol>
                                    <!--Enable Strong Password-->
                                    <CCol xl="6" class="agentcus-grid">
                                        <label class="switch" :style="renderStyle()">
                                            <input type="checkbox" :checked="arry_CrOnOff.EPWSC.CV" @change="v => arry_CrOnOff.EPWSC.CV = v.target.checked">
                                            <span class="slider round"></span>
                                        </label>
                                        <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["ESP"]}}</label>
                                        <div class="custom-tooltip ACUZ_TT">
                                            <i class="fa fa-question-circle"></i>
                                            <span class="custom-tooltiptext2 turnover-requirement" v-html="getLanguage['ACU']['ESP']"></span>
                                        </div>
                                    </CCol>
                                </CRow>
                            </div>
                        </CCol>
                        <!--Settings for Customize Registration (Single Registration Page)-->
                        <CCol col="12" v-if="!arry_CrOnOff.RFWMP.CV">
                            <div style="width: 99%; float: left; padding: 15px; background: #ececec;">
                                <draggable class="list-group bg-white"
                                           tag="ul"
                                           :list="arry_cr.VTCRegisterDraggeBase"
                                           v-bind="dragOptions"
                                           @start="drag = false"
                                           @end="drag = false">
                                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                        <li class="list-group-item"
                                            v-for="element in arry_cr.VTCRegisterDraggeBase"
                                            :key="element.name">
                                            <template v-if="element.id == 'UN'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1" disabled>
                                                            </div>

                                                            <div class="did-floating-label-content userNameID" v-if="arry_CrOnOff.REGWPHONE.CV == false">
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 21.3" fill="currentColor">
                                                                    <path d="M14,12.5c1.2,0,2.3-0.5,3.1-1.3c0.8-0.8,1.3-1.9,1.3-3.1S17.9,5.9,17.1,5c-0.8-0.8-1.9-1.3-3.1-1.3
S11.7,4.2,10.9,5C10.1,5.9,9.6,7,9.6,8.1s0.5,2.3,1.3,3.1C11.7,12,12.8,12.5,14,12.5z"></path>
                                                                    <path d="M3.5,0.2c-0.9,0-1.8,0.4-2.5,1C0.4,1.8,0,2.7,0,3.7v14c0,0.9,0.4,1.8,1,2.5c0.7,0.7,1.5,1,2.5,1h21
c0.9,0,1.8-0.4,2.5-1c0.7-0.7,1-1.5,1-2.5v-14c0-0.9-0.4-1.8-1-2.5c-0.7-0.7-1.5-1-2.5-1H3.5z M22.4,19.4c-0.8-2.2-3.1-5.2-8.4-5.2
c-5.3,0-7.6,3-8.4,5.2H3.5c-0.5,0-0.9-0.2-1.2-0.5s-0.5-0.8-0.5-1.2v-14c0-0.5,0.2-0.9,0.5-1.2C2.6,2.1,3,1.9,3.5,1.9h21
c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.8,0.5,1.2v14c0,0.5-0.2,0.9-0.5,1.2s-0.8,0.5-1.2,0.5H22.4z"></path>
                                                                </svg>
                                                                <input type="text" name="username" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                                <label for="RegisterFocusTextBox" class="did-floating-label required">{{getLanguage["RCUZ"]["UI"]}}</label>
                                                            </div>

                                                            <div class="did-floating-label-content registerPhone" v-if="arry_CrOnOff.REGWPHONE.CV == true">
                                                                <svg viewBox="0 0 17 28" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M0 26.3048C0 18.1041 0 9.90411 0 1.70337C0.0131471 1.67969 0.0363479 1.65676 0.0394414 1.63234C0.142298 0.750332 1.01078 -0.00588499 2.13215 3.45199e-05C6.38254 0.0214927 10.6329 0.00817384 14.8841 0.0103937C15.0542 0.0103937 15.229 0.0126135 15.3937 0.0466506C16.3898 0.249394 16.9977 1.01079 16.9985 2.05188C17 7.44529 16.9985 12.8394 16.9985 18.2329C16.9985 20.8019 16.9985 23.3717 16.9985 25.9408C16.9985 26.4676 16.8608 26.9434 16.4981 27.3548C16.205 27.6878 15.8044 27.8402 15.4046 28H1.59776C1.34642 27.8824 1.07961 27.7869 0.846056 27.6419C0.345692 27.3304 0.126831 26.8413 0 26.3056V26.3048ZM15.5809 24.492V3.03082H1.42221V24.492H15.5809ZM9.47521 26.1065C9.47521 25.5923 9.03284 25.1676 8.5 25.169C7.96638 25.1705 7.52789 25.5952 7.52866 26.1102C7.52943 26.6311 7.96019 27.0426 8.50387 27.0411C9.04754 27.0396 9.47598 26.6282 9.47521 26.1065ZM8.50232 1.81732C9.15658 1.81732 9.81162 1.81732 10.4659 1.81732C10.6252 1.81732 10.7915 1.81584 10.7977 1.61236C10.8046 1.4 10.6422 1.37262 10.4651 1.37262C9.15581 1.3741 7.84651 1.3741 6.53721 1.37262C6.36011 1.37262 6.19771 1.4 6.20544 1.61236C6.2124 1.8151 6.3779 1.81732 6.53798 1.81732C7.19225 1.81584 7.84728 1.81732 8.50155 1.81732H8.50232Z" />
                                                                </svg>
                                                                <input type="tel" name="required_phone" placeholder="" class="did-floating-input register_required_phone r7" autocomplete="off" disabled>
                                                                <label for="refferal" class="did-floating-label required">{{getLanguage["RCUZ"]["PHNO"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid" v-if="arry_CrOnOff.REGWPHONE.CV == false">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.EUN.CV" @change="v => arry_CrOnOff.EUN.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["UN"]}}</label>
                                                                <div class="custom-tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["UN"]}}</span>
                                                                </div>
                                                            </div>
                                                            <div v-if="arry_CrOnOff.REGWPHONE.CV == true">
                                                                <div class="agentcus-grid">
                                                                    <label class="switch" :style="renderStyle()">
                                                                        <input type="checkbox" :checked="arry_CrOnOff.RPN.CV" @change="v => arry_CrOnOff.RPN.CV = v.target.checked">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["EPAMF"]}} </label>
                                                                </div>
                                                                <div v-if="arry_CrOnOff.RPN.CV == true">
                                                                    <div class="flex-item agentcus-grid">
                                                                        <label :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CrOnOff.DOTPV.CV" @change="v => arry_CrOnOff.DOTPV.CV = v.target.checked">
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{ getLanguage["ACO"]["DOTPV"] }}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DOTPV"] }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="flex-item agentcus-grid">
                                                                        <input type="radio" name="phone_captcha" :checked="arry_CrOnOff.REGWPHONE.CV" value="true" @change="changePhoneSetting($event,element)" :style="renderStyle()">
                                                                        <label for="html">{{getLanguage["ACO"]["REGWPHONE"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["REGWPHONE"]}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="flex-item agentcus-grid">
                                                                        <input type="radio" name="phone_captcha" :checked="!arry_CrOnOff.REGWPHONE.CV" value="false" @change="changePhoneSetting($event,element)" :style="renderStyle()">
                                                                        <label for="html">{{getLanguage["ACO"]["UANAU"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["UANAU"]}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <br />
                                                                    <!--LOCALIZED-->
                                                                    <div class="flex-item agentcus-grid">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CrOnOff.ULPN.CV" @change="v => arry_CrOnOff.ULPN.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{ getLanguage["ACO"]["ULPN"] }}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["ULPN"] }}</span>
                                                                        </div>
                                                                    </div>

                                                                    <!--PREFIX-->
                                                                    <div class="flex-item agentcus-grid" v-if="arry_CrOnOff.ULPN.CV == true">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CrOnOff.UPCODE.CV" @change="v => arry_CrOnOff.UPCODE.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{ getLanguage["ACO"]["UPCODE"] }}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["UPCODE"] }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="flex-item" v-if="arry_CrOnOff.ULPN.CV == true">
                                                                        <CInput class="inline inline30" :placeholder="getLanguage['ACO']['CCODE']" size="sm" :value="arry_cr.E_CC" @change="v => arry_cr.E_CC = v"></CInput>
                                                                        <CInput style="margin-left: 3px;" class="inline inline30" :placeholder="getLanguage['ACO']['PCODE']" size="sm" :value="arry_cr.E_PC" @change="v => arry_cr.E_PC = v"></CInput>
                                                                        <CButton style="margin-left: 15px; margin-top: 0px;" color="outline-dark" size="sm" class="btn-small inline inline10" @click="addPrefixCr()">
                                                                            <span class='plusIcon cil-plus'></span>{{getLanguage["BTN"]["AD"]}}
                                                                        </CButton>
                                                                    </div>
                                                                    <br />
                                                                    <div class="flex-item" v-if="arry_CrOnOff.ULPN.CV == true">
                                                                        <table class="custom-table custom-table-inPopUp afb-blue" style="width: 85% !important">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th v-if="!bool_isPreview" style="width: 30px;">{{ getLanguage['GL']['ACT'] }}</th>
                                                                                    <th style="width: 50% !important">{{ getLanguage['ACO']['CCODE'] }}</th>
                                                                                    <th>{{ getLanguage["ACO"]["PCODE"] }}</th>
                                                                                    <th>{{ getLanguage["ACO"]["LDZ"] }}</th>
                                                                                    <th>{{ getLanguage["ACO"]["PS"] }}</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            <td colspan="100%" v-if="arry_cr.LocalisedList == 0 || !arry_cr.LocalisedList">{{ getLanguage['GL']['NR'] }}</td>
                                                                            <tr v-for="(data,index) in arry_cr.LocalisedList" class="">
                                                                                <td v-if="!bool_isPreview">
                                                                                    <span id="actionBtnCol"> <i class="cil-trash" @click='removeLocaliseListCr(index)'></i> </span>
                                                                                </td>
                                                                                <td>+{{ data.CC }}</td>
                                                                                <td>{{ data.PC }}</td>
                                                                                <td>
                                                                                    <input type="checkbox" v-if="data.PC != ''" :checked="data.LZ > 0" @click="tickLeadinZero($event, data, data.LZ, CountItem(index+1))" :style="renderStyle()" />
                                                                                </td>
                                                                                <td>+{{ data.PN }}</td>
                                                                            </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                    <br />
                                                                </div>
                                                                <div class="agentcus-grid">
                                                                    <label class="switch" :style="renderStyle()">
                                                                        <input type="checkbox" :checked="arry_CrOnOff.CDPNO.CV" @change="v => arry_CrOnOff.CDPNO.CV = v.target.checked">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["CDPNO"]}}</label>
                                                                    <div class="custom-tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CDPNO"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <!--<div class="agentcus-grid">
                                                                    <label class="switch" :style="renderStyle()">
                                                                        <input type="checkbox" :checked="arry_CrOnOff.REGWPHONE.CV" @change="v => arry_CrOnOff.REGWPHONE.CV = v.target.checked">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["REGWPHONE"]}}</label>
                                                                    <div class="custom-tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["REGWPHONE"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div>-->
                                                                <!--LOCALIZED-->
                                                                <!--<div class="flex-item agentcus-grid" v-if="arry_CrOnOff.REGWPHONE.CV == true">
                                                                    <label class="switch" :style="renderStyle()">
                                                                        <input type="checkbox" :checked="arry_CrOnOff.ULPN.CV" @change="v => arry_CrOnOff.ULPN.CV = v.target.checked">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{ getLanguage["ACO"]["ULPN"] }}</label>
                                                                    <div class="custom-tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["ULPN"] }}</span>
                                                                    </div>
                                                                </div>-->
                                                                <!--PREFIX-->
                                                                <!--<div class="flex-item agentcus-grid" v-if="arry_CrOnOff.ULPN.CV == true && arry_CrOnOff.REGWPHONE.CV == true">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CrOnOff.UPCODE.CV" @change="v => arry_CrOnOff.UPCODE.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{ getLanguage["ACO"]["UPCODE"] }}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["UPCODE"] }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="flex-item" v-if="arry_CrOnOff.ULPN.CV == true && arry_CrOnOff.REGWPHONE.CV == true">
                                                                        <CInput class="inline inline30" :placeholder="getLanguage['ACO']['CCODE']" size="sm" :value="arry_cr.E_CC" @change="v => arry_cr.E_CC = v"></CInput>
                                                                        <CInput style="margin-left: 3px;" class="inline inline30" :placeholder="getLanguage['ACO']['PCODE']" size="sm" :value="arry_cr.E_PC" @change="v => arry_cr.E_PC = v"></CInput>
                                                                        <CButton style="margin-left: 15px; margin-top: 0px;" color="outline-dark" size="sm" class="btn-small inline inline10" @click="addPrefixCr()">
                                                                            <span class='plusIcon cil-plus'></span>{{getLanguage["BTN"]["AD"]}}
                                                                        </CButton>
                                                                    </div>
                                                                    <div class="flex-item agentcus-grid" v-if="arry_CrOnOff.ULPN.CV == true && arry_CrOnOff.REGWPHONE.CV == true">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CrOnOff.DOTPV.CV" @change="v => arry_CrOnOff.DOTPV.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{ getLanguage["ACO"]["DOTPV"] }}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DOTPV"] }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="flex-item" v-if="arry_CrOnOff.ULPN.CV == true && arry_CrOnOff.REGWPHONE.CV == true">
                                                                        <table class="custom-table custom-table-inPopUp afb-blue" style="width: 85% !important">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th v-if="!bool_isPreview" style="width: 30px;">{{ getLanguage['GL']['ACT'] }}</th>
                                                                                    <th style="width: 50% !important">{{ getLanguage['ACO']['CCODE'] }}</th>
                                                                                    <th>{{ getLanguage["ACO"]["PCODE"] }}</th>
                                                                                    <th>{{ getLanguage["ACO"]["LDZ"] }}</th>
                                                                                    <th>{{ getLanguage["ACO"]["PS"] }}</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            <td colspan="100%" v-if="arry_cr.LocalisedList == 0 || !arry_cr.LocalisedList">{{ getLanguage['GL']['NR'] }}</td>
                                                                            <tr v-for="(data,index) in arry_cr.LocalisedList" class="">
                                                                                <td v-if="!bool_isPreview">
                                                                                    <span id="actionBtnCol"> <i class="cil-trash" @click='removeLocaliseListCr(index)'></i> </span>
                                                                                </td>
                                                                                <td>+{{ data.CC }}</td>
                                                                                <td>{{ data.PC }}</td>
                                                                                <td>
                                                                                    <input type="checkbox" v-if="data.PC != ''" :checked="data.LZ > 0" @click="tickLeadinZeroCr($event, data, data.LZ, CountItem(index+1))" :style="renderStyle()" />
                                                                                </td>
                                                                                <td>+{{ data.PN }}</td>
                                                                            </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>-->
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-else-if="element.id == 'NAME'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">
                                                            </div>
                                                            <div class="did-floating-label-content userNameID">
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 21.3" fill="currentColor">
                                                                    <path d="M14,12.5c1.2,0,2.3-0.5,3.1-1.3c0.8-0.8,1.3-1.9,1.3-3.1S17.9,5.9,17.1,5c-0.8-0.8-1.9-1.3-3.1-1.3
S11.7,4.2,10.9,5C10.1,5.9,9.6,7,9.6,8.1s0.5,2.3,1.3,3.1C11.7,12,12.8,12.5,14,12.5z" />
                                                                    <path d="M3.5,0.2c-0.9,0-1.8,0.4-2.5,1C0.4,1.8,0,2.7,0,3.7v14c0,0.9,0.4,1.8,1,2.5c0.7,0.7,1.5,1,2.5,1h21
c0.9,0,1.8-0.4,2.5-1c0.7-0.7,1-1.5,1-2.5v-14c0-0.9-0.4-1.8-1-2.5c-0.7-0.7-1.5-1-2.5-1H3.5z M22.4,19.4c-0.8-2.2-3.1-5.2-8.4-5.2
c-5.3,0-7.6,3-8.4,5.2H3.5c-0.5,0-0.9-0.2-1.2-0.5s-0.5-0.8-0.5-1.2v-14c0-0.5,0.2-0.9,0.5-1.2C2.6,2.1,3,1.9,3.5,1.9h21
c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.8,0.5,1.2v14c0,0.5-0.2,0.9-0.5,1.2s-0.8,0.5-1.2,0.5H22.4z" />
                                                                </svg>
                                                                <input type="text" name="fullname" placeholder="" class="register_fullname did-floating-input" autocomplete="off" disabled>
                                                                <label class="did-floating-label" :class="arry_CrOnOff.FNM.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["FN"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.FNM.CV" @change="v => arry_CrOnOff.FNM.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["EFAMF"]}} </label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-else-if="element.id == 'PW'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1" disabled>
                                                            </div>
                                                            <div class="did-floating-label-content registerPasswordIco">
                                                                <svg viewBox="0 0 23 31" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M20.5884 31H2.41502C2.34791 30.976 2.2825 30.946 2.21369 30.928C1.1833 30.6604 0.492687 30.0198 0.146107 29.0019C0.0891934 28.8347 0.0484193 28.6624 0 28.4917C0 24.0325 0 19.5733 0 15.1141C0.0203871 15.0678 0.0518171 15.0224 0.0603117 14.9735C0.272677 13.7832 1.08136 12.924 2.24173 12.665C2.4439 12.6195 2.65117 12.5989 2.87288 12.5646C2.87288 11.6154 2.85844 10.6841 2.87712 9.75278C2.89241 8.97242 2.86778 8.1792 2.99605 7.41599C3.59067 3.8795 5.59965 1.53414 8.95501 0.391895C9.50886 0.203237 10.1009 0.127773 10.6752 0C11.2256 0 11.7769 0 12.3274 0C12.386 0.0205809 12.4429 0.0531674 12.5024 0.0591701C13.8292 0.199806 15.0618 0.630291 16.1686 1.37549C18.5131 2.95422 19.8663 5.16409 20.0685 8.01884C20.167 9.40462 20.1144 10.8015 20.1288 12.1942C20.1305 12.3194 20.1288 12.4446 20.1288 12.5801C20.3335 12.6024 20.5026 12.6067 20.6657 12.6401C22.0715 12.9317 22.9864 14.049 22.9932 15.5129C23.0034 17.6447 22.9958 19.7765 22.9958 21.9084C22.9958 23.9656 23.0025 26.022 22.9932 28.0792C22.9864 29.4461 22.1735 30.5292 20.9103 30.8954C20.8016 30.9271 20.6946 30.9657 20.5867 31.0009L20.5884 31ZM11.5068 14.5344C8.85903 14.5344 6.21126 14.5344 3.56349 14.5344C3.33074 14.5344 3.09713 14.5267 2.86438 14.5378C2.30544 14.5644 1.98689 14.886 1.95291 15.4443C1.94611 15.5515 1.94611 15.6586 1.94611 15.7658C1.94611 19.7851 1.94611 23.8053 1.94611 27.8245C1.94611 27.9635 1.94781 28.1032 1.96056 28.2422C1.99793 28.6478 2.25617 28.9411 2.64862 29.0139C2.80322 29.0431 2.96377 29.0542 3.12177 29.0542C8.70272 29.056 14.2845 29.056 19.8655 29.056C20.7574 29.056 21.0539 28.761 21.0539 27.87C21.0547 23.8181 21.0547 19.7663 21.0539 15.7144C21.0539 14.8388 20.7523 14.5344 19.8935 14.5344C17.0979 14.5344 14.3015 14.5344 11.5059 14.5344H11.5068ZM4.82154 12.5681H18.1674C18.1734 12.472 18.1827 12.3974 18.1827 12.3237C18.1827 11.0374 18.1937 9.75192 18.1717 8.46562C18.164 8.03084 18.108 7.58835 18.0077 7.16473C17.1718 3.63853 13.938 1.46982 10.3957 2.04523C7.70036 2.48343 5.55377 4.52437 4.97274 7.22647C4.881 7.65181 4.83343 8.09516 4.82749 8.53079C4.8088 9.86855 4.82069 11.2072 4.82069 12.5681H4.82154Z" />
                                                                    <path d="M10.5452 24.2589C10.5452 24.2272 10.5418 24.1946 10.5452 24.1629C10.6242 23.4983 10.5019 23.042 9.81553 22.6459C8.66196 21.9796 8.32133 20.424 8.86159 19.1505C9.37466 17.9406 10.6922 17.2305 11.9766 17.4723C13.2711 17.7159 14.186 18.6497 14.35 19.8932C14.5292 21.2541 13.8963 22.3972 12.6502 22.9975C12.5593 23.0412 12.4684 23.1947 12.4658 23.2993C12.448 23.9202 12.4616 24.5419 12.4557 25.1636C12.4497 25.7793 12.0734 26.1678 11.4983 26.1661C10.9249 26.1643 10.5546 25.775 10.5461 25.1585C10.5418 24.8583 10.5461 24.5582 10.5452 24.2589ZM11.5 21.2944C12.0709 21.2944 12.4625 20.8982 12.454 20.3279C12.4455 19.7705 12.0573 19.3864 11.5017 19.3864C10.9428 19.3864 10.5588 19.7645 10.5486 20.3254C10.5384 20.8956 10.93 21.2944 11.5 21.2944Z" />
                                                                </svg>
                                                                <input type="password" name="password" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                                <label for="register_password" class="did-floating-label required">{{getLanguage["RCUZ"]["PASS"]}}</label>
                                                                <span toggle="#register_password" class="pw-eye-slash toggle-password"></span>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;"></div>
                                                            <div class="did-floating-label-content registerPasswordIco">
                                                                <svg viewBox="0 0 23 31" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M20.5884 31H2.41502C2.34791 30.976 2.2825 30.946 2.21369 30.928C1.1833 30.6604 0.492687 30.0198 0.146107 29.0019C0.0891934 28.8347 0.0484193 28.6624 0 28.4917C0 24.0325 0 19.5733 0 15.1141C0.0203871 15.0678 0.0518171 15.0224 0.0603117 14.9735C0.272677 13.7832 1.08136 12.924 2.24173 12.665C2.4439 12.6195 2.65117 12.5989 2.87288 12.5646C2.87288 11.6154 2.85844 10.6841 2.87712 9.75278C2.89241 8.97242 2.86778 8.1792 2.99605 7.41599C3.59067 3.8795 5.59965 1.53414 8.95501 0.391895C9.50886 0.203237 10.1009 0.127773 10.6752 0C11.2256 0 11.7769 0 12.3274 0C12.386 0.0205809 12.4429 0.0531674 12.5024 0.0591701C13.8292 0.199806 15.0618 0.630291 16.1686 1.37549C18.5131 2.95422 19.8663 5.16409 20.0685 8.01884C20.167 9.40462 20.1144 10.8015 20.1288 12.1942C20.1305 12.3194 20.1288 12.4446 20.1288 12.5801C20.3335 12.6024 20.5026 12.6067 20.6657 12.6401C22.0715 12.9317 22.9864 14.049 22.9932 15.5129C23.0034 17.6447 22.9958 19.7765 22.9958 21.9084C22.9958 23.9656 23.0025 26.022 22.9932 28.0792C22.9864 29.4461 22.1735 30.5292 20.9103 30.8954C20.8016 30.9271 20.6946 30.9657 20.5867 31.0009L20.5884 31ZM11.5068 14.5344C8.85903 14.5344 6.21126 14.5344 3.56349 14.5344C3.33074 14.5344 3.09713 14.5267 2.86438 14.5378C2.30544 14.5644 1.98689 14.886 1.95291 15.4443C1.94611 15.5515 1.94611 15.6586 1.94611 15.7658C1.94611 19.7851 1.94611 23.8053 1.94611 27.8245C1.94611 27.9635 1.94781 28.1032 1.96056 28.2422C1.99793 28.6478 2.25617 28.9411 2.64862 29.0139C2.80322 29.0431 2.96377 29.0542 3.12177 29.0542C8.70272 29.056 14.2845 29.056 19.8655 29.056C20.7574 29.056 21.0539 28.761 21.0539 27.87C21.0547 23.8181 21.0547 19.7663 21.0539 15.7144C21.0539 14.8388 20.7523 14.5344 19.8935 14.5344C17.0979 14.5344 14.3015 14.5344 11.5059 14.5344H11.5068ZM4.82154 12.5681H18.1674C18.1734 12.472 18.1827 12.3974 18.1827 12.3237C18.1827 11.0374 18.1937 9.75192 18.1717 8.46562C18.164 8.03084 18.108 7.58835 18.0077 7.16473C17.1718 3.63853 13.938 1.46982 10.3957 2.04523C7.70036 2.48343 5.55377 4.52437 4.97274 7.22647C4.881 7.65181 4.83343 8.09516 4.82749 8.53079C4.8088 9.86855 4.82069 11.2072 4.82069 12.5681H4.82154Z" />
                                                                    <path d="M10.5452 24.2589C10.5452 24.2272 10.5418 24.1946 10.5452 24.1629C10.6242 23.4983 10.5019 23.042 9.81553 22.6459C8.66196 21.9796 8.32133 20.424 8.86159 19.1505C9.37466 17.9406 10.6922 17.2305 11.9766 17.4723C13.2711 17.7159 14.186 18.6497 14.35 19.8932C14.5292 21.2541 13.8963 22.3972 12.6502 22.9975C12.5593 23.0412 12.4684 23.1947 12.4658 23.2993C12.448 23.9202 12.4616 24.5419 12.4557 25.1636C12.4497 25.7793 12.0734 26.1678 11.4983 26.1661C10.9249 26.1643 10.5546 25.775 10.5461 25.1585C10.5418 24.8583 10.5461 24.5582 10.5452 24.2589ZM11.5 21.2944C12.0709 21.2944 12.4625 20.8982 12.454 20.3279C12.4455 19.7705 12.0573 19.3864 11.5017 19.3864C10.9428 19.3864 10.5588 19.7645 10.5486 20.3254C10.5384 20.8956 10.93 21.2944 11.5 21.2944Z" />
                                                                </svg>
                                                                <input type="password" name="password" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                                <label for="register_password" class="did-floating-label required">{{getLanguage["RCUZ"]["CPASS"]}}</label>
                                                                <span toggle="#register_password" class="pw-eye-slash toggle-password"></span>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.EPWSC.CV" @change="v => arry_CrOnOff.EPWSC.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["ESP"]}}</label>
                                                                <div class="custom-tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="custom-tooltiptext2 turnover-requirement" v-html="getLanguage['ACU']['ESP']"></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-if="element.id == 'CUR'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1" disabled>
                                                            </div>
                                                            <div class="selectCustom registerCurrencySelect">
                                                                <svg id="ddSVgIcon" class=" " viewBox="0 0 26 26" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M12.1367 0C12.7125 0 13.2875 0 13.8633 0C13.9452 0.0165039 14.0264 0.0374512 14.1089 0.048877C14.6345 0.123779 15.1677 0.164404 15.6857 0.276123C18.4082 0.865185 20.7219 2.1855 22.6002 4.24341C24.2918 6.09629 25.3697 8.26084 25.7981 10.7396C25.8781 11.203 25.9333 11.6708 26 12.1367V13.8633C25.9841 13.9363 25.9625 14.008 25.9524 14.0816C25.894 14.5247 25.8648 14.9735 25.7785 15.4108C25.1405 18.6316 23.5276 21.2621 20.9428 23.2838C19.2645 24.5965 17.3678 25.4401 15.2629 25.7981C14.7983 25.8769 14.3305 25.9333 13.8639 26H12.1374C12.0555 25.9835 11.9742 25.9625 11.8917 25.9511C11.3661 25.8762 10.8329 25.8356 10.3149 25.7239C7.59243 25.1348 5.27871 23.8145 3.40044 21.7566C1.70879 19.9037 0.630957 17.7392 0.20249 15.2604C0.121875 14.797 0.0666504 14.3292 0 13.8633C0 13.2875 0 12.7125 0 12.1367C0.0158691 12.0637 0.0374512 11.992 0.0476074 11.9184C0.106006 11.4753 0.135205 11.0265 0.221533 10.5892C0.859473 7.36836 2.47241 4.73789 5.05718 2.71616C6.73613 1.40347 8.63218 0.559863 10.7377 0.201855C11.2023 0.123145 11.6702 0.0666504 12.1367 0ZM13.007 1.625C6.75772 1.61484 1.62627 6.74248 1.625 12.9987C1.62373 19.2455 6.71519 24.3674 12.9797 24.368C19.2639 24.3693 24.3375 19.3312 24.3712 13.0127C24.4048 6.76914 19.2683 1.63452 13.007 1.62437V1.625Z" />
                                                                    <path d="M12.1881 7.36265C12.1881 7.0478 12.1843 6.76914 12.1888 6.48985C12.197 6.03408 12.5461 5.68941 12.9955 5.68814C13.4456 5.68687 13.8004 6.02901 13.8106 6.48159C13.8157 6.70122 13.822 6.92212 13.8087 7.14175C13.7979 7.31504 13.8449 7.39058 14.0302 7.42739C14.7012 7.5607 15.3143 7.83047 15.8539 8.26148C16.2874 8.60806 16.382 9.08985 16.0773 9.47642C15.7771 9.85728 15.2972 9.88965 14.8637 9.55767C13.881 8.80484 12.3595 8.74326 11.3109 9.41421C10.3245 10.0452 10.3429 11.1255 11.3464 11.7343C11.9076 12.0745 12.5252 12.1729 13.1663 12.1913C14.1565 12.2205 15.0649 12.5049 15.8469 13.1219C16.5756 13.697 17.0415 14.4301 17.0593 15.3886C17.0765 16.2951 16.6848 17.0181 16.0189 17.6071C15.4489 18.1111 14.7799 18.4165 14.0416 18.5796C13.9686 18.5955 13.8963 18.617 13.8112 18.6386C13.8112 18.9287 13.8138 19.2074 13.8112 19.486C13.8061 19.9621 13.4634 20.3119 13.0038 20.3131C12.543 20.315 12.1951 19.9672 12.1875 19.4949C12.185 19.3426 12.1875 19.1902 12.1875 19.0379C12.1875 18.624 12.1856 18.631 11.7705 18.532C11.1185 18.3771 10.5346 18.0813 10.0268 17.6439C9.69096 17.3545 9.65224 16.8676 9.92265 16.5249C10.1931 16.1827 10.6812 16.0938 11.0303 16.3725C11.568 16.801 12.1742 17.0244 12.8496 17.0447C13.7052 17.0708 14.5057 16.8892 15.1004 16.2164C15.6044 15.6463 15.5232 14.9773 14.936 14.4809C14.319 13.9591 13.5821 13.8392 12.807 13.8081C11.6137 13.7611 10.5568 13.3694 9.72397 12.4839C8.56615 11.2531 8.70644 9.43325 10.0172 8.35987C10.5923 7.88887 11.2372 7.58291 11.9571 7.42232C12.0301 7.40581 12.1024 7.38487 12.1875 7.36328L12.1881 7.36265Z" />
                                                                </svg>
                                                                <div class="custom-select-dd did-floating-select position-relative">{{getLanguage["RCUZ"]["SC"]}}</div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0" v-if='ShowFullAgentConfig'>
                                                        <div class="agentcus-grid">
                                                            <label class="switch" :style="renderStyle()">
                                                                <input type="checkbox" :checked="arry_CrOnOff.HCDIHO.CV" @change="v => arry_CrOnOff.HCDIHO.CV = v.target.checked">
                                                                <span class="slider round"></span>
                                                            </label>
                                                            <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["HCDIHO"]}}</label>
                                                            <div class="custom-tooltip ACUZ_TT">
                                                                <i class="fa fa-question-circle"></i>
                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["HCDIHO"]}}</span>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-if="element.id == 'BANK'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">
                                                            </div>
                                                            <div class="selectCustom registerBankSelect">
                                                                <svg id="ddSVgIcon" class=" " viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M24.9997 15.8203C24.902 16.1094 24.8363 16.4147 24.7008 16.6842C24.1598 17.7598 23.2712 18.321 22.07 18.3522C21.2178 18.3744 20.3643 18.3568 19.4951 18.3568V16.3952C19.7152 16.3952 19.932 16.3952 20.1488 16.3952C20.7673 16.3952 21.3857 16.4004 22.0036 16.3932C22.6247 16.3861 23.0361 15.9863 23.0374 15.3691C23.0426 12.6602 23.0394 9.95052 23.0387 7.24154C23.0387 7.21745 23.0335 7.19336 23.0277 7.14909H1.95866C1.95866 7.23828 1.95866 7.32552 1.95866 7.41276C1.95866 10.0247 1.95866 12.6361 1.95866 15.248C1.95866 16.0189 2.33887 16.3952 3.11686 16.3958C3.92155 16.3958 4.72689 16.3958 5.55046 16.3958V18.3262C5.54199 18.3327 5.52897 18.3503 5.5166 18.3503C4.50879 18.3405 3.49447 18.3971 2.49512 18.3001C1.24642 18.1784 0.28418 17.1868 0.0485026 15.9525C0.0400391 15.9076 0.0159505 15.8652 -0.000976562 15.8216C-0.000325521 11.3932 -0.000325521 6.96615 -0.000325521 2.53906C0.0152995 2.50326 0.038737 2.46875 0.0458984 2.43099C0.187174 1.64193 0.570638 0.988281 1.23991 0.555339C1.61816 0.310547 2.07064 0.181641 2.48991 0C9.16309 0 15.8363 0 22.5094 0C22.5524 0.0169271 22.5947 0.0403646 22.6397 0.0501302C23.6331 0.276693 24.3473 0.848958 24.7568 1.78255C24.8623 2.02344 24.9202 2.28581 24.9997 2.53841V15.8203ZM23.0407 4.18229C23.0407 3.81315 23.0407 3.45703 23.0407 3.10156C23.0394 2.33203 22.6579 1.95247 21.8838 1.95247C15.6266 1.95247 9.36882 1.95247 3.11165 1.95247C3.04655 1.95247 2.98145 1.94987 2.91634 1.95378C2.43717 1.97852 2.04069 2.28971 1.99316 2.76628C1.94694 3.23047 1.9834 3.70247 1.9834 4.18229H23.0407Z" />
                                                                    <path d="M12.5 25C11.4616 23.957 10.4232 22.9141 9.38411 21.8717C8.76432 21.25 8.14258 20.6302 7.5332 20.0208C7.99609 19.5586 8.44857 19.1055 8.89909 18.6549C9.73893 19.498 10.5918 20.3535 11.444 21.209C11.4668 21.1973 11.4902 21.1855 11.513 21.1738V13.3359H13.4648V21.2018C14.3444 20.3216 15.2122 19.4525 16.0775 18.5866C16.5781 19.0996 17.0299 19.5618 17.513 20.0573C17.4694 20.0911 17.3841 20.1432 17.3151 20.2116C15.7839 21.7402 14.2539 23.2702 12.7253 24.8008C12.6628 24.8633 12.6074 24.9329 12.5488 24.9987H12.5V25Z" />
                                                                    <path d="M16.2 8.60807V10.5319H3.34253V8.60807H16.2Z" />
                                                                </svg>
                                                                <div class="custom-select-dd did-floating-select position-relative" :class="arry_CrOnOff.RWBA.CV == true ? 'required': ''">{{getLanguage["DCUZ"]["PSDB"]}}</div>
                                                            </div>
                                                        </div>

                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                            </div>
                                                            <div class="did-floating-label-content registerAccount">
                                                                <svg viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M1.95328 24.9999C1.9808 22.8842 2.53058 20.9183 3.73104 19.1701C5.466 16.6442 7.8388 15.0721 10.8867 14.5939C13.4962 14.1848 15.9412 14.685 18.1544 16.1232C20.7014 17.7778 22.3037 20.1057 22.8553 23.1123C22.9691 23.7323 22.9856 24.3701 23.0473 24.9999H25C24.8141 19.2282 21.8823 15.3931 16.6756 13.1459C18.7378 11.5781 19.8306 9.49361 19.7126 6.84838C19.6288 4.96628 18.8803 3.35077 17.5251 2.04406C14.5364 -0.837197 10.0049 -0.570596 7.30859 2.2012C4.33708 5.25611 4.56702 10.4897 8.36962 13.1802C8.23936 13.234 8.12378 13.2823 8.00881 13.33C3.93102 15.014 1.34295 17.9851 0.301493 22.2789C0.168175 22.828 0.129648 23.4003 0.0452538 23.9616C0.0373039 24.016 0.0152893 24.068 0 24.1212V24.9999H1.95328ZM12.5012 1.95723C15.3847 1.95967 17.7538 4.32423 17.7721 7.21771C17.7899 10.0947 15.3865 12.5027 12.4988 12.5002C9.61534 12.4978 7.24621 10.1332 7.22786 7.23973C7.21013 4.36275 9.6135 1.95478 12.5012 1.95723Z" />
                                                                </svg>
                                                                <input type="text" name="register_bankaccname" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                                <label for="register_bankaccname" class="did-floating-label" :class="arry_CrOnOff.RWBA.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["BACCNAME"]}}</label>
                                                            </div>
                                                        </div>

                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                            </div>
                                                            <div class="did-floating-label-content registerBankAccno">
                                                                <svg viewBox="0 0 29 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M28.9925 10.3978C28.9811 8.51296 27.4124 6.97772 25.4951 6.97549C24.9561 6.97475 24.417 6.97401 23.878 6.97401H19.9157C19.915 6.59094 19.9157 6.20788 19.9157 5.82407C19.9157 5.13306 19.9165 4.44132 19.9142 3.75031C19.9127 3.22146 20.1002 2.75435 20.4706 2.36235C21.0868 1.71077 21.8889 1.39391 22.9217 1.39391C22.9867 1.39391 23.0524 1.3954 23.1182 1.39763C24.6567 1.4549 25.6637 2.32963 25.8815 3.79717C25.9336 4.15049 26.2315 4.4071 26.5883 4.4071C26.6034 4.4071 26.6186 4.40636 26.6337 4.40561C27.0019 4.3833 27.2778 4.10065 27.2884 3.73395C27.2929 3.59039 27.2929 3.40221 27.2574 3.21477C26.9958 1.84689 26.1204 0.8658 24.656 0.300501C24.4163 0.207524 24.1683 0.147275 23.9279 0.0885139C23.8213 0.0624804 23.7147 0.0364469 23.6096 0.00818196L23.5794 0H22.217L22.1898 0.00669433C22.1165 0.0245459 22.0424 0.0416536 21.9683 0.0587614C21.8073 0.0959521 21.641 0.13463 21.4769 0.180003C19.5816 0.697698 18.4944 2.09756 18.4937 4.02106V4.84744C18.4929 5.66489 18.4922 6.51061 18.4982 7.34294C18.499 7.43815 18.4884 7.46939 18.3893 7.5341C17.3687 8.20725 16.8191 9.15264 16.8002 10.2684C16.7654 12.3406 16.7684 14.1496 16.8085 15.8001C16.8486 17.4402 18.3334 18.9159 19.986 18.9591C21.0248 18.9859 22.0454 19 23.0192 19C23.9302 19 24.8306 18.9881 25.697 18.9643C26.5861 18.9405 27.4162 18.5708 28.0353 17.9244C28.6477 17.2848 28.9879 16.4457 28.9925 15.5613C29.0023 13.8208 29.0023 12.084 28.9925 10.3978ZM27.5779 15.426C27.5764 16.6875 26.6836 17.5749 25.4059 17.583C25.0876 17.5853 24.7694 17.586 24.4511 17.586C24.1902 17.586 23.9287 17.586 23.6678 17.586C23.407 17.5853 23.1462 17.5845 22.8846 17.5845C22.623 17.5845 22.3758 17.5853 22.121 17.5853C21.8587 17.586 21.5971 17.586 21.3348 17.586C21.0203 17.586 20.7058 17.586 20.3913 17.5838C19.0902 17.5763 18.2139 16.7157 18.2117 15.4408C18.2079 13.6185 18.2079 12.0037 18.2117 10.5056C18.2147 9.24859 19.1166 8.37015 20.4041 8.36866C21.1979 8.36791 21.991 8.36791 22.7848 8.36791C23.6452 8.36791 24.5047 8.36791 25.3651 8.36866C26.6874 8.3694 27.5764 9.24487 27.5779 10.5465C27.5795 12.1733 27.5795 13.8 27.5779 15.4267V15.426Z" />
                                                                    <path d="M15.7223 17.8441C15.6693 18.1692 15.4433 18.3767 15.1023 18.4131C15.0509 18.4191 15.0018 18.4198 14.9647 18.4198H14.4756C13.6478 18.4198 12.8207 18.4206 11.9928 18.4213C11.165 18.4221 10.3372 18.4235 9.51009 18.4235C7.65785 18.4235 6.23503 18.4183 4.89537 18.4072C2.58196 18.3886 0.465876 16.5878 0.0772837 14.3088C-0.148765 12.9833 0.126425 11.6623 0.852956 10.5904C1.58024 9.51562 2.712 8.76213 4.04107 8.46684C4.45764 8.37386 4.89159 8.35824 5.29833 8.35527C5.89256 8.3508 6.54424 8.34857 7.3494 8.34857C7.76294 8.34857 8.17723 8.34857 8.59077 8.34932C8.99675 8.35006 9.40274 8.3508 9.80872 8.3508H12.2695C13.1412 8.3508 14.0129 8.3508 14.8846 8.34932H14.8861C15.0638 8.34932 15.466 8.35006 15.6656 8.73684C15.7661 8.93098 15.7676 9.15412 15.6716 9.34826C15.5703 9.55206 15.3783 9.69413 15.1447 9.73876C15.0638 9.75438 14.9859 9.75661 14.9209 9.75661C14.8975 9.75661 14.8113 9.75512 14.7909 9.75512H14.2155C13.3877 9.75512 12.5591 9.75513 11.7313 9.75438H9.247C7.62685 9.75438 6.31592 9.75513 5.12142 9.75884C3.34554 9.76331 1.92877 10.8731 1.5122 12.5868C1.27708 13.5493 1.47591 14.5847 2.05804 15.4267C2.63866 16.2687 3.54361 16.831 4.53929 16.9716C4.76609 17.0036 5.01104 17.02 5.26884 17.02C7.02733 17.0215 8.78583 17.0222 10.5443 17.0222C11.9717 17.0229 13.3983 17.0229 14.8256 17.0237C14.9783 17.0244 15.1409 17.0319 15.2906 17.0854C15.6195 17.2029 15.7805 17.4863 15.7223 17.8441Z" />
                                                                    <path d="M11.8431 13.8558C11.3683 13.7301 10.9321 13.6178 10.4974 13.4995C10.1723 13.411 10.0022 13.1737 10.0687 12.9149C10.142 12.6307 10.4036 12.4901 10.7385 12.5712C11.2012 12.6835 11.6609 12.8063 12.1477 12.9305C12.1477 12.4396 12.1462 11.9851 12.1477 11.5314C12.1493 11.181 12.3322 10.9594 12.6195 10.9549C12.9174 10.9504 13.1086 11.1788 13.1102 11.5447C13.1117 11.962 13.1102 12.38 13.1102 12.8412C13.5381 12.6672 13.9365 12.4901 14.347 12.3451C14.4967 12.2923 14.7046 12.2543 14.8293 12.3176C14.9616 12.3853 15.0781 12.5705 15.1098 12.7222C15.1529 12.926 15.0214 13.0919 14.815 13.1767C14.3636 13.3626 13.913 13.5486 13.4292 13.7479C13.6734 14.038 13.9055 14.3132 14.1368 14.5892C14.2147 14.6822 14.2979 14.7722 14.3697 14.8696C14.5413 15.1002 14.5163 15.3754 14.3145 15.5427C14.1081 15.7138 13.8299 15.6975 13.6326 15.4773C13.315 15.1225 13.0134 14.7543 12.6807 14.3631C12.4509 14.7186 12.2362 15.0526 12.02 15.3858C11.9693 15.4639 11.9217 15.545 11.8635 15.6171C11.6964 15.8224 11.4174 15.8723 11.2073 15.7391C10.9903 15.6015 10.9124 15.3397 11.05 15.1061C11.2436 14.7774 11.4605 14.462 11.6669 14.1407C11.7214 14.0559 11.7735 13.9688 11.8438 13.8558H11.8431Z" />
                                                                    <path d="M5.99306 14.3653C5.73375 14.767 5.49787 15.1359 5.25822 15.5018C5.06165 15.8031 4.76832 15.8961 4.52186 15.7421C4.26708 15.5829 4.23306 15.301 4.4334 14.9871C4.66852 14.6189 4.90667 14.2522 5.16145 13.8573C4.68516 13.7323 4.23533 13.614 3.7855 13.4958C3.55416 13.4348 3.3712 13.292 3.38178 13.0577C3.38859 12.9059 3.49292 12.7096 3.61766 12.627C3.73484 12.5489 3.9435 12.5601 4.09849 12.592C4.54529 12.685 4.98605 12.8077 5.45554 12.926C5.45554 12.4358 5.45402 11.9814 5.45554 11.5276C5.45705 11.1818 5.64605 10.9571 5.93258 10.9549C6.22138 10.9527 6.41492 11.1766 6.41719 11.5217C6.41946 11.9486 6.41719 12.3756 6.41719 12.8375C6.85568 12.662 7.26997 12.4924 7.68729 12.3302C7.98668 12.2142 8.22406 12.2804 8.3541 12.505C8.50908 12.7728 8.39492 13.0681 8.06984 13.2057C7.63815 13.3887 7.20118 13.5597 6.73698 13.7479C7.01595 14.0759 7.28131 14.3861 7.54516 14.6985C7.61169 14.7766 7.682 14.854 7.73417 14.941C7.86269 15.1567 7.80523 15.4178 7.60791 15.5613C7.39623 15.7146 7.13691 15.693 6.94791 15.4803C6.63114 15.1247 6.32798 14.758 5.99306 14.3653Z" />
                                                                    <path d="M23.3761 12.9007C23.3761 13.2161 23.3814 13.5322 23.3746 13.8476C23.3678 14.157 23.175 14.3489 22.8885 14.3474C22.6012 14.346 22.416 14.1555 22.4145 13.8416C22.4107 13.2101 22.4107 12.5786 22.4145 11.9479C22.4167 11.6429 22.6163 11.4391 22.8938 11.4414C23.1667 11.4436 23.3685 11.6526 23.3746 11.9538C23.3806 12.2692 23.3761 12.5853 23.3761 12.9007Z" />
                                                                </svg>
                                                                <input type="text" name="registerBankAccno" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                                <label for="registerBankAccno" class="did-floating-label" :class="arry_CrOnOff.RWBA.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["BACCNO"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.RWBA.CV" @change="v => arry_CrOnOff.RWBA.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["EBAMF"]}} </label>
                                                            </div>

                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.CDBACC.CV" @change="v => arry_CrOnOff.CDBACC.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["CDBACC"]}}</label>
                                                                <div class="custom-tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CDBACC"]}}</span>
                                                                </div>
                                                            </div>

                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.BABLBA.CV" @change="v => arry_CrOnOff.BABLBA.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["BABLBA"]}}</label>
                                                                <div class="custom-tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["BABLBA"]}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-if="element.id == 'EM'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">
                                                            </div>
                                                            <div class="did-floating-label-content registerEmail">
                                                                <svg viewBox="0 0 26 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M0 3.5C0 2.63805 0.34241 1.8114 0.951903 1.2019C1.5614 0.59241 2.38805 0.25 3.25 0.25H22.75C23.612 0.25 24.4386 0.59241 25.0481 1.2019C25.6576 1.8114 26 2.63805 26 3.5V16.5C26 17.362 25.6576 18.1886 25.0481 18.7981C24.4386 19.4076 23.612 19.75 22.75 19.75H3.25C2.38805 19.75 1.5614 19.4076 0.951903 18.7981C0.34241 18.1886 0 17.362 0 16.5V3.5ZM3.25 1.875C2.81902 1.875 2.4057 2.0462 2.10095 2.35095C1.7962 2.6557 1.625 3.06902 1.625 3.5V3.85262L13 10.6776L24.375 3.85262V3.5C24.375 3.06902 24.2038 2.6557 23.899 2.35095C23.5943 2.0462 23.181 1.875 22.75 1.875H3.25ZM24.375 5.74738L16.7245 10.338L24.375 15.0456V5.74738ZM24.3197 16.9209L15.1548 11.2805L13 12.5724L10.8452 11.2805L1.68025 16.9193C1.77259 17.265 1.97651 17.5707 2.26036 17.7887C2.5442 18.0067 2.89209 18.1249 3.25 18.125H22.75C23.1077 18.125 23.4554 18.0071 23.7392 17.7894C24.0231 17.5716 24.2271 17.2664 24.3197 16.9209ZM1.625 15.0456L9.2755 10.338L1.625 5.74738V15.0456Z" />
                                                                </svg>
                                                                <input type="email" name="required_email" placeholder="" class="did-floating-input register_required_email" autocomplete="off" disabled>
                                                                <label for="email" class="did-floating-label" :class="arry_CrOnOff.REM.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["EM"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.REM.CV" @change="v => arry_CrOnOff.REM.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["EEAMF"]}} </label>
                                                            </div>

                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.RWEA.CV" @change="v => arry_CrOnOff.RWEA.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["RWEA"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-if="element.id == 'REF'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">
                                                            </div>
                                                            <div class="did-floating-label-content" id="RCfilCol">
                                                                <svg viewBox="0 0 30 15" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M27.5131 7.5C27.5131 6.66466 28.1731 5.95564 28.9846 5.9188C29.4715 5.89624 29.7962 5.70827 29.9769 5.34211L30 5.29624V0.790226L29.9738 0.741354C29.7908 0.400753 29.5185 0.157144 29.1638 0.0165424L29.1215 9.53674e-07H23.4223L23.3708 0.0270681C23.3077 0.0601511 23.1885 0.123309 23.0862 0.225565C22.9531 0.357896 22.8477 0.55564 22.9277 0.837595C23.0677 1.33308 23.5577 1.33308 23.7423 1.33308C24.5208 1.33233 25.2946 1.33158 26.0685 1.33158H28.6577V4.62556C27.79 4.78572 27.1123 5.22256 26.6423 5.92556C26.2885 6.45489 26.1315 7.03158 26.1754 7.6406C26.2769 9.06241 27.1108 9.97895 28.6554 10.3669V13.6519H1.34692V10.3722C2.17077 10.2218 2.82615 9.81579 3.29692 9.16391C3.68231 8.63008 3.86077 8.03835 3.82769 7.40602C3.75308 5.97293 2.83154 4.94887 1.34923 4.63534V1.33233H21.3238C21.35 1.33158 21.3762 1.33158 21.4023 1.33233C21.4238 1.33308 21.4446 1.33308 21.4654 1.33308C21.8738 1.33308 22.1323 1.17068 22.2323 0.849625C22.3223 0.563159 22.2115 0.363158 22.0708 0.225565C21.9838 0.139851 21.8862 0.078948 21.8169 0.0353394L21.76 9.53674e-07H0.877692L0.835385 0.0165424C0.478462 0.159399 0.206154 0.40376 0.0261538 0.741354L0 0.790226V5.29549L0.0230769 5.34211C0.263077 5.82932 0.703846 5.90451 1.01538 5.9188C1.82692 5.95639 2.48692 6.66541 2.48692 7.5C2.48692 8.33459 1.82692 9.04511 1.01538 9.0812C0.703846 9.09549 0.262308 9.17068 0.0230769 9.65789L0 9.70451V14.2098L0.0261538 14.2586C0.206923 14.597 0.479231 14.8406 0.835385 14.9835L0.877692 15H29.1215L29.1631 14.9835C29.52 14.8429 29.7931 14.5985 29.9738 14.2579L30 14.209V9.70376L29.9769 9.65714C29.7954 9.29173 29.4708 9.10301 28.9846 9.0812C28.1731 9.04511 27.5131 8.33609 27.5131 7.5Z" />
                                                                    <path d="M10.776 2.36917C10.4737 2.32256 10.1668 2.30151 9.86143 2.26842C7.20143 2.28872 4.92374 4.21805 4.57527 6.79775C4.37912 8.24963 4.7545 9.56993 5.67681 10.7331C5.90066 11.015 6.17297 11.0842 6.38758 10.9196C6.61527 10.7459 6.60912 10.503 6.37143 10.2053C4.39912 7.7391 5.59297 4.16241 8.67297 3.30677C11.2337 2.59624 13.8768 4.27444 14.2614 6.85714C14.6822 9.6782 12.2876 12.1429 9.40527 11.8278C8.92758 11.7752 8.46912 11.5699 7.99604 11.4609C7.82373 11.4203 7.60066 11.3917 7.45835 11.4647C7.15143 11.6241 7.21758 12.0361 7.55912 12.2008C8.31297 12.5647 9.11604 12.7353 9.95373 12.7105C12.646 12.6301 14.7684 10.7729 15.1576 8.17218C15.5622 5.47293 13.5414 2.79474 10.776 2.36917Z" />
                                                                    <path d="M25.4768 5.45113C25.4699 5.96843 25.2215 6.20151 24.6907 6.20151C23.4991 6.20301 22.3076 6.20151 21.1161 6.20151C19.9245 6.20151 18.7138 6.20226 17.513 6.20151C17.0099 6.20076 16.7507 5.95339 16.7453 5.45941C16.7391 4.91504 16.7399 4.36993 16.7453 3.82557C16.7499 3.32858 17.0007 3.06993 17.5038 3.06918C19.9061 3.06392 22.3084 3.06392 24.7107 3.06843C25.2207 3.06918 25.4691 3.31655 25.4768 3.81655C25.4853 4.36166 25.4845 4.90677 25.4768 5.45113ZM24.573 3.9564H17.6615V5.3361H24.573V3.9564Z" />
                                                                    <path d="M25.4378 9.57068C25.3463 9.34136 25.1509 9.2985 24.9224 9.29925C23.644 9.30376 22.3647 9.30151 21.0863 9.30151C19.8078 9.30151 18.5486 9.30301 17.2801 9.30001C17.0478 9.29925 16.8632 9.3564 16.7809 9.59173C16.6947 9.8361 16.8509 10.0977 17.114 10.1444C17.1609 10.1519 17.2093 10.1496 17.2578 10.1496C19.824 10.1496 22.3909 10.1504 24.9578 10.1496C25.337 10.1489 25.5609 9.87745 25.4378 9.57143V9.57068Z" />
                                                                    <path d="M11.5116 10.3218C11.4678 10.1767 11.4486 10.0842 11.4124 9.99925C10.6501 8.2218 9.88933 6.44361 9.11395 4.67143C9.05395 4.53383 8.90779 4.39023 8.76856 4.3421C8.65779 4.30451 8.42394 4.37068 8.37318 4.46015C8.29394 4.6015 8.25702 4.82632 8.31471 4.97218C8.63702 5.78346 8.99241 6.5812 9.33702 7.38346C9.76318 8.37519 10.1863 9.36842 10.6163 10.3586C10.7486 10.6647 11.0139 10.7835 11.2516 10.6308C11.367 10.5571 11.4355 10.415 11.5116 10.3218Z" />
                                                                    <path d="M23.1592 7.9391C23.1399 7.70076 22.9992 7.55489 22.7576 7.53309C22.5476 7.51354 22.3353 7.52181 22.1238 7.52181C21.393 7.52031 20.663 7.52106 19.9323 7.52106C19.0861 7.52106 18.2407 7.52031 17.3946 7.52256C17.2899 7.52256 17.1553 7.50226 17.0861 7.55565C16.9546 7.6564 16.7799 7.79926 16.7723 7.93309C16.7646 8.06692 16.9184 8.23234 17.0415 8.34211C17.1107 8.40377 17.2599 8.39174 17.373 8.39174C19.0938 8.39474 20.8146 8.39399 22.5346 8.39324C22.6115 8.39324 22.6899 8.39775 22.7653 8.38497C23.0092 8.34587 23.1769 8.15865 23.1592 7.9391Z" />
                                                                    <path d="M8.26704 10.6962C7.52166 10.7 6.88704 10.0789 6.89089 9.34887C6.89396 8.62406 7.50627 8.0188 8.24473 8.01128C8.99781 8.00301 9.62781 8.60677 9.63243 9.34135C9.63627 10.0774 9.01781 10.6917 8.26704 10.6962ZM8.25242 8.87444C7.98089 8.88196 7.77396 9.1 7.78242 9.36993C7.79089 9.63384 7.98781 9.8188 8.26012 9.8203C8.5355 9.82181 8.75781 9.60827 8.75473 9.34737C8.75166 9.08722 8.51781 8.86767 8.25242 8.87444Z" />
                                                                    <path d="M11.4562 6.98873C10.7008 6.98647 10.0939 6.38271 10.0969 5.63685C10.1 4.91279 10.7092 4.31279 11.4516 4.30377C12.1977 4.29474 12.8246 4.90677 12.8262 5.64662C12.8277 6.39023 12.2146 6.99174 11.4562 6.98873ZM11.4839 5.18046C11.2062 5.16993 10.9785 5.36918 10.9677 5.63309C10.9577 5.88722 11.1877 6.12256 11.4523 6.12707C11.7192 6.13234 11.9446 5.91429 11.9454 5.64963C11.9462 5.38722 11.7523 5.19023 11.4839 5.18046Z" />
                                                                    <path d="M21.2277 11.509C21.2339 11.2293 21.0254 11.0632 20.6531 11.0617C20.0862 11.0594 19.5185 11.0609 18.9516 11.0609C18.3847 11.0609 17.8562 11.0586 17.3085 11.0624C16.967 11.0639 16.7477 11.2414 16.7493 11.5015C16.7508 11.7617 16.9647 11.9316 17.3147 11.9323C18.4293 11.9353 19.5447 11.9353 20.6593 11.9323C21.0224 11.9316 21.2216 11.7782 21.2277 11.509Z" />
                                                                </svg>
                                                                <input type="text" name="referral" placeholder="" class="did-floating-input register_referral" autocomplete="off" disabled>
                                                                <label for="refferal" class="did-floating-label">{{getLanguage["RCUZ"]["REF"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>


                                                </CRow>
                                            </template>
                                            <template v-if="element.id == 'PN' && arry_CrOnOff.REGWPHONE.CV == false">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1" :disabled="arry_CrOnOff.REGWPHONE.CV">
                                                            </div>
                                                            <div class="did-floating-label-content registerPhone">
                                                                <svg viewBox="0 0 17 28" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M0 26.3048C0 18.1041 0 9.90411 0 1.70337C0.0131471 1.67969 0.0363479 1.65676 0.0394414 1.63234C0.142298 0.750332 1.01078 -0.00588499 2.13215 3.45199e-05C6.38254 0.0214927 10.6329 0.00817384 14.8841 0.0103937C15.0542 0.0103937 15.229 0.0126135 15.3937 0.0466506C16.3898 0.249394 16.9977 1.01079 16.9985 2.05188C17 7.44529 16.9985 12.8394 16.9985 18.2329C16.9985 20.8019 16.9985 23.3717 16.9985 25.9408C16.9985 26.4676 16.8608 26.9434 16.4981 27.3548C16.205 27.6878 15.8044 27.8402 15.4046 28H1.59776C1.34642 27.8824 1.07961 27.7869 0.846056 27.6419C0.345692 27.3304 0.126831 26.8413 0 26.3056V26.3048ZM15.5809 24.492V3.03082H1.42221V24.492H15.5809ZM9.47521 26.1065C9.47521 25.5923 9.03284 25.1676 8.5 25.169C7.96638 25.1705 7.52789 25.5952 7.52866 26.1102C7.52943 26.6311 7.96019 27.0426 8.50387 27.0411C9.04754 27.0396 9.47598 26.6282 9.47521 26.1065ZM8.50232 1.81732C9.15658 1.81732 9.81162 1.81732 10.4659 1.81732C10.6252 1.81732 10.7915 1.81584 10.7977 1.61236C10.8046 1.4 10.6422 1.37262 10.4651 1.37262C9.15581 1.3741 7.84651 1.3741 6.53721 1.37262C6.36011 1.37262 6.19771 1.4 6.20544 1.61236C6.2124 1.8151 6.3779 1.81732 6.53798 1.81732C7.19225 1.81584 7.84728 1.81732 8.50155 1.81732H8.50232Z" />
                                                                </svg>
                                                                <input type="tel" name="required_phone" placeholder="" class="did-floating-input register_required_phone r7" autocomplete="off" disabled>
                                                                <label for="registerPhone" class="did-floating-label" :class="arry_CrOnOff.RPN.CV == true ? 'required': ''">{{getLanguage["RCUZ"]["PHNO"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.RPN.CV" @change="v => arry_CrOnOff.RPN.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["EPAMF"]}} </label>
                                                            </div>
                                                            <div v-if="arry_CrOnOff.RPN.CV == true">
                                                                <div class="flex-item agentcus-grid">
                                                                    <label :style="renderStyle()">
                                                                        <input type="checkbox" :checked="arry_CrOnOff.DOTPV.CV" @change="v => arry_CrOnOff.DOTPV.CV = v.target.checked">
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{ getLanguage["ACO"]["DOTPV"] }}</label>
                                                                    <div class="custom-tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["DOTPV"] }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <input type="radio" name="captcha" :checked="arry_CrOnOff.REGWPHONE.CV" value="true" @change="changePhoneSetting($event,element)" :style="renderStyle()">
                                                                    <label for="html">{{getLanguage["ACO"]["REGWPHONE"]}}</label>
                                                                    <div class="custom-tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["REGWPHONE"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item agentcus-grid">
                                                                    <input type="radio" name="captcha" :checked="!arry_CrOnOff.REGWPHONE.CV" value="false" @change="changePhoneSetting($event,element)" :style="renderStyle()">
                                                                    <label for="html">{{getLanguage["ACO"]["UANAU"]}}</label>
                                                                    <div class="custom-tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["UANAU"]}}</span>
                                                                    </div>
                                                                </div>
                                                                <br />
                                                                <!--LOCALIZED-->
                                                                <div class="flex-item agentcus-grid">
                                                                    <label class="switch" :style="renderStyle()">
                                                                        <input type="checkbox" :checked="arry_CrOnOff.ULPN.CV" @change="v => arry_CrOnOff.ULPN.CV = v.target.checked">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{ getLanguage["ACO"]["ULPN"] }}</label>
                                                                    <div class="custom-tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["ULPN"] }}</span>
                                                                    </div>
                                                                </div>

                                                                <!--PREFIX-->
                                                                <div class="flex-item agentcus-grid" v-if="arry_CrOnOff.ULPN.CV == true">
                                                                    <label class="switch" :style="renderStyle()">
                                                                        <input type="checkbox" :checked="arry_CrOnOff.UPCODE.CV" @change="v => arry_CrOnOff.UPCODE.CV = v.target.checked">
                                                                        <span class="slider round"></span>
                                                                    </label>
                                                                    <label class="ACUZ_DO col-form-label">{{ getLanguage["ACO"]["UPCODE"] }}</label>
                                                                    <div class="custom-tooltip ACUZ_TT">
                                                                        <i class="fa fa-question-circle"></i>
                                                                        <span class="custom-tooltiptext2 turnover-requirement">{{ getLanguage["ACU"]["UPCODE"] }}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="flex-item" v-if="arry_CrOnOff.ULPN.CV == true">
                                                                    <CInput class="inline inline30" :placeholder="getLanguage['ACO']['CCODE']" size="sm" :value="arry_cr.E_CC" @change="v => arry_cr.E_CC = v"></CInput>
                                                                    <CInput style="margin-left: 3px;" class="inline inline30" :placeholder="getLanguage['ACO']['PCODE']" size="sm" :value="arry_cr.E_PC" @change="v => arry_cr.E_PC = v"></CInput>
                                                                    <CButton style="margin-left: 15px; margin-top: 0px;" color="outline-dark" size="sm" class="btn-small inline inline10" @click="addPrefixCr()">
                                                                        <span class='plusIcon cil-plus'></span>{{getLanguage["BTN"]["AD"]}}
                                                                    </CButton>
                                                                </div>
                                                                <br />
                                                                <div class="flex-item" v-if="arry_CrOnOff.ULPN.CV == true">
                                                                    <table class="custom-table custom-table-inPopUp afb-blue" style="width: 85% !important">
                                                                        <thead>
                                                                            <tr>
                                                                                <th v-if="!bool_isPreview" style="width: 30px;">{{ getLanguage['GL']['ACT'] }}</th>
                                                                                <th style="width: 50% !important">{{ getLanguage['ACO']['CCODE'] }}</th>
                                                                                <th>{{ getLanguage["ACO"]["PCODE"] }}</th>
                                                                                <th>{{ getLanguage["ACO"]["LDZ"] }}</th>
                                                                                <th>{{ getLanguage["ACO"]["PS"] }}</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                        <td colspan="100%" v-if="arry_cr.LocalisedList == 0 || !arry_cr.LocalisedList">{{ getLanguage['GL']['NR'] }}</td>
                                                                        <tr v-for="(data,index) in arry_cr.LocalisedList" class="">
                                                                            <td v-if="!bool_isPreview">
                                                                                <span id="actionBtnCol"> <i class="cil-trash" @click='removeLocaliseListCr(index)'></i> </span>
                                                                            </td>
                                                                            <td>+{{ data.CC }}</td>
                                                                            <td>{{ data.PC }}</td>
                                                                            <td>
                                                                                <input type="checkbox" v-if="data.PC != ''" :checked="data.LZ > 0" @click="tickLeadinZero($event, data, data.LZ, CountItem(index+1))" :style="renderStyle()" />
                                                                            </td>
                                                                            <td>+{{ data.PN }}</td>
                                                                        </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <br />
                                                            </div>
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.CDPNO.CV" @change="v => arry_CrOnOff.CDPNO.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["CDPNO"]}}</label>
                                                                <div class="custom-tooltip ACUZ_TT">
                                                                    <i class="fa fa-question-circle"></i>
                                                                    <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CDPNO"]}}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-if="element.id == 'WC'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">
                                                            </div>
                                                            <div class="did-floating-label-content registerWechat">
                                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve" fill="currentColor">
                                                                <g>
                                                                <path d="M17.3,6.8C17,5.9,16.6,5.1,16,4.4c-1.6-1.8-3.6-2.8-6-3.1C7.9,1.2,6,1.6,4.2,2.6c-2.7,1.6-4.4,4.6-3.9,7.7
		                        c0.3,1.5,1,2.9,2,4c0.4,0.4,0.8,0.7,1.3,1.1c-0.1,0.6-0.3,1.1-0.4,1.7c-0.1,0.3,0,0.6,0.3,0.8c0.3,0.2,0.6,0.2,0.9,0
		                        c0.5-0.3,1-0.6,1.5-0.9c0.4-0.3,0.8-0.4,1.3-0.2c0.3,0.1,0.7,0.1,1.1,0.2c0-0.1,0-0.1,0-0.1C8,15.6,8,14.4,8.3,13.2
		                        c1-3.4,4.1-5.7,7.6-6.1c0.5,0,0.9,0,1.4-0.1C17.4,6.9,17.4,6.9,17.3,6.8z M6.1,7.3C5.7,7.3,5.4,7,5.4,6.6c0-0.4,0.3-0.7,0.7-0.7
		                        c0.4,0,0.7,0.3,0.7,0.7C6.8,7,6.5,7.3,6.1,7.3z M10.8,7.3c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7
		                        C11.5,7,11.2,7.3,10.8,7.3z" />
                                                                <path d="M22.4,20c1.7-1.4,2.5-3.7,2.1-5.8c-0.5-2.9-3-5-5.8-5.6c-3.1-0.7-6.5,0.5-8.3,3.2c-0.6,1-1,2.2-1,3.3
		                        c0,0.4,0,0.7,0.1,1.1c0.3,1.8,1.3,3.2,2.7,4.2c2.2,1.5,4.6,1.9,7.1,1.2c0.2-0.1,0.4-0.1,0.6,0c0.5,0.2,1,0.4,1.5,0.6
		                        c0.3,0.1,0.6,0.1,0.8-0.1c0.2-0.2,0.3-0.5,0.2-0.8c-0.1-0.3-0.1-0.5-0.2-0.8C22.1,20.4,22.2,20.2,22.4,20z M14.4,14.1
		                        c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7C15.1,13.8,14.8,14.1,14.4,14.1z M19.3,14.1
		                        c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0.4,0,0.7,0.3,0.7,0.7C20,13.8,19.7,14.1,19.3,14.1z" />
                        </g>
                        </svg>
                                                                <input type="text" name="wechat_input" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                                <label for="registerWechat" class="did-floating-label" :class="arry_CrOnOff.RWC.CV ? 'required':''">{{getLanguage["RCUZ"]["WCID"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.RWC.CV" @change="v => arry_CrOnOff.RWC.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["EWCAMF"]}} </label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-if="element.id == 'LINE'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">
                                                            </div>
                                                            <div class="did-floating-label-content registerLine">
                                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve" fill="currentColor">
                                                                <g>
                                                                <path d="M24.4,8.8c-0.2-0.9-0.6-1.7-1.1-2.4c-0.8-1.1-1.7-2.1-2.8-2.8c-1-0.7-2.1-1.2-3.2-1.6c-1-0.3-2.1-0.6-3.2-0.7
		                            c-0.5,0-0.9-0.1-1.3-0.1c-0.5,0-0.9,0-1.4,0c-0.5,0-0.9,0.1-1.4,0.2C9.2,1.5,8.4,1.7,7.6,2C6.8,2.3,6.1,2.6,5.4,3
		                            c-1,0.6-1.9,1.3-2.7,2.1C2.1,5.7,1.6,6.4,1.2,7.2c-0.5,1-0.8,2-0.9,3c-0.1,0.7,0,1.4,0.1,2c0.1,0.7,0.4,1.5,0.7,2.1
		                            c0.4,0.9,1,1.7,1.7,2.4c1,1,2.2,1.8,3.5,2.4c0.7,0.3,1.4,0.6,2.2,0.8c0.5,0.1,0.9,0.2,1.4,0.3c0.3,0,0.6,0.1,0.9,0.1
		                            c0.4,0.1,0.8,0.5,0.9,0.9c0,0.3,0,0.7-0.1,1c-0.1,0.3-0.1,0.6-0.1,0.8c0,0.1,0,0.2,0,0.3c0,0.2,0.1,0.3,0.4,0.3
		                            c0.2,0,0.4-0.1,0.6-0.1c0.5-0.2,1-0.4,1.5-0.7c0.9-0.5,1.8-1.1,2.7-1.7c1.2-0.8,2.4-1.7,3.5-2.7c0.5-0.4,0.9-0.8,1.4-1.2
		                            c0.4-0.4,0.8-0.8,1.2-1.2c0.5-0.6,0.9-1.3,1.2-2c0.4-0.9,0.7-1.9,0.7-2.9C24.7,10.4,24.6,9.6,24.4,8.8z M8.2,13.9
		                            c-0.1,0-0.2,0.1-0.2,0.1c0,0-0.1,0-0.1,0c-0.8,0-1.6,0-2.3,0c-0.2,0-0.3,0-0.4-0.1c-0.2-0.1-0.3-0.3-0.3-0.5c0,0,0,0,0-0.1
		                            c0-1.5,0-3.1,0-4.6c0-0.3,0.1-0.5,0.3-0.6c0.3-0.2,0.8-0.1,1,0.4c0,0.1,0,0.2,0,0.2c0,1.3,0,2.5,0,3.8v0.1h0.1c0.5,0,1.1,0,1.6,0
		                            c0.3,0,0.5,0.2,0.6,0.5C8.6,13.4,8.5,13.7,8.2,13.9z M10.4,13.2c0,0.1,0,0.2,0,0.2c-0.1,0.3-0.4,0.4-0.6,0.5
		                            c-0.3,0-0.5-0.1-0.6-0.3C9.1,13.5,9,13.4,9,13.3c0-0.8,0-1.5,0-2.3V8.7c0-0.2,0.1-0.4,0.3-0.5C9.5,8,9.8,8,10,8.1
		                            c0.2,0.1,0.3,0.3,0.3,0.6c0,0,0,0,0,0.1C10.4,10.2,10.4,11.7,10.4,13.2z M16.1,13.3c0,0.3-0.3,0.6-0.6,0.6c-0.1,0-0.2,0-0.3,0
		                            c-0.1,0-0.2-0.1-0.3-0.2c-0.4-0.5-0.7-1-1.1-1.4c-0.4-0.5-0.8-1.1-1.2-1.6c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0v0.1c0,0.9,0,1.8,0,2.6
		                            c0,0.3-0.2,0.5-0.5,0.6c-0.4,0.1-0.8-0.1-0.8-0.5c0,0,0-0.1,0-0.1c0-1.5,0-3.1,0-4.6c0-0.3,0.2-0.5,0.4-0.6c0.3-0.1,0.6,0,0.8,0.2
		                            c0.7,0.9,1.4,1.9,2.1,2.8c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0-0.1,0-0.1c0-0.8,0-1.7,0-2.5c0-0.1,0-0.1,0-0.2C14.9,8.2,15.1,8,15.5,8
		                            c0.3,0,0.6,0.2,0.6,0.5c0,0,0,0.1,0,0.1C16.1,10.2,16.1,11.8,16.1,13.3z M20.6,13.5C20.6,13.8,20.3,14,20,14c-0.8,0-1.7,0-2.5,0
		                            c-0.3,0-0.6-0.3-0.6-0.6c0,0,0,0,0-0.1c0-1.5,0-3,0-4.6c0-0.1,0-0.1,0-0.2C17,8.2,17.3,8,17.6,8c0.8,0,1.6,0,2.5,0
		                            c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.1,0.6-0.4,0.7c-0.1,0-0.2,0-0.3,0c-0.5,0-1,0-1.6,0h-0.1v1c0,0,0.1,0,0.1,0c0.5,0,1,0,1.6,0
		                            c0.1,0,0.2,0,0.2,0c0.3,0.1,0.5,0.3,0.5,0.6c0,0.3-0.2,0.6-0.5,0.7c-0.1,0-0.1,0-0.2,0c-0.5,0-1.1,0-1.6,0h-0.1c0,0.1,0,0.9,0,1
		                            h0.1c0.5,0,1.1,0,1.6,0c0.1,0,0.3,0,0.4,0.1C20.6,12.9,20.7,13.2,20.6,13.5z" />
                        </g>
                        </svg>
                                                                <input type="text" name="line_input" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                                <label for="registerLine" class="did-floating-label" :class="arry_CrOnOff.RLINE.CV ? 'required':''">{{getLanguage["RCUZ"]["LINE"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.RLINE.CV" @change="v => arry_CrOnOff.RLINE.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["ELAMF"]}} </label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-if="element.id == 'WSAP'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">
                                                            </div>
                                                            <div class="did-floating-label-content registerWhatsapp">
                                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve" fill="currentColor">
                                                                <g>
                                                                <path d="M1.5,23.5C2,22.3,2.4,21.1,2.9,20C3,19.5,3,19.2,2.7,18.7c-1.4-2.1-1.9-4.4-1.8-6.8C1.1,6.9,4.7,2.5,9.6,1.3
		                        C16-0.4,22.4,3.6,23.8,9.9c1.4,6.1-2.3,12.2-8.4,13.8c-3.2,0.8-6.3,0.3-9.1-1.4c-0.2-0.1-0.3-0.1-0.4,0c-1.4,0.4-2.7,0.8-4.1,1.2
		                        C1.7,23.5,1.6,23.5,1.5,23.5z M16,19c0.6,0,1.1-0.2,1.5-0.6c0.3-0.4,0.7-0.7,1-1c0.5-0.5,0.5-1.3,0-1.9c-0.6-0.6-1.2-1.2-1.8-1.8
		                        c-0.7-0.6-1.6-0.4-2,0.4c-0.3,0.7-0.9,1-1.6,0.7c-1.5-0.6-2.5-1.6-3.2-3c-0.3-0.8-0.1-1.4,0.8-1.7c0.8-0.3,1-1.3,0.4-1.9
		                        C10.7,7.5,10,6.9,9.4,6.3c-0.5-0.5-1.2-0.5-1.8,0C7.3,6.7,6.9,7.1,6.5,7.5C6.3,7.7,6.2,8,6.1,8.2C5.9,8.8,6,9.4,6.2,10
		                        c0.4,1.5,1.2,2.7,2.2,3.9c1.4,1.7,3,3.2,5,4.2C14.2,18.6,15.1,19,16,19z" />
                            </g>
                        </svg>
                                                                <input type="text" name="whatsapp_input" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                                <label for="registerWhatsapp" class="did-floating-label" :class="arry_CrOnOff.RWSAP.CV ? 'required':''">{{getLanguage["RCUZ"]["WSAP"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.RWSAP.CV" @change="v => arry_CrOnOff.RWSAP.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["EWAAMF"]}} </label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-if="element.id == 'TELE'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">
                                                            </div>
                                                            <div class="did-floating-label-content registerTelegram">
                                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve" fill="currentColor">
                                                                <g>
                                                                <path d="M13.4,18c-1,1-2,2-3,2.9c-0.2,0.2-0.3,0.3-0.5,0.2c-0.2-0.1-0.3-0.2-0.3-0.4c0.1-1.3,0.2-2.6,0.3-3.8
		                            c0-0.3,0-0.7,0.1-1c0-0.1,0.1-0.3,0.2-0.4c2.6-2.4,5.3-4.9,7.9-7.3c0.6-0.5,1.2-1.1,1.8-1.6c0.1-0.1,0.3-0.2,0.1-0.3
		                            c-0.1-0.1-0.3,0-0.3,0c-3.5,2.1-7,4.3-10.5,6.4c-0.8,0.5-1.5,0.9-2.3,1.4c-0.1,0.1-0.3,0.1-0.4,0.1c-1.7-0.6-3.5-1.2-5.2-1.8
		                            c-0.4-0.1-0.6-0.4-0.6-0.7c0-0.4,0.2-0.6,0.6-0.8c3.7-1.4,7.4-2.8,11.1-4.2c3.5-1.3,7-2.7,10.5-4c0.9-0.3,1.7,0,1.9,0.9
		                            c0.1,0.2,0,0.5,0,0.8c-1.3,5.8-2.5,11.5-3.8,17.3c-0.2,0.7-0.5,1.1-1.2,1c-0.2,0-0.4-0.1-0.6-0.3c-1.8-1.3-3.5-2.6-5.3-4
		                            C13.5,18.1,13.5,18.1,13.4,18z" />
                                </g>
                            </svg>
                                                                <input type="text" name="telegram_input" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                                <label for="registerTelegram" class="did-floating-label" :class="arry_CrOnOff.RTELE.CV ? 'required':''">{{getLanguage["RCUZ"]["TGID"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.RTELE.CV" @change="v => arry_CrOnOff.RTELE.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["ETEAMF"]}} </label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                            <template v-if="element.id == 'ZALO'">
                                                <CRow class="mx-0">
                                                    <CCol xl="6" class="px-0">
                                                        <div class="d-flex justify-content-start align-items-start">
                                                            <div style="width:15px;height:15px;margin-right:10px;">
                                                                <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">
                                                            </div>
                                                            <div class="did-floating-label-content registerZalo">
                                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;" xml:space="preserve" fill="currentColor">
                                                                <g>
                                                                <g>
                                                                <path d="M13.5,23.3c-1.2,0.1-2.4,0-3.6-0.2c-0.7-0.2-1.7-0.6-2.4-0.3c-1,0.3-1.9,0.9-2.8,1.4
			                        c-0.2,0.1-0.3,0.2-0.5,0.1C4.1,24.1,4,24,4,23.8c-0.2-1.1,0.4-2.1,0.1-3.2c-0.2-1-1-1.6-1.6-2.3C-0.3,14.4,0,8.9,3,5.1
			                        c0.8-1,1.7-1.9,2.8-2.6c5.4-3.4,13-2.2,16.7,3.1c4.2,6,1.2,14.5-5.6,16.9C15.8,22.9,14.7,23.2,13.5,23.3z M6.8,15.2
			                        c0.7,0,1.3,0,2,0c0.2,0,0.3-0.1,0.4-0.1c0.3-0.1,0.3-0.6,0.1-0.8C9,14,8.4,14,8,14c-0.6,0-1.2,0-1.8,0c-0.4,0-0.1-0.5,0-0.7
			                        c0.2-0.3,0.4-0.5,0.6-0.7c0.6-0.7,1.1-1.5,1.7-2.2c0.2-0.3,0.8-1,0.6-1.4C9,8.5,8.3,8.5,8,8.5c-0.9,0-1.8,0-2.6,0
			                        c-0.2,0-0.4,0-0.7,0.1C4.5,8.7,4.3,8.8,4.2,9C4.1,9.5,4.6,9.6,5,9.6c0.6,0,1.3,0,2,0c0.1,0,0.1,0,0.2,0c0.3,0.1,0.1,0.4,0,0.6
			                        c-0.4,0.6-0.9,1.2-1.4,1.7c-0.5,0.6-1,1.3-1.5,1.9C4,14.3,4.1,15,4.6,15.2c0.1,0,0.3,0,0.4,0C5.6,15.2,6.2,15.2,6.8,15.2z
			                            M14.1,12.9c0-0.6,0-1.2,0-1.8c0-0.3-0.3-0.5-0.5-0.5c-0.2,0-0.5,0.1-0.5,0.3c0,0.1,0,0.1-0.1,0.1c-0.1,0-0.2,0-0.2-0.1
			                        c-0.3-0.4-1-0.5-1.5-0.4c-1.3,0.2-2,1.8-1.7,3c0.2,0.7,0.6,1.3,1.3,1.6c0.5,0.2,1.4,0.3,1.7-0.1c0.1-0.1,0.1-0.1,0.2-0.1
			                        c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0.1c0,0.1,0.1,0.2,0.2,0.2c0.2,0,0.3,0,0.5-0.1c0.2-0.1,0.2-0.2,0.2-0.4
			                        C14.1,14,14.1,13.5,14.1,12.9z M17.4,11c-0.7,0.7-1.1,1.8-0.7,2.8c0.3,0.7,0.9,1.2,1.7,1.4c1.5,0.3,2.9-1,2.8-2.6
			                        c-0.1-1.2-1.3-2.3-2.6-2.1C18.2,10.5,17.8,10.7,17.4,11z M14.8,11.8c0,0.7,0,1.4,0,2.1c0,0.4-0.1,0.9,0.4,1.1
			                        c0.4,0.2,0.8-0.1,0.8-0.5c0.1-1.8-0.1-3.5,0-5.3c0-0.2,0-0.3-0.1-0.5c-0.2-0.3-0.9-0.3-1.1,0.1c0,0.1,0,0.1,0,0.2
			                        C14.8,10,14.8,10.9,14.8,11.8z" />
                                                                <path d="M12.9,12.8c0,0.1,0,0.3,0,0.4c-0.1,0.5-0.6,0.9-1.2,0.8c-0.4-0.1-0.8-0.5-0.8-0.9c-0.1-0.4,0-1,0.3-1.3
			                        c0.3-0.3,0.9-0.3,1.2-0.1C12.7,12,12.9,12.4,12.9,12.8z" />
                                                                <path d="M19.9,12.9c0,0.1,0,0.2,0,0.3c-0.1,0.5-0.6,1-1.2,0.9c-0.6-0.1-0.9-0.8-0.9-1.4c0.1-0.6,0.5-1.2,1.2-1.1
			                        C19.6,11.7,20,12.3,19.9,12.9z" />
	                        </g>
                        </g>
                        </svg>
                                                                <input type="text" name="zalo_input" placeholder="" class="did-floating-input" autocomplete="off" disabled>
                                                                <label for="registerZalo" class="did-floating-label" :class="arry_CrOnOff.RZALO.CV ? 'required':''">{{getLanguage["RCUZ"]["ZLID"]}}</label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                    <CCol xl="6" class="pr-0">
                                                        <div class="flexcontainer">
                                                            <div class="agentcus-grid">
                                                                <label class="switch" :style="renderStyle()">
                                                                    <input type="checkbox" :checked="arry_CrOnOff.RZALO.CV" @change="v => arry_CrOnOff.RZALO.CV = v.target.checked">
                                                                    <span class="slider round"></span>
                                                                </label>
                                                                <label class="ACUZ_DO col-form-label">{{getLanguage["RCUZ"]["EZAMF"]}} </label>
                                                            </div>
                                                        </div>
                                                    </CCol>
                                                </CRow>
                                            </template>
                                        </li>
                                    </transition-group>
                                </draggable>

                            </div>
                        </CCol>

                        <CCol col="12">
                            <div style="text-align:center;margin-top:20px">
                                <CButton color="outline-info" size="sm" @click="bool_isPreview = true" v-if=" !arry_CrOnOff.RFWMP.CV">
                                    <span class='fa fa-eye'></span>
                                    {{this.getLanguage["GL"]["P"]}}
                                </CButton>
                                <!--<CButton color="outline-info" size="sm" @click="saveAgentConfig()">-->
                                <CButton color="outline-info" size="sm" @click="saveRegistrationConfig()">
                                    <span class='plusIcon cil-plus'></span>
                                    {{this.getLanguage["BTN"]["SV"]}}
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                </template>

                <!--Customize Deposit-->
                <CRow class="mx-0" v-if="bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_Group.I > 0">
                    <CCol col="12">
                        <h6 class="card-title section-title2"
                            data-section="cd"
                            @click="showSectionBasedRole('cd')"
                            :class="selectedSection === 'cd' ? 'bg-blue text-white' : ''">
                            <!--<span :class="(!this.$v.obj_bankacc.$error && bool_groupCV) ? 'bg-success' : ''">-->
                            <span :class="getSectionClasses('cd', !$v.obj_bankacc.$error && bool_groupCV)">
                                {{ getSectionIndex(9) }}
                            </span>
                            {{this.getLanguage["SMB"]["DCUZ"]}}
                            <i :class="setCollapseExpandIcon('CD')"></i>
                        </h6>
                    </CCol>
                </CRow>
                <template v-if="bool_showCD && bool_isAgentType && (getUserInfo.AT == 0 || getUserInfo.AT > 2) && obj_Group.I > 0">
                    <CRow class="mx-0">
                        <!--<CCol col="4">
                        <label class="col-form-label">{{this.getLanguage["MT"]["BN"]}}<span class="required" /> :</label>
                        <customtreeselect :multiple="false"
                                            :flat="true"
                                            :clearable="false"
                                            :options="dd_agentgroup_cd"
                                            :defaultExpandLevel="Infinity"
                                            :disabled="arry_cd.I > 0"
                                            v-model="searchAgent"
                                            @input="selectAgentOptions"
                                            :placeholder="getLanguage['MT']['BN']"
                                            :limitText="count => `+${count}`" />

                        <span class="ErrMsg">{{ ValidationErrMsg('AGIT','BN') }}</span>
                        </CCol>-->
                        <CCol col="4">
                            <label class="col-form-label"> {{this.getLanguage["AG"]["C"]}}<span class="required" /> :</label>
                            <treeselect :multiple="false"
                                        @input="CurrencyChange_cd"
                                        v-model="arry_cd['CI']"
                                        :options="dd_currency_cd"
                                        ref="CI" />
                            <span class="ErrMsg">{{ ValidationErrMsgCD('CI','C') }}</span>
                        </CCol>
                    </CRow>

                    <CRow id="webTempSetting" class="mx-0 mb-3" v-if="this.dd_language_select.length > 0 && arry_cd['CI'] != undefined ">
                        <CCol>
                            <h6 @click="visible = !visible" class="card-title section-title2 px-2 m-0">
                                <template>
                                    <template v-if="visible">
                                        {{this.getLanguage["BTN"]["HD"]}}
                                    </template>
                                    <template v-else>
                                        {{this.getLanguage["BTN"]["V"]}}
                                    </template>
                                    {{this.getLanguage["AG"]["DLLS"]}}
                                </template>
                                <i class="chevron-container chevron-up" v-if="visible"></i>
                                <i class="chevron-container" v-else></i>
                            </h6>
                            <!-- View Display Label Language Setting -->
                            <div v-show="visible">
                                <div class="row mx-0 my-3">
                                    <div class="col-md-2 px-0">
                                        <div class="nav flex-column nav-pills tempScrollbar" aria-orientation="vertical" style="max-height: 584px; overflow: hidden scroll; padding: 0; flex-wrap: nowrap ">
                                            <a class="" :class="(selectedLangLabel == item.id)? 'nav-link active' : 'nav-link'" @click="selectedLangLabel = item.id;langCode = item.id" v-for="(item, index) in dd_language_select" :key="index" style="border-radius: 0px; padding: 0.5rem 0.5rem; font-size: smaller;">
                                                <div class="d-flex align-items-center">
                                                    <span class="flagClass mr-2" :class="mapLanguageFlag(item.id)"></span>
                                                    <span>{{ item.label }}</span>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="col-md-10 pr-0">
                                        <div class="tab-content">
                                            <div class="card tab-content p-2">
                                                <div :class="item.id == selectedLangLabel ? 'tab-pane fade active show': 'tab-pane fade'" :id="'lang-'+item.id" v-for="(item, index) in dd_language">
                                                    <CRow>
                                                        <CCol col="12">
                                                            <label class="col-form-label-sm font-weight-bold">{{ item.label }}</label>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["MTA"]["DAMT"]}}:</label>
                                                            <CInput :placeholder="getLanguage['MTA']['DAMT']" size="sm" :value="array_da[item.id]" v-model="array_da[item.id]" ref="DA"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["DCUZ"]["PSYBA"]}}:</label>
                                                            <CInput :placeholder="getLanguage['DCUZ']['PSYBA']" size="sm" :value="array_cya[item.id]" v-model="array_cya[item.id]" ref="CYA"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["DCUZ"]["PSDB"]}}:</label>
                                                            <CInput :placeholder="getLanguage['DCUZ']['PSDB']" size="sm" :value="array_sb[item.id]" v-model="array_sb[item.id]" ref="SB"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["MTA"]["TID"]}}:</label>
                                                            <CInput :placeholder="getLanguage['MTA']['TID']" size="sm" :value="array_ti[item.id]" v-model="array_ti[item.id]" ref="TI"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["DCUZ"]["THD"]}}:</label>
                                                            <CInput :placeholder="getLanguage['DCUZ']['THD']" size="sm" :value="array_dtod[item.id]" v-model="array_dtod[item.id]" ref="DTOD"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["DCUZ"]["UREC"]}}:</label>
                                                            <CInput :placeholder="getLanguage['DCUZ']['UREC']" size="sm" :value="array_ur[item.id]" v-model="array_ur[item.id]" ref="UR"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["DCUZ"]["P"]}}:</label>
                                                            <CInput :placeholder="getLanguage['DCUZ']['P']" size="sm" :value="array_p[item.id]" v-model="array_p[item.id]" ref="P"></CInput>
                                                        </CCol>
                                                        <CCol col="4">
                                                            <label class="col-form-label-sm">{{getLanguage["DCUZ"]["NOTE"]}}:</label>
                                                            <CInput :placeholder="getLanguage['DCUZ']['NOTE']" size="sm" :value="array_n[item.id]" v-model="array_n[item.id]" ref="N"></CInput>
                                                        </CCol>
                                                    </CRow>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </CRow>

                    <CRow class="mx-0 depositPage" v-if="arry_cd['CI'] > 0">
                        <div class="col-12">
                            <div style="width: 99%; float: left; padding: 15px; background: #ececec;">
                                <draggable class="h_nav-list nav inside-tab flex-nowrap text-nowrap overflow-auto deposit-tabs__list"
                                           tag="ul"
                                           @start="drag = true"
                                           v-bind="dragOptions"
                                           @end="drag = false" :move="checkMove" :list="arry_cd.DepositDraggeBase" group="people">
                                    <li class="h_nav-item nav-item inside-tab-item" v-for="(element, index) in arry_cd.DepositDraggeBase" :key="element.order" @click="paymentMtdSequence = element.id; (element.id == 'MD') ? showManualDeposit=true : showManualDeposit=false">
                                        <a class="pointer" :class="(paymentMtdSequence == element.id) ? 'active': ''" data-toggle="tab" role="tab">
                                            <div class="d-flex">
                                                <svg v-if="element.id == 'MD'" class="mr-1 bi bi-cash-coin" style=" height: 30px; width: 30px; margin: auto; color: #2eb85c;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"> <path style="color: #F6BC1B" fill-rule="evenodd" d="M11 15a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm5-4a5 5 0 1 1-10 0 5 5 0 0 1 10 0z" /> <path style="color: #F6BC1B" d="M9.438 11.944c.047.596.518 1.06 1.363 1.116v.44h.375v-.443c.875-.061 1.386-.529 1.386-1.207 0-.618-.39-.936-1.09-1.1l-.296-.07v-1.2c.376.043.614.248.671.532h.658c-.047-.575-.54-1.024-1.329-1.073V8.5h-.375v.45c-.747.073-1.255.522-1.255 1.158 0 .562.378.92 1.007 1.066l.248.061v1.272c-.384-.058-.639-.27-.696-.563h-.668zm1.36-1.354c-.369-.085-.569-.26-.569-.522 0-.294.216-.514.572-.578v1.1h-.003zm.432.746c.449.104.655.272.655.569 0 .339-.257.571-.709.614v-1.195l.054.012z" /> <path style="color: #2eb85c" d="M1 0a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h4.083c.058-.344.145-.678.258-1H3a2 2 0 0 0-2-2V3a2 2 0 0 0 2-2h10a2 2 0 0 0 2 2v3.528c.38.34.717.728 1 1.154V1a1 1 0 0 0-1-1H1z" /> <path style="color: #2eb85c" d="M9.998 5.083 10 5a2 2 0 1 0-3.132 1.65 5.982 5.982 0 0 1 3.13-1.567z" /> </svg>
                                                <svg v-else-if="element.id == 'AD'" class="mr-1" style="width:25px;height:25px;margin:auto;color: #FF4500 " xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"> <path d="M16 9.026v-1.651c-0.646 0.047-1.005 0.391-1.318 0.948l-6.854 13.969h3.286l-1.005-1.276 0.87-1.818 0.005 0.005 5.016-10.172zM14.036 17.495h3.927l-1.964-4.063zM10.979 19.219h0.021l-0.016-0.016zM17.964 17.495v0.005zM28.661 6.755l-10.979-6.344c-0.927-0.536-2.438-0.536-3.365 0l-10.979 6.344c-0.922 0.531-1.682 1.839-1.682 2.906v12.677c0 1.073 0.76 2.375 1.682 2.906l10.979 6.344c0.927 0.536 2.438 0.536 3.365 0l10.979-6.354c0.922-0.521 1.677-1.844 1.677-2.901v-12.672c0-1.068-0.755-2.375-1.677-2.906zM20.573 22.823l-0.917-1.849h-7.333l-0.896 1.849h-4.38l7.198-14.714c0.406-0.807 1.036-1.198 1.755-1.198s1.38 0.438 1.755 1.187l7.193 14.724zM16 9.026v3.297l3.359 6.901h-8.359l1.010 1.25h7.964l0.896 1.802h3.302l-2.276-1.318v0.052l-5.896-11.984z" fill="#FF4500 "></path> </svg>
                                                <svg v-else-if="element.id == 'ADP'" class="mr-1" style="width:25px;height:25px;margin:auto;color: #e53636" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32"> <path d="M16 9.026v-1.651c-0.646 0.047-1.005 0.391-1.318 0.948l-6.854 13.969h3.286l-1.005-1.276 0.87-1.818 0.005 0.005 5.016-10.172zM14.036 17.495h3.927l-1.964-4.063zM10.979 19.219h0.021l-0.016-0.016zM17.964 17.495v0.005zM28.661 6.755l-10.979-6.344c-0.927-0.536-2.438-0.536-3.365 0l-10.979 6.344c-0.922 0.531-1.682 1.839-1.682 2.906v12.677c0 1.073 0.76 2.375 1.682 2.906l10.979 6.344c0.927 0.536 2.438 0.536 3.365 0l10.979-6.354c0.922-0.521 1.677-1.844 1.677-2.901v-12.672c0-1.068-0.755-2.375-1.677-2.906zM20.573 22.823l-0.917-1.849h-7.333l-0.896 1.849h-4.38l7.198-14.714c0.406-0.807 1.036-1.198 1.755-1.198s1.38 0.438 1.755 1.187l7.193 14.724zM16 9.026v3.297l3.359 6.901h-8.359l1.010 1.25h7.964l0.896 1.802h3.302l-2.276-1.318v0.052l-5.896-11.984z" fill="#e53636"></path><sup style="font-weight:bold;font-size:14px;margin-left:-8px;top:-8px">+</sup> </svg>
                                                <img v-else-if="element.id == 'AD3P'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/ad3p.webp" />
                                                <img v-else-if="element.id == 'HP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/h2p.webp" />
                                                <img v-else-if="element.id == 'OP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/oopay.webp" />
                                                <img v-else-if="element.id == 'EZP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/ezpay.webp" />
                                                <img v-else-if="element.id == 'TUP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/truepay.webp" />
                                                <img v-else-if="element.id == 'STP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/starpay.webp" />
                                                <img v-else-if="element.id == 'FUP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/fupay.webp" />
                                                <img v-else-if="element.id == 'SUREP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/surepay.webp" />
                                                <img v-else-if="element.id == 'CT'" class="mr-1" style="width: 25px; height: 25px;margin: auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/cyptodeposit-icon.png" />
                                                <img v-else-if="element.id == 'XFU'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/xfuoo.webp" />
                                                <img v-else-if="element.id == 'CPAY'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/cpay.webp" />
                                                <img v-else-if="element.id == 'TMONEY'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/tmoney.webp" />
                                                <img v-else-if="element.id == 'SMP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/smartpay.webp" />
                                                <img v-else-if="element.id == 'U2P'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/u2pay.webp" />
                                                <img v-else-if="element.id == 'LP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/luckypay.webp" />
                                                <img v-else-if="element.id == 'BCP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/bcpay.webp" />
                                                <img v-else-if="element.id == 'FPG'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/fpg.webp" />
                                                <img v-else-if="element.id == 'PGA'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/mpay.webp" />
                                                <img v-else-if="element.id == 'PP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/pompay.webp" />
                                                <img v-else-if="element.id == 'DN'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/doitnow.webp" />
                                                <img v-else-if="element.id == 'AGP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/agp.webp" />
                                                <img v-else-if="element.id == 'P918'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/p918.webp" />
                                                <img v-else-if="element.id == 'UP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/universepay.webp" />
                                                <img v-else-if="element.id == 'OKP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/okayspay.webp" />
                                                <img v-else-if="element.id == 'MGP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/megaspay.webp" />
                                                <img v-else-if="element.id == 'VIP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/vip.webp" />
                                                <img v-else-if="element.id == 'AFP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/alfapay.webp" />
                                                <img v-else-if="element.id == 'ONEP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/onepay.webp" />
                                                <img v-else-if="element.id == 'BLEUP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/bleupay.webp" />
                                                <img v-else-if="element.id == 'E88P'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/easy88pay.webp" />
                                                <img v-else-if="element.id == 'ECP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/ecpay.webp" />
                                                <img v-else-if="element.id == 'ZPAY'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/zpay.webp" />
                                                <img v-else-if="element.id == 'UPAY'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/upay.webp" />
                                                <img v-else-if="element.id == 'DGPCNY'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/dgpay.webp" />
                                                <img v-else-if="element.id == 'SUPER7VND'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/super7.webp" />
                                                <!--<img v-else-if="element.id == 'PAYNGO'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/payngo.webp" />-->
                                                <!--<img v-else-if="element.id == 'PPYP'" class="mr-1" style="width:25px;height:25px;margin:auto;" src="https://d2lcoivv20vty7.cloudfront.net/Content/img/payment/papayapay.webp" />-->
                                                {{getLanguage["ACO"][element.name ]}}
                                                <input type="checkbox" class="ml-2" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">
                                            </div>
                                        </a>
                                    </li>
                                </draggable>

                                <div class="tab-content inside-tab-bg" v-if="showManualDeposit">
                                    <div class="d-flex" v-if="arr_DepositbankTempalte.length > 0">
                                        <input type="checkbox" class="mr-2" :checked="arry_CdOnOff.DPTB_DCUZ.CV" @change="v => arry_CdOnOff.DPTB_DCUZ.CV = v.target.checked"> {{getLanguage["DCUZ"]["PTB"]}}
                                    </div>
                                    <div class="payment-grid">
                                        <div id="payment-transaction" class="payment-transaction">
                                            <div class="d-flex justify-content-center align-items-center" v-if="arr_DepositbankTempalte.length <= 0" style=" border: 1px solid; background-color: inherit; border-color: rgba(0,0,21,0.125); height: 100%; border-radius: 0.25rem;">
                                                {{this.getLanguage["DCUZ"]["NBLA"]}}
                                            </div>
                                            <div v-else>
                                                <hr class="d-block d-lg-none mb-4" />
                                                <template v-for="(data, dataIdx) in arr_DepositbankTempalte">
                                                    <h6 class="font-weight-bold mb-1" style="font-size:1em" v-if="data.PM ==10 && (dataIdx === 0 || arr_DepositbankTempalte[dataIdx - 1].PM != 10)"> {{getLanguage["DCUZ"]["EW"]}}</h6>
                                                    <h6 class="font-weight-bold mb-1" style="font-size:1em" v-else-if="data.PM ==40 && (dataIdx === 0 || arr_DepositbankTempalte[dataIdx - 1].PM != 40)"> {{getLanguage["DCUZ"]["CRYPT"]}} </h6>
                                                    <h6 class="font-weight-bold mb-1" style="font-size:1em" v-else-if="data.PM ==4 && (dataIdx === 0 || arr_DepositbankTempalte[dataIdx - 1].PM != 4)"> {{getLanguage["DCUZ"]["OD"]}}</h6>
                                                    <h6 class="font-weight-bold mb-1" style="font-size:1em" v-else-if="data.PM ==1 && (dataIdx === 0 || arr_DepositbankTempalte[dataIdx - 1].PM != 1)"> {{getLanguage["DCUZ"]["CD"]}}</h6>
                                                    <h6 class="font-weight-bold mb-1" style="font-size:1em" v-else-if="data.PM ==11 && (dataIdx === 0 || arr_DepositbankTempalte[dataIdx - 1].PM != 11)"> {{getLanguage["DCUZ"]["CBD"]}}</h6>

                                                    <div class="payment-item">
                                                        <div class="d-flex align-items-center">
                                                            <div class="payment-icon">
                                                                <img :src="data.BL">
                                                            </div>
                                                            <div class="payment-content">
                                                                <p class="text-white m-0">{{data.BN}}</p>
                                                                <p class="text-white m-0 minInfo">{{ getLanguage["DCUZ"]["MIN"] }}: <span class="text-white">{{ formatNumber(data.MIND,2,arry_cd['ISOC'])}}</span></p>
                                                                <p class="text-white m-0 maxInfo">{{ getLanguage["DCUZ"]["MAX"] }}: <span class="text-white">{{ formatNumber(data.MAXD,2,arry_cd['ISOC'])}}</span></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="payment-form">
                                            <draggable class="list-group"
                                                       tag="ul"
                                                       :list="arry_cd.VTCDepositDraggeBase"
                                                       v-bind="dragOptions"
                                                       @start="drag = false"
                                                       @end="drag = false">
                                                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                                                    <li class="list-group-item"
                                                        v-for="element in arry_cd.VTCDepositDraggeBase"
                                                        v-if="showenLogic(element)"
                                                        :key="element.name">
                                                        <template v-if="element.id == 'DA'">
                                                            <CRow class="mx-0">
                                                                <CCol xl="7" class="px-0">
                                                                    <div class="d-flex justify-content-start align-items-start" :class="(manualDepositSequence == element.id) ? 'asss': ''">
                                                                        <div style="width:15px;height:15px;margin-right:10px;">
                                                                            <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1" disabled>
                                                                        </div>
                                                                        <div class="mb-0 row w-100">
                                                                            <label class="col-sm-4 col-form-label pt-0 pr-0">
                                                                                {{getLanguage["MTA"]["DAMT"]}}<span class="required" />
                                                                                <span class="amountNote amountNoteInline" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span>
                                                                            </label>
                                                                            <div class="col-sm-8">
                                                                                <div class="position-relative">
                                                                                    <input onkeypress="WithDraWnoDecimalInput(event)" ondrop="return false;" onpaste="return false" id="depositAmount" type="text" name="depositAmount" onchange="currencyValueOnChange(event, true, false)" :placeholder="getLanguage['MTA']['DAMT']" class="form-control" autocomplete="false" required="" disabled>
                                                                                    <div class="tip-container">
                                                                                        <div class="help-tip">
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                                <CCol xl="5" class="pr-0">
                                                                    <div class="flexcontainer">
                                                                        <div class="agentcus-grid">
                                                                            <label class="switch" :style="renderStyle()">
                                                                                <input type="checkbox" :checked="arry_CdOnOff.CBTU.CV" @change="v => arry_CdOnOff.CBTU.CV = v.target.checked">
                                                                                <span class="slider round"></span>
                                                                            </label>
                                                                            <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["CBTU"]}}</label>
                                                                            <div class="custom-tooltip ACUZ_TT">
                                                                                <i class="fa fa-question-circle"></i>
                                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["CBTU"]}}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="arry_CdOnOff.CBTU.CV == true">
                                                                            <div class="flex-item" style=" display: grid; grid-template-columns: 140px auto;">
                                                                                <label class="ACUZ_DO col-form-label ml-0">{{getLanguage["ACU"]["RATE"]}}</label>
                                                                                <CInput class="" :placeholder="getLanguage['ACU']['RATE']" size="sm" :value="arry_cd.Rate" @change="v => arry_cd.Rate = v"></CInput>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="agentcus-grid" v-if="!getThousandCurrency">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.E2DA.CV" @change="v => arry_CdOnOff.E2DA.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["E2DA"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["E2DA"]}}</span>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                            </CRow>
                                                        </template>
                                                        <template v-else-if="element.id == 'MB'">
                                                            <CRow class="mx-0">
                                                                <CCol xl="7" class="px-0">
                                                                    <div class="d-flex justify-content-start align-items-start" :class="(manualDepositSequence == element.id) ? 'asss': ''">
                                                                        <div style="width:15px;height:15px;margin-right:10px;">
                                                                            <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1" disabled>
                                                                        </div>
                                                                        <div class="mb-0 row w-100 ">
                                                                            <label class="col-sm-4 col-form-label pt-0 pr-0 required">{{getLanguage["DCUZ"]["PSYBA"]}}</label>
                                                                            <div class="col-sm-8">
                                                                                <div class="input-group">
                                                                                    <select name="memberbank" id="memberbank" class="orderby custom-dropdown form-control"></select>
                                                                                    <div class="input-group-append">
                                                                                        <button type="button" class="input-group-text"><i class="fa fa-plus mr-1"></i>{{getLanguage["BANK"]["AB"]}}</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                                <CCol xl="5" class="pr-0">

                                                                    <div class="agentcus-grid" v-if='ShowFullAgentConfig'>
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.NADBABA.CV" @change="v => arry_CdOnOff.NADBABA.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["NADBABA"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NADBABA"]}}</span>
                                                                        </div>
                                                                    </div>

                                                                    <div class="agentcus-grid">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.DDB.CV" @change="v => arry_CdOnOff.DDB.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["DDB"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["DDB"]}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="agentcus-grid">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.NAABA.CV" @change="v => arry_CdOnOff.NAABA.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["NAABA"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NAABA"]}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="agentcus-grid">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.NADBA.CV" @change="v => arry_CdOnOff.NADBA.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["NADBA"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NADBA"]}}</span>
                                                                        </div>
                                                                    </div>

                                                                    <!--<div class="agentcus-grid">
        <label class="switch" :style="renderStyle()">
            <input type="checkbox" :checked="arry_CdOnOff.EBAIN.CV" @change="v => arry_CdOnOff.EBAIN.CV = v.target.checked">
            <span class="slider round"></span>
        </label>
        <label class="ACUZ_DO col-form-label">{{//getLanguage["ACO"]["BAIN"]}}</label>
        <div class="custom-tooltip ACUZ_TT">
            <i class="fa fa-question-circle"></i>
            <span class="custom-tooltiptext2 turnover-requirement">{{//getLanguage["ACU"]["BAIN"]}}</span>
        </div>
    </div>-->
                                                                    <!--=========== Member Bank Account Number Validation =========-->
                                                                    <div class="agentcus-grid">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="bool_EMBANS_DC" @change="v=> bool_EMBANS_DC = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["EMBANS"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["EMBANS"]}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="bool_EMBANS_DC">
                                                                        <div class="flex-item agentcus-grid">
                                                                            <label class="switch">
                                                                                <input type="checkbox" :checked="arry_CdOnOff.MAANE.CV" @change="v => arry_CdOnOff.MAANE.CV = v.target.checked">
                                                                                <span class="slider round"></span>
                                                                            </label>
                                                                            <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["AANE"]}}</label>
                                                                            <div class="custom-tooltip ACUZ_TT">
                                                                                <i class="fa fa-question-circle"></i>
                                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AANE"]}}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div class="flex-item agentcus-grid">
                                                                            <label class="switch">
                                                                                <input type="checkbox" :checked="arry_CdOnOff.MAEWAS.CV" @change="v => arry_CdOnOff.MAEWAS.CV = v.target.checked">
                                                                                <span class="slider round"></span>
                                                                            </label>
                                                                            <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["AEWAS"]}}</label>
                                                                            <div class="custom-tooltip ACUZ_TT">
                                                                                <i class="fa fa-question-circle"></i>
                                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["AEWAS"]}}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="agentcus-grid">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.RBAN.CV" @change="v => arry_CdOnOff.RBAN.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["RBAN"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["RBAN"]}}</span>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                            </CRow>
                                                        </template>
                                                        <template v-else-if="element.id == 'DB'">
                                                            <CRow class="mx-0">
                                                                <CCol xl="7" class="px-0">
                                                                    <div class="d-flex justify-content-start align-items-start" :class="(manualDepositSequence == element.id) ? 'asss': ''">
                                                                        <div style="width:15px;height:15px;margin-right:10px;">
                                                                            <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1" disabled>
                                                                        </div>
                                                                        <div class="mb-0 row w-100">
                                                                            <label class="col-sm-4 col-form-label pt-0 pr-0">{{getLanguage["DCUZ"]["PSDB"]}}</label>
                                                                            <div class="col-sm-8">
                                                                                <select name="bank" id="bank" class="orderby custom-dropdown form-control" disabled>
                                                                                    <option v-for="data in arr_DepositbankTempalte" :value="data" v-if="selectedDataPMI(data)">{{data.BA}} - {{ arry_OnOff.BankBackOfficeSetting.SHBAN.CV?data.BAN.slice(0, -4)+"xxxx":data.BAN}}</option>
                                                                                </select>

                                                                                <div class="card mt-2" id="dpt-info" v-if="arr_DepositbankTempalte !=null && arr_DepositbankTempalte.length>0">
                                                                                    <div class="w-100 position-relative">
                                                                                        <div class="card-header d-flex justify-content-lg-center p-2">
                                                                                            <img v-if="arr_DepositbankTempalte[0].BL" :src="arr_DepositbankTempalte[0].BL" id="banklogoImage" alt="depositbank" />
                                                                                            <img v-if="arr_DepositbankTempalte[0].QRCI" :src="arr_DepositbankTempalte[0].QRCI" id="qrcodeImage" alt="depositbank-qrcode">
                                                                                        </div>
                                                                                        <div class="card-body p-2">
                                                                                            <div class="row">
                                                                                                <div class="col-7">{{getLanguage["BA"]["BAN"]}} <div class="float-right">:</div></div>
                                                                                                <div class="col-5 pl-0"><span id="db-accname">{{ arr_DepositbankTempalte[0].BA }}</span></div>
                                                                                            </div>
                                                                                            <div class="row">
                                                                                                <div class="col-7">{{getLanguage["MEM"]["DUP3"]}} <div class="float-right">:</div></div>
                                                                                                <div class="col-5 pl-0">
                                                                                                    <span class="bankno text-primary" id="db-accnum">{{ arr_DepositbankTempalte[0].BAN }}</span>

                                                                                                    <button class="btn copy-bankno text-primary p-0" type="button">
                                                                                                        <i class="fa-fw fa fa-clone" aria-hidden="true"></i>
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div id="fromCSdiv" v-if="arr_DepositbankTempalte[0].CS || arr_DepositbankTempalte[0].ER">
                                                                                                <div class="row" id="db-from-cs" v-if="arr_DepositbankTempalte[0].CS">
                                                                                                    <div class="col-7">{{ getLanguage["DCUZ"]["CS"] }} <div class="float-right">:</div></div>
                                                                                                    <div class="col-5 pl-0"><span>{{arr_DepositbankTempalte[0].CS}}</span></div>
                                                                                                </div>
                                                                                                <div class="row" id="db-from-er" v-if="arr_DepositbankTempalte[0].ER">
                                                                                                    <div class="col-7">{{ getLanguage["DCUZ"]["ER"] }} <div class="float-right">:</div></div>
                                                                                                    <div class="col-5 pl-0"><span>{{arr_DepositbankTempalte[0].ER}}</span></div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div id="minMaxdiv" v-if="arr_DepositbankTempalte[0].MIND > 0 || arr_DepositbankTempalte[0].MAXD > 0">
                                                                                                <div class="row" id="minInfo" v-if="arr_DepositbankTempalte[0].MIND > 0">
                                                                                                    <div class="col-7">{{ getLanguage["DCUZ"]["MIN"] }} <div class="float-right">:</div></div>
                                                                                                    <div class="col-5 pl-0"> <span>{{arr_DepositbankTempalte[0].MIND}}</span></div>
                                                                                                </div>
                                                                                                <div class="row" id="maxInfo" v-if="arr_DepositbankTempalte[0].MAXD > 0">
                                                                                                    <div class="col-7">{{ getLanguage["DCUZ"]["MAX"] }} <div class="float-right">:</div></div>
                                                                                                    <div class="col-5 pl-0"> <span>{{arr_DepositbankTempalte[0].MAXD}}</span></div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                                <CCol xl="5" class="pr-0">
                                                                    <div class="agentcus-grid">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.SSMRB.CV" @change="v => arry_CdOnOff.SSMRB.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["SSMRB"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SSMRB"]}}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="agentcus-grid">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.SHBAN.CV" @change="v => arry_CdOnOff.SHBAN.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["SHBAN"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["SHBAN"]}}</span>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                            </CRow>
                                                        </template>
                                                        <template v-else-if="element.id == 'TI'">
                                                            <CRow class="mx-0">
                                                                <CCol xl="7" class="px-0">
                                                                    <div class="d-flex justify-content-start align-items-start" :class="(manualDepositSequence == element.id) ? 'asss': ''">
                                                                        <div style="width:15px;height:15px;margin-right:10px;">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.DTID_DCUZ.CV" @change="v => arry_CdOnOff.DTID_DCUZ.CV = v.target.checked">
                                                                            <!--<input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">-->
                                                                        </div>
                                                                        <div class="mb-0 row w-100">
                                                                            <label class="col-sm-4 col-form-label pt-0 pr-0 transactionLabel">{{ getLanguage["MTA"]["TID"] }}</label>
                                                                            <div class="col-sm-8">
                                                                                <input id="transactionId" type="text" name="transactionId" :placeholder="getLanguage['MTA']['TID']" class="form-control" autocomplete="false" disabled>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                                <CCol xl="5" class="pr-0"></CCol>
                                                            </CRow>
                                                        </template>
                                                        <template v-else-if="element.id == 'DT'">
                                                            <CRow class="mx-0">
                                                                <CCol xl="7" class="px-0">
                                                                    <div class="d-flex justify-content-start align-items-start" :class="(manualDepositSequence == element.id) ? 'asss': ''">
                                                                        <div style="width:15px;height:15px;margin-right:10px;">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.DDTOD_DCUZ.CV" @change="v => arry_CdOnOff.DDTOD_DCUZ.CV = v.target.checked">
                                                                            <!--<input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">-->
                                                                        </div>
                                                                        <div class="mb-0 row w-100">
                                                                            <label class="col-sm-4 col-form-label pt-0 pr-0">{{ getLanguage["DCUZ"]["THD"] }}</label>
                                                                            <div class="col-sm-8">
                                                                                <div class="row">
                                                                                    <div class="col-6">
                                                                                        <input type="date" name="depositDate" placeholder="@Resources.Language.DEPOSIT_DOD" class="form-control" autocomplete="false" disabled>
                                                                                    </div>
                                                                                    <div class="col-6">
                                                                                        <input type="time" name="depositTime" placeholder="@Resources.Language.DEPOSIT_TOD" class="form-control" autocomplete="false" disabled>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                                <CCol xl="5" class="pr-0"></CCol>
                                                            </CRow>
                                                        </template>
                                                        <template v-else-if="element.id == 'R'">
                                                            <CRow class="mx-0">
                                                                <CCol xl="7" class="px-0">
                                                                    <div class="d-flex justify-content-start align-items-start" :class="(manualDepositSequence == element.id) ? 'asss': ''">
                                                                        <div style="width:15px;height:15px;margin-right:10px;">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.DUR_DCUZ.CV" @change="v => arry_CdOnOff.DUR_DCUZ.CV = v.target.checked">
                                                                            <!--<input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1">-->
                                                                        </div>
                                                                        <div class="mb-0 row w-100 form-group-choosefile fileinput">
                                                                            <label class="col-sm-4 col-form-label pt-0 pr-0">{{ getLanguage["DCUZ"]["UREC"] }}</label>
                                                                            <div class="col-sm-8">
                                                                                <input type="file" id="receipt" accept="image/png, image/jpg, image/jpeg" class="form-control choose-file" disabled>
                                                                                <small class="text-red">{{ getLanguage["DCUZ"]["MAXFILE"] }}</small>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                                <CCol xl="5" class="pr-0">
                                                                    <div class="flexcontainer">
                                                                        <div class="agentcus-grid">
                                                                            <label class="switch" :style="renderStyle()">
                                                                                <input type="checkbox" :checked="arry_CdOnOff.NBRWD.CV" @change="v => arry_CdOnOff.NBRWD.CV = v.target.checked">
                                                                                <span class="slider round"></span>
                                                                            </label>
                                                                            <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["NBRWD"]}}</label>
                                                                            <div class="custom-tooltip ACUZ_TT">
                                                                                <i class="fa fa-question-circle"></i>
                                                                                <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NBRWD"]}}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="arry_CdOnOff.NBRWD.CV == true">
                                                                            <treeselect :multiple="true"
                                                                                        :defaultExpandLevel="1"
                                                                                        valueConsistsOf="LEAF_PRIORITY"
                                                                                        :options="arr_DepositbankOption"
                                                                                        :auto-load-root-options="true"
                                                                                        :placeholder="getLanguage['GS']['ALL']"
                                                                                        v-model="arry_cd.DepositBankReceipt"
                                                                                        :limit="1"
                                                                                        :limitText="count => `+${count}`" />
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                            </CRow>
                                                        </template>
                                                        <template v-else-if="element.id == 'PM'">
                                                            <CRow class="mx-0">
                                                                <CCol xl="7" class="px-0">
                                                                    <div class="d-flex justify-content-start align-items-start" :class="(manualDepositSequence == element.id) ? 'asss': ''">
                                                                        <div style="width:15px;height:15px;margin-right:10px;">
                                                                            <input type="checkbox" :checked="element.RS === 2" @change="updateRS(element, $event.target.checked)" true-value="2" false-value="1" disabled>
                                                                        </div>
                                                                        <div class="mb-0 row w-100 user-auto-promocode">
                                                                            <label class="col-sm-4 col-form-label pt-0 pr-0">{{ getLanguage["DCUZ"]["P"] }}</label>
                                                                            <div class="col-sm-8">
                                                                                <select class="form-control" id="depositPromoId" name="depositPromoId"></select>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                                <CCol xl="5" class="pr-0">
                                                                    <div class="agentcus-grid">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.EPRL.CV" @change="v => arry_CdOnOff.EPRL.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["DCUZ"]["PR"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["DCUZ"]["EPRL"]}}</span>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                            </CRow>
                                                        </template>
                                                        <template v-else-if="element.id == 'NOTE'">
                                                            <CRow class="mx-0">
                                                                <CCol xl="7" class="px-0">
                                                                    <div class="d-flex justify-content-start align-items-start" :class="(manualDepositSequence == element.id) ? 'asss': ''">
                                                                        <div style="width:15px;height:15px;margin-right:10px;">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.DNOTE_DCUZ.CV" @change="v => arry_CdOnOff.DNOTE_DCUZ.CV = v.target.checked" />
                                                                        </div>
                                                                        <div class="mb-0 row w-100 user-auto-promocode">
                                                                            <label class="col-sm-4 col-form-label pt-0 pr-0">{{ getLanguage["DCUZ"]["NOTE"] }}</label>
                                                                            <div class="col-sm-8">
                                                                                <input type="text" :placeholder="getLanguage['DCUZ']['NOTE']" class="form-control" autocomplete="false" disabled>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                                <CCol xl="5" class="pr-0">
                                                                    <div class="agentcus-grid">
                                                                        <label class="switch" :style="renderStyle()">
                                                                            <input type="checkbox" :checked="arry_CdOnOff.NOTEIRQ.CV" @change="v => arry_CdOnOff.NOTEIRQ.CV = v.target.checked">
                                                                            <span class="slider round"></span>
                                                                        </label>
                                                                        <label class="ACUZ_DO col-form-label">{{getLanguage["ACO"]["NOTEIRQ"]}}</label>
                                                                        <div class="custom-tooltip ACUZ_TT">
                                                                            <i class="fa fa-question-circle"></i>
                                                                            <span class="custom-tooltiptext2 turnover-requirement">{{getLanguage["ACU"]["NOTEIRQ"]}}</span>
                                                                        </div>
                                                                    </div>
                                                                </CCol>
                                                            </CRow>
                                                        </template>
                                                    </li>
                                                </transition-group>
                                            </draggable>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center align-items-center mx-0 tab-content inside-tab-bg h-100" id="DepositTabContent" v-else>
                                    {{getLanguage["DCUZ"]["TPPMC"]}}
                                </div>
                            </div>
                        </div>

                        <CCol col="12">
                            <div style="text-align:center;margin-top:20px">
                                <CButton color="outline-info" size="sm" @click="bool_isPreviewCD = true">
                                    <span class='fa fa-eye'></span>
                                    {{this.getLanguage["GL"]["P"]}}
                                </CButton>
                                <!--<CButton color="outline-info" size="sm" @click="saveCustomizeDeposit()">-->
                                <CButton color="outline-info" size="sm" @click="saveDepositConfig()">
                                    <span class='plusIcon cil-plus'></span>
                                    {{this.getLanguage["BTN"]["SV"]}}
                                </CButton>
                            </div>
                        </CCol>
                    </CRow>
                </template>

                <CRow class="mx-0">
                    <CCol col="12">
                        <div style="text-align:center;margin-top:20px" v-if="!(this.$route.query.agi !== undefined && this.$route.query.di !== undefined && this.$route.query.lci !== undefined && this.$route.query.acsi !== undefined && this.$route.query.bai !== undefined)">
                            <CButton color="outline-info" size="sm" @click="saveSelfService()">
                                <span class='fa fa-save mr-2'></span>
                                {{ getLanguage["BTN"]["SV"] }}
                            </CButton>
                        </div>
                        <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>
                    </CCol>
                </CRow>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import Loading from 'vue-loading-overlay';
    import genericHelper from "@/modules/GenericHelper.js";
    import { mapGetters, mapActions } from 'vuex'
    import { required, sameAs, requiredIf, alphaNum, minLength, maxLength, between, decimal, email, minValue } from 'vuelidate/lib/validators';
    import { constAccessType, loadingFullScreen, constStatus, constYesNo, constImageCURL, constGPImageCURL, constHouseBrand, constSEORobots, constAFB1188SportbookLaunchAPI, constSMSVerification, constEmailVerification, constVerificationPage, constAFB1188SkinW, constAFB1188SkinM, constAFB1188OddsStyle, constAFB1188OddsMode, constCountryCode, constAutoDepositType, constSubAgentSchemeType, constSubAgentType, constSCBAppCardType, constAutoDepositBankApp, constSpecialProviders } from '@/modules/Constant.js'
    import $ from 'jquery'
    import _ from 'lodash'
    import draggable from 'vuedraggable';
    //import Vue from 'vue'
    //Vue.use(require('vue-shortkey'))

    function PTRangeValidation(value, vm) {
        return value >= 0 && value <= vm.MaxPT;
    }

    function validatePassword(value) {
        if (this.obj_Group.Agent.UP != null && this.obj_Group.Agent.UP != '') {

            var pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!])[A-Za-z\d@#$%^&+=!]{6,32}$/;

            return pattern.test(this.obj_Group.Agent.UP);
        }
        return true;
    }

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            draggable
            //DateRangePicker
        },
        data() {
            return {
                indices: [
                    { id: 1, isActive: true }, //SM Brand Details
                    { id: 2, isActive: false }, //Agent Admin Settings -- only set to true when creating agent
                    { id: 3, isActive: true }, //Language & Currency & Game Provider Setting
                    { id: 4, isActive: true }, //Domain & Member Site Setting
                    { id: 5, isActive: true }, //Website Config
                    { id: 6, isActive: true }, //Livechat Setting
                    { id: 7, isActive: true }, //Bank Account Setting
                    { id: 8, isActive: true }, //Customize Registration
                    { id: 9, isActive: true }, //CUstomize Deposit
                ],
                selectedSOTValue: 'HDP',
                selectedTOValue: 'D',
                sportOddsTypeOptions: [
                    { id: 'HDP', label: 'HDP' },
                    { id: 'OU', label: 'OU' },
                    { id: 'X12', label: '1X2' }
                ],
                allThemeOptions: {
                    'HDP': [{ id: 'D', label: 'Default' }, { id: 'Black', label: 'Black' }, { id: 'Blue', label: 'Blue' }, { id: 'DarkBlue', label: 'DarkBlue' }, { id: 'Silver', label: 'Silver' }, { id: 'BgPlayer', label: 'BgPlayer' }, { id: 'BgKickBall', label: 'BgKickBall' }, { id: 'BgCardRedPurple', label: 'BgCardRedPurple' }, { id: 'BgCardPurple', label: 'BgCardPurple' }, { id: 'BgCardGreen', label: 'BgCardGreen' }, { id: 'BgCardGold', label: 'BgCardGold' }, { id: 'BgCardSkyBlue', label: 'BgCardSkyBlue' }, { id: 'BgCardBlue', label: 'BgCardBlue' }, { id: 'BgCardDarkBlue', label: 'BgCardDarkBlue' }],
                    'OU': [{ id: 'D', label: 'Default' }, { id: 'Black', label: 'Black' }, { id: 'Blue', label: 'Blue' }, { id: 'DarkBlue', label: 'DarkBlue' }, { id: 'Silver', label: 'Silver' }, { id: 'BgCardRedPurple', label: 'BgCardRedPurple' }, { id: 'BgCardPurple', label: 'BgCardPurple' }, { id: 'BgCardGreen', label: 'BgCardGreen' }, { id: 'BgCardGold', label: 'BgCardGold' }, { id: 'BgCardSkyBlue', label: 'BgCardSkyBlue' }, { id: 'BgCardBlue', label: 'BgCardBlue' }, { id: 'BgCardDarkBlue', label: 'BgCardDarkBlue' }],
                    'X12': [{ id: 'Blue', label: 'Blue' }, { id: 'Silver', label: 'Silver' }, { id: 'BgKickBall', label: 'BgKickBall' }, { id: 'BgGoalBall', label: 'BgGoalBall' }]
                },
                copy_domainID: null,
                selectedSection: null, //for selecting module
                langCode: "",
                int_IC: 1, // Item Count
                int_RC: 100, //Row Count
                visible: false,
                bool_copyCuzMenu: false, //Copy Customize Menu
                bool_copyCuzReg: false, //Copy Cuztomize Register
                bool_copyCuzDeposit: false, //Copy Customize Deposit
                bool_cr: false,//  customize register
                bool_new: false,
                bool_CV: false, // Check Validation
                bool_isPreview: false,
                bool_isPreviewCD: false,// Preview Visible
                bool_isAMV: false, // Add Modal Visible
                bool_afterAdd: false,
                bool_fullLoading: true,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_groupCV: false,
                bool_isAgentType: false,
                bool_holSLBL: false,
                bool_showDS: false,
                bool_showBOAC: false,
                bool_showDSS: false,
                bool_showDMSS: false,
                bool_showACS: false,
                bool_showLCS: false,
                bool_isEditWebConfig: false,
                bool_showCR: false,
                bool_showCD: false,
                bool_showBS: false,
                bool_isSeniorMasterLv: false,
                bool_DMSA: false,
                bool_EBANS: false,
                bool_EMBANS: false,
                bool_HFLQRC: false,
                bool_EMBANS_DC: false,
                bool_isD: false,
                bool_isW: false,
                bool_errminmax: false,
                bool_isAutoDepositBank: 0,
                bool_obj_isAutoDeposit: 0,
                bool_isEditSelfService: false,
                bool_cacheOptionValue: false,
                bool_disableInsertDomain: false,
                bool_disableInsertLiveChat: true,
                bool_disableInsertBank: true,
                bool_isAutoPopulate: false,
                bool_multiTemplateOneDomain: false,
                bool_isDomain: false,
                bool_isAlternateDomain: false,
                bool_isEditDomain: false,
                bool_obj_bankaccRS: true,
                bool_obj_bankaccDC: false,
                ShowFullAgentConfig: false,
                bool_showPreloadSEO: true,
                bool_showPreloadSEO_AD: true,
                bool_isFinishLoadSectionIndex: false,
                bool_isView: false,
                constAccessType: constAccessType,
                constHouseBrand: constHouseBrand,
                newLanguage: [], // Track new languages separately from obj_Group.Language
                dd_status: constStatus,
                dd_yesno: constYesNo,
                dd_1188SW: constAFB1188SkinW,
                dd_1188SM: constAFB1188SkinM,
                dd_1188OS: constAFB1188OddsStyle,
                dd_1188OM: constAFB1188OddsMode,
                dd_1188API: constAFB1188SportbookLaunchAPI,
                dd_imageList: constImageCURL,
                dd_GPimageList: constGPImageCURL,
                dd_smsverification: constSMSVerification,
                dd_emailverification: constEmailVerification,
                dd_cc: constCountryCode,
                dd_adbct: constSCBAppCardType,
                dd_bank: [],
                dd_seorobots: [],
                dd_verificationpage: [],
                dd_agentgroup: [],
                dd_agentgroup2: [],
                dd_agentgroup_cd: [],//agent group option
                dd_template: [],
                dd_templateskins: [],
                dd_mtemplate: [],
                dd_mtemplateskins: [],
                //dd_fulltemplate:[],
                dd_language_select: [],
                dd_language: [],
                dd_language_wall: [],
                dd_currency: [],
                dd_currency_select: [],
                dd_currency_selectlabel: [],
                dd_currencyICT: [],
                dd_currencyNonICT: [],
                dd_currency_wall: [],
                dd_currency_h2p: [],
                dd_currency_cd: [],
                int_selectedPaymentMethod: null,
                arr_DepositbankTempalte: [],
                arr_DepositbankOption: [],
                depositBank_Receipt: [],
                arr_DepositbankbyBankTempalte: [],
                arr_depositSupportPaymentMethod: [],
                dd_gameprovider: [],
                dd_gameprovider_cat: [],
                dd_paymentgateway_cat:
                    ['Help2pay', 'OOPay', 'EZPay',
                    'TruePay', 'XFuoo', 'StarPay',
                    'SurePay', 'CPay', 'FuPay',
                    'TrueMoney', 'SmartPay', 'U2Pay',
                    'LuckyPay', 'BCPay', 'FPG', 'MPay', 'AutoDepo(Ext)',
                    'Chapter B', 'DoitNow', 'AgogoPay',
                    '918Pay', 'UniversePay', 'Okayspay',
                    'Megaspay', 'VIP', 'AlfaPay', 'OnePay',
                    'BleuPay', 'Easy88Pay', 'ECPay',
                    'ZPay', 'UPay', 'DGPay', 'Super7Pay'], /*, 'PayNGo', 'PapayaPay'*/
                dd_oem: [],
                dd_dofs: [],
                dd_theme: [],
                dd_GPDefaultPT: [],
                ddEditMemberTypeList: [],
                ddDefaultSubBrand: [],    //Defauld DD for Sub Brand
                arr_copyCuzDeposit: [], //array for copying all  Cuz Deposit stuff
                arr_Group: [],
                arr_CustomPT: [],
                obj_BrandDetail: {
                    "PRC": "",
                    "AGU": "",
                    "AGP": "",
                    "CSU": "",
                    "CSP": "",
                    "MKU": "",
                    "MKP": "",
                },
                obj_Group: {},
                obj_Domain: {},
                obj_ADomain: {},
                obj_livechat: {},
                obj_CustomizeRegistration: {},
                arry_aac: {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    nCuzView: null,
                    AGI: "",
                    AGIT: null,
                    E_CC: "",
                    E_PC: "",
                    LocalisedList: [],
                    InactiveDays: 365,
                    Rate: 0,
                    SOT: "",
                    TO: "",
                    DisabledProviderLobbies: [],
                    VTCRegisterDraggeBase: []
                },
                arry_cr: {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    nCuzView: null,
                    AGI: "",
                    AGIT: null,
                    E_CC: "",
                    E_PC: "",
                    LocalisedList: [],
                    InactiveDays: 365,
                    Rate: 0,
                    DisabledProviderLobbies: [],
                    VTCRegisterDraggeBase: [],
                    TMultiLangRegisterList: []
                },
                arry_cd: {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    nCuzView: null,
                    DepositDraggeBase: [],
                    VTCDepositDraggeBase: [],
                    AGI: "",
                    AGIT: null,
                    CI: null,
                    E_CC: "",
                    E_PC: "",
                    LocalisedList: [],
                    InactiveDays: 365,
                    Rate: 0,
                    TMultiLangDepositList: []
                },

                ddPaymentMethod: [
                    { "name": "MD", "id": "MD", "RS": 2 },
                    { "name": "AD", "id": "AD", "RS": 2 },
                    { "name": "ADP", "id": "ADP", "RS": 2 },
                    { "name": "HP", "id": "HP", "RS": 2 },
                    { "name": "OP", "id": "OP", "RS": 2 },
                    { "name": "EZP", "id": "EZP", "RS": 2 },
                    { "name": "TUP", "id": "TUP", "RS": 2 },
                    { "name": "CT", "id": "CT", "RS": 2 },
                    { "name": "XFU", "id": "XFU", "RS": 2 },
                    { "name": "STP", "id": "STP", "RS": 2 },
                    { "name": "SUREP", "id": "SUREP", "RS": 2 },
                    { "name": "FUP", "id": "FUP", "RS": 2 },
                    { "name": "TMONEY", "id": "TMONEY", "RS": 2 },
                    { "name": "SMP", "id": "SMP", "RS": 2 },
                    { "name": "U2P", "id": "U2P", "RS": 2 },
                    { "name": "LP", "id": "LP", "RS": 2 },
                    { "name": "BCP", "id": "BCP", "RS": 2 },
                    { "name": "FPG", "id": "FPG", "RS": 2 },
                    { "name": "PGA", "id": "PGA", "RS": 2 },
                    { "name": "PP", "id": "PP", "RS": 2 },
                    { "name": "DN", "id": "DN", "RS": 2 },
                    { "name": "AGP", "id": "AGP", "RS": 2 },
                    { "name": "P918", "id": "P918", "RS": 2 },
                    { "name": "UP", "id": "UP", "RS": 2 },
                    { "name": "OKP", "id": "OKP", "RS": 2 },
                    { "name": "MGP", "id": "MGP", "RS": 2 },
                    { "name": "VIP", "id": "VIP", "RS": 2 },
                    { "name": "AFP", "id": "AFP", "RS": 2 },
                    { "name": "ONEP", "id": "ONEP", "RS": 2 },
                    { "name": "BLEUP", "id": "BLEUP", "RS": 2 },
                    { "name": "E88P", "id": "E88P", "RS": 2 },
                    { "name": "PPYP", "id": "PPYP", "RS": 2 },
                    { "name": "ECP", "id": "ECP", "RS": 2 },
                    { "name": "ZPAY", "id": "ZPAY", "RS": 2 },
                    { "name": "UPAY", "id": "UPAY", "RS": 2 },
                    { "name": "DGPCNY", "id": "DGPCNY", "RS": 2 },
                    { "name": "SUPER7VND", "id": "SUPER7VND", "RS": 2 },
                    { "name": "PAYNGO", "id": "PAYNGO", "RS": 0 }

                ],
                searchAgent: null,
                arry_OnOff: {},
                arry_CrOnOff: {},
                arry_CdOnOff: {
                    "DPTB_DCUZ": { CV: true, DC: true },
                    "DAB_DCUZ": { CV: true, DC: true },
                    "DTID_DCUZ": { CV: true, DC: true },
                    "DNOTE_DCUZ": { CV: false, DC: false },
                    "DQRD_DCUZ": { CV: true, DC: true },
                    "DDTOD_DCUZ": { CV: true, DC: true },
                    "DUR_DCUZ": { CV: true, DC: true },
                    "DSP_DCUZ": { CV: true, DC: true },

                    //"FNM": { CV: false, DC: true },
                    //"ECF": { CV: false, DC: true },
                    "NADBABA": { CV: false, DC: false },
                    "DDB": { CV: false, DC: false },
                    "NAABA": { CV: false, DC: false },
                    "NADBA": { CV: false, DC: false },
                    "NBRWD": { CV: false, DC: true },
                    "SSMRB": { CV: false, DC: false },
                    "SHBAN": { CV: false, DC: true },
                    //"HMDO": { CV: false, DC: false },
                    // "PDO": { CV: false, DC: false },
                    // "MD": { CV: false, DC: false },
                    // "AD": { CV: false, DC: false },
                    // "ADP": { CV: false, DC: false },
                    // "HP": { CV: false, DC: false },
                    // "OP": { CV: false, DC: false },
                    // "EZP": { CV: false, DC: false },
                    // "TUP": { CV: false, DC: false },
                    // "CT": { CV: false, DC: false },
                    // "XFU": { CV: false, DC: false },
                    // "STP": { CV: false, DC: false },
                    // "SUREP": { CV: false, DC: false },
                    // "FUP": { CV: false, DC: false },
                    // "TMONEY": { CV: false, DC: false },
                    //"FNABAN": { CV: false, DC: false },
                    "CBTU": { CV: false, DC: true },
                    "E2DA": { CV: false, DC: true },
                    "EBAIN": { CV: false, DC: true },
                    "RBAN": { CV: false, DC: true },
                    "EPRL": { CV: false, DC: true },
                    "NOTEIRQ": { CV: false, DC: true },
                    "MAANE": { CV: false, DC: true }, // Allow alphanumeric entries
                    "MAEWAS": { CV: false, DC: true }, //Allow entries with “@” symbol
                },
                obj_bankacc: {},
                obj_SubGroup: {},

                arry_accType: [{ id: "0", label: "Withdrawal" }, { id: "1", label: "Deposit" }, { id: "2", label: "Deposit And Withdrawal" }],
                str_WebConfigCaptchaOption: "",
                str_CuzRegCaptchaOption: "",
                str_PreferredDepositOption: "",
                str_houtOriPrefix: "",

                str_ptrange: "",
                str_prefixError: "",
                str_prefixCorrect: "",
                customPTLabel: "",
                selectedGPCat: "",
                selectedPGCat: "Help2pay",

                configFile: null,
                newScriptFile: false,
                selectedScriptFile: null,
                selectedFile: null,
                selectedFileIco: null,
                filter_agi: null,
                selectedBankFile: null,
                selectedLangIndex: 0,
                selectedLangLabel: 'en',

                dec_availablebalance: 0,
                dec_availablebalanceusd: 0,
                dmKey: 0,
                rtKey: 0,
                rtAltKey: 0,
                fsxmlKey: 0,
                fsxmlAltKey: 0,

                rtSubBrand: 0,
                selectedMaxPT: 0,
                selectedMinPT: 0,
                rtDomainSettingKey: 0,
                pc_msg_class: "ErrMsg",
                searchSubBrand: null,   //SubBrand AGI

                blnFCOC: false,
                constSubAgentSchemeType: constSubAgentSchemeType,
                constSubAgentType: constSubAgentType,
                arr_CustomProvider: [],
                btnGP_checkedAll: [],
                btnGP2_checkedAll: false,
                btnLang_checkedAll: false,
                btnCur_checkedAll: false,
                previewImgUrl: "",
                bool_holMSLBL: false,
                selectedFileMsl: null,

                agentconfig_LS: true,
                agentconfig_RS: false,
                agentconfig_MSS: false,
                agentconfig_BBOS: false,
                agentconfig_CS: false,
                //Duplicate
                //str_CaptchaOption: "",
                str_PreferredDepositOption: "",
                str_TournamentNavOption: "",
                str_ForgotPasswordLinkOption: "",
                SpecialProviders: constSpecialProviders,
                checkSpecialProviders: false,
                drag: false,
                cloudFlareStatus: "",

                obj_LCC: {
                    CC: "",
                    PC: "",
                    LZ: 0,
                    PN: ""
                },

                showManualDeposit: false,
                paymentMtdSequence: "",
                manualDepositSequence: "",
                list: [
                    { "name": "MD", "id": "MD", "RS": 2 },
                    { "name": "AD", "id": "AD", "RS": 2 },
                    { "name": "ADP", "id": "ADP", "RS": 2 },
                    { "name": "HP", "id": "HP", "RS": 2 },
                    { "name": "OP", "id": "OP", "RS": 2 },
                    { "name": "EZP", "id": "EZP", "RS": 2 },
                    { "name": "TUP", "id": "TUP", "RS": 2 },
                    { "name": "CT", "id": "CT", "RS": 2 },
                    { "name": "XFU", "id": "XFU", "RS": 2 },
                    { "name": "STP", "id": "STP", "RS": 2 },
                    { "name": "SUREP", "id": "SUREP", "RS": 2 },
                    { "name": "FUP", "id": "FUP", "RS": 2 },
                    { "name": "TMONEY", "id": "TMONEY", "RS": 2 },
                    { "name": "SMP", "id": "SMP", "RS": 2 },
                    { "name": "U2P", "id": "U2P", "RS": 2 },
                    { "name": "LP", "id": "LP", "RS": 2 },
                    { "name": "BCP", "id": "BCP", "RS": 2 },
                    { "name": "FPG", "id": "FPG", "RS": 2 },
                    { "name": "PGA", "id": "PGA", "RS": 2 },
                    { "name": "PP", "id": "PP", "RS": 2 },
                    { "name": "DN", "id": "DN", "RS": 2 },
                    { "name": "AGP", "id": "AGP", "RS": 2 },
                    { "name": "P918", "id": "P918", "RS": 2 },
                    { "name": "UP", "id": "UP", "RS": 2 },
                    { "name": "OKP", "id": "OKP", "RS": 2 },
                    { "name": "MGP", "id": "MGP", "RS": 2 },
                    { "name": "VIP", "id": "VIP", "RS": 2 },
                    { "name": "AFP", "id": "AFP", "RS": 2 },
                    { "name": "ONEP", "id": "ONEP", "RS": 2 },
                    { "name": "BLEUP", "id": "BLEUP", "RS": 2 },
                    { "name": "E88P", "id": "E88P", "RS": 2 },
                    { "name": "PPYP", "id": "PPYP", "RS": 2 },
                    { "name": "ECP", "id": "ECP", "RS": 2 },
                    { "name": "ZPAY", "id": "ZPAY", "RS": 2 },
                    { "name": "UPAY", "id": "UPAY", "RS": 2 },
                    { "name": "DGPCNY", "id": "DGPCNY", "RS": 2 },
                    { "name": "SUPER7VND", "id": "SUPER7VND", "RS": 2 },
                    { "name": "PAYNGO", "id": "PAYNGO", "RS": 0 }

                ],
                //Removed for TT9958
                //depositOptions: [
                //    { key: 'MD', value: 'MD', languageKey: 'MD' },
                //    { key: 'AD', value: 'AD', languageKey: 'AD' },
                //    { key: 'ADP', value: 'ADP', languageKey: 'ADP' },
                //    { key: 'HP', value: 'HP', languageKey: 'HP' },
                //    { key: 'OP', value: 'OP', languageKey: 'OP' },
                //    { key: 'EZP', value: 'EZP', languageKey: 'EZP' },
                //    { key: 'TUP', value: 'TUP', languageKey: 'TUP' },
                //    { key: 'CT', value: 'CT', languageKey: 'CT' },
                //    { key: 'XFU', value: 'XFU', languageKey: 'XFU' },
                //    { key: 'STP', value: 'STP', languageKey: 'STP' },
                //    { key: 'SUREP', value: 'SUREP', languageKey: 'SUREP' },
                //    { key: 'P918', value: 'P918', languageKey: '918P' },
                //    { key: 'FUP', value: 'FUP', languageKey: 'FUP' },
                //    { key: 'TMONEY', value: 'TMONEY', languageKey: 'TMONEY' },
                //    { key: 'SMP', value: 'SMP', languageKey: 'SMP' },
                //    { key: 'U2P', value: 'U2P', languageKey: 'U2P' },
                //    { key: 'LP', value: 'LP', languageKey: 'LP' },
                //    { key: 'BCP', value: 'BCP', languageKey: 'BCP' },
                //    { key: 'FPG', value: 'FPG', languageKey: 'FPG' },
                //    { key: 'PGA', value: 'PGA', languageKey: 'PGA' },
                //    { key: 'PP', value: 'PP', languageKey: 'PP' },
                //    { key: 'DN', value: 'DN', languageKey: 'DN' },
                //    { key: 'AGP', value: 'AGP', languageKey: 'AGP' },
                //    { key: 'UP', value: 'UP', languageKey: 'UP' },
                //    { key: 'OKP', value: 'OKP', languageKey: 'OKP' },
                //    { key: 'MGP', value: 'MGP', languageKey: 'MGP' },
                //    { key: 'VIP', value: 'VIP', languageKey: 'VIP' },

                //],
                captchaOptions: [
                    { value: 'CCAOLN', languageKey: 'AOLN' },
                    { value: 'CCALPN', languageKey: 'CCALPN' },
                    { value: 'CCNO', languageKey: 'CCNO' },
                    { value: 'DCC', languageKey: 'DCC' }
                ],
            }
        },
        mounted() {
            this.checkActive();
        },
        validations: {
            obj_Group: {
                GN: { required },
                AT: { required },
                PGI: { required },
                PC: { required, minLength: minLength(4), maxLength: maxLength(4), alphaNum },
                //PT: { required, decimal, PTRangeValidation },
                PT: { decimal, PTRangeValidation },
                //WLIPS: { required },
                DCI: { required },
                //TB: { required, decimal, minValue: minValue(0) },
                TB: { decimal, minValue: minValue(0) },
                TCB: { required, decimal, minValue: minValue(0) },
                H2PU: { required: requiredIf(function (vm) { return this.validateH2p(); }) },
                H2PMC: { required: requiredIf(function (vm) { return this.validateH2p(); }) },
                H2PSC: { required: requiredIf(function (vm) { return this.validateH2p(); }) },

                OOPTHMN: { required: requiredIf(function (vm) { return this.validateOOPTH(); }) },
                OOPTHAS: { required: requiredIf(function (vm) { return this.validateOOPTH(); }) },
                OOPTHSK: { required: requiredIf(function (vm) { return this.validateOOPTH(); }) },
                OOPVIMN: { required: requiredIf(function (vm) { return this.validateOOPVI(); }) },
                OOPVIAS: { required: requiredIf(function (vm) { return this.validateOOPVI(); }) },
                OOPVISK: { required: requiredIf(function (vm) { return this.validateOOPVI(); }) },
                OOPIDMN: { required: requiredIf(function (vm) { return this.validateOOPID(); }) },
                OOPIDAS: { required: requiredIf(function (vm) { return this.validateOOPID(); }) },
                OOPIDSK: { required: requiredIf(function (vm) { return this.validateOOPID(); }) },

                EZPUSDMN: { required: requiredIf(function (vm) { return this.validateEZPUSD(); }) },
                EZPUSDAS: { required: requiredIf(function (vm) { return this.validateEZPUSD(); }) },
                EZPIDRMN: { required: requiredIf(function (vm) { return this.validateEZPIDR(); }) },
                EZPIDRAS: { required: requiredIf(function (vm) { return this.validateEZPIDR(); }) },
                EZPMYRMN: { required: requiredIf(function (vm) { return this.validateEZPMYR(); }) },
                EZPMYRAS: { required: requiredIf(function (vm) { return this.validateEZPMYR(); }) },
                EZPTHBMN: { required: requiredIf(function (vm) { return this.validateEZPTHB(); }) },
                EZPTHBAS: { required: requiredIf(function (vm) { return this.validateEZPTHB(); }) },
                EZPVNDMN: { required: requiredIf(function (vm) { return this.validateEZPVND(); }) },
                EZPVNDAS: { required: requiredIf(function (vm) { return this.validateEZPVND(); }) },

                TUPVNDMN: { required: requiredIf(function (vm) { return this.validateTUPVND(); }) },
                TUPVNDAS: { required: requiredIf(function (vm) { return this.validateTUPVND(); }) },
                TUPMYRMN: { required: requiredIf(function (vm) { return this.validateTUPMYR(); }) },
                TUPMYRAS: { required: requiredIf(function (vm) { return this.validateTUPMYR(); }) },

                XFTHN: { required: requiredIf(function (vm) { return this.validateXFuooTH(); }) },
                XFTHK: { required: requiredIf(function (vm) { return this.validateXFuooTH(); }) },
                XFVIN: { required: requiredIf(function (vm) { return this.validateXFuooVI(); }) },
                XFVIK: { required: requiredIf(function (vm) { return this.validateXFuooVI(); }) },
                XFMYRN: { required: requiredIf(function (vm) { return this.validateXFuooMYR(); }) },
                XFMYRK: { required: requiredIf(function (vm) { return this.validateXFuooMYR(); }) },
                XFUSDTN: { required: requiredIf(function (vm) { return this.validateXFuooUSDT(); }) },
                XFUSDTK: { required: requiredIf(function (vm) { return this.validateXFuooUSDT(); }) },
                XFIDRN: { required: requiredIf(function (vm) { return this.validateXFuooIDR(); }) },
                XFIDRK: { required: requiredIf(function (vm) { return this.validateXFuooIDR(); }) },

                SPAK: { required: requiredIf(function (vm) { return this.validateStarsPay(); }) },
                SPMN: { required: requiredIf(function (vm) { return this.validateStarsPay(); }) },

                SUMYRAK: { required: requiredIf(function (vm) { return this.validateSurePayMYR(); }) },
                SUMYRMN: { required: requiredIf(function (vm) { return this.validateSurePayMYR(); }) },
                SUMYRCN: { required: requiredIf(function (vm) { return this.validateSurePayMYR(); }) },
                SUTHBAK: { required: requiredIf(function (vm) { return this.validateSurePayTHB(); }) },
                SUTHBMN: { required: requiredIf(function (vm) { return this.validateSurePayTHB(); }) },
                SUTHBCN: { required: requiredIf(function (vm) { return this.validateSurePayTHB(); }) },
                SUSGDAK: { required: requiredIf(function (vm) { return this.validateSurePaySGD(); }) },
                SUSGDMN: { required: requiredIf(function (vm) { return this.validateSurePaySGD(); }) },
                SUSGDCN: { required: requiredIf(function (vm) { return this.validateSurePaySGD(); }) },

                CI: {
                    required: requiredIf(function (vm) {
                        if (vm.PGIT != null && vm.PGIT != "") {
                            var pgi = vm.PGIT.split("-");
                            return pgi[0] == "2";
                        }
                        return false;
                    }),
                },
                L: {
                    required: requiredIf(function (vm) {
                        if (vm.PGIT != null && vm.PGIT != "") {
                            var pgi = vm.PGIT.split("-");
                            return pgi[0] == "2";
                        }
                        return false;
                    }),
                },
                GPI: {
                    required: requiredIf(function (vm) {
                        if (vm.PGIT != null && vm.PGIT != "") {
                            var pgi = vm.PGIT.split("-");
                            return pgi[0] == "2";
                        }
                        return false;
                    }),
                },
                Agent: {
                    U: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                    },
                    UP: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                        minLength: value => !value || minLength(6)(value), validatePassword
                    },
                    CUP: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0 && vm.UP != null && vm.UP != '';
                        }),
                        sameAsPassword: sameAs('UP')
                    },
                    DN: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                    },
                    E: { email }
                },
            },
            obj_Domain: {
                DN: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertDomain == false && this.bool_isDomain == true);
                    }),
                },
                //AGI: { required },
                //L: {    required    },
                //L: {
                //    required: requiredIf(function (vm) {
                //        return (this.bool_disableInsertDomain);
                //    })
                //},
                DL: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertDomain == false && vm.L != null && vm.L.length > 0 && this.bool_isDomain == false);
                    }),
                },
                SMSVP: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertDomain == false && vm.SMSV == 2 && this.bool_isDomain == false);
                    }),
                },
                EVP: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertDomain == false && vm.EV == 2 && this.bool_isDomain == false);
                    }),
                },
                DS: {
                    $each: {
                        CC: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && this.bool_isDomain == false);
                            }),
                        },
                        TI: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && this.bool_isDomain == false);
                            }),
                        },
                        TSI: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && vm.TI > 0 && this.bool_isDomain == false);
                            }),
                        },
                        MTI: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && vm.AMT && this.bool_isDomain == false);
                            }),
                        },
                        MTSI: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && vm.MTI > 0 && this.bool_isDomain == false);
                            }),
                        },
                        TIALT: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && vm.E2SSIM && this.bool_isDomain == false);
                            }),
                        },
                        TSIALT: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && vm.TIALT > 0 && this.bool_isDomain == false);
                            }),
                        },
                        MTIALT: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && vm.E2SSIM && vm.AMTALT && this.bool_isDomain == false);
                            }),
                        },
                        MTSIALT: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && vm.MTIALT > 0 && this.bool_isDomain == false);
                            }),
                        },
                        GPI: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && this.bool_isDomain == false);
                            }),
                        },
                        DSN1: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && this.bool_isDomain == false);
                            }),
                        },
                        DSN2: {
                            required: requiredIf(function (vm) {
                                return (this.bool_disableInsertDomain == false && vm.TC && vm.E2SSIM && this.bool_isDomain == false);
                            }),
                        },
                    }
                }
            },
            obj_ADomain: {
                DN: { required }
            },
            obj_livechat: {
                LCPI: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertLiveChat == false);
                    }),
                },
                LK: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertLiveChat == false);
                    }),
                },
                S: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertLiveChat == false);
                    }),
                },
                arry_holdLang: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertLiveChat == false);
                    }),
                },
            },
            obj_bankacc: {
                BI: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false);
                    }),
                },
                BA: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false);
                    }),
                },
                BAN: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false);
                    }), alphaNum
                },
                CI: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false);
                    }),
                },
                Add_AB: {
                    required: requiredIf(function (vm) {
                        return (this.bool_isAAB == true && vm.Add_AB != 0) || (this.bool_isAAB == true && vm.Add_AB > vm.AB)
                    }),
                },
                AT: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false);
                    }),
                },
                CC: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false);
                    }),
                },
                BP: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false && (vm.I == 0 && vm.BU != "") || (vm.BPC != '' && vm.BPC != null));
                    }),
                },
                BPC: {
                    sameAsPassword: sameAs(function (vm) { return ((vm.I == 0 && vm.BU != "") || (vm.BP != '' && vm.BP != null) ? vm.BP : vm.BPC); })
                },
                BU: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false && vm.IA != null && (vm.IA == 1 || vm.IA == 2));
                    }),
                },
                MTV: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false && vm.VIPBA);
                    })
                },
                FCS: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false && vm.FCS != null && vm.FCS != "");
                    })
                },
                ER: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false && vm.ER != null && vm.ER != 1);
                    })
                },
                TCS: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false && vm.TCS != null && vm.TCS != "");
                        //return vm.ER != null && vm.ER != 1;
                    })
                },
                TER: {
                    required: requiredIf(function (vm) {
                        return (this.bool_disableInsertBank == false && vm.TER != null && vm.TER != 1);
                        //return vm.FCS != null && vm.FCS != "";
                    })
                }
            },
            obj_SubGroup: {
                GN: { required },
                AT: { required },
                PGI: { required },
                DCI: { required },
                SAGAGI: {
                    required: requiredIf(function (vm) {
                        if (!vm.PGIT) {
                            return false;
                        }
                        if (vm.PGIT.indexOf("-") > 0) {
                            var agi = vm.PGIT.split("-");

                            if (agi[0] == 4)
                                return true;
                            else
                                return false;
                        } else
                            return true;
                    })
                },
                PC: { required, minLength: minLength(8), maxLength: maxLength(8), alphaNum },
                Agent: {
                    U: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                    },
                    UP: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                        minLength: minLength(4)
                    },
                    CUP: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0 && vm.UP != null && vm.UP != '';
                        }),
                        sameAsPassword: sameAs('UP')
                    },
                    DN: {
                        required: requiredIf(function (vm) {
                            return vm.I == 0;
                        }),
                    },
                    E: { email },
                },
                SubAgentPayoutScheme: {
                    PT: {
                        required,
                        between: function (val, obj) {
                            let res = true;
                            if (val) {
                                if (val < this.selectedMinPT || val > this.selectedMaxPT) {
                                    res = false;
                                }
                            }
                            return res;
                        }
                    },
                    WLT: { required },
                    POT: { required },
                },
            },
            arry_cr: {
                AGIT: { required },
            },
            arry_cd: {
                AGIT: { required },
                CI: { required },
            },

        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            filteredThemeOptions() {
                return this.allThemeOptions[this.selectedSOTValue] || [];
            }
        },
        watch: {
            'arry_CrOnOff.RPN.CV': function (newVal) {
                if (newVal == false) {
                    this.arry_CrOnOff.REGWPHONE.CV = false;
                }
            },
            'arry_CrOnOff.REGWPHONE.CV': function (newVal) {
                if (newVal == true) {
                    this.arry_CrOnOff.EUN.CV = false;
                }
            },
            'obj_Group.PGIT': {
                handler: function (val, oldVal) {
                    if (val != null && val.length > 0) {
                        var agi = val.split("-");
                        this.obj_Group.AT = parseInt(agi[0]) + 1;
                    }
                }, deep: true
            },
            'obj_Group.Language': {
                handler: function (val, oldVal) {
                    if (val != null && val.length > 0) {
                        this.dd_language_select = [];
                        for (var i = 0; i < this.obj_Group.Language.length; i++) {
                            for (var x = 0; x < this.dd_language.length; x++) {
                                if (this.obj_Group.Language[i] == this.dd_language[x].id) {
                                    this.dd_language_select.push({ id: this.dd_language[x].id, label: this.dd_language[x].label });
                                }
                            }
                        }

                        //if (!this.bool_isEditSelfService) {
                        for (var i = 0; i < this.obj_Domain.DS.length; i++) {
                            if (!this.obj_Group.Language.includes(this.obj_Domain.DS[i].L)) {
                                this.$set(this.obj_Domain.DS[i], 'LE', false);
                                this.$set(this.obj_Domain.DS[i], 'TC', false);
                            } else {
                                this.$set(this.obj_Domain.DS[i], 'LE', true);
                                if (!this.bool_isEditSelfService) {
                                    this.$set(this.obj_Domain.DS[i], 'TC', true);
                                }
                            }
                        }
                        //}
                    }
                }, deep: true
            },
            'obj_Group.CurrencyIds': {
                handler: function (val, oldVal) {
                    if (val != null && val.length > 0) {
                        this.dd_currency_select = [];
                        this.dd_currency_selectlabel = [];
                        var currency_select = [];
                        for (var i = 0; i < this.dd_currency.length; i++) {
                            if (this.obj_Group.CurrencyIds.includes(this.dd_currency[i].id)) {
                                this.dd_currency_select.push({ id: this.dd_currency[i].id, label: this.dd_currency[i].label });
                                this.dd_currency_selectlabel.push({ id: this.dd_currency[i].label, label: this.dd_currency[i].label });
                                currency_select.push(this.dd_currency[i].label)
                            }
                        }
                        this.dd_currency_selectlabel = this.dd_currency_selectlabel.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));

                        //// auto populate afbsport oddstyle & oddmode
                        if (currency_select.every((element) => ["MYR", "KHR", "THB", "VND", "SGD"].includes(element))) {
                            this.obj_Domain.DS[this.selectedLangIndex].AFB1188OS = "MY";
                        } else if (currency_select.every((element) => ["EUR"].includes(element))) {
                            this.obj_Domain.DS[this.selectedLangIndex].AFB1188OS = "EU";
                        } else if (currency_select.every((element) => ["IDR", "INR"].includes(element))) {
                            this.obj_Domain.DS[this.selectedLangIndex].AFB1188OS = "ID";
                        } else if (currency_select.every((element) => ["USD", "CNY", "KRW", "HKD"].includes(element))) {
                            this.obj_Domain.DS[this.selectedLangIndex].AFB1188OS = "HK";
                        } else {
                            this.obj_Domain.DS[this.selectedLangIndex].AFB1188OS = "HK";
                        }
                    }
                }, deep: true
            },
            'obj_Group.ICT': {
                handler: function (val, oldVal) {
                    if (val != null && val.length > 0) {
                        this.obj_Group.DCI = null;
                        this.obj_Group.CurrencyIds = [];
                        if (val == 'true') {
                            this.dd_currency = [];
                            this.dd_currency.push(this.dd_currencyNonICT.find(f => f.label === 'USD'));
                            this.dd_currency_wall = this.appendSelectAllOption(this.dd_currencyICT);
                        }
                        else {
                            this.dd_currency = this.dd_currencyNonICT;
                            this.dd_currency_wall = this.appendSelectAllOption(this.dd_currencyNonICT);
                        }
                    }
                }, deep: true
            },
            'obj_bankacc.AT'(newValue) {
                if (this.obj_bankacc.I == 0) {
                    if (newValue == "0") { //with
                        this.bool_isW = true;
                        this.bool_isD = false;
                        this.obj_bankacc.MIND = null
                        this.obj_bankacc.MAXD = null
                        // this.obj_bankacc.TD = 0
                        this.obj_bankacc.ID = 0
                        this.obj_bankacc.IW = 1
                    } else if (newValue == "1") { // deposit
                        this.bool_isW = false;
                        this.bool_isD = true;
                        this.obj_bankacc.MINW = null
                        this.obj_bankacc.MAXW = null
                        this.obj_bankacc.TW = null
                        this.obj_bankacc.ID = 1
                        this.obj_bankacc.IW = 0
                    } else if (newValue == "2") {
                        this.bool_isW = true;
                        this.bool_isD = true;
                        this.obj_bankacc.MINW = null
                        this.obj_bankacc.MAXW = null
                        this.obj_bankacc.TW = null
                        this.obj_bankacc.MIND = null
                        this.obj_bankacc.MAXD = null
                        // this.obj_bankacc.TD = 0
                        this.obj_bankacc.IW = 1
                        this.obj_bankacc.ID = 1
                    }
                }
                else {
                    if (newValue == "0") { //with
                        this.bool_isW = true;
                        this.bool_isD = false;

                        // this.obj_bankacc.TD = 0
                        this.obj_bankacc.ID = 0
                        this.obj_bankacc.IW = 1
                    } else if (newValue == "1") { // deposit
                        this.bool_isW = false;
                        this.bool_isD = true;
                        this.obj_bankacc.ID = 1
                        this.obj_bankacc.IW = 0
                    } else if (newValue == "2") {
                        this.bool_isW = true;
                        this.bool_isD = true;

                        // this.obj_bankacc.TD = 0
                        this.obj_bankacc.IW = 1
                        this.obj_bankacc.ID = 1
                    }
                }
            },
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_groupCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                    //this.$router.push("/AGS/AGD");

                    var parameters = this.$route.query;
                    if (parameters.agi !== undefined && parameters.di !== undefined && parameters.lci !== undefined && parameters.acsi !== undefined && parameters.bai !== undefined && parameters.cri !== undefined) {
                        this.$router.push("/AGS/AGD");
                    }
                }
            },
            bool_isAgentType: function (newData, oldData) {
                if (newData == false) {
                    this.obj_Group.ICT = false;
                }
            },
            bool_showDMSS() {
                if (this.bool_showDMSS && this.bool_isAgentType) {
                    this.autoPopulateDefaultTemplate();
                    //this.autoScrollTemplate();
                }
            },
            bool_disableInsertDomain() {
                if (this.bool_disableInsertDomain) {
                    this.bool_disableInsertLiveChat = true;
                }
            },
            //bool_fullLoading() {
            //    if (!this.bool_fullLoading) {
            //        setTimeout(() => {
            //            $("#SSA .table-wrapper .row .section-title2").each(function (index) {
            //                $(this).find('span').html(index + 1);
            //            });
            //        }, 1500)
            //    }
            //},
            getLanguage: {
                handler: function (val, oldVal) {
                    if (val != oldVal) {
                        this.langCode = window.localStorage.getItem('lang') || "en"
                    }
                }, deep: true,
            },
            '$route.query': {
                handler(query) {
                    var parameters = query;
                    if (parameters.pgit !== undefined && parameters.agt !== undefined) {
                        this.addSelfService(parameters.pgit, parameters.agt)
                    }
                    else if (parameters.agi !== undefined && parameters.di !== undefined && parameters.lci !== undefined && parameters.acsi !== undefined && parameters.bai !== undefined && parameters.cri !== undefined) {
                        this.editSelfService();
                    }
                    else {
                        this.$router.push("/AGS/AGD");
                    }
                },
            },
        },
        methods: {
            ...mapActions('SMBData', [
                'setCurrencySymbol',
                'setSystemBalance',
                'setCreditBalance'
            ]),
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            changePhoneSetting(event, element) {
                if (event.target.value == 'true') {
                    this.arry_CrOnOff.REGWPHONE.CV = true;
                } else {
                    this.arry_CrOnOff.REGWPHONE.CV = false;
                }
                if (this.arry_CrOnOff.REGWPHONE.CV == true && element.id == 'PN') {
                    element.RS = 1;
                }
            },
            getSectionClasses(section, condition) {
                if (this.selectedSection === section) {
                    return {
                        'bg-blue text-white': true
                    };
                }

                return {
                    'bg-success': condition
                };
            },
            //Handles index no to show Agent Admin or no
            checkActive() {
                if (!this.$route.query.agi) {
                    const section = this.indices.find(s => s.id === 2);
                    if (section) {
                        section.isActive = true;
                    }
                }
            },
            getSectionIndex(id) {
                //get active sections only
                const activeSections = this.indices.filter(s => s.isActive);

                //mapping
                const idToNewIndex = activeSections.reduce((acc, section, index) => {
                    acc[section.id] = index + 1;
                    return acc;
                }, {});

                // Return the new index if exists or 0
                return idToNewIndex[id] || 0;
            },
            //Handle toggle change, currently for Website Config only
            handleToggleChange(category, key) {
                if (this.arry_OnOff[category][key]) {
                    this.arry_OnOff[category][key].CV = !this.arry_OnOff[category][key].CV;
                }
            },
            //Save Downline Setting & Save Language & Currency & Game Provider Setting
            saveDownlineConfig() {
                var checkValidLocalized = true;

                if (this.obj_Group.I == 0) {
                    this.obj_Group.PT = this.obj_Group.DPT;
                }
                if (this.obj_Group.PGIT != null && this.obj_Group.PGIT.length > 0) {
                    var agi = this.obj_Group.PGIT.split("-");
                    this.obj_Group.PGI = agi[1];
                    this.obj_Group.AT = parseInt(agi[0]) + 1;
                }
                if (this.obj_Group.CurrencyIds != null && this.obj_Group.CurrencyIds.length > 0) {
                    this.obj_Group.CI = this.obj_Group.CurrencyIds.join(',');
                }
                if (this.obj_Group.H2PCurrencyCodes != null && this.obj_Group.H2PCurrencyCodes.length > 0) {
                    this.obj_Group.H2PCC = this.obj_Group.H2PCurrencyCodes.join(',');
                }
                if (this.obj_Group.Language != null && this.obj_Group.Language.length > 0) {
                    this.obj_Group.L = this.obj_Group.Language.join(',');
                }
                if (this.obj_Group.GameProviderIds != null && this.obj_Group.GameProviderIds.length > 0) {
                    this.obj_Group.GPI = this.obj_Group.GameProviderIds.join(',');
                }
                this.obj_Group.WLIPS = "";
                if (this.obj_Group.WhiteListIP != null && this.obj_Group.WhiteListIP.length > 0) { // If WhiteListIP Input box has Ip address
                    for (var i = 0; i < this.obj_Group.WhiteListIP.length; i++) {
                        if (i != 0) {
                            this.obj_Group.WLIPS += ",";
                        }
                        // Insert the IP Address from InputBox into the Table.
                        this.obj_Group.WLIPS += this.obj_Group.WhiteListIP[i].WLIPS;
                    }
                }
                if (this.str_houtOriPrefix == this.obj_Group.PC) {
                    this.obj_Group.hout_PrefixChange = true;
                } else {
                    this.obj_Group.hout_PrefixChange = false;
                }

                this.bool_errminmax = false;

                //// check the require field
                this.bool_groupCV = true;
                if (this.getUserInfo.AT == 1) {
                    this.bool_disableInsertDomain = true;
                }

                this.bool_disableInsertLiveChat = true;
                this.bool_disableInsertBank = true;
                this.bool_disableInsertDomain = true;

                this.$v.obj_Group.$touch();
                if (!this.$v.obj_Group.$error && this.str_prefixError == "") {
                    this.bool_showDS = false;
                    this.bool_showDSS = false;
                    this.bool_showBOAC = false;
                }

                setTimeout(() => {
                    $(".ErrMsg").each(function (index) {
                        if ($(this).text()) {
                            $('html, body').animate({
                                scrollTop: $(this).parent().offset().top - 70
                            }, 'smooth');
                            return false;
                        }
                    });
                }, 100)

                if (!this.$v.obj_Group.$error) {
                    this.obj_Group.IsSendNoti = true;
                }

                //grab domainId to pass to SelfServiceController
                var domainId = this.$route.query.di;

                this.obj_Group.IsSendNoti = true;
                this.bool_fullLoading = true;

                var that = this;
                if (!this.bool_isAgentType) {

                    this.postDataApi(`/api/ag/s`, this.obj_Group,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;

                                // reload agent group dropdown
                                that.popUpAgentDetailModal(d.BD);
                            }
                        });
                } else if (this.bool_isAgentType && checkValidLocalized == true) {
                    this.arry_aac['bool_isEditWebConfig'] = true;
                    /*var bool_deleteDomainCache = true;*/
                    this.postDataApiWithAttach(`/api/agss/sg`, {
                        "AgentGroup": this.obj_Group,
                        "Domain": this.obj_Domain,
                        "DomainId": domainId,
                        "NewLanguage": this.newLanguage
                    },
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;

                                // reload agent group dropdown
                                that.popUpAgentDetailModal(d.BD);
                            }
                        });
                }

            },
            //Save Language & Currency & Game Provider Setting
            saveGameProviderConfig() {
                //Left blank for now
            },
            //Save Domain & Membersite Setting
            saveDomainConfig() {

                //Temporary Fixes
                if (this.obj_Group.Language != null && this.obj_Group.Language.length > 0) {
                    this.obj_Group.L = this.obj_Group.Language.join(',');
                }

                //Temporary Fixes
                if (this.obj_Group.CurrencyIds != null && this.obj_Group.CurrencyIds.length > 0) {
                    this.obj_Group.CI = this.obj_Group.CurrencyIds.join(',');
                }

                var checkValidLocalized = true;

                //Caches the result
                const imageUrlTabIndexCache = {
                    '#imageURLTab': this.getIURLTabIndex("#imageURLTab"),
                    '#imageURLTab2': this.getIURLTabIndex("#imageURLTab2"),
                    '#imageURLTab4': this.getIURLTabIndex("#imageURLTab4")
                };

                //site logo
                this.obj_Domain.SLBL = imageUrlTabIndexCache['#imageURLTab'] === 2 && this.obj_Domain.LOGOByLink && this.obj_Domain.LOGOByLink.trim();

                //site icon
                this.obj_Domain.SIBL = imageUrlTabIndexCache['#imageURLTab2'] === 2 && this.obj_Domain.ICONByLink && this.obj_Domain.ICONByLink.trim();

                //mobile site logo
                this.obj_Domain.MSLBL = imageUrlTabIndexCache['#imageURLTab4'] === 2 && this.obj_Domain.MobileLOGOByLink && this.obj_Domain.MobileLOGOByLink.trim();

                // Handle Currency Codes
                const selectedLangDS = this.obj_Domain.DS[this.selectedLangIndex];
                selectedLangDS.CurrencyCodes = _.uniq(selectedLangDS.CurrencyCodes);
                if (selectedLangDS.CurrencyCodes && selectedLangDS.CurrencyCodes.length) {
                    selectedLangDS.CC = selectedLangDS.CurrencyCodes.join(',');
                }

                for (var i = 0; i < this.obj_Domain.DS.length; i++) {
                    if (this.obj_Domain.DS[i].TC) {
                        //auto populate same setting for other language setting
                        this.obj_Domain.DS[i].AFB1188OM = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].AFB1188OM : this.obj_Domain.DS[i].AFB1188OM);
                        this.obj_Domain.DS[i].AFB1188OS = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].AFB1188OS : this.obj_Domain.DS[i].AFB1188OS);
                        this.obj_Domain.DS[i].AFB1188SM = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].AFB1188SM : this.obj_Domain.DS[i].AFB1188SM);
                        this.obj_Domain.DS[i].AFB1188SW = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].AFB1188SW : this.obj_Domain.DS[i].AFB1188SW);

                        this.obj_Domain.DS[i].CURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].CURL : this.obj_Domain.DS[i].CURL);
                        this.obj_Domain.DS[i].GCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].GCURL : this.obj_Domain.DS[i].GCURL);
                        this.obj_Domain.DS[i].ALTCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].ALTCURL : this.obj_Domain.DS[i].ALTCURL);
                        this.obj_Domain.DS[i].ALTGCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].ALTGCURL : this.obj_Domain.DS[i].ALTGCURL);
                        this.obj_Domain.DS[i].MCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].MCURL : this.obj_Domain.DS[i].MCURL);
                        this.obj_Domain.DS[i].MGCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].MGCURL : this.obj_Domain.DS[i].MGCURL);
                        this.obj_Domain.DS[i].ALTMCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].ALTMCURL : this.obj_Domain.DS[i].ALTMCURL);
                        this.obj_Domain.DS[i].ALTMGCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].ALTMGCURL : this.obj_Domain.DS[i].ALTMGCURL);

                        this.obj_Domain.DS[i].CurrencyCodes = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].CurrencyCodes : this.obj_Domain.DS[i].CurrencyCodes);
                        this.obj_Domain.DS[i].CC = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].CC : this.obj_Domain.DS[i].CC);

                        this.obj_Domain.DS[i].GameProviderIdS = this.obj_Group.GameProviderIds;
                        this.obj_Domain.DS[i].GPI = this.obj_Group.GPI;

                        this.obj_Domain.DS[i].TI = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].TI : this.obj_Domain.DS[i].TI);
                        this.obj_Domain.DS[i].MTI = (!this.bool_multiTemplateOneDomain ? (this.obj_Domain.DS[this.selectedLangIndex].AMT ? this.obj_Domain.DS[this.selectedLangIndex].MTI : null) : (this.obj_Domain.DS[i].AMT ? this.obj_Domain.DS[i].MTI : null))
                        this.obj_Domain.DS[i].TSI = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].TSI : this.obj_Domain.DS[i].TSI);
                        this.obj_Domain.DS[i].MTSI = (!this.bool_multiTemplateOneDomain ? (this.obj_Domain.DS[this.selectedLangIndex].AMT ? this.obj_Domain.DS[this.selectedLangIndex].MTSI : null) : (this.obj_Domain.DS[i].AMT ? this.obj_Domain.DS[i].MTSI : null))

                        if (this.obj_Domain.DS[i].E2SSIM) {
                            this.obj_Domain.DS[i].TIALT = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].TIALT : this.obj_Domain.DS[i].TIALT);
                            this.obj_Domain.DS[i].MTIALT = (!this.bool_multiTemplateOneDomain ? (this.obj_Domain.DS[this.selectedLangIndex].AMTALT ? this.obj_Domain.DS[this.selectedLangIndex].MTIALT : null) : (this.obj_Domain.DS[i].AMTALT ? this.obj_Domain.DS[i].MTIALT : null))
                            this.obj_Domain.DS[i].TSIALT = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].TSIALT : this.obj_Domain.DS[i].TSIALT);
                            this.obj_Domain.DS[i].MTSIALT = (!this.bool_multiTemplateOneDomain ? (this.obj_Domain.DS[this.selectedLangIndex].AMTALT ? this.obj_Domain.DS[this.selectedLangIndex].MTSIALT : null) : (this.obj_Domain.DS[i].AMTALT ? this.obj_Domain.DS[i].MTSIALT : null))
                        } else {
                            //this.obj_Domain.DS[i].EETAD = null;
                            this.obj_Domain.DS[i].TIALT = null;
                            this.obj_Domain.DS[i].MTIALT = null
                            this.obj_Domain.DS[i].TSIALT = null;
                            this.obj_Domain.DS[i].MTSIALT = null;
                        }
                    }
                }


                // Handle Maintenance IP
                if (this.obj_Domain.MaintenanceIP && this.obj_Domain.MaintenanceIP.length) {
                    this.obj_Domain.MIP = this.obj_Domain.MaintenanceIP.map(ip => ip.MIP).join(',');
                }

                // Handle Domain Name Server
                if (this.obj_Domain.DomainNameServer && this.obj_Domain.DomainNameServer.length) {
                    this.obj_Domain.DNS = this.obj_Domain.DomainNameServer.map(dns => dns.DNS).join(',');
                }

                // Handle SEO settings
                this.obj_Domain.SEOR = this.obj_Domain.SRT && this.obj_Domain.SRT.length ? this.obj_Domain.SRT.join(',') : "";

                // Handle default values for ADI
                if (!this.obj_Domain.ADI) {
                    this.obj_Domain.ADI = "";
                }

                // Handle SMSV Pages and EV Pages
                this.obj_Domain.SMSVP = this.obj_Domain.SMSVPages ? this.obj_Domain.SMSVPages.join(',') : "";
                this.obj_Domain.EVP = this.obj_Domain.EVPages ? this.obj_Domain.EVPages.join(',') : "";


                // Update flags based on SLBL, SIBL, MSLBL
                this.obj_Domain.RSL = this.obj_Domain.SLBL !== this.bool_holSLBL && this.obj_Domain.SLBL;
                this.obj_Domain.RSI = this.obj_Domain.SIBL !== this.bool_holSIBL && this.obj_Domain.SIBL;
                this.obj_Domain.RMSL = this.obj_Domain.MSLBL !== this.bool_holMSLBL && this.obj_Domain.MSLBL;

                // Assign selected files
                this.obj_Domain.NSL = this.selectedFile;
                this.obj_Domain.NSI = this.selectedFileIco;
                this.obj_Domain.NMSL = this.selectedFileMsl;

                this.obj_Domain.L = this.obj_Domain.DS
                    .filter(setting => setting.TC) // Include only enabled settings
                    .map(setting => setting.L)     // Extract the language codes
                    .join(',');                   // Create a comma-separated string

                // Handle domain error validation
                if (this.bool_isAgentType) {
                    this.$v.obj_Domain.$touch();
                    if (!this.$v.obj_Domain.$error) {
                        this.bool_showDMSS = !this.bool_disableInsertDomain;
                    } else if (this.bool_disableInsertDomain) {
                        this.bool_showDMSS = false;
                    }
                }

                if (!this.$v.obj_Domain.$error) {
                    if (this.bool_disableInsertDomain) {
                        // Reset domain settings when disabled
                        Object.assign(this.obj_Domain, {
                            I: 0, RS: 0, CTS: "1900-01-01 00:00:00.000",
                            CBI: 0, CB: "skip", UTS: "1900-01-01 00:00:00.000",
                            UBI: 0, UB: "skip", AGI: 0, L: "", DL: "",
                            CC: "", SEOR: "", MIP: "", TID: "", SMSV: 0,
                            SMSVP: "", EV: 0, EVP: "", SIBL: 0, SLBL: 0,
                            IM: 0, DLFIP: 0, AFB1188SBAPI: "", MSLBL: 0
                        });
                    }
                }

                this.bool_groupCV = true;
                if (this.getUserInfo.AT === 1 || this.getUserInfo.AT === 2) {
                    this.bool_disableInsertDomain = true;
                }

                //grab domainId to pass to SelfServiceController
                if (!this.$v.obj_Domain.$error) {
                    var domainId = this.$route.query.di;
                    this.bool_fullLoading = true;
                    var that = this;

                    if (!this.bool_isAgentType) {
                        this.postDataApi(`/api/ag/s`, this.obj_Group,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.bool_isAMV = false;

                                    // reload agent group dropdown
                                    that.popUpAgentDetailModal(d.BD);
                                }
                            });
                    } else if (this.bool_isAgentType && checkValidLocalized == true) {
                        this.arry_aac['bool_isEditWebConfig'] = true;

                        /*var bool_deleteDomainCache = true;*/
                        this.postDataApiWithAttach(`/api/agss/sd`, {
                            "AgentGroup": this.obj_Group,
                            "Domain": this.obj_Domain,
                            "DomainId": domainId
                        },
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.bool_isAMV = false;

                                    // reload agent group dropdown
                                    that.popUpAgentDetailModal(d.BD);
                                }
                            });
                    }
                }
            },
            //Save Website Config Setting
            saveWebsiteConfig() {
                if (this.bool_EBANS) {
                    if (!this.arry_OnOff.BankBackOfficeSetting.AANE.CV && !this.arry_OnOff.BankBackOfficeSetting.AEWAS.CV) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["ALOBANS"]), 1000);
                        return;
                    }
                } else {
                    this.arry_OnOff.BankBackOfficeSetting.AANE.CV = false;
                    this.arry_OnOff.BankBackOfficeSetting.AEWAS.CV = false;
                }

                if (this.bool_EMBANS) {
                    if (!this.arry_OnOff.BankBackOfficeSetting.MAANE.CV && !this.arry_OnOff.BankBackOfficeSetting.MAEWAS.CV) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["ALOBANS"]), 1000);
                        return;
                    }
                } else {
                    this.arry_OnOff.BankBackOfficeSetting.MAANE.CV = false;
                    this.arry_OnOff.BankBackOfficeSetting.MAEWAS.CV = false;
                }

                if (this.bool_EMBANS_DC) {
                    if (!this.arry_CdOnOff.MAANE.CV && !this.arry_CdOnOff.MAEWAS.CV) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["ALOBANS"]), 1000);
                        return;
                    }
                } else {
                    this.arry_CdOnOff.MAANE.CV = false;
                    this.arry_CdOnOff.MAEWAS.CV = false;
                }

                if (this.bool_HFLQRC) {
                    if (!this.arry_OnOff.MemberSiteSetting.HSQRCM.CV && !this.arry_OnOff.MemberSiteSetting.HQRCBL.CV) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["ALOQRDO"]), 1000);
                        return;
                    }
                } else {
                    this.arry_OnOff.MemberSiteSetting.HSQRCM.CV = false;
                    this.arry_OnOff.MemberSiteSetting.HQRCBL.CV = false;
                }

                if (this.arry_OnOff.MemberSiteSetting.DODDS.CV) {
                    if (this.selectedSOTValue == "" || this.selectedSOTValue == undefined) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["SOT"]), 1000);
                        return;
                    }
                    if (this.selectedTOValue == "" || this.selectedTOValue == undefined) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["TO"]), 1000);
                        return;
                    }
                } 

                this.bool_disableInsertLiveChat = true;
                this.bool_disableInsertBank = true;
                this.bool_disableInsertDomain = true;

                var isRegWPhone = this.arry_OnOff.RegistrationSetting.REGWPHONE.CV;
                var isLocalized = this.arry_OnOff.RegistrationSetting.ULPN.CV;
                var isEPrefix = this.arry_OnOff.RegistrationSetting.UPCODE.CV;
                var checkValidLocalized = true;
                var emptyPrefix = false;
                this.arry_aac['RS'] = 2;
                this.arry_aac['SportOddsType'] = this.selectedSOTValue;
                this.arry_aac['ThemeOption'] = this.selectedTOValue;

                if (this.arry_aac.AGIT != null && this.arry_aac.AGIT.length > 0) {
                    var agi = this.arry_aac.AGIT.split("-");
                }

                //Turn any passed in object to false (or opposite of DC)
                const updateCV = (settings) => {
                    Object.keys(settings).forEach(key => {
                        settings[key].CV = !settings[key].DC;
                    });
                };

                ////Sets a default value if CV is true but radio group is empty
                //const updateCVDefaultValue = (optionKey, setting, defaultValue) => {
                //    if (!setting.CV) {
                //        this[optionKey] = "";
                //    } else if (this[optionKey] === "") {
                //        this[optionKey] = defaultValue;
                //    }
                //};

                //Set the selected radio button to true
                const updateCaptchaOption = (optionKey, setting) => {
                    if (this[optionKey] && setting[this[optionKey]]) {
                        setting[this[optionKey]].CV = setting[this[optionKey]].DC;
                    }
                };

                //Toggle CV for all Captchas
                updateCV(this.arry_OnOff.Captchas);

                //Toggle CV for all Payment Options
                updateCV(this.arry_OnOff.PaymentOptions);

                //Toggle CV for all Passowrd Options
                updateCV(this.arry_OnOff.PasswordOptions);

                //Sets default value for Captcha Option if found empty
                //updateCVDefaultValue('str_WebConfigCaptchaOption', this.arry_OnOff.Captchas.DCC, "DCC");

                //Removed for TT9958
                //Sets default value for Preferred Deposit Option if found empty
                //updateCVDefaultValue('str_PreferredDepositOption', this.arry_OnOff.BankBackOfficeSetting.PDO, "MD");

                //Sets default value for Tournament Option if found empty
                //updateCVDefaultValue('str_TournamentNavOption', this.arry_OnOff.TournamentOptions.DTMB, "DTMB");

                ////Sets default value for Forgot Password Option if found empty
                //updateCVDefaultValue('str_ForgotPasswordLinkOption', this.arry_OnOff.PasswordOptions.FPDTMB, "FPDTMB");

                //Enables the selected radio button for Captcha Option
                updateCaptchaOption('str_WebConfigCaptchaOption', this.arry_OnOff.Captchas);

                //Removed for TT9958
                //Enables the selected radio button for Preferred Deposit Option
                //updateCaptchaOption('str_PreferredDepositOption', this.arry_OnOff.BankBackOfficeSetting);
 
                //Enables the selected radio button for Forgot Password Option
                updateCaptchaOption('str_ForgotPasswordLinkOption', this.arry_OnOff.PasswordOptions);

                //Enables the selected radio button for Tournament Option
                updateCaptchaOption('str_TournamentNavOption', this.arry_OnOff.TournamentOptions);

                this.arry_OnOff.RegistrationSetting.FNM.CV = this.arry_OnOff.RegistrationSetting.FNM.CV || this.arry_OnOff.BankBackOfficeSetting.FNABAN.CV;

                if (this.arry_OnOff.MemberSiteSetting.DSAB.CV) {
                    this.arry_aac.InactiveDays = -1;
                }

                this.arry_OnOff.MemberSiteSetting.GLIFSW.CV = this.arry_OnOff.MemberSiteSetting.GLIF.CV && this.arry_OnOff.MemberSiteSetting.GLIFSW.CV;
                this.arry_OnOff.MemberSiteSetting.DLGFML.CV = this.arry_OnOff.MemberSiteSetting.EGPLL.CV && this.arry_OnOff.MemberSiteSetting.DLGFML.CV;



                // Save all CV equal to DC settings into arry_aac.nCuzView
                this.arry_aac.nCuzView = [];
                Object.entries(this.arry_OnOff).forEach(([categoryKey, categoryValue]) => {
                    if (typeof categoryValue === 'object') {
                        Object.entries(categoryValue).forEach(([key, value]) => {
                            if (value.CV === value.DC) {
                                this.arry_aac.nCuzView.push(key);
                            }
                        });
                    }
                });

                // Validate Social Media settings
                if (this.arry_OnOff.RegistrationSetting.SM.CV) {
                    const socialMediaKeys = ['WCID', 'LID', 'WAID', 'TGID', 'ZLID'];
                    const validSocialMedia = socialMediaKeys.some(key => this.arry_OnOff.RegistrationSetting[key].CV);
                    if (!validSocialMedia) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["SMCODE"]), 1000);
                        checkValidSocialMedia = false;
                    }
                }

                if (this.getUserInfo.AT == 1 || this.getUserInfo.AT == 2) {
                    this.bool_disableInsertAgentMembersiteConfig = true;
                }

                if (checkValidLocalized == true) {
                    if (this.bool_disableInsertAgentMembersiteConfig) {
                        this.arry_aac.CB = "skip";
                        this.arry_aac.UB = "skip";
                    }
                }

                this.bool_groupCV = true;
                this.bool_fullLoading = true;
                var that = this;

                if (!this.bool_isAgentType) {

                    this.postDataApi(`/api/ag/s`, this.obj_Group,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;

                                // reload agent group dropdown
                                that.popUpAgentDetailModal(d.BD);
                            }
                        });
                } else if (this.bool_isAgentType && checkValidLocalized == true) {
                    this.arry_aac['bool_isEditWebConfig'] = true;
                    /*var bool_deleteDomainCache = true;*/
                    this.postDataApiWithAttach(`/api/agss/sw`, {
                        "AgentGroup": this.obj_Group,
                        "Domain": this.obj_Domain,
                        "AgentMembersiteConfig": this.arry_aac
                    },
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;

                                // reload agent group dropdown
                                that.popUpAgentDetailModal(d.BD);
                            }
                        });
                }
            },
            //Save Livechat Config
            saveLivechatConfig() {
                var checkValidLocalized = true;

                this.bool_showLCS = true;
                this.bool_disableInsertDomain = true;
                this.bool_disableInsertBank = true;
                this.bool_disableInsertLiveChat = false;


                if (this.bool_isAgentType && !this.bool_disableInsertLiveChat) {
                    this.$v.obj_livechat.$touch();
                    if (!this.$v.obj_livechat.$error) {
                        this.bool_showLCS = false;
                    }
                } else if (this.bool_isAgentType && this.bool_disableInsertLiveChat) {
                    this.bool_showLCS = false;
                }

                setTimeout(() => {
                    $(".ErrMsg").each(function (index) {
                        if ($(this).text()) {
                            $('html, body').animate({
                                scrollTop: $(this).parent().offset().top - 70
                            }, 'smooth');
                            return false;
                        }
                    });
                }, 100)

                if (!this.$v.obj_livechat.$error) {
                    this.obj_livechat["L"] = [];
                    for (var i = 0; i < this.obj_livechat.arry_holdLang.length; i++) {
                        if (i != 0) {
                            this.obj_livechat["L"] += ",";
                        }
                        this.obj_livechat["L"] += this.obj_livechat.arry_holdLang[i];
                    }

                    if (this.newScriptFile == true || this.obj_livechat["I"] == 0) {
                        //if new File is selected
                        this.obj_livechat["configFile"] = this.selectedScriptFile;

                    } else if (this.newScriptFile == false && this.obj_livechat["I"] > 0) {
                        this.obj_livechat["configFile"] = null;
                        //if user edit, but want to retain file
                    }

                    if (this.bool_disableInsertLiveChat) {
                        this.obj_livechat.I = 0;
                        this.obj_livechat.RS = 0;
                        this.obj_livechat.CTS = "1900-01-01 00:00:00.000";
                        this.obj_livechat.CBI = 0;
                        this.obj_livechat.CB = "skip";
                        this.obj_livechat.UTS = "1900-01-01 00:00:00.000";
                        this.obj_livechat.UBI = 0;
                        this.obj_livechat.UB = "skip";
                        this.obj_livechat.AGI = 0;
                        this.obj_livechat.LCPI = "";
                        this.obj_livechat.L = "";
                        this.obj_livechat.LK = "";
                        this.obj_livechat.DI = 0;
                        this.obj_livechat.CURL = "";
                        this.obj_livechat.LCURL = "";
                    }
                }

                this.bool_groupCV = true;
                this.bool_fullLoading = true;
                var that = this;

                if (!this.bool_isAgentType) {

                    this.postDataApi(`/api/ag/s`, this.obj_Group,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;

                                // reload agent group dropdown
                                that.popUpAgentDetailModal(d.BD);
                            }
                        });
                } else if (this.bool_isAgentType && checkValidLocalized == true) {
                    this.arry_aac['bool_isEditWebConfig'] = true;
                    /*var bool_deleteDomainCache = true;*/
                    this.postDataApiWithAttach(`/api/agss/sl`, {
                        "AgentGroup": this.obj_Group,
                        "Domain": this.obj_Domain,
                        "LiveChat": this.obj_livechat
                    },
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;

                                // reload agent group dropdown
                                that.popUpAgentDetailModal(d.BD);
                            }
                        });
                }

            },
            // Save Customize Registration
            saveRegistrationConfig(isSimple = false) {
                this.bool_fullLoading = true;
                this.bool_CV = true;



                const { REGWPHONE: { CV: isRegWPhone }, ULPN: { CV: isLocalized }, UPCODE: { CV: isEPrefix } } = this.arry_CrOnOff;
                let checkValidLocalized = true;
                let emptyPrefix = false;

                this.arry_cr['RS'] = 2;
                if (this.arry_cr.AGIT != null && this.arry_cr.AGIT.length > 0) {
                    var agi = this.arry_cr.AGIT.split("-");
                    //this.arry_aac.AGI = agi[1];
                    //this.arry_aac.AgentGroupIds = this.arry_aac
                }

                const processMultiLangArray = (sourceArray, key) => {
                    return Object.entries(sourceArray).reduce((acc, [langKey, value]) => {
                        if (langKey) {
                            acc.push({ L: langKey, [key]: value });
                        }
                        return acc;
                    }, []);
                };

                //Hold all TMultiLangList into 1 object
                const arraysToProcess = {
                    TMultiLangUIList: { array: this.array_ui, key: 'UI' },
                    TMultiLangFNList: { array: this.array_fn, key: 'FN' },
                    TMultiLangPNList: { array: this.array_pn, key: 'PN' },
                    TMultiLangPWList: { array: this.array_pw, key: 'PW' },
                    TMultiLangCPWList: { array: this.array_cpw, key: 'CPW' },
                    TMultiLangSCList: { array: this.array_sc, key: 'SC' },
                    TMultiLangSBList: { array: this.array_sbk, key: 'SB' },
                    TMultiLangANMList: { array: this.array_anm, key: 'ANM' },
                    TMultiLangANList: { array: this.array_an, key: 'AN' },
                    TMultiLangEMList: { array: this.array_em, key: 'EM' },
                    TMultiLangRCList: { array: this.array_rc, key: 'RC' },
                    TMultiLangWCList: { array: this.array_wc, key: 'WC' },
                    TMultiLangWAList: { array: this.array_wa, key: 'WA' },
                    TMultiLangLNList: { array: this.array_ln, key: 'LN' },
                    TMultiLangTGList: { array: this.array_tg, key: 'TG' },
                    TMultiLangZLList: { array: this.array_zl, key: 'ZL' }
                };

                //Process all arrays in 1 single loop
                for (const [listName, { array, key }] of Object.entries(arraysToProcess)) {
                    this.arry_cr[listName] = processMultiLangArray(array, key);
                }

                if (!isSimple) {
                    this.arry_cr.nCuzView = Object.entries(this.arry_CrOnOff)
                        .filter(([key, value]) => value.CV === value.DC)
                        .map(([key]) => key);
                }

                this.$v.arry_cr.$touch();

                if (!this.$v.arry_cr.$error) {
                    if (isRegWPhone && isLocalized) {
                        if (!this.arry_cr.LocalisedList.length) {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage.ACO.RPCODE), 1000);
                            checkValidLocalized = false;
                        } else if (isEPrefix) {
                            emptyPrefix = this.arry_cr.LocalisedList.some(item => !item.PC);
                            if (emptyPrefix) {
                                this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage.ACO.EMPCODE), 1000);
                                checkValidLocalized = false;
                            }
                        }
                    } else if (isRegWPhone) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage.ACO.RPCODE), 1000);
                        checkValidLocalized = false;
                    }

                    if (this.bool_isAgentType) {
                        this.$v.arry_cr.$touch();
                        if (!this.$v.arry_cr.$error) {
                            this.bool_showCR = false;
                        }
                    }

                    this.bool_groupCV = true;

                    if (checkValidLocalized) {
                        this.postDataApi('/api/rcuz/s', this.arry_cr, (d, s) => {
                            if (s) {
                                this.bool_isAMV = false;
                                this.popUpAgentDetailModal(d.BD);
                            }

                            // Set loading to false only if bool_copyCuzReg is not true
                            if (!this.bool_copyCuzReg) {
                                this.bool_fullLoading = false;
                            }
                        });
                    } else {
                        this.bool_fullLoading = false;
                    }
                } else {
                    this.bool_fullLoading = false;
                    const validation = this.$v["arry_cr"];
                    if (validation) {
                        const input = this.findRequiredInput(validation, this.$refs);
                        if (input && typeof input.focus === "function") {
                            input.focus();
                        }
                    }
                }
            },
            //Save Bank Account Settings
            saveBankAccountConfig() {
                var checkValidLocalized = true;

                this.bool_disableInsertBank = false;

                this.bool_errminmax = false;
                if (this.obj_bankacc.MIND != 0 && this.obj_bankacc.MIND != null && this.obj_bankacc.MAXD != 0 && this.obj_bankacc.MAXD != null) {
                    if (parseFloat(this.obj_bankacc.MIND) < parseFloat(this.obj_bankacc.MAXD)) {
                        this.bool_errminmax = true;
                    }
                    else {
                        this.bool_errminmax = false;
                    }
                } else {
                    this.bool_errminmax = true;
                }
                if (this.obj_bankacc.MINW != 0 && this.obj_bankacc.MINW != null && this.obj_bankacc.MAXW != 0 && this.obj_bankacc.MAXW != null) {
                    if (parseFloat(this.obj_bankacc.MINW) < parseFloat(this.obj_bankacc.MAXW)) {
                        this.bool_errminmax = true;
                    }
                    else {
                        this.bool_errminmax = false;
                    }
                } else {
                    this.bool_errminmax = true;
                }
                this.obj_bankacc.BAN = this.obj_bankacc.BAN.replace(/[^0-9a-z]/gi, ''); // TT2791 remove nonAlphaNum and whitespace before saving
                var iurlTab = this.getIURLTabIndex("#imageURLTab3");
                if (iurlTab != 1) { // external img url
                    if (this.obj_bankacc.QRCI != null && this.obj_bankacc.QRCI != "") {
                        //if img url is not empty
                        this.obj_bankacc.IUT = true;
                        this.newImg = true;
                    }
                }

                this.bool_groupCV = true;

                if (this.getUserInfo.AT == 1 || this.getUserInfo.AT == 2) {
                    this.bool_disableInsertBank = true;
                }


                this.bool_showBS = true;

                if (this.bool_isAgentType && !this.bool_disableInsertBank) {
                    this.$v.obj_bankacc.$touch();
                    if (!this.$v.obj_bankacc.$error) {
                        this.bool_showBS = false;
                    }
                } else if (this.bool_isAgentType && this.bool_disableInsertBank) {
                    this.bool_showBS = false;
                }

                setTimeout(() => {
                    $(".ErrMsg").each(function (index) {
                        if ($(this).text()) {
                            $('html, body').animate({
                                scrollTop: $(this).parent().offset().top - 70
                            }, 'smooth');
                            return false;
                        }
                    });
                }, 100)

                if (!this.$v.obj_Group.$error && !this.$v.obj_Domain.$error && this.str_prefixError == "" && checkValidLocalized == true && !this.$v.obj_livechat.$error && !this.$v.obj_bankacc.$error && this.bool_errminmax) {
                    this.obj_bankacc.MT = '';
                    if (this.obj_bankacc.MTV && this.obj_bankacc.MTV.length > 0 && this.obj_bankacc.VIPBA) {
                        this.obj_bankacc.MT = this.obj_bankacc.MTV.join(',');
                    }
                    this.obj_bankacc.ID = this.obj_bankacc.ID == 1 ? true : false;
                    this.obj_bankacc.IW = this.obj_bankacc.IW == 1 ? true : false;
                    this.obj_bankacc.IA = this.obj_bankacc.IA == null ? 0 : this.obj_bankacc.IA;
                    if (this.newImg == true) {
                        this.obj_bankacc['QRCodeImage'] = this.selectedFile;
                    }

                    if (this.bool_disableInsertBank) {
                        this.obj_bankacc.I = 0;
                        this.obj_bankacc.RS = 0;
                        this.obj_bankacc.CTS = "1900-01-01 00:00:00.000";
                        this.obj_bankacc.CBI = "";
                        this.obj_bankacc.CB = "skip";
                        this.obj_bankacc.UTS = "1900-01-01 00:00:00.000";
                        this.obj_bankacc.UBI = 0;
                        this.obj_bankacc.UB = "skip";
                        this.obj_bankacc.BI = 0;
                        this.obj_bankacc.BA = "";
                        this.obj_bankacc.BAN = "";
                        this.obj_bankacc.CI = 0;
                        this.obj_bankacc.AB = 0;
                        this.obj_bankacc.MIND = 0;
                        this.obj_bankacc.MAXD = 0;
                        this.obj_bankacc.MINW = 0;
                        this.obj_bankacc.MAXW = 0;
                        this.obj_bankacc.TD = 0;
                        this.obj_bankacc.TW = 0;
                        this.obj_bankacc.ID = 0;
                        this.obj_bankacc.IW = 0;
                        this.obj_bankacc.AGI = 0;
                        this.obj_bankacc.BU = "";
                        this.obj_bankacc.BP = "";
                        this.obj_bankacc.SS = 0;
                        this.obj_bankacc.IA = 0;
                        this.obj_bankacc.ADS = "";
                        this.obj_bankacc.ADR = "";
                        this.obj_bankacc.LPUTS = "";
                        this.obj_bankacc.QRCI = "";
                        this.obj_bankacc.VIPBA = 0;
                        this.obj_bankacc.VIPBA = "";
                        this.obj_bankacc.TUD = 0;
                        this.obj_bankacc.BICN = "";
                        this.obj_bankacc.BDOB = "";
                        this.obj_bankacc.BMN = "";
                        this.obj_bankacc.BAP = "";
                        this.obj_bankacc.BDI = "";
                        this.obj_bankacc.BCT = "";
                    }
                }

                this.bool_fullLoading = true;
                var that = this;

                if (!this.bool_isAgentType) {

                    this.postDataApi(`/api/ag/s`, this.obj_Group,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;

                                // reload agent group dropdown
                                that.popUpAgentDetailModal(d.BD);
                            }
                        });
                } else if (this.bool_isAgentType && checkValidLocalized == true) {
                    this.arry_aac['bool_isEditWebConfig'] = true;
                    /*var bool_deleteDomainCache = true;*/
                    this.postDataApiWithAttach(`/api/agss/sb`, {
                        "AgentGroup": this.obj_Group,
                        "Domain": this.obj_Domain,
                        "BankAccount": this.obj_bankacc
                    },
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.bool_isAMV = false;
                                // reload agent group dropdown
                                that.popUpAgentDetailModal(d.BD);
                            }
                        });
                }

            },
            //Save Customize Deposit
            saveDepositConfig(isSimple = false) {

                this.bool_fullLoading = true;
                this.bool_CV = true;

                const checkValidLocalized = true;
                //const emptyPrefix = false;

                this.arry_cd['RS'] = 2;
                if (this.arry_cd.AGIT != null && this.arry_cd.AGIT.length > 0) {
                    var agi = this.arry_cd.AGIT.split("-");
                    //this.arry_aac.AGI = agi[1];
                    //this.arry_aac.AgentGroupIds = this.arry_aac
                }

                const processMultiLangArray = (sourceArray, key) => {
                    return Object.entries(sourceArray).reduce((acc, [langKey, value]) => {
                        if (langKey) {
                            acc.push({ L: langKey, [key]: value });
                        }
                        return acc;
                    }, []);
                };

                //Hold all TMultiLangList into 1 object
                const arraysToProcess = {
                    TMultiLangDAList: { array: this.array_da, key: 'DA' },
                    TMultiLangCYAList: { array: this.array_cya, key: 'CYA' },
                    TMultiLangSBList: { array: this.array_sb, key: 'SB' },
                    TMultiLangDTODList: { array: this.array_dtod, key: 'DTOD' },
                    TMultiLangTIList: { array: this.array_ti, key: 'TI' },
                    TMultiLangURList: { array: this.array_ur, key: 'UR' },
                    TMultiLangPList: { array: this.array_p, key: 'P' },
                    TMultiLangNList: { array: this.array_n, key: 'N' }
                };

                //Process all arrays in 1 single loop
                for (const [listName, { array, key }] of Object.entries(arraysToProcess)) {
                    this.arry_cd[listName] = processMultiLangArray(array, key);
                }

                if (!isSimple) {
                    this.arry_cd.nCuzView = Object.entries(this.arry_CdOnOff).reduce((acc, [key, value]) => {
                        const specialKeys = ['DAB_DCUZ', 'DTID_DCUZ', 'DQRD_DCUZ', 'DDTOD_DCUZ', 'DUR_DCUZ', 'DSP_DCUZ', 'DPTB_DCUZ'];
                        const condition = specialKeys.includes(key) ? value.CV !== value.DC : value.CV === value.DC;
                        if (condition) acc.push(key);
                        return acc;
                    }, []);
                }

                this.arry_cd.DepositBankReceipt = this.arry_cd.DepositBankReceipt && this.arry_cd.DepositBankReceipt.length > 0
                    ? JSON.stringify(this.arry_cd.DepositBankReceipt)
                    : "";


                this.$v.arry_cd.$touch();

                if (!this.$v.arry_cd.$error) {

                    if (this.bool_isAgentType) {
                        this.$v.arry_cd.$touch();
                        if (!this.$v.arry_cd.$error) {
                            this.bool_showCD = false;
                        }
                    }

                    this.bool_groupCV = true;

                    var that = this;
                    if (checkValidLocalized == true) {
                        this.postDataApi(`/api/dcuz/s`, this.arry_cd,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.bool_isAMV = false;
                                    // reload agent group dropdown
                                    that.popUpAgentDetailModal(d.BD);
                                    //that.$root.UserInfo.getInfoApi(that);

                                }
                            });
                    } else {
                        this.bool_fullLoading = false;
                    }
                }
                else {
                    this.bool_fullLoading = false;
                    //get the object for validating.
                    const validation = this.$v["arry_cd"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            ParentGroupChange(value) {
                //this.bool_fullLoading = true;


                var agi = 0;
                if (value && value != "") {
                    agi = value.split("-");

                    if (agi[0] == "2") {
                        this.bool_isAgentType = true;
                        this.bool_isSeniorMasterLv = false;
                    }
                    else if (agi[0] == "0") {
                        this.bool_isSeniorMasterLv = true;
                        this.bool_isAgentType = false;
                    }
                    else {
                        this.bool_isAgentType = false;
                        this.bool_isSeniorMasterLv = false;
                    }

                    this.obj_Group.OEMI = 0;
                    if (this.obj_Group.I == 0) {
                        var that = this;
                        this.getDataApi(`/api/ag/gb/${agi[1]}/0`,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.dec_availablebalance = that.formatNumber(d.D.TB - d.D.BL, 2, d.D.CS);
                                    if (d.D.CS == "$") {
                                        that.dec_availablebalanceusd = that.dec_availablebalance;
                                    }
                                    else {
                                        that.dec_availablebalanceusd = that.formatNumber((d.D.TB - d.D.BL) / d.D.USDER, 2, d.D.USDCS);
                                    }
                                    that.str_ptrange = "0.00% - " + d.D.PT.toFixed(2) + "%";
                                    that.obj_Group.MaxPT = d.D.PT;
                                    that.obj_Group.OEMI = d.D.OEMI;

                                    //removed to allow system balance to follow agent
                                    //that.obj_Group.DCI = d.D.DCI;
                                    that.CurrencyChange(that.obj_Group.DCI);

                                    if (d.D.OEMI == 2) {
                                        if (that.obj_Group.I == 0) {
                                            that.obj_Group.PC = d.D.PC;
                                            that.str_houtOriPrefix = d.D.PC;
                                        }
                                        if (!(agi[0] == "1")) {
                                            that.obj_Group.DCI = d.D.CI;
                                            if (that.bool_isAgentType) {
                                                that.obj_Group.CurrencyIds = [d.D.CI];
                                            }
                                        }
                                    }
                                    else {
                                        that.str_houtOriPrefix = "";
                                    }
                                }
                            });

                        if (this.bool_isAgentType) {
                            this.getDataApi(`/api/ag/gpt`,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    if (s) {
                                        that.dd_GPDefaultPT = d.D.Items;
                                    }
                                });
                        }
                    }
                }
                this.checkSelectAllGPButton();
                this.checkSelectAllLangButton();
                this.checkSelectAllCurButton();
            },
            disableAgentGroupParent(item, index) {
                if (item.children && item.children.length > 0) {
                    var agi = item.id.split("-");
                    if (agi[0] == "2") {
                        item.children.splice(0, item.children.length);
                        item.children = null;
                        delete item.children;
                    }
                    else {
                        item.children.forEach(this.disableAgentGroupParent);
                    }
                }
            },
            disableAgentGroupParent3(item, index) {
                var agi = item.id.split("-");

                if (agi[0] != "3" && agi[0] != "4") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent3);
                }
            },
            getDropdownList() {
                this.dd_seorobots = this.appendSelectAllOption(constSEORobots);
                this.dd_verificationpage = this.appendSelectAllOption(constVerificationPage);

                var that = this;
                if (this.dd_language.length == 0 && this.dd_language_wall.length == 0) {
                    this.getDataApi(`/api/dd/lang/0`,
                        function (d, s) {
                            if (s) {
                                that.dd_language = d.dropdownlist;
                                that.dd_language.sort((a, b) => {
                                    // Push 'en' to the very top
                                    if (a.id === 'en') return -1;
                                    if (b.id === 'en') return 1;

                                    // Sort alphabetically by label
                                    return a.label.localeCompare(b.label);
                                });

                                that.dd_language_wall = that.appendSelectAllOption(d.dropdownlist);
                                that.dd_language_wall[0].children.sort((a, b) => {
                                    // Push 'en' to the very top
                                    if (a.id === 'en') return -1;
                                    if (b.id === 'en') return 1;

                                    // Sort alphabetically by label
                                    return a.label.localeCompare(b.label);
                                });

                                var DS = [];
                                for (var i = 0; i < that.dd_language.length; i++) {
                                    DS[i] = {
                                        "I": 0,
                                        "TC": false,
                                        "LE": true,
                                        "L": that.dd_language[i].id,
                                        "LN": that.dd_language[i].label,
                                        "CC": null,
                                        "CurrencyCodes": [],
                                        "TI": null,
                                        "TSI": null,
                                        "MTI": null,
                                        "MTSI": null,
                                        "TIALT": null,
                                        "TSIALT": null,
                                        "MTIALT": null,
                                        "MTSIALT": null,
                                        "AMT": false,
                                        "AMTALT": false,
                                        "EETAD": 0,
                                        "GPI": "",
                                        "GameProviderIdS": [],
                                        "CURL": "",
                                        "GCURL": "",
                                        "ALTCURL": "",
                                        "ALTGCURL": "",
                                        "MCURL": "",
                                        "MGCURL": "",
                                        "ALTMCURL": "",
                                        "ALTMGCURL": "",
                                        "AFB1188SW": "W0",
                                        "AFB1188SM": "W0",
                                        "AFB1188OS": "HK",
                                        "AFB1188OM": "Single",
                                        "DSN1": "Skin 1",
                                        "DSN2": "Skin 2",
                                    };
                                }
                                that.$set(that.$data.obj_Domain, 'DS', DS);
                            }
                        });
                }

                if (this.dd_currency.length == 0 && this.dd_currency_wall.length == 0) {
                    this.getDataApi('/api/dd/cur/0',
                        function (d, s) {
                            if (s) {
                                if (d.dropdownlist != null && d.dropdownlist.length > 0) {
                                    for (var i = 0; i < d.dropdownlist.length; i++) {
                                        if (d.dropdownlist[i].ICT == true)
                                            that.dd_currencyICT.push(d.dropdownlist[i]);
                                        else
                                            that.dd_currencyNonICT.push(d.dropdownlist[i]);
                                    }
                                }

                                if (that.obj_Group.ICT) {
                                    that.dd_currency = [];
                                    that.dd_currency.push(that.dd_currencyNonICT.find(f => f.label === 'USD'));
                                    that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyICT);
                                }
                                else {
                                    that.dd_currency = that.dd_currencyNonICT;
                                    that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyNonICT);
                                }

                                that.dd_currency.sort((a, b) => {
                                    // Push 'en' to the very top
                                    //if (a.id === 'en') return -1;
                                    //if (b.id === 'en') return 1;

                                    // Sort alphabetically by label
                                    return a.label.localeCompare(b.label);
                                });

                                that.dd_currency_wall[0].children.sort((a, b) => {
                                    // Push 'en' to the very top
                                    //if (a.id === 'en') return -1;
                                    //if (b.id === 'en') return 1;

                                    // Sort alphabetically by label
                                    return a.label.localeCompare(b.label);
                                });
                            }
                        });
                }

                if (this.dd_currency_h2p.length == 0) {
                    this.getDataApi('/api/dd/cur-pg/1',
                        function (d, s) {
                            if (s) {
                                that.dd_currency_h2p = that.appendSelectAllOption(d.dropdownlist);
                            }
                        });
                }
                
                if (this.dd_agentgroup.length == 0 && this.dd_agentgroup2.length == 0) {

                    //if "Create", it will function as normal
                    if (this.$route.query.agi == undefined) {
                        this.getDataApi(`/api/dd/ag/1/0/0/0/0/0`,
                            function (d, s) {
                                if (s) {

                                    //dd_agentgroup2 = copyGroup
                                    //dd_agentgroup = Parent Group
                                    that.dd_agentgroup2 = that.deepClone(d.dropdownlist);

                                    //temporary fix to remove 0 from agent brand
                                    that.dd_agentgroup2 = that.dd_agentgroup2.filter(item => item.label !== "0");

                                    if (that.dd_agentgroup2.length > 0) {
                                        that.dd_agentgroup2.forEach(that.disableAgentGroupParent3);
                                    }

                                    that.dd_agentgroup = d.dropdownlist;
                                    that.dd_agentgroup = that.dd_agentgroup.filter(item => item.label !== "0");

                                    if (that.dd_agentgroup.length > 0) {
                                        that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                                    }
                                }
                            });
                    } else {
                        //if "Edit", it will get all agent brands but it will be uneditable
                        this.getDataApi(`/api/dd/ag/1/0/0/0/0/1`,
                            function (d, s) {
                                if (s) {
                                    that.dd_agentgroup2 = that.deepClone(d.dropdownlist);
                                    that.dd_agentgroup2 = that.dd_agentgroup2.filter(item => item.label !== "0");

                                    if (that.dd_agentgroup2.length > 0) {
                                        that.dd_agentgroup2.forEach(that.disableAgentGroupParent3);
                                    }

                                    that.dd_agentgroup = d.dropdownlist;
                                    that.dd_agentgroup = that.dd_agentgroup.filter(item => item.label !== "0");
                                    if (that.dd_agentgroup.length > 0) {
                                        that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                                    }
                                }
                            });
                    }

                    //this.getDataApi(`/api/dd/ag/1/0`,
                    //this.getDataApi(`/api/dd/ag/1/0/0/0/0/1`,
                    //    function (d, s) {
                    //        if (s) {
                    //            that.dd_agentgroup2 = that.deepClone(d.dropdownlist);
                    //            if (that.dd_agentgroup2.length > 0) {
                    //                that.dd_agentgroup2.forEach(that.disableAgentGroupParent3);
                    //            }

                    //            that.dd_agentgroup = d.dropdownlist;
                    //            if (that.dd_agentgroup.length > 0) {
                    //                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                    //            }
                    //        }
                    //    });
                }

                //OEM only appear for Superadmin Level & SM Level
                if ((this.getUserInfo.AT == 0 || this.getUserInfo.AT == 1) && this.dd_oem.length == 0) {
                    this.getDataApi(`/api/dd/oem`,
                        function (d, s) {
                            if (s) {
                                that.dd_oem = d.dropdownlist;
                            }
                        });
                }

                if (this.dd_template.length == 0) {
                    this.getDataApi(`/api/dd/tp/1`,
                        function (d, s) {
                            if (s) {
                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    d.dropdownlist[i].label = that.renderTemplateName(d.dropdownlist[i].label);
                                }

                                d.dropdownlist.sort((a, b) => {
                                    let fa = a.label.toLowerCase(),
                                        fb = b.label.toLowerCase();

                                    if (fa === 'casino ug') {
                                        return -1;
                                    } else if (fb === 'casino ug') {
                                        return 1;
                                    }

                                    if (fa < fb) {
                                        return -1;
                                    }
                                    if (fa > fb) {
                                        return 1;
                                    }
                                    return 0;
                                });

                                that.dd_template = d.dropdownlist;
                                //that.dd_fulltemplate=[...that.dd_fulltemplate,...d.dropdownlist];
                            }
                        });
                }

                if (this.dd_mtemplate.length == 0) {
                    this.getDataApi(`/api/dd/tp/2`,
                        function (d, s) {
                            if (s) {
                                for (var i = 0; i < d.dropdownlist.length; i++) {
                                    d.dropdownlist[i].label = that.renderTemplateName(d.dropdownlist[i].label);
                                }

                                d.dropdownlist.sort((a, b) => {
                                    let fa = a.label.toLowerCase(),
                                        fb = b.label.toLowerCase();

                                    if (fa === 'nbamobile') {
                                        return -1;
                                    } else if (fb === 'nbamobile') {
                                        return 1;
                                    }

                                    if (fa < fb) {
                                        return -1;
                                    }
                                    if (fa > fb) {
                                        return 1;
                                    }
                                    return 0;
                                });

                                that.dd_mtemplate = d.dropdownlist;
                                //that.dd_fulltemplate=[...that.dd_fulltemplate,...d.dropdownlist];
                            }
                        });
                }

                if (this.dd_theme.length == 0) {
                    this.getDataApi(`/api/dd/th`,
                        function (d, s) {
                            if (s) {
                                that.dd_theme = d.dropdownlist;
                            }
                        });
                }

                //if (this.obj_Group.CurrencyIds != null && this.obj_Group.CurrencyIds.length > 0) {
                //if (this.dd_gameprovider.length == 0) {
                //    this.selectSupportedCurrency()
                //}
            },
            selectSupportedCurrency(isCopyGroup = false) {

                this.bool_fullLoading = true;
                this.dd_gameprovider = [];
                var agi = 0;

                if (this.obj_Group.I == 0 && this.obj_Group.PGIT != null) {
                    agi = this.obj_Group.PGIT.split("-")[1];
                }
                else if (this.obj_Group.PGIT == null) {
                    agi = 0;
                }
                else {
                    agi = this.obj_Group.I;
                }

                //Check if CurrencyIds is empty
                if (!this.obj_Group.CurrencyIds || this.obj_Group.CurrencyIds.length === 0) {
                    this.dd_gameprovider = [];
                    this.obj_Group.GameProviderIds = [];
                    this.addHouseBrandGames();
                    this.bool_fullLoading = false;
                    return; 
                }

                if (this.dd_gameprovider.length == 0) {
                    var that = this;
                    if (!that.bool_isEditSelfService) {
                        that.obj_Group.GameProviderIds = [];
                    }

                    this.getDataApi('/api/dd/game/provbycur/' + agi + '/1' + '/CRD2',
                        function (d, s) {
                            if (s) {
                                that.bool_gameloaded = true;

                                //Process original dropdownlist (dd_gameprovider)
                                //for (var j = 0; j < d.dropdownlist.length; j++) {
                                //    if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                //        for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                //            if (d.dropdownlist[j].children[l].label in that.getLanguage['GP']) {
                                //                d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                //            }
                                //        }
                                //    }
                                //}

                                if (d == null || !d.dropdownlist || !Array.isArray(d.dropdownlist)) {
                                    //if CRD2 doesn't return any agi for a specific brand
                                    //may cause some games to show up unexpectedly. 
                                    that.getDDGameProvider(agi);
                                    return; 
                                } else {
                                    d.dropdownlist.forEach((item) => {
                                        if (item.children && item.children.length > 0) {
                                            item.children.forEach((child) => {
                                                if (child.label in that.getLanguage['GP']) {
                                                    child.label = that.renderProviderName(child.label);
                                                }
                                            });
                                        }
                                    });


                                    //Assign the original dropdownlist to dd_gameprovider
                                    var dd_gameproviderCompare = d.dropdownlist;

                                    that.getDataApi('/api/dd/game/provbycur/0/1/' + agi + '/' + that.obj_Group.CurrencyIds.join(','),
                                        function (d, s) {
                                            if (s) {
                                                that.dd_gameprovider = [];
                                                that.dd_gameprovider_cat = [];

                                                const GameProviderIds = [];

                                                //process list
                                                d.dropdownlist.forEach((item) => {
                                                    if (item.children && item.children.length > 0) {
                                                        item.children.forEach((child) => {
                                                            if (child.label in that.getLanguage['GP']) {
                                                                child.label = that.renderProviderName(child.label);
                                                            }

                                                            if (!that.bool_isEditSelfService) {
                                                                that.obj_Group.GameProviderIds.push(child.id);
                                                            } else {
                                                                GameProviderIds.push(child.id);
                                                            }
                                                        });

                                                        that.dd_gameprovider_cat.push({
                                                            id: item.id.split("-")[1],
                                                            label: item.label,
                                                        });
                                                    }
                                                });

                                                //sort list alphabetically. (by label)
                                                d.dropdownlist.forEach((item) => {
                                                    if (item.children && item.children.length > 0) {
                                                        item.children = _.sortBy(item.children, ['label']);
                                                    }
                                                });

                                                //for (var j = 0; j < d.dropdownlist.length; j++) {
                                                //    if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                                //        for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                                //            if (d.dropdownlist[j].children[l].label in that.getLanguage['GP']) {

                                                //                d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                                //            }

                                                //            if (!that.bool_isEditSelfService) {
                                                //                that.obj_Group.GameProviderIds.push(d.dropdownlist[j].children[l].id);
                                                //            }
                                                //            else {
                                                //                GameProviderIds.push(d.dropdownlist[j].children[l].id);
                                                //            }
                                                //        }

                                                //        that.dd_gameprovider_cat.push({
                                                //            id: d.dropdownlist[j].id.split("-")[1],
                                                //            label: d.dropdownlist[j].label,
                                                //        });
                                                //    }
                                                //}

                                                //for (var j = 0; j < d.dropdownlist.length; j++) {
                                                //    if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                                //        d.dropdownlist[j].children = _.sortBy(d.dropdownlist[j].children, ['label']);
                                                //    }
                                                //}

                                                that.dd_gameprovider = d.dropdownlist;

                                                //compare dd_gameProviderNew & dd_gameProvider (original)
                                                that.dd_gameprovider.forEach((provider) => {
                                                    if (provider.children && provider.children.length > 0) {
                                                        provider.children = provider.children.filter((originalChild) =>
                                                            dd_gameproviderCompare.some((compareDropdown) =>
                                                                compareDropdown.children && compareDropdown.children.some(
                                                                    (compareChild) => compareChild.label === originalChild.label
                                                                )
                                                            )
                                                        );
                                                    }
                                                });

                                                that.dd_gameprovider_cat.sort((a, b) => (parseInt(a.id) > parseInt(b.id)) ? 1 : -1)
                                                that.selectedGPCat = '0-' + that.dd_gameprovider_cat[0].id;

                                                //if (!that.bool_isEditSelfService) {
                                                //    that.bool_isEditSelfService = false;
                                                //} else {
                                                //    var a = that.obj_Group.GameProviderIds.filter(val => GameProviderIds.includes(val));
                                                //    that.obj_Group.GameProviderIds = _.uniq(a);
                                                //    //that.obj_Group.GameProviderIds = _.uniq(that.obj_Group.GameProviderIds);
                                                //    that.obj_Group.GPI = that.obj_Group.GameProviderIds.join(',');
                                                //}

                                                if (that.bool_isEditSelfService) {
                                                    const validGameProviderIds = that.obj_Group.GameProviderIds.filter(val => GameProviderIds.includes(val));
                                                    that.obj_Group.GameProviderIds = _.uniq(validGameProviderIds);
                                                    that.obj_Group.GPI = that.obj_Group.GameProviderIds.join(',');
                                                } else {
                                                    that.bool_isEditSelfService = false;
                                                }

                                                var check = that.obj_Group.GameProviderIds.filter(val => constSpecialProviders.includes(val));
                                                for (var i in check) {
                                                    if (that.SpecialProviders.includes(check[i])) {
                                                        that.checkSpecialProviders = true;
                                                    }
                                                }
                                                that.bool_fullLoading = false;
                                                that.checkSelectAllGPButton();
                                            }
                                            else {
                                                //if not successful, return immediately.
                                                return;
                                            }
                                        }
                                    )
                                }
                            }
                            else {
                                //if not successful, return immediately.
                                return;
                            }
                        });
                }
            },
            getDDGameProvider(agi) {
                var that = this;
                this.getDataApi('/api/dd/game/provbycur/0/1/' + agi + '/' + this.obj_Group.CurrencyIds.join(','),
                    function (d, s) {
                        if (s) {
                            that.dd_gameprovider = [];
                            that.dd_gameprovider_cat = [];
                            const GameProviderIds = [];
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP']) {

                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                        }

                                        if (!that.bool_isEditSelfService) {
                                            that.obj_Group.GameProviderIds.push(d.dropdownlist[j].children[l].id);
                                        }
                                        else {
                                            GameProviderIds.push(d.dropdownlist[j].children[l].id);
                                        }
                                    }

                                    that.dd_gameprovider_cat.push({
                                        id: d.dropdownlist[j].id.split("-")[1],
                                        label: d.dropdownlist[j].label,
                                    });
                                }
                            }

                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    d.dropdownlist[j].children = _.sortBy(d.dropdownlist[j].children, ['label']);
                                }
                            }

                            that.dd_gameprovider = d.dropdownlist;

                            that.dd_gameprovider_cat.sort((a, b) => (parseInt(a.id) > parseInt(b.id)) ? 1 : -1)
                            that.selectedGPCat = '0-' + that.dd_gameprovider_cat[0].id;

                            if (!that.bool_isEditSelfService) {
                                that.bool_isEditSelfService = false;
                            } else {
                                var a = that.obj_Group.GameProviderIds.filter(val => GameProviderIds.includes(val));
                                that.obj_Group.GameProviderIds = _.uniq(a);
                                //that.obj_Group.GameProviderIds = _.uniq(that.obj_Group.GameProviderIds);
                                that.obj_Group.GPI = that.obj_Group.GameProviderIds.join(',');
                            }
                            var check = that.obj_Group.GameProviderIds.filter(val => constSpecialProviders.includes(val));
                            for (var i in check) {
                                if (that.SpecialProviders.includes(check[i])) {
                                    that.checkSpecialProviders = true;
                                }
                            }
                            that.bool_fullLoading = false;
                            that.checkSelectAllGPButton();
                        }
                    });
            },
            closeAfterAdd() {
                this.bool_afterAdd = !this.bool_afterAdd;

                if (this.checkModuleAccess('ASS', 'AGS', this.constAccessType.view)) {
                    this.$router.push("/AGS/AGD");
                }
            },
            popUpAgentDetailModal(data) {
                if (data && data.IN) {
                    this.obj_BrandDetail = Object.assign(this.obj_BrandDetail, data);
                    this.bool_afterAdd = true;
                }
            },
            addHouseBrandGames() {
                for (const gameProviderId of this.constHouseBrand) {
                    this.obj_Group.GameProviderIds.push(gameProviderId)
                }
            },
            setObject() {
                this.obj_Group = {
                    "I": 0,
                    "RS": 2,
                    "GN": "",
                    "AT": "",
                    "PGI": "",
                    "PGIT": null,
                    "CPGIT": null,
                    "PC": "",
                    "SPC": "",
                    "PT": 0.00,
                    "DPT": 0.00,
                    "WLIPS": "",
                    "DCI": null,
                    "TB": 0.00,
                    "TCB": 0.00,
                    "CI": "",
                    "CurrencyIds": [],
                    "L": "",
                    "Language": ['en'],
                    "GPI": "",
                    "GameProviderIds": [],
                    "LB": 1,
                    "H2PU": "",
                    "H2PMC": "",
                    "H2PSC": "",
                    "H2PCC": "",
                    "H2PCurrencyCodes": null,
                    "OOPTHMN": "",
                    "OOPTHAS": "",
                    "OOPTHSK": "",
                    "OOPVIMN": "",
                    "OOPVIAS": "",
                    "OOPVISK": "",
                    "EZPIDRMN": "",
                    "EZPUSDMN": "",
                    "EZPUSDAS": "",
                    "EZPIDRAS": "",
                    "EZPMYRMN": "",
                    "EZPMYRAS": "",
                    "EZPTHBMN": "",
                    "EZPTHBAS": "",
                    "EZPVNDMN": "",
                    "EZPVNDAS": "",
                    "TUPVNDMN": "",
                    "TUPVNDAS": "",
                    "TUPMYRMN": "",
                    "TUPMYRAS": "",
                    "XFTHN": "",
                    "XFTHK": "",
                    "XFVIN": "",
                    "XFVIK": "",
                    "XFMYRN": "",
                    "XFMYRK": "",
                    "XFUSDTN": "",
                    "XFUSDTK": "",
                    "XFIDRN": "",
                    "XFIDRK": "",
                    "SPAK": "",
                    "SPMN": "",
                    "SUMYRAK": "",
                    //"SUMYRPOAK": "",
                    "SUMYRMN": "",
                    "SUMYRCN": "",
                    "SUTHBAK": "",
                    //"SUTHBPOAK": "",
                    "SUTHBMN": "",
                    "SUTHBCN": "",
                    "SUSGDAK": "",
                    "SUSGDMN": "",
                    "SUSGDCN": "",
                    "OOPIDMN": "",
                    "OOPIDAS": "",
                    "OOPIDSK": "",
                    "Agent": {
                        "I": 0,
                        "RS": 2,
                        "U": "",
                        "UP": "",
                        "CUP": "",
                        "DN": "",
                        "E": "",
                        "PN": ""
                    },
                    "WhiteListIP": [],
                    "ICT": false,
                    "MaxPT": 100,
                    "PMGW": []
                };

                this.addHouseBrandGames();
                //for (const gameProviderId of this.constHouseBrand) {
                //    this.obj_Group.GameProviderIds.push(gameProviderId)
                //}

                this.obj_Domain = {
                    "I": 0,
                    "RS": 1,
                    "DN": "",
                    "L": "",
                    "DL": "en",
                    "R": "",
                    "AGIT": null,
                    "AGI": "",
                    "SRT": null,
                    "SEOR": "",
                    "MIP": "",
                    "DNS": "",
                    "DS": [],
                    "TI": 1,
                    "SMSV": "1",
                    "SMSVP": "",
                    "SMSVPages": null,
                    "EV": "1",
                    "EVP": "",
                    "EVPages": null,
                    "SL": "",
                    "RSL": false,
                    "SLBL": false,
                    "SI": "",
                    "RSI": false,
                    "SIBL": false,
                    "ICONByLink": "",
                    "LOGOByLink": "",
                    "MaintenanceIP": [],
                    "DomainNameServer": [],
                    "RedirectTo": [],
                    "ALD": null,
                    "ADI": null,
                    "CN": "",
                    "SIP": "",
                    "PRBT": "2",
                    "PSEO": "1",
                    "MSL": "",
                    "MSLBL": false,
                    "RMSL": false,
                    "MobileLOGOByLink": "",
                    "UCF": true,
                    "RDT": null,
                    "DLFIP": 1,
                    "AFB1188SBAPI": "api.jps128.com",
                    "E2SSIM": false,
                };
                var DS = [];
                if (this.dd_language.length > 0) {
                    for (var i = 0; i < this.dd_language.length; i++) {
                        DS[i] = {
                            "I": 0,
                            "TC": false,
                            "LE": true,
                            "L": this.dd_language[i].id,
                            "LN": this.dd_language[i].label,
                            "CC": null,
                            "CurrencyCodes": [],
                            "TI": null,
                            "TSI": null,
                            "MTI": null,
                            "MTSI": null,
                            "TIALT": null,
                            "TSIALT": null,
                            "MTIALT": null,
                            "MTSIALT": null,
                            "AMT": false,
                            "AMTALT": false,
                            "EETAD": 0,
                            "GPI": "",
                            "GameProviderIdS": [],
                            "CURL": "",
                            "GCURL": "",
                            "ALTCURL": "",
                            "ALTGCURL": "",
                            "MCURL": "",
                            "MGCURL": "",
                            "ALTMCURL": "",
                            "ALTMGCURL": "",
                            "AFB1188SW": "W0",
                            "AFB1188SM": "W0",
                            "AFB1188OS": "HK",
                            "AFB1188OM": "Single",
                            "DSN1": "Skin 1",
                            "DSN2": "Skin 2",
                        };
                    }
                }
                this.$set(this.$data.obj_Domain, 'DS', DS);

                this.obj_ADomain = {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "DI": null,
                    "DN": "",
                    "DNS": "",
                    "DomainNameServer": [],
                    "ADI": null,
                    "RT": this.getDefaultRobotsTxt(),
                    "CN": "",
                    "UCF": true,
                    "index": -1,
                };

                this.obj_livechat = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AGI: null,
                    LCP: null,
                    L: "",
                    LK: null,
                    S: null,
                    R: null,
                    DI: (this.$route.query.di > 0) ? this.$route.query.di : 0,
                    AGIT: null,
                    arry_holdLang: [],
                    configFile: null,
                    LCURL: null
                };

                this.arry_cr = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    nCuzView: [],
                    AGI: "",
                    AGIT: null,
                    E_CC: "",
                    E_PC: "",
                    LocalisedList: [],
                    InactiveDays: 365,
                    Rate: 0,
                    DisabledProviderLobbies: [],
                    VTCRegisterDraggeBase: []
                };
                this.arry_cd = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    nCuzView: null,
                    DepositDraggeBase: [],
                    VTCDepositDraggeBase: [],
                    AGI: "",
                    AGIT: null,
                    CI: null,
                    E_CC: "",
                    E_PC: "",
                    LocalisedList: [],
                    InactiveDays: 365,
                    Rate: 0,
                    TMultiLangDepositList: []
                };

                this.showAgentConfig(1);
                this.arry_aac = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    nCuzView: null,
                    AGI: "",
                    AGIT: null,
                    E_CC: "",
                    E_PC: "",
                    LocalisedList: [],
                    InactiveDays: 365,
                    Rate: 0,
                    DisabledProviderLobbies: [],
                    VTCRegisterDraggeBase: []
                };

                this.arry_OnOff = {
                    //"DGPL": { CV: false, DC: true }, //Disable Game Provider Lobbies
                    //"SL": { CV: true, DC: true }, //Simple Login

                    //Captchas: {
                    //    "DCC": {CV: false, DC: true}, //Disable Captcha (Default)
                    //    "CCAOLN": {CV: false, DC: true}, //Alphabets Only
                    //    "CCALPN": {CV: false, DC: true}, //Alphanumeric
                    //    "CCNO": {CV: false, DC: true}, //Numeric Only
                    //},

                    //ForgotPassword: {
                    //    "FPDTMB": { CV: false, DC: true }, // Desktop & Mobile
                    //    "FPDT": { CV: false, DC: true }, //Desktop
                    //    "FPMB": { CV: false, DC: true }, //Mobile
                    //},

                    ////Captchas
                    //"DCC": { CV: false, DC: true }, //Disable Captcha
                    //"CCAOLN": { CV: false, DC: true }, //Alphabets Only
                    //"CCALPN": { CV: false, DC: true }, //Alphanumeric
                    //"CCNO": { CV: false, DC: true }, //Numeric Only
                    ////

                    //"RFWMP": { CV: false, DC: true }, //Register Form With Multiple Page
                    //"RWBA": { CV: true, DC: false }, //Register Without Bank Account
                    //"RWEA": { CV: false, DC: true }, //Register With Email/ RCUZ_check Duplicate Email
                    //"CDBACC": { CV: true, DC: true }, //Check Duplicate Bank Account
                    //"CDPNO": { CV: true, DC: true }, //Check Duplicate Phone Number
                    //"HMCI": { CV: false, DC: true }, //Hide Member Contact Info
                    //"NADBABA": { CV: false, DC: false }, //Not Allow Deposit Before Add Bank Account
                    //"DDB": { CV: false, DC: false }, //No Duplicate Withdraw Bank
                    //"NADBA": { CV: false, DC: false }, //Not Allow Delete Bank Account
                    //"NAABA": { CV: false, DC: false }, //Not Allow Add Bank Account
                    //"LMIAA": { CV: false, DC: false }, //Lock Member Info After Add
                    //"NBRWD": { CV: false, DC: true }, //Need Bank Receipt When Deposit
                    //"OWB": { CV: false, DC: false }, //Withdraw With One Bank Account Only
                    //"SSMRB": { CV: false, DC: true }, //Show Same Bank As Member Registered Bank
                    //"SHBAN": { CV: false, DC: true }, //Show Half Bank Account No.
                    //"HSCM": { CV: true, DC: false }, //Hide Side Contact Menu
                    //"HSQRCM": { CV: true, DC: false }, //Hide Side QR Code Menu
                    //"HICSM": { CV: true, DC: false }, //Hide Info Center Side Menu
                    //"SQRCSM": { CV: true, DC: true }, //Show QR Code Side Menu
                    //"RPN": { CV: false, DC: true }, //Required Phone No
                    //"REGWPHONE": { CV: false, DC: true }, //Register With Phone
                    //"HBLPU": { CV: true, DC: false }, //Hide Bet Limit POP UP
                    //"LD": { CV: false, DC: true }, //Login Disclaimer
                    //"DADIF": { CV: false, DC: true }, //Display Auto Deposit In-Front
                    //"HMDO": { CV: false, DC: true }, //Hide Manual Deposit Option
                    //"FNM": { CV: false, DC: true }, //Full Name Mandatory
                    //"FNABAN": { CV: false, DC: true }, //Full Name As Bank Account Name
                    //"DWOTT": { CV: false, DC: true }, //Transfer Amount Without 1:1000
                    //"ULPN": { CV: false, DC: true }, //Localised Country Code
                    //"UPCODE": { CV: false, DC: true }, //Enable Prefix Code
                    //"HCDIHO": { CV: true, DC: true }, //Hide Currency Dropdown If Having Only One Option

                    ////Duplicate
                    ////"DWOTT": { CV: false, DC: true }, //Transfer Amount Without 1:1000


                    //"DODDS": { CV: false, DC: true }, //Display Odds Iframe at Member Site
                    //"DDNF": { CV: false, DC: false }, //Disable Default News Feed
                    //"MDMIA": { CV: false, DC: true }, //Mask Downline Member Name in Affiliate
                    //"HMAN": { CV: false, DC: true }, //Hide Main Affiliate Name
                    //"EAFBFHP": { CV: false, DC: true }, //Display AFB1188 iframe at Member Site
                    //"DDLS": { CV: false, DC: true }, //Display Daily Lucky Spin before requirement
                    //"SRC": { CV: false, DC: true }, //Show Referral Code in Register Form
                    //"BABLBA": { CV: false, DC: true }, //Block All Black Listed Bank Account
                    //"ECF": { CV: false, DC: true }, //Enable Crypto Feature
                    //"HATT": { CV: false, DC: true }, //Hide Affiliate Tiering Table
                    //"EFPL": { CV: true, DC: true }, //Enable Forgot Password Link

                    ////Forgot Password



                    //"ETBN": { CV: false, DC: true }, //Enable Tournament Bottom Navigation
                    //"DTMB": { CV: true, DC: false }, //Desktop and Mobile
                    //"DT": { CV: false, DC: true }, //Desktop
                    //"MB": { CV: false, DC: true }, //Mobile
                    //"PDO": { CV: false, DC: true }, //Preferred Deposit Option
                    //"EFV": { CV: true, DC: false }, //Enable Full Version
                    //"MD": { CV: false, DC: true }, //Manual Deposit
                    //"AD": { CV: false, DC: true }, //Auto Deposit
                    //"ADP": { CV: false, DC: true }, //Auto Deposit Plus
                    //"HP": { CV: false, DC: true }, //Help2Pay
                    //"OP": { CV: false, DC: true }, //Oopay
                    //"EZP": { CV: false, DC: true }, //EeziePay
                    //"TUP": { CV: false, DC: true }, //TruePay
                    //"CT": { CV: false, DC: true }, //Crypto
                    //"HATT": { CV: false, DC: true }, //Hide Affiliate Tiering Table
                    //"SIPWM": { CV: true, DC: false }, //Show Invalid Phone Waring Message
                    //"HMSB": { CV: false, DC: true }, //Hide Member Site Background
                    //"DSAB": { CV: false, DC: true }, //Disable System Auto Block
                    //"EASF": { CV: false, DC: true }, //Show Affiliate System Federation(AFS)
                    //"CBTU": { CV: false, DC: true }, //Enable cellular balance top up
                    //"AFTTFG": { CV: false, DC: true }, //Allow Free Trial On Top 5 Games
                    //"HFTGBL": { CV: false, DC: true }, //Hide Free Trial Game Before Member Login
                    //"HFTGAL": { CV: false, DC: true }, //Hide Free Trial Game After Member Login
                    //"DOTPV": { CV: false, DC: true }, //Disable OTP Validation
                    //"GLIF": { CV: true, DC: true }, //Enable Iframe Game Launch
                    //"GLIFSW": { CV: false, DC: true }, //Open game in iframe within same browser window
                    //"HT5DG": { CV: false, DC: true }, //Hide Top 5 Demand Game
                    //"HT5J": { CV: false, DC: true }, //Hide Top 5 Jackpots
                    //"HT5S": { CV: false, DC: true }, //Hide Top 5 Slots
                    //"HT5LC": { CV: false, DC: true }, //Hide Top 5 Live Casino
                    //"HT5SES": { CV: false, DC: true }, //Hide Top 5 Sports & Esports
                    //"XFU": { CV: false, DC: true }, //XFuoo
                    //"STP": { CV: false, DC: true }, //StarsPay
                    //"SUREP": { CV: false, DC: true }, //SurePay
                    //"P918": { CV: false, DC: true }, //P918
                    //"FUP": { CV: false, DC: true }, //FuPay
                    //"TMONEY": { CV: false, DC: true }, //TrueMoney
                    //"SMP": { CV: false, DC: true }, //SmartPay
                    //"U2P": { CV: false, DC: true }, //U2Pay
                    //"LP": { CV: false, DC: true }, //LuckyPay
                    //"BCP": { CV: false, DC: true }, //BCPay
                    //"FPG": { CV: false, DC: true }, //FPG
                    //"PGA": { CV: false, DC: true }, //PGAuto
                    //"AGP": { CV: false, DC: true }, //AgogoPay
                    //"UP": { CV: false, DC: true }, //UniversePay
                    //"EUN": { CV: false, DC: true }, //Enable UserID Numeric
                    //"EBAIN": { CV: false, DC: true }, //Enable Bank Account in Numeric
                    //"RBAN": { CV: false, DC: true }, //Use Register Bank Account Name
                    //"HL5GH": { CV: false, DC: true }, //Hide Last 5 Game History
                    //"HTR": { CV: false, DC: true }, //Hide Tournament Ranking
                    //"DMAL": { CV: false, DC: true }, //Disable Login
                    //"DMAR": { CV: false, DC: true }, //Disable Register
                    //"DMAD": { CV: false, DC: true }, //Disable Deposit
                    //"DMAW": { CV: false, DC: true }, //Disable Withdrawal
                    //"SM": { CV: false, DC: true }, //Social Media
                    ////"PHONE": { CV: false, DC: true },
                    ////"EMAIL": { CV: false, DC: true },
                    //"WCID": { CV: false, DC: true }, //WeChat ID
                    //"LID": { CV: false, DC: true }, //Line ID
                    //"WAID": { CV: false, DC: true }, //Whatsapp
                    //"TGID": { CV: false, DC: true }, //Telegram
                    //"ZLID": { CV: false, DC: true }, //Zalo
                    //"EPDN": { CV: false, DC: true }, //Exclude Deposit Notice for Sub-Agent & Outlet
                    //"EPWN": { CV: false, DC: true }, //Exclude Withdrawal Notice for Sub-Agent & Outlet
                    //"EPPN": { CV: false, DC: true }, //Exclude Promotion Notice for Sub-Agent & Outlet
                    //"CAD": { CV: false, DC: true }, //Company Account Details
                    //"PP": { CV: false, DC: true },
                    //"DN": { CV: false, DC: true },
                    //"EGPLL": { CV: false, DC: true }, //Enable Game Provider lobby (only for Live Casino)
                    //"DLGFML": { CV: false, DC: true }, //Direct Launch Live Casino Lobby from Menu
                    //"OKP": { CV: false, DC: true }, //OkaysPay
                    //"MGP": { CV: false, DC: true }, //MegasPay
                    //"VIP": { CV: false, DC: true }, //VIP Pay

                    LoginSetting: {
                        "SL": { CV: true, DC: true }, //Simple Login
                        "EFPL": { CV: true, DC: true }, //Enable Forgot Password Link
                        "LD": { CV: false, DC: true }, //Login Disclaimer
                        "DMAL": { CV: false, DC: true }, //Disable Login
                        "DMAR": { CV: false, DC: true }, //Disable Register
                        "DMAD": { CV: false, DC: true }, //Disable Deposit
                        "DMAW": { CV: false, DC: true }, //Disable Withdrawal
                    },

                    RegistrationSetting: {
                        "RFWMP": { CV: false, DC: true }, //Register Form With Multiple Page
                        "RWBA": { CV: true, DC: false }, //Register Without Bank Account
                        "RWEA": { CV: false, DC: true }, //Register With Email/ RCUZ_check Duplicate Email
                        "CDBACC": { CV: true, DC: true }, //Check Duplicate Bank Account
                        "CDPNO": { CV: true, DC: true }, //Check Duplicate Phone Number
                        "HMCI": { CV: false, DC: true }, //Hide Member Contact Info
                        "RPN": { CV: false, DC: true }, //Required Phone No
                        "REGWPHONE": { CV: false, DC: true }, //Register With Phone
                        "DADIF": { CV: false, DC: true }, //Display Auto Deposit In-Front
                        "FNM": { CV: false, DC: true }, //Full Name Mandatory
                        "ULPN": { CV: false, DC: true }, //Localised Country Code
                        "UPCODE": { CV: false, DC: true }, //Enable Prefix Code
                        "HCDIHO": { CV: true, DC: true }, //Hide Currency Dropdown If Having Only One Option
                        "SRC": { CV: false, DC: true }, //Show Referral Code in Register Form
                        "BABLBA": { CV: false, DC: true }, //Block All Black Listed Bank Account
                        //"HATT": { CV: false, DC: true }, //Hide Affiliate Tiering Table
                        "SIPWM": { CV: true, DC: false }, //Show Invalid Phone Waring Message
                        "HMSB": { CV: false, DC: true }, //Hide Member Site Background
                        "DOTPV": { CV: false, DC: true }, //Disable OTP Validation
                        "EUN": { CV: false, DC: true }, //Enable UserID Numeric
                        "SM": { CV: false, DC: true }, //Social Media
                        "EPWSC": { CV: false, DC: true },
                        //"PHONE": { CV: false, DC: true },
                        //"EMAIL": { CV: false, DC: true },
                        "WCID": { CV: false, DC: true }, //WeChat ID
                        "LID": { CV: false, DC: true }, //Line ID
                        "WAID": { CV: false, DC: true }, //Whatsapp
                        "TGID": { CV: false, DC: true }, //Telegram
                        "ZLID": { CV: false, DC: true }, //Zalo
                        "PP": { CV: false, DC: true },
                        "DN": { CV: false, DC: true },
                    },

                    MemberSiteSetting: {
                        "LMIAA": { CV: false, DC: false }, //Lock Member Info After Add
                        "HSCM": { CV: true, DC: false }, //Hide Side Contact Menu
                        "HSQRCM": { CV: true, DC: false }, //Hide Side QR Code Menu
                        "HQRCBL": { CV: true, DC: false }, //Hide Side QR Code Menu Before Login
                        "SQRCSM": { CV: true, DC: true }, //Show QR Code Side Menu
                        "HICSM": { CV: true, DC: false }, //Hide Info Center Side Menu
                        "HBLPU": { CV: true, DC: false }, //Hide Bet Limit POP UP
                        "DWOTT": { CV: false, DC: true }, //Transfer Amount Without 1:1000
                        "DODDS": { CV: false, DC: true }, //Display Odds Iframe at Member Site
                        "EAFBFHP": { CV: false, DC: true }, //Display AFB1188 iframe at Member Site
                        "DDNF": { CV: false, DC: false }, //Disable Default News Feed
                        "MDMIA": { CV: false, DC: true }, //Mask Downline Member Name in Affiliate
                        "HMAN": { CV: false, DC: true }, //Hide Main Affiliate Name
                        "HATT": { CV: false, DC: true }, //Hide Affiliate Tiering Table
                        "AFTTFG": { CV: false, DC: true }, //Allow Free Trial On Top 5 Games
                        "HFTGBL": { CV: false, DC: true }, //Hide Free Trial Game Before Member Login
                        "HFTGAL": { CV: false, DC: true }, //Hide Free Trial Game After Member Login
                        "DSAB": { CV: false, DC: true }, //Disable System Auto Block
                        "DDLS": { CV: false, DC: true }, //Display Daily Lucky Spin before requirement
                        "GLIF": { CV: true, DC: true }, //Enable Iframe Game Launch
                        "GLIFSW": { CV: false, DC: true }, //Open game in iframe within same browser window
                        "HL5GH": { CV: false, DC: true }, //Hide Last 5 Game History
                        "HTR": { CV: false, DC: true }, //Hide Tournament Ranking
                        "ETBN": { CV: false, DC: true }, //Enable Tournament Bottom Navigation
                        "DGPL": { CV: false, DC: true }, //Disable Game Provider Lobbies
                        "EASF": { CV: false, DC: true }, //Show Affiliate System Federation(AFS)
                        "EFV": { CV: true, DC: false }, //Enable Full Version
                        "EUL": { CV: true, DC: false }, //Enable Userful Link
                        "EGPLL": { CV: false, DC: true }, //Enable Game Provider lobby (only for Live Casino)
                        "DLGFML": { CV: false, DC: true }, //Direct Launch Live Casino Lobby from Menu
                        "HT5DG": { CV: false, DC: true }, //Hide Top 5 Demand Game
                        "HT5J": { CV: false, DC: true }, //Hide Top 5 Jackpots
                        "HT5S": { CV: false, DC: true }, //Hide Top 5 Slots
                        "HT5LC": { CV: false, DC: true }, //Hide Top 5 Live Casino
                        "HT5SES": { CV: false, DC: true }, //Hide Top 5 Sports & Esports
                    },

                    BankBackOfficeSetting: {
                        "NADBABA": { CV: false, DC: false }, //Not Allow Deposit Before Add Bank Account
                        "DDB": { CV: false, DC: false }, //No Duplicate Withdraw Bank
                        "NAABA": { CV: false, DC: false }, //Not Allow Add Bank Account
                        "NADBA": { CV: false, DC: false }, //Not Allow Delete Bank Account
                        "NBRWD": { CV: false, DC: true }, //Need Bank Receipt When Deposit
                        "OWB": { CV: false, DC: false }, //Withdraw With One Bank Account Only
                        "SSMRB": { CV: false, DC: true }, //Show Same Bank As Member Registered Bank
                        "SHBAN": { CV: false, DC: true }, //Show Half Bank Account No.
                        "HMDO": { CV: false, DC: true }, //Hide Manual Deposit Option
                        "PDO": { CV: false, DC: true }, //Preferred Deposit Option
                        "FNABAN": { CV: false, DC: true }, //Full Name As Bank Account Name
                        "CBTU": { CV: false, DC: true }, //Enable cellular balance top up
                        "EBAIN": { CV: false, DC: true }, //Enable Bank Account in Numeric
                        "RBAN": { CV: false, DC: true }, //Use Register Bank Account Name
                        "EPDN": { CV: false, DC: true }, //Exclude Deposit Notice for Sub-Agent & Outlet
                        "EPWN": { CV: false, DC: true }, //Exclude Withdrawal Notice for Sub-Agent & Outlet
                        "EPPN": { CV: false, DC: true }, //Exclude Promotion Notice for Sub-Agent & Outlet
                        "CAD": { CV: false, DC: true }, //Company Account Details
                        "AANE": { CV: false, DC: true }, // Allow alphanumeric entries
                        "AEWAS": { CV: false, DC: true }, //Allow entries with “@” symbol
                        "MAANE": { CV: false, DC: true }, // Allow alphanumeric entries
                        "MAEWAS": { CV: false, DC: true }, //Allow entries with “@” symbol
                    },

                    CryptoSetting: {
                        "ECF": { CV: false, DC: true }, //Enable Crypto Feature
                    },

                    Captchas: {
                        "DCC": { CV: false, DC: true }, //Disable Captcha (Default)
                        "CCAOLN": { CV: false, DC: true }, //Alphabets Only
                        "CCALPN": { CV: false, DC: true }, //Alphanumeric
                        "CCNO": { CV: false, DC: true }, //Numeric Only
                    },

                    PasswordOptions: {
                        "FPDTMB": { CV: false, DC: true }, // Desktop & Mobile
                        "FPDT": { CV: false, DC: true }, //Desktop
                        "FPMB": { CV: false, DC: true }, //Mobile
                    },

                    TournamentOptions: {
                        "DTMB": { CV: true, DC: false }, //Desktop and Mobile
                        "DT": { CV: false, DC: true }, //Desktop
                        "MB": { CV: false, DC: true }, //Mobile
                    },

                    PaymentOptions: {
                        "MD": { CV: false, DC: true }, //Manual Deposit
                        "AD": { CV: false, DC: true }, //Auto Deposit
                        "ADP": { CV: false, DC: true }, //Auto Deposit Plus
                        "HP": { CV: false, DC: true }, //Help2Pay
                        "OP": { CV: false, DC: true }, //Oopay
                        "EZP": { CV: false, DC: true }, //EeziePay
                        "TUP": { CV: false, DC: true }, //TruePay
                        "CT": { CV: false, DC: true }, //Crypto
                        "XFU": { CV: false, DC: true }, //XFuoo
                        "STP": { CV: false, DC: true }, //StarsPay
                        "SUREP": { CV: false, DC: true }, //SurePay
                        "P918": { CV: false, DC: true }, //P918
                        "FUP": { CV: false, DC: true }, //FuPay
                        "TMONEY": { CV: false, DC: true }, //TrueMoney
                        "SMP": { CV: false, DC: true }, //SmartPay
                        "U2P": { CV: false, DC: true }, //U2Pay
                        "LP": { CV: false, DC: true }, //LuckyPay
                        "BCP": { CV: false, DC: true }, //BCPay
                        "FPG": { CV: false, DC: true }, //FPG
                        "PGA": { CV: false, DC: true }, //PGAuto
                        "AGP": { CV: false, DC: true }, //AgogoPay
                        "UP": { CV: false, DC: true }, //UniversePay
                        "OKP": { CV: false, DC: true }, //OkaysPay
                        "MGP": { CV: false, DC: true }, //MegasPay
                        "VIP": { CV: false, DC: true }, //VIP Pay
                        "AFP": { CV: false, DC: true }, //AlfaPay
                        "ONEP": { CV: false, DC: true }, //OnePay
                        "BLEUP": { CV: false, DC: true }, //BluePay
                        "E88P": { CV: false, DC: true }, //Easy88Pay
                        //"PPYP": { CV: false, DC: true }, //PapayaPay
                        "ECP": { CV: false, DC: true }, //ECPay
                        "DGPCNY": { CV: false, DC: true }, //DGPay
                        "SUPER7VND": { CV: false, DC: true }, //SUPER7VND
                        //"PAYNGO": { CV: false, DC: true }, //PayNGo
                    },
                };

                //Default Setting for Captcha [WebConfigCaptchaOption for SSA, CaptchaOption for AgentCustomization]
                //if (this.str_WebConfigCaptchaOption == null || this.str_WebConfigCaptchaOption == "") {
                //    this.str_WebConfigCaptchaOption = "DCC";
                //}

                //Default Setting for Enable Forgot Password Link
                if (this.arry_OnOff["LoginSetting"]["EFPL"].CV == true && (this.str_ForgotPasswordLinkOption == null || this.str_ForgotPasswordLinkOption == "")) {
                    this.str_ForgotPasswordLinkOption = "FPDTMB";
                }


                this.arry_CrOnOff = {
                    "RFWMP": { CV: false, DC: true },
                    "RWBA": { CV: true, DC: false }, //Default Value for Customize Registration
                    "RWEA": { CV: false, DC: true },
                    "CDBACC": { CV: true, DC: true }, //Default Value for Customize Registration
                    "CDPNO": { CV: true, DC: true }, //Default Value for Customize Registration
                    "RPN": { CV: false, DC: true },
                    "REGWPHONE": { CV: false, DC: true },
                    "ULPN": { CV: false, DC: true },
                    "UPCODE": { CV: false, DC: true },
                    "DOTPV": { CV: false, DC: true },
                    "FNM": { CV: false, DC: true },
                    "HCDIHO": { CV: true, DC: true }, //Default Value for Customize Registration
                    "EUN": { CV: false, DC: true },
                    "BABLBA": { CV: false, DC: true },
                    "SM": { CV: false, DC: true },
                    "WCID": { CV: false, DC: true },
                    "LID": { CV: false, DC: true },
                    "WAID": { CV: false, DC: true },
                    "TGID": { CV: false, DC: true },
                    "EPWSC": { CV: false, DC: true },
                    "ZLID": { CV: false, DC: true },
                    "REM": { CV: false, DC: true },
                    "RWSAP": { CV: false, DC: true },
                    "RWC": { CV: false, DC: true },
                    "RLINE": { CV: false, DC: true },
                    "RTELE": { CV: false, DC: true },
                    "RZALO": { CV: false, DC: true },
                    "SRC": { CV: false, DC: true }
                };
                this.bool_obj_bankaccRS = true;
                this.bool_obj_bankaccDC = false;
                this.bool_isAutoDepositBank = 0;
                this.bool_obj_isAutoDeposit = 0;
                this.newImg = false;
                this.obj_bankacc = {
                    I: 0,
                    RS: 1,
                    VIPBA: false,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    AT: null,
                    BI: null,
                    BA: "",
                    BAN: "",
                    CI: null,
                    Add_AB: null,
                    AB: null,
                    MINW: null,
                    MAXW: null,
                    MIND: null,
                    MAXD: null,
                    TD: null,
                    TUD: null,
                    TW: null,
                    AGI: null,
                    ID: null,
                    IW: null,
                    AGIT: null,
                    CC: null,
                    BU: "",
                    BP: "",
                    BPC: "",
                    IA: null,
                    ADS: "",
                    ADR: "",
                    LPUTS: null,
                    IUT: false,
                    QRCI: "",
                    MT: [],
                    MTV: [],

                    BICN: "",
                    BDOB: "",
                    BMN: "",
                    BAPIN: "",
                    BDI: "",
                    BCT: null,
                    FCS: "",
                    ER: 1,
                    TCS: "",
                    TER: 1,
                    PM: [],
                    HBI: false
                };

                this.obj_SubGroup = {
                    "I": 0,
                    "RS": 2,        //Status
                    "GN": "",       //Brand Name
                    "AT": "",       //Agent Type
                    "PGI": "",      //Parent Group Id
                    "PGIT": null,   //3-0304
                    "PC": "",       //Prefix Code
                    "WLIPS": "",    //White List Ip
                    "SPG": "",      //Sub Brand
                    "IOL": false,      //Outlet
                    //"SAPSI": null,
                    //"L": "",
                    //"Language": null,
                    "Agent": {
                        "I": 0,
                        "RS": 2,
                        "U": "",
                        "UP": "",
                        "CUP": "",
                        "DN": "",
                        "E": "",
                        "PN": ""
                    },
                    "Contact": [{
                        "CN": "",
                        "PN": "",
                        "T": "",
                        "S": "",
                        "E": "",
                        "OC": ""
                    },
                    {
                        "CN": "",
                        "PN": "",
                        "T": "",
                        "S": "",
                        "E": "",
                        "OC": ""
                    }],
                    "SubAgentPayoutScheme": {
                        "PT": 0,
                        "WLT": 2,
                        "POT": 1
                    },
                    "SubAgentCustomPT": [],
                    "WhiteListIP": [],
                };

                //Copy Customize Menu
                this.obj_awt = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    DI: null,
                    SB: 0,
                    SGL: 0,
                    SGP: 0,
                    SSP: 0,
                    SEP: 0,
                    AGI: "",
                    AGIT: null,
                    SABL: true,
                    BankList: [],
                    CustomNavMenu: [],
                    MainMenu: [],
                    HDC: null,
                    ICC: false,
                    BGC: null,
                    BGBC: null
                };
                this.bool_CV = false;
                this.boolSBL = false;
                this.boolSGL = false;
                this.boolSGP = false;
                this.boolSSP = false;
                this.boolSEP = false;
                this.boolSPB = false;
                this.boolBigImg = false;
                this.bool_gps_one = true;
                this.bool_gps_two = false;
                this.bool_gps_three = false;
                this.str_gpStyle = "1";
                this.nav_menu = null;
                this.isDragDropMainMenu = false;
                this.isDragDropBankList = false;
                this.isDragDropNavMenu = false;
            },
            grabDomainID(agi) {
                return new Promise((resolve, reject) => {
                    this.getDataApi(`/api/ag/gd/${agi}`, function (d, s) {
                        if (s) {
                            resolve(d); 
                        } else {
                            reject('Failed to get domain ID'); 
                        }
                    });
                });
            },
            copyGroup(value) {

                var id = 0;
                var tempId = 0; // for Copy Cuz Menu ID Reference
                var agi = 0;

                var tempcri = 0; //for customize registration id reference.

                var bool_copyWebsiteConfig = true;
                var bool_copyDomain = true;
                var bool_copyGroup = true;

                //inside data(), global so can be used in saveselfservice function 
                this.bool_copyCuzMenu = true;
                this.bool_copyCuzReg = true;
                this.bool_copyCuzDeposit = true;

                var agentAPIstatusOK, domainAPIstatusOK, agentconfigAPIstatusOK, livechatAPIstatusOK, bankaccAPIstatusOK, registerCustomizeAPIstatusOK, depositCustomizeAPIstatusOK;
                agentAPIstatusOK = domainAPIstatusOK = agentconfigAPIstatusOK = livechatAPIstatusOK = bankaccAPIstatusOK = registerCustomizeAPIstatusOK = depositCustomizeAPIstatusOK = true;

                if (value) {
                    if ($.isNumeric(value)) {
                        id = value;
                    } else {
                        agi = value.split("-");
                        id = agi[1];
                    }

                    var that = this;

                    //initiate loading
                    this.bool_fullLoading = true;

                    this.bool_groupCV = false;
                    this.setObject();

                    //Copy Website Config
                    if (bool_copyWebsiteConfig) {
                        agentconfigAPIstatusOK = false;

                        this.getDataApi(`/api/acuz/g/${id}`,
                            function (d, s) {
                                if (s) {
                                    agentconfigAPIstatusOK = true;
                                    if (d.D != null) {
                                        that.setAC(d.D);
                                    }

                                    that.bool_isAMV = false;
                                    if (that.arry_aac.AGI != 0) {
                                        that.arry_aac.AGIT = that.arry_aac.AGI;
                                        that.searchAgent = ["3-" + that.arry_aac.AGI];
                                    }
                                    that.bool_isAMV = true;
                                }
                            });
                    }

                    //Copy Downline Setting & Language, Currency, and Game Provider Setting
                    if (bool_copyGroup) {

                        //this.getDataApi(`/api/ag/g/${id}`,
                        //    function (d, s) {

                        //        if (s) {
                        //            that.obj_Group = Object.assign(that.obj_Group, d.D);
                        //            that.obj_Group.I = 0;
                        //            that.obj_Group.GN = "";
                        //            that.obj_Group.PC = "";
                        //            that.bool_isAgentType = that.obj_Group.AT == "3" ? true : false;

                        //            if (that.obj_Group.PT != null && that.obj_Group.PT > 0) {
                        //                that.obj_Group.PT = that.obj_Group.PT.toFixed(2);
                        //            }
                        //            else {
                        //                that.obj_Group.PT = "0.00";
                        //            }
                        //            if (that.obj_Group.DPT != null && that.obj_Group.DPT > 0) {
                        //                that.obj_Group.DPT = that.obj_Group.DPT.toFixed(2);
                        //            }
                        //            else {
                        //                that.obj_Group.DPT = "0.00";
                        //            }

                        //            if (that.obj_Group.TB != null && that.obj_Group.TB > 0) {
                        //                that.obj_Group.TB = that.obj_Group.TB.toFixed(2);
                        //            }
                        //            else {
                        //                that.obj_Group.TB = "0.00";
                        //            }

                        //            if (that.obj_Group.TCB != null && that.obj_Group.TCB > 0) {
                        //                that.obj_Group.TCB = that.obj_Group.TCB.toFixed(2);
                        //            }
                        //            else {
                        //                that.obj_Group.TCB = "0.00";
                        //            }

                        //            if (that.obj_Group.ICT) {
                        //                that.dd_currency = [];
                        //                that.dd_currency.push(that.dd_currencyNonICT.find(f => f.label === 'USD'));
                        //                that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyICT);
                        //            }
                        //            else {
                        //                that.dd_currency = that.dd_currencyNonICT;
                        //                that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyNonICT);
                        //            }

                        //            that.arr_CustomPT = [];
                        //            if (that.obj_Group.CI != null && that.obj_Group.CI.length > 0) {
                        //                that.obj_Group.CurrencyIds = that.obj_Group.CI.split(',');
                        //            }
                        //            else {
                        //                that.obj_Group.CurrencyIds = [];
                        //            }

                        //            if (that.obj_Group.H2PCC != null && that.obj_Group.H2PCC.length > 0) {
                        //                that.obj_Group.H2PCurrencyCodes = that.obj_Group.H2PCC.split(',');
                        //            }
                        //            else {
                        //                that.obj_Group.H2PCurrencyCodes = null;
                        //            }

                        //            if (that.obj_Group.L != null && that.obj_Group.L.length > 0) {
                        //                that.obj_Group.Language = that.obj_Group.L.split(',');
                        //            }
                        //            else {
                        //                that.obj_Group.Language = [];
                        //            }

                        //            if (that.obj_Group.GPI != null && that.obj_Group.GPI.length > 0) {
                        //                //that.obj_Group.GameProviderIds = that.obj_Group.GPI.split(',');
                        //                // that.obj_Group.GameProviderIds = that.obj_Group.GameProviderIds.filter(val => !constSpecialProviders.includes(val));
                        //            }
                        //            else {
                        //                that.obj_Group.GameProviderIds = [];
                        //            }

                        //            that.obj_Group.Agent = {
                        //                "I": 0,
                        //                "RS": 2,
                        //                "U": "",
                        //                "UP": "",
                        //                "CUP": "",
                        //                "DN": "",
                        //                "E": "",
                        //                "PN": ""
                        //            };

                        //            that.obj_Group.BL = 0;
                        //            that.obj_Group.CBL = 0;

                        //            that.dec_availablebalance = that.formatNumber(that.obj_Group.TB - that.obj_Group.BL, 2, d.D.CS);
                        //            if (d.D.CS == "$") {
                        //                that.dec_availablebalanceusd = that.dec_availablebalance;
                        //            }
                        //            else {
                        //                that.dec_availablebalanceusd = that.formatNumber((that.obj_Group.TB - that.obj_Group.BL) / that.obj_Group.USDER, 2, d.D.USDCS);
                        //            }

                        //            that.CurrencyChange(that.obj_Group.DCI);

                        //            //this calls CheckAllGPButton
                        //            that.ParentGroupChange(that.obj_Group.PGIT, true);

                        //            var this1 = that;
                        //            that.getDataApi(`/api/ag/gb/${that.obj_Group.PGI}/0`,
                        //                function (d, s) {
                        //                    if (s) {

                        //                        this1.dec_availablebalance = this1.formatNumber(d.D.TB - d.D.BL, 2, d.D.CS);
                        //                        if (d.D.CS == "$") {
                        //                            this1.dec_availablebalanceusd = this1.dec_availablebalance;
                        //                        }
                        //                        else {
                        //                            this1.dec_availablebalanceusd = this1.formatNumber((d.D.TB - d.D.BL) / d.D.USDER, 2, d.D.USDCS);
                        //                        }
                        //                        this1.str_ptrange = "0.00% - " + d.D.PT.toFixed(2) + "%";
                        //                        this1.obj_Group.MaxPT = d.D.PT;
                        //                    }
                        //                });

                        //            that.bool_isAMV = true;

                        //            //tempID is the copied agent's id
                        //            //used to grab their menu id
                        //            tempId = d.D.I;

                        //            //copies 11.6 Customize Menu
                        //            //Copy Customize Menu
                        //            if (that.bool_copyCuzMenu) {

                        //                that.getDataApi(`/api/cms/gagi/${tempId}`,
                        //                    function (d, s) {
                        //                        if (s) {
                        //                            //setCMS
                        //                            that.obj_awt = d;
                        //                        } else {
                        //                            that.obj_awt = null;
                        //                        }
                        //                    });
                        //            }

                        //            //This one also checks CheckAllGPButton
                        //            that.selectSupportedCurrency(false);
                        //            //that.checkSelectAllGPButton(false);
                        //        }
                        //    });

                        agentAPIstatusOK = false;
                        this.getDataApi(`/api/agss/agg/${id}`,
                            function (d, s) {
                                if (s) {
                                    agentAPIstatusOK = true;
                                    that.obj_Group = Object.assign(that.obj_Group, d.D);
                                    that.obj_Group.CPGIT = null;
                                    that.obj_Group.I = 0;
                                    that.obj_Group.GN = "";
                                    that.obj_Group.PC = "";

                                    that.bool_isAgentType = that.obj_Group.AT == "3" ? true : false;
                                    that.bool_isSeniorMasterLv = that.obj_Group.AT == "1" ? true : false;
                                    that.bool_isEditSelfService = true;

                                    if (that.obj_Group.PT != null && that.obj_Group.PT > 0) {
                                        that.obj_Group.PT = that.obj_Group.PT.toFixed(2);
                                    }
                                    else {
                                        that.obj_Group.PT = "0.00";
                                    }
                                    if (that.obj_Group.DPT != null && that.obj_Group.DPT > 0) {
                                        that.obj_Group.DPT = that.obj_Group.DPT.toFixed(2);
                                    }
                                    else {
                                        that.obj_Group.DPT = "0.00";
                                    }

                                    if (that.obj_Group.TB != null && that.obj_Group.TB > 0) {
                                        that.obj_Group.TB = that.obj_Group.TB.toFixed(2);
                                    }
                                    else {
                                        that.obj_Group.TB = "0.00";
                                    }

                                    if (that.obj_Group.TCB != null && that.obj_Group.TCB > 0) {
                                        that.obj_Group.TCB = that.obj_Group.TCB.toFixed(2);
                                    }
                                    else {
                                        that.obj_Group.TCB = "0.00";
                                    }

                                    if (that.obj_Group.ICT) {
                                        that.dd_currency = [];
                                        that.dd_currency.push(that.dd_currencyNonICT.find(f => f.label === 'USD'));
                                        that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyICT);
                                    }
                                    else {
                                        that.dd_currency = that.dd_currencyNonICT;
                                        that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyNonICT);
                                    }

                                    if (that.obj_Group.CI != null && that.obj_Group.CI.length > 0) {
                                        that.obj_Group.CurrencyIds = that.obj_Group.CI.split(',');
                                    }
                                    else {
                                        that.obj_Group.CurrencyIds = [];
                                    }

                                    if (that.obj_Group.H2PCC != null && that.obj_Group.H2PCC.length > 0) {
                                        that.obj_Group.H2PCurrencyCodes = that.obj_Group.H2PCC.split(',');
                                    }
                                    else {
                                        that.obj_Group.H2PCurrencyCodes = null;
                                    }

                                    if (that.obj_Group.L != null && that.obj_Group.L.length > 0) {
                                        that.obj_Group.Language = that.obj_Group.L.split(',');
                                    }
                                    else {
                                        that.obj_Group.Language = [];
                                    }

                                    if (that.obj_Group.GPI != null && that.obj_Group.GPI.length > 0) {
                                        that.obj_Group.GameProviderIds = that.obj_Group.GPI.split(',');
                                    }
                                    else {
                                        that.obj_Group.GameProviderIds = [];
                                    }

                                    that.obj_Group.Agent = {
                                        "I": -1,
                                        "UP": "",
                                        "CUP": ""
                                    };

                                    that.dec_availablebalance = that.formatNumber(that.obj_Group.TB - that.obj_Group.BL, 2, d.D.CS);
                                    that.CurrencyChange(that.obj_Group.DCI);

                                    that.obj_Group.WhiteListIP = [];
                                    if (that.obj_Group.WLIPS != "") {
                                        var WLIPS_C = that.obj_Group.WLIPS;
                                        that.obj_Group.WLIPS = "";
                                        var WLIPS_CARRY = WLIPS_C.split(',');
                                        for (var i = 0; i < WLIPS_CARRY.length; i++) {
                                            that.obj_WLIPS = {
                                                WLIPS: WLIPS_CARRY[i]
                                            }
                                            that.obj_Group.WhiteListIP.push(that.obj_WLIPS);
                                        }
                                    }
                                    that.ParentGroupChange(that.obj_Group.PGIT);
                                    var this1 = that;
                                    that.getDataApi(`/api/ag/gb/${that.obj_Group.PGI}/0`,
                                        function (d, s) {
                                            if (s) {
                                                this1.dec_availablebalance = this1.formatNumber(d.D.TB - d.D.BL, 2, d.D.CS);
                                                this1.str_ptrange = "0.00% - " + d.D.PT.toFixed(2) + "%";
                                                this1.obj_Group.MaxPT = d.D.PT;
                                            }
                                        });

                                    that.bool_isAMV = true;

                                    //tempID is the copied agent's id
                                    //used to grab their menu id
                                    tempId = d.D.I;
                                    
                                    //copies 11.6 Customize Menu
                                    //Copy Customize Menu
                                    if (that.bool_copyCuzMenu) {
                                    
                                        that.getDataApi(`/api/cms/gagi/${tempId}`,
                                            function (d, s) {
                                                if (s) {
                                                    //setCMS
                                                    that.obj_awt = d;
                                                } else {
                                                    that.obj_awt = null;
                                                }
                                            });
                                    }
                                }
                            });
                    }

                    if (bool_copyDomain) {

                        this.grabDomainID(id)
                            .then(domainId => {

                                this.copy_domainID = domainId;

                                this.selectedFile = null;
                                this.selectedFileMsl = null;
                                this.isChangeDomainName = false;
                                //var domainId = this.$route.query.di;
                                var domainId = this.copy_domainID;


                                if (domainId > 0 && this.obj_Domain.I <= 0 && (this.getUserInfo.AT == 0 || this.getUserInfo.AT >= 2)) {
                                    this.bool_fullLoading = true;
                                    domainAPIstatusOK = false;
                                    this.getDataApi(`/api/dm/g/${domainId}`,
                                        function (d, s) {
                                            if (s) {
                                                domainAPIstatusOK = true;
                                                that.obj_Domain = Object.assign(that.obj_Domain, d.D);
                                                var cloudflareDomainID = that.obj_Domain.I;
                                                that.obj_Domain.I = 0;

                                                //remove domain
                                                that.obj_Domain.DALT = null;
                                                that.obj_Domain.DN = '';
                                                that.obj_Domain.DNS = null;
                                                that.obj_Domain.TN = null;
                                                that.obj_Domain.SN = null;
                                                that.obj_Domain.CFStatus = false;
                                                that.obj_Domain.SL = "";
                                                that.obj_Domain.SI = "";
                                                that.obj_Domain.MSL = "";


                                                that.obj_Domain.RT = ""; //Robot Text
                                                that.obj_Domain.FSXML = ""; //Sitemap XML
                                                that.obj_Domain.SIP = ""; //Domain IP
                                                that.obj_Domain.AMPSU = ""; //Self AMP Link

                                                //that.selectedAGI = that.obj_Domain.agi;
                                                that.selectedAGI = 0;
                                                var DS = [];
                                                if (that.dd_language.length > 0) {
                                                    var activeDomainLangSetting = false;
                                                    for (var i = 0; i < that.dd_language.length; i++) {
                                                        DS[i] = {
                                                            "I": 0,
                                                            "TC": false,
                                                            "LE": false,
                                                            "L": that.dd_language[i].id,
                                                            "LN": that.dd_language[i].label,
                                                            "CC": null,
                                                            "CurrencyCodes": [],
                                                            "TI": null,
                                                            "TSI": null,
                                                            "MTI": null,
                                                            "MTSI": null,
                                                            "TIALT": null,
                                                            "TSIALT": null,
                                                            "MTIALT": null,
                                                            "MTSIALT": null,
                                                            "EETAD": 0,
                                                            "GPI": "",
                                                            "GameProviderIdS": [],
                                                            "CURL": "",
                                                            "GCURL": "",
                                                            "ALTCURL": "",
                                                            "ALTGCURL": "",
                                                            "MCURL": "",
                                                            "MGCURL": "",
                                                            "ALTMCURL": "",
                                                            "ALTMGCURL": "",
                                                            "AFB1188SW": "W0",
                                                            "AFB1188SM": "W0",
                                                            "AFB1188OS": "HK",
                                                            "AFB1188OM": "Single",
                                                            "DSN1": "Skin 1",
                                                            "DSN2": "Skin 2",
                                                        };

                                                        if (d.D.DS) {
                                                            d.D.DS.find(function (val, idx) {
                                                                if (val.L == that.dd_language[i].id && !activeDomainLangSetting) {
                                                                    that.selectedLangIndex = i;
                                                                    activeDomainLangSetting = true;
                                                                }

                                                                if (val.L == that.dd_language[i].id) {
                                                                    // handle remove unknow value from option
                                                                    //for (var x = 0; x < val.CurrencyCodes.length; x++) {
                                                                    //    if (!_.includes(_.map(that.dd_currency_selectlabel, 'label'), val.CurrencyCodes[x])) {
                                                                    //        val.CurrencyCodes.splice(x, 1);
                                                                    //    }
                                                                    //}
                                                                    //val.CC = val.CurrencyCodes.join(',');
                                                                    //end handle

                                                                    DS[i].I = 0;
                                                                    DS[i].TC = true;
                                                                    DS[i].LE = true;
                                                                    //DS[i].CC = val.CC;
                                                                    //DS[i].CurrencyCodes = val.CurrencyCodes;
                                                                    //DS[i].TI = (val.TI == 0) ? null : val.TI;
                                                                    //DS[i].TSI = (val.TI == 0) ? null : val.TSI;
                                                                    //DS[i].MTI = (val.MTI == 0) ? null : val.MTI;
                                                                    //DS[i].MTSI = (val.MTI == 0) ? null : val.MTSI;
                                                                    //DS[i].TIALT = (val.TIALT == 0) ? null : val.TIALT;
                                                                    //DS[i].TSIALT = (val.TIALT == 0) ? null : val.TSIALT;
                                                                    //DS[i].MTIALT = (val.MTIALT == 0) ? null : val.MTIALT;
                                                                    //DS[i].MTSIALT = (val.MTIALT == 0) ? null : val.MTSIALT;
                                                                    //DS[i].EETAD = val.EETAD;
                                                                    //DS[i].GPI = val.GPI;
                                                                    //DS[i].GameProviderIdS = val.GameProviderIdS;
                                                                    //DS[i].CURL = val.CURL;
                                                                    //DS[i].GCURL = val.GCURL;
                                                                    //DS[i].MCURL = val.MCURL;
                                                                    //DS[i].MGCURL = val.MGCURL;
                                                                    //DS[i].ALTCURL = val.ALTCURL;
                                                                    //DS[i].ALTGCURL = val.ALTGCURL;
                                                                    //DS[i].ALTMCURL = val.ALTMCURL;
                                                                    //DS[i].ALTMGCURL = val.ALTMGCURL;
                                                                    //if (val.DSN1) DS[i].DSN1 = val.DSN1;
                                                                    //if (val.DSN2) DS[i].DSN2 = val.DSN2;
                                                                    //DS[i].AFB1188SW = val.AFB1188SW !== "" ? val.AFB1188SW : null;
                                                                    //DS[i].AFB1188SM = val.AFB1188SM !== "" ? val.AFB1188SM : null;
                                                                    //DS[i].AFB1188OS = val.AFB1188OS !== "" ? val.AFB1188OS : null;
                                                                    //DS[i].AFB1188OM = val.AFB1188OM !== "" ? val.AFB1188OM : null;
                                                                    //if (DS[i].TI > 0) {
                                                                    //    that.TemplateChange(DS[i].TI);
                                                                    //}
                                                                    //else {
                                                                    //    DS[i].TI = null;
                                                                    //}
                                                                    //if (DS[i].MTI > 0) {
                                                                    //    DS[i].AMT = true;
                                                                    //    that.MobileTemplateChange(DS[i].MTI);
                                                                    //}
                                                                    //else {
                                                                    //    DS[i].MTI = null;
                                                                    //}

                                                                    //if (DS[i].TIALT > 0) {
                                                                    //    DS[i].E2SSIM = true;
                                                                    //    that.AlternateTemplateChange(DS[i].TIALT);
                                                                    //} else {
                                                                    //    DS[i].TIALT = null;
                                                                    //}
                                                                    //if (DS[i].MTIALT > 0) {
                                                                    //    DS[i].AMTALT = true;
                                                                    //    that.AlternateMobileTemplateChange(DS[i].MTIALT);
                                                                    //}
                                                                    //else {
                                                                    //    DS[i].MTIALT = null;
                                                                    //}
                                                                }
                                                            });
                                                        }
                                                    }
                                                }

                                                if (that.obj_Domain.SMSVP != null && that.obj_Domain.SMSVP.length > 0) {
                                                    that.obj_Domain.SMSVPages = that.obj_Domain.SMSVP.split(',');
                                                }
                                                else {
                                                    that.obj_Domain.SMSVPages = null;
                                                }

                                                if (that.obj_Domain.EVP != null && that.obj_Domain.EVP.length > 0) {
                                                    that.obj_Domain.EVPages = that.obj_Domain.EVP.split(',');
                                                }
                                                else {
                                                    that.obj_Domain.EVPages = null;
                                                }

                                                that.$set(that.$data.obj_Domain, 'DS', DS);
                                                //that.autoScrollTemplate();

                                                if (that.obj_Domain.AGI != 0) {
                                                    that.obj_Domain.AGIT = "3-" + that.obj_Domain.AGI;
                                                    that.checkDomainSupportLanguage(that.obj_Domain.AGIT);
                                                    //that.AgentGroupChange(that.obj_Domain.AGIT, true);
                                                }

                                                if (that.obj_Domain.AGI != 0 && that.obj_Domain.PDI > 0) {
                                                    that.searchSubBrand = that.obj_Domain.SAGAGI;
                                                    //that.SubAgentGroupChange(that.searchSubBrand);

                                                    that.isSubAgent = true;
                                                }

                                                //that.bool_holSLBL = that.obj_Domain.SLBL;
                                                //if (that.bool_holSLBL) {
                                                //    that.obj_Domain.LOGOByLink = that.obj_Domain.SL
                                                //}
                                                //that.bool_holSIBL = that.obj_Domain.SIBL;
                                                //if (that.bool_holSIBL) {
                                                //    that.obj_Domain.ICONByLink = that.obj_Domain.SI
                                                //}
                                                //that.bool_holMSLBL = that.obj_Domain.MSLBL;
                                                //if (that.bool_holMSLBL) {
                                                //    that.obj_Domain.MobileLOGOByLink = that.obj_Domain.MSL
                                                //}

                                                //that.obj_Domain.MaintenanceIP = [];
                                                //if (that.obj_Domain.MIP != "" && that.obj_Domain.MIP != null) {
                                                //    var MIP_C = that.obj_Domain.MIP;
                                                //    //that.obj_Domain.MIP = "";
                                                //    var MIP_CARRY = MIP_C.split(',');
                                                //    for (var i = 0; i < MIP_CARRY.length; i++) {
                                                //        that.obj_MIP = {
                                                //            MIP: MIP_CARRY[i]
                                                //        }
                                                //        that.obj_Domain.MaintenanceIP.push(that.obj_MIP);
                                                //    }
                                                //}

                                                //that.obj_Domain.DomainNameServer = [];
                                                //if (that.obj_Domain.DNS != "" && that.obj_Domain.DNS != null) {
                                                //    var DNS_C = that.obj_Domain.DNS;
                                                //    //that.obj_Domain.DNS = "";
                                                //    var DNS_CARRY = DNS_C.split(',');
                                                //    for (var i = 0; i < DNS_CARRY.length; i++) {
                                                //        that.obj_DNS = {
                                                //            DNS: DNS_CARRY[i]
                                                //        }
                                                //        that.obj_Domain.DomainNameServer.push(that.obj_DNS);
                                                //    }
                                                //}

                                                that.OldDomainName = that.obj_Domain.DN;

                                                if (that.obj_Domain.RTD != "") {
                                                    that.obj_Domain.RTD = that.obj_Domain.RTD;
                                                }
                                                else {
                                                    that.obj_Domain.RTD = "";
                                                }

                                                that.dd_dofs = [];
                                                if (that.obj_Domain.I > 0 && that.obj_Domain.AGI > 0) {
                                                    that.refreshDofs(that, that.obj_Domain.AGI);
                                                }

                                                if (that.obj_Domain.RT == null || that.obj_Domain.RT == '') {
                                                    that.obj_Domain.RT = "";
                                                }

                                                if (that.obj_Domain.IM == 0) {
                                                    that.obj_Domain.IM = null;
                                                }

                                                if (that.obj_Domain.AFB1188SBAPI == '') {
                                                    that.obj_Domain.AFB1188SBAPI = null;
                                                }

                                                that.bool_isAMV = true;
                                                //if (agentAPIstatusOK && domainAPIstatusOK && agentconfigAPIstatusOK && livechatAPIstatusOK && bankaccAPIstatusOK && registerCustomizeAPIstatusOK) {
                                                //    that.bool_fullLoading = false;
                                                //    that.getCloudFlareStatus(cloudflareDomainID);
                                                //}
                                            }
                                        });

                                    //use this copy function to test for error TT10613
                                    this.getDataApi(`/api/seo/l?p=1&n=100&s=CTS&d=true&f[DI]=${domainId}&f[DAI]=0&f[AGI]=${agi[1]}`,
                                        function (d, s) { 
                                            if (s && d.D.TotalItems == 0) {
                                                that.bool_showPreloadSEO = true;
                                            } else {
                                                that.bool_showPreloadSEO = false;
                                            }
                                        });
                                }
                            })
                            .catch(error => {
                                console.error("Error fetching domain:", error);
                            });
                    }


                    //Copy Customize Registration
                    if (that.bool_copyCuzReg) {
                        this.bool_showCR = (this.bool_showCR ? this.bool_showCR = false : this.bool_showCR = true);
                        this.bool_showDS = this.bool_showBOAC = this.bool_showDSS = this.bool_showDMSS = this.bool_showACS = this.bool_showBS = this.bool_showLCS = this.bool_showCD = false;

                        this.array_ui = [];
                        this.array_pn = [];
                        this.array_pw = [];
                        this.array_cpw = [];
                        this.array_fn = [];
                        this.array_sc = [];
                        this.array_sbk = [];
                        this.array_anm = [];
                        this.array_an = [];
                        this.array_rc = [];
                        this.array_em = [];
                        this.array_wa = [];
                        this.array_wc = [];
                        this.array_ln = [];
                        this.array_tg = [];
                        this.array_zl = [];

                        //this part need to update $cri of the id we get from the user we copy

                        //var customizeRegistrationId = this.$route.query.cri;
                        //if (customizeRegistrationId > 0 && this.bool_showCR && (this.getUserInfo.AT == 0 || this.getUserInfo.AT > 2)) {
                        this.getDataApi(`/api/rcuz/g/${id}`,
                            function (d, s) {
                                if (s && d && d.D) {
                                    that.setCR(d.D);

                                    if (that.arry_cr.AGI != 0) {

                                        that.arry_cr.I = 0;
                                        that.arry_cr.AGI = 0;
                                        that.arry_cr.AGIT = 0;
                                        that.arry_cr.GN = "";
                                        that.arry_cr.GPC = "";

                                        that.arry_cr.AGIT = that.arry_cr.AGI;
                                        that.searchAgent = ["3-" + that.arry_cr.AGI];
                                    }
                                }
                            });
                        //}
                    }

                    //Copy Customize Deposit
                    if (that.bool_copyCuzDeposit) {
                        this.bool_showCD = (this.bool_showCD ? this.bool_showCD = false : this.bool_showCD = true);
                        this.bool_showDS = this.bool_showBOAC = this.bool_showDSS = this.bool_showDMSS = this.bool_showACS = this.bool_showBS = this.bool_showLCS = this.bool_showCR = false;

                        //reset to blank
                        this.arry_cd = {
                            I: 0,
                            RS: 2,
                            CTS: "0001-01-01T00:00:00",
                            CBI: 0,
                            CB: null,
                            UTS: "0001-01-01T00:00:00",
                            UBI: 0,
                            UB: null,
                            nCuzView: null,
                            DepositDraggeBase: [],
                            VTCDepositDraggeBase: [],
                            AGI: "",
                            AGIT: null,
                            CI: null,
                            E_CC: "",
                            E_PC: "",
                            LocalisedList: [],
                            InactiveDays: 365,
                            Rate: 0,
                            TMultiLangDepositList: []
                        };

                        this.getDataApi(`/api/dd/cur/` + id,
                            function (d, s) {
                                if (s) {
                                    that.dd_currency_cd = d.dropdownlist;

                                    that.arry_cd.AGI = id;

                                    //Shuffle through each of the Currency ID
                                    for (let key in that.dd_currency_cd) {
                                        if (that.dd_currency_cd.hasOwnProperty(key)) {
                                            let item = that.dd_currency_cd[key];
                                            that.arry_cd['AGI'] = id;

                                            that.CurrencyChange_cd(item.id);
                                        }
                                    }
                                }

                                that.addCustomizeDeposit();
                                //that.arry_cd.AGIT = agi[1];
                                //that.arry_cd.AGI = agi[1];
                            });

                        this.array_da = [];
                        this.array_cya = [];
                        this.array_sb = [];
                        this.array_ti = [];
                        this.array_dtod = [];
                        this.array_ur = [];
                        this.array_p = [];
                        this.array_n = [];
                    }


                    //only stop loading when all has finished process
                    this.bool_fullLoading = false;
                }
            },
            addSelfService(pgit, agentType) {
                var that = this;
                this.bool_fullLoading = true;
                this.bool_groupCV = false;
                this.str_WebConfigCaptchaOption = "";

                this.setObject();
                if (this.getUserInfo.AT == 0) {
                    this.bool_fullLoading = false;
                    if (agentType == 'sm' || agentType == 'ma') {
                        this.bool_isAgentType = false;
                    } else {
                        this.bool_isAgentType = true;
                    }
                } else {
                    //this.obj_Group.PGIT = pgit;
                    if (this.getUserInfo.AT != 0 || this.getUserInfo.IHAGIF) { // check if not superadmin / not cross brand will auto populate brand value
                        this.bool_isAutoPopulate = true;
                        if (this.dd_agentgroup.length != 0) {
                            this.obj_Group.PGIT = this.dd_agentgroup[0].id;
                        }
                        else {
                            this.obj_Group.PGIT = pgit;
                        }
                    }
                    this.ParentGroupChange(this.obj_Group.PGIT)
                }

                this.showSectionBasedRole('ds');

            },
            editSelfService() {
                this.bool_fullLoading = true;
                this.bool_groupCV = false;
                this.searchSubBrand = null;
                this.bool_disableInsertDomain = false;
                this.bool_disableInsertLiveChat = true;
                this.bool_disableInsertBank = true;
                this.setObject();
                this.showSectionBasedRole(this.$route.query.section);
            },
            DSCurrencyChange() {
                // Handle Currency Codes
                const selectedLangDS = this.obj_Domain.DS[this.selectedLangIndex];
                selectedLangDS.CurrencyCodes = _.uniq(selectedLangDS.CurrencyCodes);
                if (selectedLangDS.CurrencyCodes && selectedLangDS.CurrencyCodes.length) {
                    selectedLangDS.CC = selectedLangDS.CurrencyCodes.join(',');
                }
            },
            /* Save Button on:
             Downline Setting(ds), Language & Currency & Gameprovider Setting(dss), Domain & Member Site Setting(dmss),
             Website Config Setting(acs), LiveChat Setting(lcs), Bank Account Setting(bs)
            */
            saveSelfService(type) {

                if (this.obj_Group.I == 0) {
                    this.obj_Group.PT = this.obj_Group.DPT;
                }
                if (this.obj_Group.PGIT != null && this.obj_Group.PGIT.length > 0) {
                    var agi = this.obj_Group.PGIT.split("-");
                    this.obj_Group.PGI = agi[1];
                    this.obj_Group.AT = parseInt(agi[0]) + 1;
                }
                if (this.obj_Group.CurrencyIds != null && this.obj_Group.CurrencyIds.length > 0) {
                    this.obj_Group.CI = this.obj_Group.CurrencyIds.join(',');
                }
                if (this.obj_Group.H2PCurrencyCodes != null && this.obj_Group.H2PCurrencyCodes.length > 0) {
                    this.obj_Group.H2PCC = this.obj_Group.H2PCurrencyCodes.join(',');
                }
                if (this.obj_Group.Language != null && this.obj_Group.Language.length > 0) {
                    this.obj_Group.L = this.obj_Group.Language.join(',');
                }
                if (this.obj_Group.GameProviderIds != null && this.obj_Group.GameProviderIds.length > 0) {
                    this.obj_Group.GPI = this.obj_Group.GameProviderIds.join(',');
                }
                if (this.obj_Group.WhiteListIP != null && this.obj_Group.WhiteListIP.length > 0) {
                    this.obj_Group.WLIPS = "";
                    for (var i = 0; i < this.obj_Group.WhiteListIP.length; i++) {
                        if (i != 0) {
                            this.obj_Group.WLIPS += ",";
                        }
                        this.obj_Group.WLIPS += this.obj_Group.WhiteListIP[i].WLIPS;
                    }
                }
                if (this.str_houtOriPrefix == this.obj_Group.PC) {
                    this.obj_Group.hout_PrefixChange = true;
                } else {
                    this.obj_Group.hout_PrefixChange = false;
                }

                //New Domain
                //Temporary Fixes
                if (this.obj_Group.Language != null && this.obj_Group.Language.length > 0) {
                    this.obj_Group.L = this.obj_Group.Language.join(',');
                }

                //Temporary Fixes
                if (this.obj_Group.CurrencyIds != null && this.obj_Group.CurrencyIds.length > 0) {
                    this.obj_Group.CI = this.obj_Group.CurrencyIds.join(',');
                }

                var checkValidLocalized = true;

                //Caches the result
                const imageUrlTabIndexCache = {
                    '#imageURLTab': this.getIURLTabIndex("#imageURLTab"),
                    '#imageURLTab2': this.getIURLTabIndex("#imageURLTab2"),
                    '#imageURLTab4': this.getIURLTabIndex("#imageURLTab4")
                };

                //site logo
                this.obj_Domain.SLBL = imageUrlTabIndexCache['#imageURLTab'] === 2 && this.obj_Domain.LOGOByLink && this.obj_Domain.LOGOByLink.trim();

                //site icon
                this.obj_Domain.SIBL = imageUrlTabIndexCache['#imageURLTab2'] === 2 && this.obj_Domain.ICONByLink && this.obj_Domain.ICONByLink.trim();

                //mobile site logo
                this.obj_Domain.MSLBL = imageUrlTabIndexCache['#imageURLTab4'] === 2 && this.obj_Domain.MobileLOGOByLink && this.obj_Domain.MobileLOGOByLink.trim();

                for (var i = 0; i < this.obj_Domain.DS.length; i++) {
                    if (this.obj_Domain.DS[i].TC) {
                        //auto populate same setting for other language setting
                        this.obj_Domain.DS[i].AFB1188OM = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].AFB1188OM : this.obj_Domain.DS[i].AFB1188OM);
                        this.obj_Domain.DS[i].AFB1188OS = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].AFB1188OS : this.obj_Domain.DS[i].AFB1188OS);
                        this.obj_Domain.DS[i].AFB1188SM = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].AFB1188SM : this.obj_Domain.DS[i].AFB1188SM);
                        this.obj_Domain.DS[i].AFB1188SW = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].AFB1188SW : this.obj_Domain.DS[i].AFB1188SW);

                        this.obj_Domain.DS[i].CURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].CURL : this.obj_Domain.DS[i].CURL);
                        this.obj_Domain.DS[i].GCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].GCURL : this.obj_Domain.DS[i].GCURL);
                        this.obj_Domain.DS[i].ALTCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].ALTCURL : this.obj_Domain.DS[i].ALTCURL);
                        this.obj_Domain.DS[i].ALTGCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].ALTGCURL : this.obj_Domain.DS[i].ALTGCURL);
                        this.obj_Domain.DS[i].MCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].MCURL : this.obj_Domain.DS[i].MCURL);
                        this.obj_Domain.DS[i].MGCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].MGCURL : this.obj_Domain.DS[i].MGCURL);
                        this.obj_Domain.DS[i].ALTMCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].ALTMCURL : this.obj_Domain.DS[i].ALTMCURL);
                        this.obj_Domain.DS[i].ALTMGCURL = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].ALTMGCURL : this.obj_Domain.DS[i].ALTMGCURL);

                        this.obj_Domain.DS[i].CurrencyCodes = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].CurrencyCodes : this.obj_Domain.DS[i].CurrencyCodes);
                        this.obj_Domain.DS[i].CC = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].CC : this.obj_Domain.DS[i].CurrencyCodes.join(','));

                        this.obj_Domain.DS[i].GameProviderIdS = this.obj_Group.GameProviderIds;
                        this.obj_Domain.DS[i].GPI = this.obj_Group.GPI;

                        this.obj_Domain.DS[i].TI = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].TI : this.obj_Domain.DS[i].TI);
                        this.obj_Domain.DS[i].MTI = (!this.bool_multiTemplateOneDomain ? (this.obj_Domain.DS[this.selectedLangIndex].AMT ? this.obj_Domain.DS[this.selectedLangIndex].MTI : null) : (this.obj_Domain.DS[i].AMT ? this.obj_Domain.DS[i].MTI : null))
                        this.obj_Domain.DS[i].TSI = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].TSI : this.obj_Domain.DS[i].TSI);
                        this.obj_Domain.DS[i].MTSI = (!this.bool_multiTemplateOneDomain ? (this.obj_Domain.DS[this.selectedLangIndex].AMT ? this.obj_Domain.DS[this.selectedLangIndex].MTSI : null) : (this.obj_Domain.DS[i].AMT ? this.obj_Domain.DS[i].MTSI : null))

                        if (this.obj_Domain.DS[i].E2SSIM) {
                            this.obj_Domain.DS[i].TIALT = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].TIALT : this.obj_Domain.DS[i].TIALT);
                            this.obj_Domain.DS[i].MTIALT = (!this.bool_multiTemplateOneDomain ? (this.obj_Domain.DS[this.selectedLangIndex].AMTALT ? this.obj_Domain.DS[this.selectedLangIndex].MTIALT : null) : (this.obj_Domain.DS[i].AMTALT ? this.obj_Domain.DS[i].MTIALT : null))
                            this.obj_Domain.DS[i].TSIALT = (!this.bool_multiTemplateOneDomain ? this.obj_Domain.DS[this.selectedLangIndex].TSIALT : this.obj_Domain.DS[i].TSIALT);
                            this.obj_Domain.DS[i].MTSIALT = (!this.bool_multiTemplateOneDomain ? (this.obj_Domain.DS[this.selectedLangIndex].AMTALT ? this.obj_Domain.DS[this.selectedLangIndex].MTSIALT : null) : (this.obj_Domain.DS[i].AMTALT ? this.obj_Domain.DS[i].MTSIALT : null))
                        } else {
                            //this.obj_Domain.DS[i].EETAD = null;
                            this.obj_Domain.DS[i].TIALT = null;
                            this.obj_Domain.DS[i].MTIALT = null
                            this.obj_Domain.DS[i].TSIALT = null;
                            this.obj_Domain.DS[i].MTSIALT = null;
                        }
                    }
                }


                // Handle Maintenance IP
                if (this.obj_Domain.MaintenanceIP && this.obj_Domain.MaintenanceIP.length) {
                    this.obj_Domain.MIP = this.obj_Domain.MaintenanceIP.map(ip => ip.MIP).join(',');
                }

                // Handle Domain Name Server
                if (this.obj_Domain.DomainNameServer && this.obj_Domain.DomainNameServer.length) {
                    this.obj_Domain.DNS = this.obj_Domain.DomainNameServer.map(dns => dns.DNS).join(',');
                }

                // Handle SEO settings
                this.obj_Domain.SEOR = this.obj_Domain.SRT && this.obj_Domain.SRT.length ? this.obj_Domain.SRT.join(',') : "";

                // Handle default values for ADI
                if (!this.obj_Domain.ADI) {
                    this.obj_Domain.ADI = "";
                }

                // Handle SMSV Pages and EV Pages
                this.obj_Domain.SMSVP = this.obj_Domain.SMSVPages ? this.obj_Domain.SMSVPages.join(',') : "";
                this.obj_Domain.EVP = this.obj_Domain.EVPages ? this.obj_Domain.EVPages.join(',') : "";


                // Update flags based on SLBL, SIBL, MSLBL
                this.obj_Domain.RSL = this.obj_Domain.SLBL !== this.bool_holSLBL && this.obj_Domain.SLBL;
                this.obj_Domain.RSI = this.obj_Domain.SIBL !== this.bool_holSIBL && this.obj_Domain.SIBL;
                this.obj_Domain.RMSL = this.obj_Domain.MSLBL !== this.bool_holMSLBL && this.obj_Domain.MSLBL;

                // Assign selected files
                this.obj_Domain.NSL = this.selectedFile;
                this.obj_Domain.NSI = this.selectedFileIco;
                this.obj_Domain.NMSL = this.selectedFileMsl;

                this.obj_Domain.L = this.obj_Domain.DS
                    .filter(setting => setting.TC) // Include only enabled settings
                    .map(setting => setting.L)     // Extract the language codes
                    .join(',');                   // Create a comma-separated string


                var isRegWPhone = this.arry_OnOff.RegistrationSetting.REGWPHONE.CV;
                var isLocalized = this.arry_OnOff.RegistrationSetting.ULPN.CV;
                var isEPrefix = this.arry_OnOff.RegistrationSetting.UPCODE.CV;
                var checkValidLocalized = true;
                var emptyPrefix = false;
                this.arry_aac['RS'] = 2;


                //Turn any passed in object to false (or opposite of DC)
                const updateCV = (settings) => {
                    Object.keys(settings).forEach(key => {
                        settings[key].CV = !settings[key].DC;
                    });
                };

                //Sets a default value if CV is true but radio group is empty
                const updateCVDefaultValue = (optionKey, setting, defaultValue) => {
                    if (!setting.CV) {
                        this[optionKey] = "";
                    } else if (this[optionKey] === "") {
                        this[optionKey] = defaultValue;
                    }
                };

                //Set the selected radio button to true
                const updateCaptchaOption = (optionKey, setting) => {
                    if (this[optionKey] && setting[this[optionKey]]) {
                        setting[this[optionKey]].CV = setting[this[optionKey]].DC;
                    }
                };

                //Toggle CV for all Captchas
                updateCV(this.arry_OnOff.Captchas);

                //Toggle CV for all Payment Options
                updateCV(this.arry_OnOff.PaymentOptions);

                //Sets default value for Captcha Option if found empty
                //updateCVDefaultValue('str_WebConfigCaptchaOption', this.arry_OnOff.BankBackOfficeSetting.PDO, "DCC");

                //Removed for TT9958
                //Sets default value for Preferred Deposit Option if found empty
                //updateCVDefaultValue('str_PreferredDepositOption', this.arry_OnOff.BankBackOfficeSetting.PDO, "MD");

                //Sets default value for Tournament Option if found empty
                //updateCVDefaultValue('str_TournamentNavOption', this.arry_OnOff.TournamentOptions.DTMB, "DTMB");

                ////Sets default value for Forgot Password Option if found empty
                //updateCVDefaultValue('str_ForgotPasswordLinkOption', this.arry_OnOff.PasswordOptions.FPDTMB, "FPDTMB");

                //Enables the selected radio button for Captcha Option
                updateCaptchaOption('str_WebConfigCaptchaOption', this.arry_OnOff.Captchas);

                //Removed for TT9958
                //Enables the selected radio button for Preferred Deposit Option
                //updateCaptchaOption('str_PreferredDepositOption', this.arry_OnOff.BankBackOfficeSetting);

                //Enables the selected radio button for Forgot Password Option
                updateCaptchaOption('str_ForgotPasswordLinkOption', this.arry_OnOff.PasswordOptions);

                //Enables the selected radio button for Tournament Option
                updateCaptchaOption('str_TournamentNavOption', this.arry_OnOff.TournamentOptions);

                this.arry_OnOff.RegistrationSetting.FNM.CV = this.arry_OnOff.RegistrationSetting.FNM.CV || this.arry_OnOff.BankBackOfficeSetting.FNABAN.CV;

                if (this.arry_OnOff.MemberSiteSetting.DSAB.CV) {
                    this.arry_aac.InactiveDays = -1;
                }

                this.arry_OnOff.MemberSiteSetting.GLIFSW.CV = this.arry_OnOff.MemberSiteSetting.GLIF.CV && this.arry_OnOff.MemberSiteSetting.GLIFSW.CV;
                this.arry_OnOff.MemberSiteSetting.DLGFML.CV = this.arry_OnOff.MemberSiteSetting.EGPLL.CV && this.arry_OnOff.MemberSiteSetting.DLGFML.CV;

                if (this.arry_aac.AGIT != null && this.arry_aac.AGIT.length > 0) {
                    var agi = this.arry_aac.AGIT.split("-");
                    //this.arry_aac.AGI = agi[1];
                    //this.arry_aac.AgentGroupIds = this.arry_aac
                }

                //this.arry_OnOff["Captchas"]["CCAOLN"].CV = !this.arry_OnOff["Captchas"]["CCAOLN"].DC;
                //this.arry_OnOff["Captchas"]["CCNO"].CV = !this.arry_OnOff["Captchas"]["CCNO"].DC;
                //this.arry_OnOff["Captchas"]["CCALPN"].CV = !this.arry_OnOff["Captchas"]["CCALPN"].DC;
                //this.arry_OnOff["Captchas"]["DCC"].CV = !this.arry_OnOff["Captchas"]["DCC"].DC;
                //if (this.arry_OnOff["RegistrationSetting"]["FNM"].CV == false) {
                //    this.arry_OnOff["BankBackOfficeSetting"]["FNABAN"].CV = false;
                //}
                //if (this.str_WebConfigCaptchaOption != "" && this.str_WebConfigCaptchaOption != null) {
                //    this.arry_OnOff["Captchas"][this.str_WebConfigCaptchaOption].CV = this.arry_OnOff["Captchas"][this.str_WebConfigCaptchaOption].DC;
                //}
                //this.arry_OnOff["MD"].CV = !this.arry_OnOff["MD"].DC;
                //this.arry_OnOff["AD"].CV = !this.arry_OnOff["AD"].DC;
                //this.arry_OnOff["ADP"].CV = !this.arry_OnOff["ADP"].DC;
                //this.arry_OnOff["HP"].CV = !this.arry_OnOff["HP"].DC;
                //this.arry_OnOff["OP"].CV = !this.arry_OnOff["OP"].DC;
                //this.arry_OnOff["EZP"].CV = !this.arry_OnOff["EZP"].DC;
                //this.arry_OnOff["TUP"].CV = !this.arry_OnOff["TUP"].DC;
                //this.arry_OnOff["CT"].CV = !this.arry_OnOff["CT"].DC;
                //this.arry_OnOff["XFU"].CV = !this.arry_OnOff["XFU"].DC;
                //this.arry_OnOff["STP"].CV = !this.arry_OnOff["STP"].DC;
                //this.arry_OnOff["SUREP"].CV = !this.arry_OnOff["SUREP"].DC;
                //this.arry_OnOff["FUP"].CV = !this.arry_OnOff["FUP"].DC;
                //this.arry_OnOff["U2P"].CV = !this.arry_OnOff["U2P"].DC;
                //this.arry_OnOff["LP"].CV = !this.arry_OnOff["LP"].DC;
                //this.arry_OnOff["BCP"].CV = !this.arry_OnOff["BCP"].DC;
                //this.arry_OnOff["FPG"].CV = !this.arry_OnOff["FPG"].DC;
                //this.arry_OnOff["PGA"].CV = !this.arry_OnOff["PGA"].DC;
                //this.arry_OnOff["AGP"].CV = !this.arry_OnOff["AGP"].DC;
                //this.arry_OnOff["P918"].CV = !this.arry_OnOff["P918"].DC;
                //this.arry_OnOff["TMONEY"].CV = !this.arry_OnOff["TMONEY"].DC;
                //this.arry_OnOff["DTMB"].CV = !this.arry_OnOff["DTMB"].DC;
                //this.arry_OnOff["DT"].CV = !this.arry_OnOff["DT"].DC;
                //this.arry_OnOff["MB"].CV = !this.arry_OnOff["MB"].DC;
                //this.arry_OnOff["FPDTMB"].CV = !this.arry_OnOff["FPDTMB"].DC;
                //this.arry_OnOff["FPDT"].CV = !this.arry_OnOff["FPDT"].DC;
                //this.arry_OnOff["FPMB"].CV = !this.arry_OnOff["FPMB"].DC;
                //this.arry_OnOff["PP"].CV = !this.arry_OnOff["PP"].DC;
                //this.arry_OnOff["DN"].CV = !this.arry_OnOff["DN"].DC;
                //this.arry_OnOff["UP"].CV = !this.arry_OnOff["UP"].DC;
                //this.arry_OnOff["OKP"].CV = !this.arry_OnOff["OKP"].DC;
                //this.arry_OnOff["MGP"].CV = !this.arry_OnOff["MGP"].DC;
                //this.arry_OnOff["VIP"].CV = !this.arry_OnOff["VIP"].DC;


                //if (this.str_PreferredDepositOption == "" && this.arry_OnOff["PDO"].CV) {
                //    this.str_PreferredDepositOption = "MD";
                //}
                //if (!this.arry_OnOff["PDO"].CV) {
                //    this.str_PreferredDepositOption = "";
                //}
                //if (this.str_PreferredDepositOption != "" && this.str_PreferredDepositOption != null) {
                //    this.arry_OnOff[this.str_PreferredDepositOption].CV = this.arry_OnOff[this.str_PreferredDepositOption].DC;
                //}
                //if (this.str_TournamentNavOption == "" && this.arry_OnOff["ETBN"].CV) {
                //    this.str_TournamentNavOption = "DTMB";
                //}
                //if (!this.arry_OnOff["ETBN"].CV) {
                //    this.str_TournamentNavOption = "";
                //}
                //if (this.str_TournamentNavOption != "" && this.str_TournamentNavOption != null) {
                //    this.arry_OnOff[this.str_TournamentNavOption].CV = this.arry_OnOff[this.str_TournamentNavOption].DC;
                //}

                //if (this.str_ForgotPasswordLinkOption == "" && this.arry_OnOff["EFPL"].CV) {
                //    this.str_ForgotPasswordLinkOption = "FPDTMB";
                //}
                //if (!this.arry_OnOff["EFPL"].CV) {
                //    this.str_ForgotPasswordLinkOption = "";
                //}
                //if (this.str_ForgotPasswordLinkOption != "" && this.str_ForgotPasswordLinkOption != null) {
                //    this.arry_OnOff[this.str_ForgotPasswordLinkOption].CV = this.arry_OnOff[this.str_ForgotPasswordLinkOption].DC;
                //}
                //if (this.arry_OnOff["DSAB"].CV) {
                //    this.arry_aac.InactiveDays = -1;
                //}
                //if (!this.arry_OnOff["GLIF"].CV) {
                //    this.arry_OnOff["GLIFSW"].CV = false;
                //}
                //if (!this.arry_OnOff["EGPLL"].CV) {
                //    this.arry_OnOff["DLGFML"].CV = false;
                //}

                this.arry_aac.nCuzView = [];
                Object.entries(this.arry_OnOff).forEach(([categoryKey, categoryValue]) => {
                    if (typeof categoryValue === 'object') {
                        Object.entries(categoryValue).forEach(([key, value]) => {
                            if (value.CV === value.DC) {
                                this.arry_aac.nCuzView.push(key);
                            }
                        });
                    }
                });

                //this.arry_aac.nCuzView = [];
                //for (const [key, value] of Object.entries(this.arry_OnOff)) {
                //    if (value.CV == value.DC) {
                //        this.arry_aac.nCuzView.push(key);
                //    }
                //}
                //if (this.arry_OnOff["SM"].CV) {
                //    if (!this.arry_OnOff["WCID"].CV && !this.arry_OnOff["LID"].CV && !this.arry_OnOff["WAID"].CV && !this.arry_OnOff["TGID"].CV && !this.arry_OnOff["ZLID"].CV) {
                //        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["SMCODE"]), 1000);
                //        checkValidSocialMedia = false;
                //    }
                //}

                // Validate Social Media settings
                if (this.arry_OnOff.RegistrationSetting.SM.CV) {
                    const socialMediaKeys = ['WCID', 'LID', 'WAID', 'TGID', 'ZLID'];
                    const validSocialMedia = socialMediaKeys.some(key => this.arry_OnOff.RegistrationSetting[key].CV);
                    if (!validSocialMedia) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["SMCODE"]), 1000);
                        checkValidSocialMedia = false;
                    }
                }


                this.bool_errminmax = false;
                if (this.obj_bankacc.MIND != 0 && this.obj_bankacc.MIND != null && this.obj_bankacc.MAXD != 0 && this.obj_bankacc.MAXD != null) {
                    if (parseFloat(this.obj_bankacc.MIND) < parseFloat(this.obj_bankacc.MAXD)) {
                        this.bool_errminmax = true;
                    }
                    else {
                        this.bool_errminmax = false;
                    }
                } else {
                    this.bool_errminmax = true;
                }
                if (this.obj_bankacc.MINW != 0 && this.obj_bankacc.MINW != null && this.obj_bankacc.MAXW != 0 && this.obj_bankacc.MAXW != null) {
                    if (parseFloat(this.obj_bankacc.MINW) < parseFloat(this.obj_bankacc.MAXW)) {
                        this.bool_errminmax = true;
                    }
                    else {
                        this.bool_errminmax = false;
                    }
                } else {
                    this.bool_errminmax = true;
                }
                this.obj_bankacc.BAN = this.obj_bankacc.BAN.replace(/[^0-9a-z]/gi, ''); // TT2791 remove nonAlphaNum and whitespace before saving
                var iurlTab = this.getIURLTabIndex("#imageURLTab3");
                if (iurlTab != 1) { // external img url
                    if (this.obj_bankacc.QRCI != null && this.obj_bankacc.QRCI != "") {
                        //if img url is not empty
                        this.obj_bankacc.IUT = true;
                        this.newImg = true;
                    }
                }

                //// check the require field
                this.bool_groupCV = true;

                if (this.getUserInfo.AT == 1) {
                    this.bool_disableInsertDomain = true;
                    this.bool_disableInsertLiveChat = true;
                    this.bool_disableInsertBank = true;
                    this.bool_disableInsertAgentMembersiteConfig = true;
                } else if (this.getUserInfo.AT == 2) {
                    this.bool_disableInsertLiveChat = true;
                    this.bool_disableInsertBank = true;
                    this.bool_disableInsertAgentMembersiteConfig = true;
                }

                if (type == 'ds' || type == 'dss' || type == 'acs') {
                    this.bool_disableInsertLiveChat = true;
                    this.bool_disableInsertBank = true;
                    this.bool_disableInsertDomain = true;
                    this.arry_aac['bool_isEditWebConfig'] = true;
                }
                else if (type == 'dmss') {
                    this.bool_showDMSS = true;
                    this.bool_disableInsertLiveChat = true;
                    this.bool_disableInsertBank = true;
                }
                else if (type == 'lcs') {
                    this.bool_showLCS = true;
                    this.bool_disableInsertDomain = true;
                    this.bool_disableInsertBank = true;
                }
                else if (type == 'bs') {
                    this.bool_showBS = true;
                    this.bool_disableInsertLiveChat = true;
                    this.bool_disableInsertDomain = true;
                }

                this.$v.obj_Group.$touch();
                if (!this.$v.obj_Group.$error && this.str_prefixError == "") {
                    this.bool_showDS = false;
                    this.bool_showDSS = false;
                    this.bool_showBOAC = false;
                }

                // Handle domain error validation
                if (this.bool_isAgentType) {
                    this.$v.obj_Domain.$touch();
                    if (!this.$v.obj_Domain.$error) {
                        this.bool_showDMSS = !this.bool_disableInsertDomain;
                    } else if (this.bool_disableInsertDomain) {
                        this.bool_showDMSS = false;
                    }
                }

                this.bool_showACS = false;


                if (this.bool_isAgentType && !this.bool_disableInsertLiveChat) {
                    this.$v.obj_livechat.$touch();
                    if (!this.$v.obj_livechat.$error) {
                        this.bool_showLCS = false;
                    }
                } else if (this.bool_isAgentType && this.bool_disableInsertLiveChat) {
                    this.bool_showLCS = false;
                }


                if (this.bool_isAgentType && !this.bool_disableInsertBank) {
                    this.$v.obj_bankacc.$touch();
                    if (!this.$v.obj_bankacc.$error) {
                        this.bool_showBS = false;
                    }
                } else if (this.bool_isAgentType && this.bool_disableInsertBank) {
                    this.bool_showBS = false;
                }

                setTimeout(() => {
                    $(".ErrMsg").each(function (index) {
                        if ($(this).text()) {
                            $('html, body').animate({
                                scrollTop: $(this).parent().offset().top - 70
                            }, 'smooth');
                            return false;
                        }
                    });
                }, 100)

                if (!this.$v.obj_Group.$error && !this.$v.obj_Domain.$error && this.str_prefixError == "" && checkValidLocalized == true && !this.$v.obj_livechat.$error && !this.$v.obj_bankacc.$error && this.bool_errminmax) {
                    this.obj_livechat["L"] = [];
                    for (var i = 0; i < this.obj_livechat.arry_holdLang.length; i++) {
                        if (i != 0) {
                            this.obj_livechat["L"] += ",";
                        }
                        this.obj_livechat["L"] += this.obj_livechat.arry_holdLang[i];
                    }

                    if (this.newScriptFile == true || this.obj_livechat["I"] == 0) {
                        //if new File is selected
                        this.obj_livechat["configFile"] = this.selectedScriptFile;

                    } else if (this.newScriptFile == false && this.obj_livechat["I"] > 0) {
                        this.obj_livechat["configFile"] = null;
                        //if user edit, but want to retain file
                    }

                    //if (isRegWPhone == true) {
                    //    if (isLocalized == true) {
                    //        if (this.arry_aac.LocalisedList.length == 0) {
                    //            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["RPCODE"]), 1000);
                    //            checkValidLocalized = false;
                    //        } else {
                    //            if (isEPrefix == true) {
                    //                for (var i = 0; i < this.arry_aac.LocalisedList.length; i++) {
                    //                    if (this.arry_aac.LocalisedList[i].PC == "") {
                    //                        emptyPrefix = true;
                    //                        break;
                    //                    }
                    //                }

                    //                if (emptyPrefix) {
                    //                    checkValidLocalized = false;
                    //                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["EMPCODE"]), 1000);
                    //                }
                    //            }
                    //        }
                    //    } else {
                    //        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["RPCODE"]), 1000);
                    //        checkValidLocalized = false;
                    //    }
                    //}

                    this.obj_bankacc.MT = '';
                    if (this.obj_bankacc.MTV && this.obj_bankacc.MTV.length > 0 && this.obj_bankacc.VIPBA) {
                        this.obj_bankacc.MT = this.obj_bankacc.MTV.join(',');
                    }
                    this.obj_bankacc.ID = this.obj_bankacc.ID == 1 ? true : false;
                    this.obj_bankacc.IW = this.obj_bankacc.IW == 1 ? true : false;
                    this.obj_bankacc.IA = this.obj_bankacc.IA == null ? 0 : this.obj_bankacc.IA;
                    if (this.newImg == true) {
                        this.obj_bankacc['QRCodeImage'] = this.selectedFile;
                    }
                    if (this.bool_disableInsertAgentMembersiteConfig) {
                        this.arry_aac.CB = "skip";
                        this.arry_aac.UB = "skip";
                    }
                    if (this.bool_disableInsertDomain) {
                        this.obj_Domain.I = 0;
                        this.obj_Domain.RS = 0;
                        this.obj_Domain.CTS = "1900-01-01 00:00:00.000";
                        this.obj_Domain.CBI = 0;
                        this.obj_Domain.CB = "skip";
                        this.obj_Domain.UTS = "1900-01-01 00:00:00.000";
                        this.obj_Domain.UBI = 0;
                        this.obj_Domain.UB = "skip";
                        this.obj_Domain.AGI = 0;
                        this.obj_Domain.L = "";
                        this.obj_Domain.DL = "";
                        this.obj_Domain.CC = "";
                        this.obj_Domain.SEOR = "";
                        this.obj_Domain.MIP = "";
                        this.obj_Domain.TID = "";
                        this.obj_Domain.SMSV = 0;
                        this.obj_Domain.SMSVP = "";
                        this.obj_Domain.EV = 0;
                        this.obj_Domain.EVP = "";
                        this.obj_Domain.SIBL = 0;
                        this.obj_Domain.SLBL = 0;
                        this.obj_Domain.IM = 0;
                        this.obj_Domain.DLFIP = 0;
                        this.obj_Domain.AFB1188SBAPI = "";
                        this.obj_Domain.MSLBL = 0;
                    }
                    if (this.bool_disableInsertLiveChat) {
                        this.obj_livechat.I = 0;
                        this.obj_livechat.RS = 0;
                        this.obj_livechat.CTS = "1900-01-01 00:00:00.000";
                        this.obj_livechat.CBI = 0;
                        this.obj_livechat.CB = "skip";
                        this.obj_livechat.UTS = "1900-01-01 00:00:00.000";
                        this.obj_livechat.UBI = 0;
                        this.obj_livechat.UB = "skip";
                        this.obj_livechat.AGI = 0;
                        this.obj_livechat.LCPI = "";
                        this.obj_livechat.L = "";
                        this.obj_livechat.LK = "";
                        this.obj_livechat.DI = 0;
                        this.obj_livechat.CURL = "";
                        this.obj_livechat.LCURL = "";
                    }
                    if (this.bool_disableInsertBank) {
                        this.obj_bankacc.I = 0;
                        this.obj_bankacc.RS = 0;
                        this.obj_bankacc.CTS = "1900-01-01 00:00:00.000";
                        this.obj_bankacc.CBI = "";
                        this.obj_bankacc.CB = "skip";
                        this.obj_bankacc.UTS = "1900-01-01 00:00:00.000";
                        this.obj_bankacc.UBI = 0;
                        this.obj_bankacc.UB = "skip";
                        this.obj_bankacc.BI = 0;
                        this.obj_bankacc.BA = "";
                        this.obj_bankacc.BAN = "";
                        this.obj_bankacc.CI = 0;
                        this.obj_bankacc.AB = 0;
                        this.obj_bankacc.MIND = 0;
                        this.obj_bankacc.MAXD = 0;
                        this.obj_bankacc.MINW = 0;
                        this.obj_bankacc.MAXW = 0;
                        this.obj_bankacc.TD = 0;
                        this.obj_bankacc.TW = 0;
                        this.obj_bankacc.ID = 0;
                        this.obj_bankacc.IW = 0;
                        this.obj_bankacc.AGI = 0;
                        this.obj_bankacc.BU = "";
                        this.obj_bankacc.BP = "";
                        this.obj_bankacc.SS = 0;
                        this.obj_bankacc.IA = 0;
                        this.obj_bankacc.ADS = "";
                        this.obj_bankacc.ADR = "";
                        this.obj_bankacc.LPUTS = "";
                        this.obj_bankacc.QRCI = "";
                        this.obj_bankacc.VIPBA = 0;
                        this.obj_bankacc.VIPBA = "";
                        this.obj_bankacc.TUD = 0;
                        this.obj_bankacc.BICN = "";
                        this.obj_bankacc.BDOB = "";
                        this.obj_bankacc.BMN = "";
                        this.obj_bankacc.BAP = "";
                        this.obj_bankacc.BDI = "";
                        this.obj_bankacc.BCT = "";
                    }

                    //grab domainId to pass to SelfServiceController
                    var domainId = this.$route.query.di;

                    const createPayload = {
                        ...this.obj_Group
                    }

                    if (this.$route.query.agt == 'sm' ||
                        this.$route.query.agt == 'ma' ||
                        this.$route.query.agt == 'a') {
                        createPayload.isCreateSM = true; 
                    }

                    this.obj_Group.IsSendNoti = true;
                    this.bool_fullLoading = true;
                    var that = this;
                    if (!this.bool_isAgentType) {

                        this.postDataApi(`/api/ag/s`, createPayload,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {

                                    that.bool_isAMV = false;

                                    // reload agent group dropdown
                                    that.popUpAgentDetailModal(d.BD);
                                }
                            });

                        //this.postDataApi(`/api/ag/s`, this.obj_Group,
                        //    function (d, s) {
                        //        that.bool_fullLoading = false;
                        //        if (s) {

                        //            that.bool_isAMV = false;

                        //            // reload agent group dropdown
                        //            that.popUpAgentDetailModal(d.BD);
                        //        }
                        //    });
                    } else if (this.bool_isAgentType && checkValidLocalized == true) {
                        this.arry_aac['bool_isEditWebConfig'] = true;
                        var bool_deleteDomainCache = true;

                        //use payload for easier adjustment
                        var payload = {
                            "AgentGroup": this.obj_Group,
                            "Domain": this.obj_Domain,
                            "LiveChat": this.obj_livechat,
                            "AgentMembersiteConfig": this.arry_aac,
                            "BankAccount": this.obj_bankacc,
                            "DomainId": domainId,
                            "DeleteDomainCache": bool_deleteDomainCache
                        }

                        //Conditionally add CuzMenu only if copied is true
                        if (this.bool_copyCuzMenu && this.obj_awt != null) {
                            payload.CuzMenu = this.obj_awt.D;
                        }

                        //Conditionally add CuzReg if copied is true
                        if (this.bool_copyCuzReg && this.arry_cr != null) {
                            payload.CuzReg = this.arry_cr;
                        }

                        //Conditionally add CuzDeposit if copied is true
                        if (this.bool_copyCuzDeposit && this.arr_copyCuzDeposit != null) {
                            payload.CuzDeposit = this.arr_copyCuzDeposit;
                        }

                        this.postDataApiWithAttach(`/api/agss/s`, payload,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.bool_isAMV = false;

                                    // Reload agent group dropdown
                                    that.popUpAgentDetailModal(d.BD);
                                }
                            });
                    }
                }

            },
            ValidationErrMsg(value, langKey = "") {
                if (this.bool_CV) {
                    var validateObj = this.$v.arry_aac[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MT"][langKey]);
                    }
                }

            },
            ValidationErrMsgCD(value, langKey = "") {
                if (this.bool_CV) {
                    var validateObj = this.$v.arry_cd[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["BAL"][langKey]);
                    }
                }

            },

            saveAgentConfig(isSimple = false) {
                this.bool_fullLoading = true;
                this.bool_CV = true;
                var isRegWPhone = this.arry_CrOnOff.REGWPHONE.CV;
                var isLocalized = this.arry_CrOnOff.ULPN.CV;
                var isEPrefix = this.arry_CrOnOff.UPCODE.CV;
                var checkValidLocalized = true;
                var emptyPrefix = false;
                var checkValidSocialMedia = true;

                this.arry_cr['RS'] = 2;
                if (this.arry_cr.AGIT != null && this.arry_cr.AGIT.length > 0) {
                    var agi = this.arry_cr.AGIT.split("-");
                    //this.arry_aac.AGI = agi[1];
                    //this.arry_aac.AgentGroupIds = this.arry_aac
                }

                // for (var i = 0; i < this.arry_aac.VTCRegisterDraggeBase.length; i++) {
                //     // if ((this.arry_aac.VTCRegisterDraggeBase[i].id == 'WSAP' && this.arry_aac.VTCRegisterDraggeBase[i].RS == 2) || (this.arry_aac.VTCRegisterDraggeBase[i].id == 'WC' && this.arry_aac.VTCRegisterDraggeBase[i].RS == 2) || (this.arry_aac.VTCRegisterDraggeBase[i].id == 'LINE' && this.arry_aac.VTCRegisterDraggeBase[i].RS == 2) || (this.arry_aac.VTCRegisterDraggeBase[i].id == 'TELE' && this.arry_aac.VTCRegisterDraggeBase[i].RS == 2) || (this.arry_aac.VTCRegisterDraggeBase[i].id == 'ZALO' && this.arry_aac.VTCRegisterDraggeBase[i].RS == 2)) {
                //     //     this.arry_OnOff.SM.CV = true;
                //     //     break;
                //     // }
                // }

                // if (this.arry_OnOff["SM"].CV) {
                //     if (!this.arry_OnOff["WCID"].CV && !this.arry_OnOff["LID"].CV && !this.arry_OnOff["WAID"].CV && !this.arry_OnOff["TGID"].CV && !this.arry_OnOff["ZLID"].CV) {
                //         this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["SMCODE"]), 1000);
                //         checkValidSocialMedia = false;
                //     }
                // }

                var ui = [];
                var pn = [];
                var pw = [];
                var cpw = [];
                var fn = [];
                var sc = [];
                var sb = [];
                var anm = [];
                var an = [];
                var em = [];
                var rc = [];
                var wc = [];
                var wa = [];
                var ln = [];
                var tg = [];
                var zl = [];

                for (const [key, value] of Object.entries(this.array_ui)) {
                    if (key != "") {
                        var ui_temp = {
                            L: key,
                            UI: value,
                        };
                        ui.push(ui_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_pn)) {
                    if (key != "") {
                        var pn_temp = {
                            L: key,
                            PN: value,
                        };
                        pn.push(pn_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_fn)) {
                    if (key != "") {
                        var fn_temp = {
                            L: key,
                            FN: value,
                        };
                        fn.push(fn_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_pw)) {
                    if (key != "") {
                        var pw_temp = {
                            L: key,
                            PW: value,
                        };
                        pw.push(pw_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_cpw)) {
                    if (key != "") {
                        var cpw_temp = {
                            L: key,
                            CPW: value,
                        };
                        cpw.push(cpw_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_sc)) {
                    if (key != "") {
                        var sc_temp = {
                            L: key,
                            SC: value,
                        };
                        sc.push(sc_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_sbk)) {
                    if (key != "") {
                        var sb_temp = {
                            L: key,
                            SB: value,
                        };
                        sb.push(sb_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_anm)) {
                    if (key != "") {
                        var anm_temp = {
                            L: key,
                            ANM: value,
                        };
                        anm.push(anm_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_an)) {
                    if (key != "") {
                        var an_temp = {
                            L: key,
                            AN: value,
                        };
                        an.push(an_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_em)) {
                    if (key != "") {
                        var em_temp = {
                            L: key,
                            EM: value,
                        };
                        em.push(em_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_rc)) {
                    if (key != "") {
                        var rc_temp = {
                            L: key,
                            RC: value,
                        };
                        rc.push(rc_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_wc)) {
                    if (key != "") {
                        var wc_temp = {
                            L: key,
                            WC: value,
                        };
                        wc.push(wc_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_wa)) {
                    if (key != "") {
                        var wa_temp = {
                            L: key,
                            WA: value,
                        };
                        wa.push(wa_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_ln)) {
                    if (key != "") {
                        var ln_temp = {
                            L: key,
                            LN: value,
                        };
                        ln.push(ln_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_tg)) {
                    if (key != "") {
                        var tg_temp = {
                            L: key,
                            TG: value,
                        };
                        tg.push(tg_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_zl)) {
                    if (key != "") {
                        var zl_temp = {
                            L: key,
                            ZL: value,
                        };
                        zl.push(zl_temp);
                    }
                }

                this.arry_cr.TMultiLangUIList = ui;
                this.arry_cr.TMultiLangFNList = fn;
                this.arry_cr.TMultiLangPNList = pn;
                this.arry_cr.TMultiLangPWList = pw;
                this.arry_cr.TMultiLangCPWList = cpw;
                this.arry_cr.TMultiLangSCList = sc;
                this.arry_cr.TMultiLangSBList = sb;
                this.arry_cr.TMultiLangANMList = anm;
                this.arry_cr.TMultiLangANList = an;
                this.arry_cr.TMultiLangEMList = em;
                this.arry_cr.TMultiLangRCList = rc;
                this.arry_cr.TMultiLangWAList = wa;
                this.arry_cr.TMultiLangWCList = wc;
                this.arry_cr.TMultiLangLNList = ln;
                this.arry_cr.TMultiLangTGList = tg;
                this.arry_cr.TMultiLangZLList = zl;

                if (this.getThousandCurrency) {
                    this.arry_CdOnOff.E2DA.CV = false;
                }

                if (!isSimple) {
                    this.arry_cr.nCuzView = [];
                    for (const [key, value] of Object.entries(this.arry_CrOnOff)) {
                        if (value.CV == value.DC) {
                            this.arry_cr.nCuzView.push(key);
                        }
                    }
                }
                this.$v.arry_cr.$touch();
                if (!this.$v.arry_cr.$error) {
                    if (isRegWPhone == true) {
                        if (isLocalized == true) {
                            if (this.arry_cr.LocalisedList.length == 0) {
                                this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["RPCODE"]), 1000);
                                checkValidLocalized = false;
                            } else {
                                if (isEPrefix == true) {
                                    for (var i = 0; i < this.arry_cr.LocalisedList.length; i++) {
                                        if (this.arry_cr.LocalisedList[i].PC == "") {
                                            emptyPrefix = true;
                                            break;
                                        }
                                    }

                                    if (emptyPrefix) {
                                        checkValidLocalized = false;
                                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["EMPCODE"]), 1000);
                                    }
                                }
                            }
                        } else {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["RPCODE"]), 1000);
                            checkValidLocalized = false;
                        }
                    }
                    if (this.bool_isAgentType) {
                        this.$v.arry_cr.$touch();
                        if (!this.$v.arry_cr.$error) {
                            this.bool_showCR = false;
                        }
                    }

                    this.bool_groupCV = true;

                    var that = this;
                    if (checkValidLocalized == true && checkValidSocialMedia == true) {
                        this.postDataApi(`/api/rcuz/s`, this.arry_cr,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.bool_isAMV = false;
                                    // reload agent group dropdown
                                    that.popUpAgentDetailModal(d.BD);
                                }
                            });
                    } else {
                        this.bool_fullLoading = false;
                    }
                }
                else {
                    this.bool_fullLoading = false;

                    //get the object for validating.
                    const validation = this.$v["arry_cr"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            showSectionBasedRole(type) {

                //Used to select individual section

                this.selectedSection = type ? type : "";
                
                var that = this;
                if (type == 'openAll') {
                    this.bool_showDS = true;
                    this.bool_showBOAC = true;
                    this.bool_showDSS = true;
                    this.bool_showDMSS = true;
                    this.bool_showACS = true;
                    this.bool_showLCS = true;
                    this.bool_showBS = true;

                } else {
                    var agentAPIstatusOK, domainAPIstatusOK, agentconfigAPIstatusOK, livechatAPIstatusOK, bankaccAPIstatusOK, registerCustomizeAPIstatusOK, depositCustomizeAPIstatusOK;
                    agentAPIstatusOK = domainAPIstatusOK = agentconfigAPIstatusOK = livechatAPIstatusOK = bankaccAPIstatusOK = registerCustomizeAPIstatusOK = depositCustomizeAPIstatusOK = true;

                    var agi = (this.$route.query.agi != undefined) ? this.$route.query.agi.split("-") : "";
                    this.selectedPGCat = 'Help2pay';
                    if (agi[1] > 0 && this.obj_Group.I <= 0) {
                        agentAPIstatusOK = false;
                        this.getDataApi(`/api/agss/agg/${agi[1]}`,
                            function (d, s) {
                                if (s) {
                                    agentAPIstatusOK = true;
                                    that.obj_Group = Object.assign(that.obj_Group, d.D);
                                    that.obj_Group.CPGIT = null;
                                    that.bool_isAgentType = that.obj_Group.AT == "3" ? true : false;
                                    that.bool_isSeniorMasterLv = that.obj_Group.AT == "1" ? true : false;
                                    that.bool_isEditSelfService = true;

                                    if (that.obj_Group.PT != null && that.obj_Group.PT > 0) {
                                        that.obj_Group.PT = that.obj_Group.PT.toFixed(2);
                                    }
                                    else {
                                        that.obj_Group.PT = "0.00";
                                    }
                                    if (that.obj_Group.DPT != null && that.obj_Group.DPT > 0) {
                                        that.obj_Group.DPT = that.obj_Group.DPT.toFixed(2);
                                    }
                                    else {
                                        that.obj_Group.DPT = "0.00";
                                    }

                                    if (that.obj_Group.TB != null && that.obj_Group.TB > 0) {
                                        that.obj_Group.TB = that.obj_Group.TB.toFixed(2);
                                    }
                                    else {
                                        that.obj_Group.TB = "0.00";
                                    }

                                    if (that.obj_Group.TCB != null && that.obj_Group.TCB > 0) {
                                        that.obj_Group.TCB = that.obj_Group.TCB.toFixed(2);
                                    }
                                    else {
                                        that.obj_Group.TCB = "0.00";
                                    }

                                    if (that.obj_Group.ICT) {
                                        that.dd_currency = [];
                                        that.dd_currency.push(that.dd_currencyNonICT.find(f => f.label === 'USD'));
                                        that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyICT);
                                    }
                                    else {
                                        that.dd_currency = that.dd_currencyNonICT;
                                        that.dd_currency_wall = that.appendSelectAllOption(that.dd_currencyNonICT);
                                    }

                                    if (that.obj_Group.CI != null && that.obj_Group.CI.length > 0) {
                                        that.obj_Group.CurrencyIds = that.obj_Group.CI.split(',');
                                    }
                                    else {
                                        that.obj_Group.CurrencyIds = [];
                                    }

                                    if (that.obj_Group.H2PCC != null && that.obj_Group.H2PCC.length > 0) {
                                        that.obj_Group.H2PCurrencyCodes = that.obj_Group.H2PCC.split(',');
                                    }
                                    else {
                                        that.obj_Group.H2PCurrencyCodes = null;
                                    }

                                    if (that.obj_Group.L != null && that.obj_Group.L.length > 0) {
                                        that.obj_Group.Language = that.obj_Group.L.split(',');

                                        if (that.$route.query.di == 0 && agi[1] > 0) {
                                            var DS = [];
                                            if (that.dd_language.length > 0) {
                                                for (var i = 0; i < that.dd_language.length; i++) {
                                                    DS[i] = {
                                                        "I": 0,
                                                        "TC": false,
                                                        "LE": that.obj_Group.Language.includes(that.dd_language[i].id) ? true : false,
                                                        "L": that.dd_language[i].id,
                                                        "LN": that.dd_language[i].label,
                                                        "CC": null,
                                                        "CurrencyCodes": [],
                                                        "TI": null,
                                                        "TSI": null,
                                                        "MTI": null,
                                                        "MTSI": null,
                                                        "TIALT": null,
                                                        "TSIALT": null,
                                                        "MTIALT": null,
                                                        "MTSIALT": null,
                                                        "EETAD": 0,
                                                        "GPI": "",
                                                        "GameProviderIdS": [],
                                                        "CURL": "",
                                                        "GCURL": "",
                                                        "ALTCURL": "",
                                                        "ALTGCURL": "",
                                                        "MCURL": "",
                                                        "MGCURL": "",
                                                        "ALTMCURL": "",
                                                        "ALTMGCURL": "",
                                                        "AFB1188SW": "W0",
                                                        "AFB1188SM": "W0",
                                                        "AFB1188OS": "HK",
                                                        "AFB1188OM": "Single",
                                                        "DSN1": "Skin 1",
                                                        "DSN2": "Skin 2",
                                                    };
                                                }
                                            }
                                            that.$set(that.$data.obj_Domain, 'DS', DS);
                                        }
                                    }
                                    else {
                                        that.obj_Group.Language = [];
                                    }

                                    if (that.obj_Group.GPI != null && that.obj_Group.GPI.length > 0) {
                                        that.obj_Group.GameProviderIds = that.obj_Group.GPI.split(',');
                                    }
                                    else {
                                        that.obj_Group.GameProviderIds = [];
                                    }

                                    that.obj_Group.Agent = {
                                        "I": -1,
                                        "UP": "",
                                        "CUP": ""
                                    };

                                    that.dec_availablebalance = that.formatNumber(that.obj_Group.TB - that.obj_Group.BL, 2, d.D.CS);
                                    that.CurrencyChange(that.obj_Group.DCI);

                                    that.obj_Group.WhiteListIP = [];
                                    if (that.obj_Group.WLIPS != "") {
                                        var WLIPS_C = that.obj_Group.WLIPS;
                                        that.obj_Group.WLIPS = "";
                                        var WLIPS_CARRY = WLIPS_C.split(',');
                                        for (var i = 0; i < WLIPS_CARRY.length; i++) {
                                            that.obj_WLIPS = {
                                                WLIPS: WLIPS_CARRY[i]
                                            }
                                            that.obj_Group.WhiteListIP.push(that.obj_WLIPS);
                                        }
                                    }
                                    that.ParentGroupChange(that.obj_Group.PGIT);
                                    var this1 = that;
                                    that.getDataApi(`/api/ag/gb/${that.obj_Group.PGI}/0`,
                                        function (d, s) {
                                            if (s) {
                                                this1.dec_availablebalance = this1.formatNumber(d.D.TB - d.D.BL, 2, d.D.CS);
                                                this1.str_ptrange = "0.00% - " + d.D.PT.toFixed(2) + "%";
                                                this1.obj_Group.MaxPT = d.D.PT;
                                            }
                                        });

                                    that.bool_isAMV = true;

                                    if (agentAPIstatusOK && domainAPIstatusOK && agentconfigAPIstatusOK && livechatAPIstatusOK && bankaccAPIstatusOK && registerCustomizeAPIstatusOK && depositCustomizeAPIstatusOK) {
                                        that.bool_fullLoading = false;
                                    }
                                }
                            });
                    }

                    if (type == 'ds') {
                        this.bool_showDS = (this.bool_showDS ? this.bool_showDS = false : this.bool_showDS = true);
                        this.bool_showBOAC = this.bool_showDSS = this.bool_showDMSS = this.bool_showACS = this.bool_showLCS = this.bool_showBS = this.bool_showCR = this.bool_showCD = false;
                    }
                    if (type == 'boac') {
                        this.bool_showBOAC = (this.bool_showBOAC ? this.bool_showBOAC = false : this.bool_showBOAC = true);
                        this.bool_showDS = this.bool_showDSS = this.bool_showDMSS = this.bool_showACS = this.bool_showLCS = this.bool_showBS = this.bool_showCR = this.bool_showCD = false;
                    }
                    if (type == 'dss') {
                        this.bool_showDSS = (this.bool_showDSS ? this.bool_showDSS = false : this.bool_showDSS = true);
                        this.bool_showDS = this.bool_showBOAC = this.bool_showDMSS = this.bool_showACS = this.bool_showLCS = this.bool_showBS = this.bool_showCR = this.bool_showCD = false;
                    }
                    //domain
                    if (type == 'dmss') {

                        this.bool_showDMSS = (this.bool_showDMSS ? this.bool_showDMSS = false : this.bool_showDMSS = true);
                        this.bool_showDS = this.bool_showBOAC = this.bool_showDSS = this.bool_showACS = this.bool_showLCS = this.bool_showBS = this.bool_showCR = this.bool_showCD = false;
                        this.selectedFile = null;
                        this.selectedFileMsl = null;
                        this.isChangeDomainName = false;
                        var domainId = this.$route.query.di;
                        if (domainId > 0 && this.obj_Domain.I <= 0 && (this.getUserInfo.AT == 0 || this.getUserInfo.AT >= 2)) {
                            this.bool_fullLoading = true;
                            domainAPIstatusOK = false;
                            this.getDataApi(`/api/dm/g/${domainId}`,
                                function (d, s) {
                                    if (s) {
                                        domainAPIstatusOK = true;
                                        that.obj_Domain = Object.assign(that.obj_Domain, d.D);
                                        that.selectedAGI = that.obj_Domain.agi;
                                        var DS = [];
                                        if (that.dd_language.length > 0) {
                                            var activeDomainLangSetting = false;
                                            for (var i = 0; i < that.dd_language.length; i++) {
                                                DS[i] = {
                                                    "I": 0,
                                                    "TC": false,
                                                    "LE": false,
                                                    "L": that.dd_language[i].id,
                                                    "LN": that.dd_language[i].label,
                                                    "CC": null,
                                                    "CurrencyCodes": [],
                                                    "TI": null,
                                                    "TSI": null,
                                                    "MTI": null,
                                                    "MTSI": null,
                                                    "TIALT": null,
                                                    "TSIALT": null,
                                                    "MTIALT": null,
                                                    "MTSIALT": null,
                                                    "EETAD": 0,
                                                    "GPI": "",
                                                    "GameProviderIdS": [],
                                                    "CURL": "",
                                                    "GCURL": "",
                                                    "ALTCURL": "",
                                                    "ALTGCURL": "",
                                                    "MCURL": "",
                                                    "MGCURL": "",
                                                    "ALTMCURL": "",
                                                    "ALTMGCURL": "",
                                                    "AFB1188SW": "W0",
                                                    "AFB1188SM": "W0",
                                                    "AFB1188OS": "HK",
                                                    "AFB1188OM": "Single",
                                                    "DSN1": "Skin 1",
                                                    "DSN2": "Skin 2",
                                                };

                                                if (d.D.DS) {
                                                    d.D.DS.find(function (val, idx) {
                                                        if (val.L == that.dd_language[i].id && !activeDomainLangSetting) {
                                                            that.selectedLangIndex = i;
                                                            activeDomainLangSetting = true;
                                                        }

                                                        if (val.L == that.dd_language[i].id) {
                                                            // handle remove unknow value from option
                                                            for (var x = 0; x < val.CurrencyCodes.length; x++) {
                                                                if (!_.includes(_.map(that.dd_currency_selectlabel, 'label'), val.CurrencyCodes[x])) {
                                                                    val.CurrencyCodes.splice(x, 1);
                                                                }
                                                            }
                                                            val.CC = val.CurrencyCodes.join(',');
                                                            //end handle

                                                            DS[i].I = val.I;
                                                            DS[i].TC = true;
                                                            DS[i].LE = true;
                                                            DS[i].CC = val.CC;
                                                            DS[i].CurrencyCodes = val.CurrencyCodes;
                                                            DS[i].TI = (val.TI == 0) ? null : val.TI;
                                                            DS[i].TSI = (val.TI == 0) ? null : val.TSI;
                                                            DS[i].MTI = (val.MTI == 0) ? null : val.MTI;
                                                            DS[i].MTSI = (val.MTI == 0) ? null : val.MTSI;
                                                            DS[i].TIALT = (val.TIALT == 0) ? null : val.TIALT;
                                                            DS[i].TSIALT = (val.TIALT == 0) ? null : val.TSIALT;
                                                            DS[i].MTIALT = (val.MTIALT == 0) ? null : val.MTIALT;
                                                            DS[i].MTSIALT = (val.MTIALT == 0) ? null : val.MTSIALT;
                                                            DS[i].EETAD = val.EETAD;
                                                            DS[i].GPI = val.GPI;
                                                            DS[i].GameProviderIdS = val.GameProviderIdS;
                                                            DS[i].CURL = val.CURL;
                                                            DS[i].GCURL = val.GCURL;
                                                            DS[i].MCURL = val.MCURL;
                                                            DS[i].MGCURL = val.MGCURL;
                                                            DS[i].ALTCURL = val.ALTCURL;
                                                            DS[i].ALTGCURL = val.ALTGCURL;
                                                            DS[i].ALTMCURL = val.ALTMCURL;
                                                            DS[i].ALTMGCURL = val.ALTMGCURL;
                                                            if (val.DSN1) DS[i].DSN1 = val.DSN1;
                                                            if (val.DSN2) DS[i].DSN2 = val.DSN2;
                                                            DS[i].AFB1188SW = val.AFB1188SW !== "" ? val.AFB1188SW : null;
                                                            DS[i].AFB1188SM = val.AFB1188SM !== "" ? val.AFB1188SM : null;
                                                            DS[i].AFB1188OS = val.AFB1188OS !== "" ? val.AFB1188OS : null;
                                                            DS[i].AFB1188OM = val.AFB1188OM !== "" ? val.AFB1188OM : null;
                                                            if (DS[i].TI > 0) {
                                                                that.TemplateChange(DS[i].TI);
                                                            }
                                                            else {
                                                                DS[i].TI = null;
                                                            }
                                                            if (DS[i].MTI > 0) {
                                                                DS[i].AMT = true;
                                                                that.MobileTemplateChange(DS[i].MTI);
                                                            }
                                                            else {
                                                                DS[i].MTI = null;
                                                            }

                                                            if (DS[i].TIALT > 0) {
                                                                DS[i].E2SSIM = true;
                                                                that.AlternateTemplateChange(DS[i].TIALT);
                                                            } else {
                                                                DS[i].TIALT = null;
                                                            }
                                                            if (DS[i].MTIALT > 0) {
                                                                DS[i].AMTALT = true;
                                                                that.AlternateMobileTemplateChange(DS[i].MTIALT);
                                                            }
                                                            else {
                                                                DS[i].MTIALT = null;
                                                            }
                                                        }
                                                    });
                                                }
                                            }
                                        }

                                        if (that.obj_Domain.SMSVP != null && that.obj_Domain.SMSVP.length > 0) {
                                            that.obj_Domain.SMSVPages = that.obj_Domain.SMSVP.split(',');
                                        }
                                        else {
                                            that.obj_Domain.SMSVPages = null;
                                        }

                                        if (that.obj_Domain.EVP != null && that.obj_Domain.EVP.length > 0) {
                                            that.obj_Domain.EVPages = that.obj_Domain.EVP.split(',');
                                        }
                                        else {
                                            that.obj_Domain.EVPages = null;
                                        }

                                        that.$set(that.$data.obj_Domain, 'DS', DS);
                                        //that.autoScrollTemplate();

                                        if (that.obj_Domain.AGI != 0) {
                                            that.obj_Domain.AGIT = "3-" + that.obj_Domain.AGI;
                                            that.checkDomainSupportLanguage(that.obj_Domain.AGIT);
                                            //that.AgentGroupChange(that.obj_Domain.AGIT, true);
                                        }

                                        if (that.obj_Domain.AGI != 0 && that.obj_Domain.PDI > 0) {
                                            that.searchSubBrand = that.obj_Domain.SAGAGI;
                                            //that.SubAgentGroupChange(that.searchSubBrand);

                                            that.isSubAgent = true;
                                        }

                                        that.bool_holSLBL = that.obj_Domain.SLBL;
                                        if (that.bool_holSLBL) {
                                            that.obj_Domain.LOGOByLink = that.obj_Domain.SL
                                        }
                                        that.bool_holSIBL = that.obj_Domain.SIBL;
                                        if (that.bool_holSIBL) {
                                            that.obj_Domain.ICONByLink = that.obj_Domain.SI
                                        }
                                        that.bool_holMSLBL = that.obj_Domain.MSLBL;
                                        if (that.bool_holMSLBL) {
                                            that.obj_Domain.MobileLOGOByLink = that.obj_Domain.MSL
                                        }

                                        that.obj_Domain.MaintenanceIP = [];
                                        if (that.obj_Domain.MIP != "" && that.obj_Domain.MIP != null) {
                                            var MIP_C = that.obj_Domain.MIP;
                                            //that.obj_Domain.MIP = "";
                                            var MIP_CARRY = MIP_C.split(',');
                                            for (var i = 0; i < MIP_CARRY.length; i++) {
                                                that.obj_MIP = {
                                                    MIP: MIP_CARRY[i]
                                                }
                                                that.obj_Domain.MaintenanceIP.push(that.obj_MIP);
                                            }
                                        }

                                        that.obj_Domain.DomainNameServer = [];
                                        if (that.obj_Domain.DNS != "" && that.obj_Domain.DNS != null) {
                                            var DNS_C = that.obj_Domain.DNS;
                                            //that.obj_Domain.DNS = "";
                                            var DNS_CARRY = DNS_C.split(',');
                                            for (var i = 0; i < DNS_CARRY.length; i++) {
                                                that.obj_DNS = {
                                                    DNS: DNS_CARRY[i]
                                                }
                                                that.obj_Domain.DomainNameServer.push(that.obj_DNS);
                                            }
                                        }

                                        that.OldDomainName = that.obj_Domain.DN;

                                        if (that.obj_Domain.RTD != "") {
                                            that.obj_Domain.RTD = that.obj_Domain.RTD;
                                        }
                                        else {
                                            that.obj_Domain.RTD = "";
                                        }

                                        that.dd_dofs = [];
                                        if (that.obj_Domain.I > 0 && that.obj_Domain.AGI > 0) {
                                            that.refreshDofs(that, that.obj_Domain.AGI);
                                        }

                                        if (that.obj_Domain.RT == null || that.obj_Domain.RT == '') {
                                            that.obj_Domain.RT = "";
                                        }

                                        if (that.obj_Domain.IM == 0) {
                                            that.obj_Domain.IM = null;
                                        }

                                        if (that.obj_Domain.AFB1188SBAPI == '') {
                                            that.obj_Domain.AFB1188SBAPI = null;
                                        }

                                        that.bool_isAMV = true;
                                        if (agentAPIstatusOK && domainAPIstatusOK && agentconfigAPIstatusOK && livechatAPIstatusOK && bankaccAPIstatusOK && registerCustomizeAPIstatusOK) {
                                            that.bool_fullLoading = false;
                                            that.getCloudFlareStatus(that.obj_Domain.I);
                                        }
                                    }
                                });

                            this.getDataApi(`/api/seo/l?p=1&n=100&s=CTS&d=true&f[DI]=${domainId}&f[DAI]=0&f[AGI]=${agi[1]}`,
                                function (d, s) {
                                    if (s && d.D.TotalItems == 0) {
                                        that.bool_showPreloadSEO = true;
                                    } else {
                                        that.bool_showPreloadSEO = false;
                                    }
                                });
                        } 
                    }
                    //agent config
                    if (type == 'acs') {
                        this.bool_showACS = (this.bool_showACS ? this.bool_showACS = false : this.bool_showACS = true);
                        this.bool_showDS = this.bool_showBOAC = this.bool_showDSS = this.bool_showDMSS = this.bool_showLCS = this.bool_showBS = this.bool_showCR = this.bool_showCD = false;
                        this.bool_isEditWebConfig = true;
                        this.bool_EBANS = this.arry_OnOff.BankBackOfficeSetting.AANE.CV || this.arry_OnOff.BankBackOfficeSetting.AEWAS.CV;
                        this.bool_EMBANS = this.arry_OnOff.BankBackOfficeSetting.MAANE.CV || this.arry_OnOff.BankBackOfficeSetting.MAEWAS.CV;
                        this.bool_HFLQRC = this.arry_OnOff.MemberSiteSetting.HSQRCM.CV || this.arry_OnOff.MemberSiteSetting.HQRCBL.CV;

                        var agentconfigId = this.$route.query.acsi;
                        if (agentconfigId > 0 && this.arry_aac.I <= 0 && (this.getUserInfo.AT == 0 || this.getUserInfo.AT > 2)) {
                            this.bool_fullLoading = true;
                            agentconfigAPIstatusOK = false;

                            //check customize register
                            this.getDataApi(`/api/rcuz/g/${agentconfigId}`,
                                function (d, s) {
                                    if (s) {
                                        if (d.D != null) {
                                            that.bool_cr = true;
                                            if (d.D.CuzView.length > 0) {
                                                for (var x = 0; x < d.D.CuzView.length; x++) {
                                                    if (d.D.CuzView[x].CC == "RFWMP") {
                                                        that.bool_cr = false;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                });

                            this.getDataApi(`/api/acuz/g/${agentconfigId}`,
                                function (d, s) {
                                    if (s) {
                                        agentconfigAPIstatusOK = true;
                                        if (d.D != null) {
                                            that.setAC(d.D);
                                        }
                                        that.bool_isAMV = false;
                                        if (that.arry_aac.AGI != 0) {
                                            that.arry_aac.AGIT = that.arry_aac.AGI;
                                            that.searchAgent = ["3-" + that.arry_aac.AGI];
                                        }
                                        that.bool_isAMV = true;

                                        if (agentAPIstatusOK && domainAPIstatusOK && agentconfigAPIstatusOK && livechatAPIstatusOK && bankaccAPIstatusOK && registerCustomizeAPIstatusOK) {
                                            that.bool_fullLoading = false;
                                        }
                                    }
                                });
                        }
                    }
                    //livechat
                    if (type == 'lcs') {
                        this.bool_showLCS = (this.bool_showLCS ? this.bool_showLCS = false : this.bool_showLCS = true);
                        this.bool_showDS = this.bool_showBOAC = this.bool_showDSS = this.bool_showDMSS = this.bool_showACS = this.bool_showBS = this.bool_showCR = this.bool_showCD = false;

                        var livechatId = this.$route.query.lci;
                        this.newFile = false;
                        if (livechatId > 0 && this.obj_livechat.I <= 0 && (this.getUserInfo.AT == 0 || this.getUserInfo.AT > 2)) {
                            livechatAPIstatusOK = false;
                            this.bool_fullLoading = true;
                            this.getDataApi(`/api/livechat/g/${livechatId}`,
                                function (d, s) {
                                    if (s) {
                                        livechatAPIstatusOK = true;

                                        that.setLiveChat(d.D);
                                        if (that.obj_livechat.AGI != 0) {
                                            that.obj_livechat.AGIT = "3-" + that.obj_livechat.AGI;
                                            //that.AgentGroupChange(that.obj_livechat.AGIT);
                                        }

                                        if (agentAPIstatusOK && domainAPIstatusOK && agentconfigAPIstatusOK && livechatAPIstatusOK && bankaccAPIstatusOK && registerCustomizeAPIstatusOK) {
                                            that.bool_fullLoading = false;
                                        }
                                    }
                                });
                        }
                    }
                    ////bank
                    if (type == 'bs') {
                        this.bool_showBS = (this.bool_showBS ? this.bool_showBS = false : this.bool_showBS = true);
                        this.bool_showDS = this.bool_showBOAC = this.bool_showDSS = this.bool_showDMSS = this.bool_showACS = this.bool_showLCS = this.bool_showCR = this.bool_showCD = false;

                        var bankId = this.$route.query.bai;
                        this.newImg = false;
                        if (bankId > 0 && this.obj_bankacc.I <= 0 && (this.getUserInfo.AT == 0 || this.getUserInfo.AT > 2)) {
                            bankaccAPIstatusOK = false;
                            this.bool_fullLoading = true;
                            this.getDataApi(`/api/bankacc/g/${bankId}`,
                                function (d, s) {
                                    if (s) {
                                        bankaccAPIstatusOK = true;

                                        that.setBankAccount(d.D);
                                        that.bool_isAMV = true;
                                        if (that.obj_bankacc.AGI != 0) {
                                            that.obj_bankacc.AGIT = "3-" + that.obj_bankacc.AGI;
                                            //that.AgentGroupChange(that.obj_bankacc.AGIT);
                                            that.CountryCodeChange(that.obj_bankacc.CC);
                                        }
                                        that.obj_bankacc.IUT = false;

                                        if (agentAPIstatusOK && domainAPIstatusOK && agentconfigAPIstatusOK && livechatAPIstatusOK && bankaccAPIstatusOK && registerCustomizeAPIstatusOK) {
                                            that.bool_fullLoading = false;
                                        }
                                    }
                                });
                        }
                    }
                    //customize registration
                    if (type == 'cr') {
                        this.bool_showCR = (this.bool_showCR ? this.bool_showCR = false : this.bool_showCR = true);
                        this.bool_showDS = this.bool_showBOAC = this.bool_showDSS = this.bool_showDMSS = this.bool_showACS = this.bool_showBS = this.bool_showLCS = this.bool_showCD = false;

                        this.array_ui = [];
                        this.array_pn = [];
                        this.array_pw = [];
                        this.array_cpw = [];
                        this.array_fn = [];
                        this.array_sc = [];
                        this.array_sbk = [];
                        this.array_anm = [];
                        this.array_an = [];
                        this.array_rc = [];
                        this.array_em = [];
                        this.array_wa = [];
                        this.array_wc = [];
                        this.array_ln = [];
                        this.array_tg = [];
                        this.array_zl = [];

                        var customizeRegistrationId = this.$route.query.cri;
                        if (customizeRegistrationId > 0 && this.bool_showCR && (this.getUserInfo.AT == 0 || this.getUserInfo.AT > 2)) {
                            registerCustomizeAPIstatusOK = false;
                            this.bool_fullLoading = true;
                            this.getDataApi(`/api/rcuz/g/${customizeRegistrationId}`,
                                function (d, s) {
                                    if (s) {
                                        registerCustomizeAPIstatusOK = true;

                                        that.setCR(d.D);
                                        if (that.arry_cr.AGI != 0) {
                                            that.arry_cr.AGIT = that.arry_cr.AGI;
                                            that.searchAgent = ["3-" + that.arry_cr.AGI];
                                        }

                                        if (agentAPIstatusOK && domainAPIstatusOK && agentconfigAPIstatusOK && livechatAPIstatusOK && bankaccAPIstatusOK && registerCustomizeAPIstatusOK && depositCustomizeAPIstatusOK) {
                                            that.bool_fullLoading = false;
                                        }
                                    }
                                });
                        }
                        else {
                            var agi = (this.$route.query.agi != undefined) ? this.$route.query.agi.split("-") : "";
                            this.arry_cr.AGIT = agi[1];
                            //if (this.arry_cr.AGI != 0) {
                            //    this.arry_cr.AGIT = this.arry_cr.AGI;
                            //    this.searchAgent = ["3-" + this.arry_cr.AGI];
                            //}
                            this.addAgentConfig();
                        }
                    }
                    //customize deposit
                    if (type == 'cd') {
                        this.bool_showCD = (this.bool_showCD ? this.bool_showCD = false : this.bool_showCD = true);
                        this.bool_showDS = this.bool_showBOAC = this.bool_showDSS = this.bool_showDMSS = this.bool_showACS = this.bool_showBS = this.bool_showLCS = this.bool_showCR = false;

                        this.getDataApi(`/api/dd/cur/` + agi[1],
                            function (d, s) {
                                if (s) {
                                    that.dd_currency_cd = d.dropdownlist;
                                }

                                that.addCustomizeDeposit();
                                //that.arry_cd.AGIT = agi[1];
                                //that.arry_cd.AGI = agi[1];
                            });

                        this.array_da = [];
                        this.array_cya = [];
                        this.array_sb = [];
                        this.array_ti = [];
                        this.array_dtod = [];
                        this.array_ur = [];
                        this.array_p = [];
                        this.array_n = [];
                    }

                    setTimeout(() => {
                        //Excludes webTempSetting
                        $("#SSA .table-wrapper .row .section-title2:not(#webTempSetting .section-title2)").each(function (index) {
                            //if (!this.bool_isFinishLoadSectionIndex) {
                            //    $(this).find('span').html(index + 1);
                            //}

                            if (type == $(this).data('section')) {
                                $('html, body').animate({
                                    scrollTop: $(this).parent().offset().top - 70
                                }, 'smooth');
                            }
                        });
                        this.bool_isFinishLoadSectionIndex = true;
                    }, 1500);
                }
            },
            checkDomainSupportLanguage(value) {
                var agi = 0;
                if (value) {
                    agi = value.split("-")[1];
                }
                var that = this;
                this.getDataApi('/api/dd/lang/' + agi,
                    function (d, s) {
                        if (s) {

                            if (d.dropdownlist.length > 0) {
                                for (var k = 0; k < that.obj_Domain.DS.length; k++) {
                                    var isSupported = false;

                                    for (var l = 0; l < d.dropdownlist.length; l++) {
                                        if (that.obj_Domain.DS[k].L == d.dropdownlist[l].id) {
                                            isSupported = true;
                                            break;
                                        }
                                    }

                                    that.obj_Domain.DS[k].LE = isSupported;

                                    if (!isSupported) {
                                        if (that.obj_Domain.DS[k].TC) {
                                            that.obj_Domain.DS[k].TC = isSupported;
                                            that.obj_Domain.DS[k].TI = null;
                                            that.obj_Domain.DS[k].TIALT = null;

                                            if (that.obj_Domain.DL == that.obj_Domain.DS[k].L) {
                                                that.obj_Domain.DL = null;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    });
            },

            addAgentConfig(isSimple = false) {
                this.arry_cr = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    nCuzView: null,
                    AGI: "",
                    AGIT: this.arry_cr.AGIT,
                    E_CC: "",
                    E_PC: "",
                    LocalisedList: [],
                    InactiveDays: 365,
                    Rate: 0,
                    DisabledProviderLobbies: [],
                    VTCRegisterDraggeBase: [
                        { "name": "UN", "id": "UN", "RS": 2 },
                        { "name": "PW", "id": "PW", "RS": 2 },
                        { "name": "NAME", "id": "NAME", "RS": 1 },
                        { "name": "CUR", "id": "CUR", "RS": 2 },
                        { "name": "BANK", "id": "BANK", "RS": 2 },
                        { "name": "REF", "id": "REF", "RS": 1 },
                        { "name": "EM", "id": "EM", "RS": 1 },
                        { "name": "PN", "id": "PN", "RS": 1 },
                        //{ "name": "SM", "id": "SM", "RS": 1 },
                        { "name": "WSAP", "id": "WSAP", "RS": 1 },
                        { "name": "WC", "id": "WC", "RS": 1 },
                        { "name": "LINE", "id": "LINE", "RS": 1 },
                        { "name": "TELE", "id": "TELE", "RS": 1 },
                        { "name": "ZALO", "id": "ZALO", "RS": 1 }
                    ],
                };


                this.arry_CrOnOff = {
                    "RFWMP": { CV: false, DC: true },
                    "RWBA": { CV: true, DC: false },
                    "RWEA": { CV: false, DC: true },
                    "CDBACC": { CV: true, DC: true },
                    "CDPNO": { CV: true, DC: true },
                    "RPN": { CV: false, DC: true },
                    "REGWPHONE": { CV: false, DC: true },
                    "ULPN": { CV: false, DC: true },
                    "UPCODE": { CV: false, DC: true },
                    "EPWSC": { CV: false, DC: true },
                    "DOTPV": { CV: false, DC: true },
                    "FNM": { CV: false, DC: true },
                    "HCDIHO": { CV: true, DC: true },
                    "EUN": { CV: false, DC: true },
                    "BABLBA": { CV: false, DC: true },
                    "SM": { CV: false, DC: true },
                    "WCID": { CV: false, DC: true },
                    "LID": { CV: false, DC: true },
                    "WAID": { CV: false, DC: true },
                    "TGID": { CV: false, DC: true },
                    "ZLID": { CV: false, DC: true },
                    "SRC": { CV: false, DC: true },
                    "REM": { CV: false, DC: true },
                    "RWSAP": { CV: false, DC: true },
                    "RWC": { CV: false, DC: true },
                    "RLINE": { CV: false, DC: true },
                    "RTELE": { CV: false, DC: true },
                    "RZALO": { CV: false, DC: true },
                };

                this.obj_LCC = {
                    CC: "",
                    PC: "",
                    LZ: 0,
                    PN: ""
                };

                this.arry_cr.nCuzView = [];
                this.bool_isAMV = true;
                this.bool_CV = false;
                this.bool_EBANS = false;
                this.bool_EMBANS = false;
                this.bool_HFLQRC = true;
                //if (this.dd_agentgroup[0].children == undefined) {
                //    var at = 0;
                //    at = this.dd_agentgroup[0].id.split("-")[0];
                //    if (at == 3 && this.dd_agentgroup.length < 2) {
                //        this.arry_aac.AGIT = this.dd_agentgroup[0].id;
                //    }
                //}

            },
            CurrencyChange_cd(value) {
                if (value != undefined && this.arry_cd) {
                    this.bool_fullLoading = true;
                    this.bool_CV = false;
                    const arry_cd_AGI = this.arry_cd['AGI'];

                    var that = this;

                    this.getDataApi(`/api/dcuz/g/` + arry_cd_AGI + '/' + value,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d.D != null) {
                                    that.setCD(d.D);
                                }
                                else if (!that.bool_copyCuzDeposit) {
                                    that.addCustomizeDeposit(value);
                                }

                                if (that.arry_cd.AGI != 0) {
                                    that.arry_cd.AGIT = that.arry_cd.AGI;
                                    //that.searchAgent = ["3-" + that.arry_cd.AGI];
                                }
                                that.bool_fullLoading = true;
                                that.getDataApi(`/api/dd/pmgw2/` + arry_cd_AGI + '/' + value,
                                    function (d, s) {
                                        that.bool_fullLoading = false;

                                        if (s) {
                                            that.arry_cd.DepositDraggeBase = d.Item1.draggelist;
                                            that.arry_cd.VTCDepositDraggeBase = d.Item2.draggelist;
                                        }
                                        else {
                                            return;
                                        }
                                    });

                                that.getdepositDropDown(arry_cd_AGI, value);


                                that.dd_currency_cd.find(function (val, idx) {
                                    if (val.id == value) {
                                        that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                                    }
                                });


                                //To copy all this.arry_cd values when copy group is active
                                if (that.bool_copyCuzDeposit) {

                                    that.arr_copyCuzDeposit.push(that.arry_cd);
                                }
                            }
                            else {
                                return;
                            }
                        });
                }
            },
            getdepositDropDown(agi, ci) {
                var that = this;
                this.getDataApi(`/api/dcuz/gbacc/` + agi + '/' + ci,
                    function (d, s) {
                        if (s) {
                            that.arr_DepositbankTempalte = d.D.BankAccountDcuz;
                            that.arr_DepositbankOption = that.depositBank_Receipt = [];
                            const appendCategory = ''; // Example value, set this as needed
                            if (that.arr_DepositbankTempalte.length > 0) {
                                $.each(that.arr_DepositbankTempalte, function (i, bank) {
                                    let paymentMethod = bank.PM.toString();
                                    if (appendCategory) paymentMethod = `${bank.PM}`;

                                    let categoryIndex = that.arr_DepositbankOption.findIndex(s => s.id === paymentMethod);
                                    if (categoryIndex < 0) {
                                        const depositTypeLabel = (bank.PM === 10 ? that.getLanguage["DCUZ"]["EW"] :
                                            bank.PM === 40 ? that.getLanguage["DCUZ"]["CRYPT"] :
                                                bank.PM === 4 ? that.getLanguage["DCUZ"]["OD"] :
                                                    bank.PM === 1 ? that.getLanguage["DCUZ"]["CD"] :
                                                        bank.PM === 11 ? that.getLanguage["DCUZ"]["CBD"] : ""
                                        );

                                        that.arr_DepositbankOption.push({ ICT: false, id: paymentMethod, label: depositTypeLabel, children: [] });
                                        categoryIndex = that.arr_DepositbankOption.length - 1;
                                    }

                                    if (!appendCategory) {
                                        if (!that.arr_DepositbankOption[categoryIndex].children.some(w => w.id === `${bank.PM}-${bank.I}`)) {
                                            that.arr_DepositbankOption[categoryIndex].children.push({ ICT: false, id: `${bank.PM}-${bank.I}`, label: `${bank.BN} - ${bank.BAN}` });
                                        }
                                    }
                                });
                            }

                            that.arr_DepositbankOption = that.appendSelectAllOption(that.arr_DepositbankOption);
                            that.arr_DepositbankbyBankTempalte = d.D.BankAccountbyBankDcuz;
                            that.arr_depositSupportPaymentMethod = d.D.DepositSupportPaymentMethod;
                            that.int_selectedPaymentMethod = that.arr_depositSupportPaymentMethod[0];
                        }
                        else {
                            return;
                        }
                    });

            },
            setCollapseExpandIcon(settingType) {
                if (settingType == 'DL') {
                    if (this.bool_showDS) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showDS) {
                        return "chevron-container";
                    }
                } else if (settingType == 'BOA') {
                    if (this.bool_showBOAC) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showBOAC) {
                        return "chevron-container";
                    }
                } else if (settingType == 'DS') {
                    if (this.bool_showDSS) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showDSS) {
                        return "chevron-container";
                    }
                } else if (settingType == 'AC') {
                    if (this.bool_showACS) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showACS) {
                        return "chevron-container";
                    }
                } else if (settingType == 'T') {
                    if (this.bool_showDMSS) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showDMSS) {
                        return "chevron-container";
                    }
                } else if (settingType == 'LC') {
                    if (this.bool_showLCS) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showLCS) {
                        return "chevron-container";
                    }
                } else if (settingType == 'PGB') {
                    if (this.bool_showBS) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showBS) {
                        return "chevron-container";
                    }
                } else if (settingType == 'CR') {
                    if (this.bool_showCR) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showCR) {
                        return "chevron-container";
                    }
                } else if (settingType == 'CD') {
                    if (this.bool_showCD) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showCD) {
                        return "chevron-container";
                    }
                }
            },

            selectGPAll() {
                for (var i = 0; i < this.dd_gameprovider.length; i++) {
                    this.btnGP_checkedAll[i] = (this.btnGP2_checkedAll) ? false : true;

                    if (this.btnGP_checkedAll[i]) {
                        if (this.dd_gameprovider[i].children != null && this.dd_gameprovider[i].children.length > 0) {
                            for (var j = 0; j < this.dd_gameprovider[i].children.length; j++) {
                                if (this.obj_Group.GameProviderIds.indexOf(this.dd_gameprovider[i].children[j].id) < 0) {
                                    if (!this.constHouseBrand.includes(this.dd_gameprovider[i].children[j].id)) {
                                        this.obj_Group.GameProviderIds.push(this.dd_gameprovider[i].children[j].id);
                                    }
                                }
                            }
                        }
                    } else {
                        if (this.dd_gameprovider[i].children != null && this.dd_gameprovider[i].children.length > 0) {
                            for (var j = 0; j < this.dd_gameprovider[i].children.length; j++) {
                                var tempItem = this.obj_Group.GameProviderIds.indexOf(this.dd_gameprovider[i].children[j].id);
                                if (tempItem >= 0) {
                                    if (!this.constHouseBrand.includes(this.dd_gameprovider[i].children[j].id)) {
                                        this.obj_Group.GameProviderIds.splice(tempItem, 1);
                                    }
                                }
                            }
                        }
                    }
                    this.obj_Group.GPI = "";
                    this.obj_Group.GPI = this.obj_Group.GameProviderIds.join(',')
                }

                this.checkSelectAllGPButton();
            },
            selectGPCatAll(tabIndex) {
                this.btnGP_checkedAll[tabIndex] = (this.btnGP_checkedAll[tabIndex]) ? false : true;

                if (this.btnGP_checkedAll[tabIndex]) {
                    if (this.dd_gameprovider[tabIndex].children != null && this.dd_gameprovider[tabIndex].children.length > 0) {
                        for (var j = 0; j < this.dd_gameprovider[tabIndex].children.length; j++) {
                            if (this.obj_Group.GameProviderIds.indexOf(this.dd_gameprovider[tabIndex].children[j].id) < 0) {
                                if (!this.constHouseBrand.includes(this.dd_gameprovider[tabIndex].children[j].id)) {
                                    this.obj_Group.GameProviderIds.push(this.dd_gameprovider[tabIndex].children[j].id);

                                }
                            }
                        }
                    }
                } else {
                    if (this.dd_gameprovider[tabIndex].children != null && this.dd_gameprovider[tabIndex].children.length > 0) {
                        for (var j = 0; j < this.dd_gameprovider[tabIndex].children.length; j++) {
                            var tempItem = this.obj_Group.GameProviderIds.indexOf(this.dd_gameprovider[tabIndex].children[j].id);
                            if (tempItem >= 0) {
                                if (!this.constHouseBrand.includes(this.dd_gameprovider[tabIndex].children[j].id)) {
                                    this.obj_Group.GameProviderIds.splice(tempItem, 1);
                                }
                            }
                        }
                    }
                    this.btnGP2_checkedAll = false;
                }

                this.obj_Group.GPI = "";
                this.obj_Group.GPI = this.obj_Group.GameProviderIds.join(',')

                var activeALLGP = true;
                for (const tabIndex in this.dd_gameprovider) {
                    if (!this.btnGP_checkedAll[tabIndex]) {
                        activeALLGP = false;
                        break;
                    }
                }
                if (activeALLGP) this.btnGP2_checkedAll = true;
            },
            checkSelectAllGPButton() {

                var activeALLGP = true;
                for (const tabIndex in this.dd_gameprovider) {
                    this.btnGP_checkedAll[tabIndex] = false;
                    if (this.dd_gameprovider[tabIndex].children != null && this.dd_gameprovider[tabIndex].children.length > 0) {
                        for (var j = 0; j < this.dd_gameprovider[tabIndex].children.length; j++) {
                            if (this.obj_Group.GameProviderIds.indexOf(this.dd_gameprovider[tabIndex].children[j].id) >= 0) {
                                this.btnGP_checkedAll[tabIndex] = true;
                            } else {
                                this.btnGP_checkedAll[tabIndex] = false;
                                this.btnGP2_checkedAll = false;
                                activeALLGP = false;
                                break;
                            }
                        }
                    }
                }

                if (activeALLGP) this.btnGP2_checkedAll = true;

            },
            selectLangAll(tabIndex) {
                this.obj_Group.Language = [];
                this.obj_Group.L = "";
                if (this.btnLang_checkedAll) {
                    var that = this;
                    $.each(this.dd_language_wall[0].children, function (index, value) {
                        that.obj_Group.Language.push(value.id)
                    });
                    this.obj_Group.L = this.obj_Group.Language.join(',')

                } else {
                    this.obj_Group.Language = ['en'];
                    this.obj_Group.L = "en";
                }
            },
            checkSelectAllLangButton(langId = null) {
                //Removed loop
                //if (this.dd_language_wall.length != 0) {
                //    for (const tabIndex in this.dd_language_wall[0].children) {
                //        if (this.obj_Group.Language.length == this.dd_language_wall[0].children.length) {
                //            this.btnLang_checkedAll = true;
                //        } else {
                //            this.btnLang_checkedAll = false;
                //        }
                //    }
                //}

                if (this.dd_language_wall.length != 0) {

                    // Direct check for this.btnLang_checkedAll
                    this.btnLang_checkedAll =
                        this.obj_Group.Language.length === this.dd_language_wall[0].children.length;

                    // Only accessed when langId exists, prevents ParentGroupChange from encountering error. 
                    if (langId) {
                        // Add to newLanguage if it's newly selected
                        if (
                            this.obj_Group.Language.includes(langId) && // Language is selected
                            !this.newLanguage.includes(langId) // Not already in newLanguage
                        ) {
                            this.newLanguage.push(langId);
                        }

                        // Remove from newLanguage if deselected
                        if (!this.obj_Group.Language.includes(langId)) {
                            this.newLanguage = this.newLanguage.filter(id => id !== langId);
                        }
                    }
                }
                this.obj_Group.L = this.obj_Group.Language.join(',');
            },
            selectCurAll(tabIndex) {
                this.obj_Group.CurrencyIds = [];
                this.obj_Group.CI = "";
                if (this.btnCur_checkedAll) {
                    var that = this;
                    $.each(this.dd_currency_wall[0].children, function (index, value) {
                        that.obj_Group.CurrencyIds.push(value.id)
                    });
                    this.obj_Group.CI = this.obj_Group.CurrencyIds.join(',')
                } else {
                    this.obj_Group.CurrencyIds = [];
                    this.obj_Group.CI = "";
                }

                this.checkShowAvailablePaymentGateway();
                this.selectSupportedCurrency();
            },
            checkSelectAllCurButton() {
                if (this.dd_currency_wall.length != 0) {
                    for (const tabIndex in this.dd_currency_wall[0].children) {
                        if (this.obj_Group.CurrencyIds.length == this.dd_currency_wall[0].children.length) {
                            this.btnCur_checkedAll = true;
                        } else {
                            this.btnCur_checkedAll = false;
                        }
                        this.obj_Group.CI = this.obj_Group.CurrencyIds.join(',')
                    }

                    this.checkShowAvailablePaymentGateway();
                    this.selectSupportedCurrency(true);
                }

            },
            checkShowAvailablePaymentGateway() {
                this.dd_paymentgateway_cat =
                    ['Help2pay', 'OOPay', 'EZPay',
                    'TruePay', 'XFuoo', 'StarPay',
                    'SurePay', 'CPay', 'FuPay',
                    'TrueMoney', 'SmartPay', 'U2Pay',
                    'LuckyPay', 'BCPay', 'FPG',
                    'MPay', 'AutoDepo(Ext)', 'Chapter B',
                    'DoitNow', 'AgogoPay', '918Pay',
                    'UniversePay', 'Okayspay', 'Megaspay',
                    'VIP', 'AlfaPay', 'OnePay',
                    'BleuPay', 'Easy88Pay', 'ECPay',
                    'ZPay', 'UPay', 'DGPay', 'Super7Pay'];/* , 'PayNGo', 'PapayaPay'*/
                if (!this.checkCurrencyID('THB') && !this.checkCurrencyID('VND') && !this.checkCurrencyID('IDR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "OOPay"; });
                }
                if (!this.checkCurrencyID('USD') && !this.checkCurrencyID('IDR') && !this.checkCurrencyID('MYR') && !this.checkCurrencyID('THB') && !this.checkCurrencyID('VND')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "EZPay"; });
                }
                if (!this.checkCurrencyID('MYR') && !this.checkCurrencyID('VND')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "TruePay"; });
                }
                if (!this.checkCurrencyID('THB') && !this.checkCurrencyID('VND') && !this.checkCurrencyID('MYR') && !this.checkCurrencyID('USD') && !this.checkCurrencyID('IDR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "XFuoo"; });
                }
                if (!this.checkCurrencyID('IDR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "StarPay"; });
                }
                if (!this.checkCurrencyID('MYR') && !this.checkCurrencyID('THB') && !this.checkCurrencyID('SGD') && !this.checkCurrencyID('IDR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "SurePay"; });
                }
                if (!this.checkCurrencyID('INR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "FuPay"; });
                }
                if (!this.checkCurrencyID('THB')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "TrueMoney"; });
                }
                if (!this.checkCurrencyID('THB') && !this.checkCurrencyID('IDR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "SmartPay"; });
                }
                if (!this.checkCurrencyID('IDR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "U2Pay"; });
                }
                if (!this.checkCurrencyID('THB')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "LuckyPay"; });
                }
                if (!this.checkCurrencyID('BRL')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "BCPay"; });
                }
                if (!this.checkCurrencyID('MYR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "FPG"; });
                }
                if (!this.checkCurrencyID('IDR') && !this.checkCurrencyID('IDR2')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "MPay"; });
                }
                if (!this.checkCurrencyID('THB')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "Chapter B"; });
                }
                if (!this.checkCurrencyID('THB')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "AutoDepo(Ext)"; });
                }
                //if (!this.checkCurrencyID('THB')) {
                //    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "PapayaPay"; });
                //}
                if (!this.checkCurrencyID('CNY')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "DGPay"; });
                }
                if (!this.checkCurrencyID('VND')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "Super7Pay"; });
                }
                if (!this.checkCurrencyID('MYR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "DoitNow"; });
                }
                if (!this.checkCurrencyID('VND')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "AgogoPay"; });
                }
                if (!this.checkCurrencyID('VND')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "918Pay"; });
                }
                if (!this.checkCurrencyID('VND')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "UniversePay"; });
                }
                if (!this.checkCurrencyID('USD') && !this.checkCurrencyID('MYR') && !this.checkCurrencyID('IDR') && !this.checkCurrencyID('KHR') && !this.checkCurrencyID('THB') && !this.checkCurrencyID('VND') && !this.checkCurrencyID('HKD') && !this.checkCurrencyID('AED') && !this.checkCurrencyID('MMK') && !this.checkCurrencyID('INR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "CPay"; });
                }
                if (!this.checkCurrencyID('MYR') && !this.checkCurrencyID('IDR') && !this.checkCurrencyID('THB') && !this.checkCurrencyID('VND')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "Help2pay"; });
                }
                if (!this.checkCurrencyID('THB') && !this.checkCurrencyID('VND') && !this.checkCurrencyID('IDR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "Okayspay"; });
                }
                if (!this.checkCurrencyID('MYR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "Megaspay"; });
                }
                if (!this.checkCurrencyID('IDR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "VIP"; });
                }
                if (!this.checkCurrencyID('PHP')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "AlfaPay"; });
                }
                if (!this.checkCurrencyID('NPR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "OnePay"; });
                }
                if (!this.checkCurrencyID('MMK')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "BleuPay"; });
                }
                if (!this.checkCurrencyID('BDT')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "Easy88Pay"; });
                }
                if (!this.checkCurrencyID('BDT')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "ECPay"; });
                }
                if (!this.checkCurrencyID('THB') && !this.checkCurrencyID('INR') && !this.checkCurrencyID('BRL') && !this.checkCurrencyID('VND') && !this.checkCurrencyID('MYR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "ZPay"; });
                }
                if (!this.checkCurrencyID('MYR')) {
                    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "UPay"; });
                }
                //if (!this.checkCurrencyID('IDR')) {
                //    this.dd_paymentgateway_cat = $.grep(this.dd_paymentgateway_cat, function (value) { return value != "PayNGo"; });
                //}
                this.selectedPGCat = this.dd_paymentgateway_cat[0];
            },
            TextValueChange(type, event) {
                if (type == "S") {
                    this.obj_livechat.S = event.target.value;
                }
                else if (type == "RT") {
                    this.obj_Domain.RT = event.target.value;
                }
                else if (type == "CN") {
                    this.obj_Domain.CN = event.target.value;
                }
                else if (type == "FSXML") {
                    this.obj_Domain.FSXML = event.target.value;
                }
                else if (type == "RTAD") {
                    this.obj_ADomain.RT = event.target.value;
                }
                else if (type == "CNAD") {
                    this.obj_ADomain.CN = event.target.value;
                }
                else if (type == "FSXMLAD") {
                    this.obj_ADomain.FSXML = event.target.value;
                }
            },
            autoPopulateDefaultTemplate() {
                if (this.obj_Domain.I == 0) {
                    for (var i = 0; i < this.dd_template.length; i++) {
                        if (this.dd_template[i].label == 'Casino UG') {
                            this.obj_Domain.DS[this.selectedLangIndex].TI = this.dd_template[i].id;
                            this.TemplateChange(this.obj_Domain.DS[this.selectedLangIndex].TI);
                            break;
                        }
                    }


                    //for (var i = 0; i < this.dd_mtemplate.length; i++) {
                    //    if (this.dd_mtemplate[i].label == 'NBAMobile') {
                    //        this.obj_Domain.DS[this.selectedLangIndex].MTI = this.dd_mtemplate[i].id;
                    //        this.MobileTemplateChange(this.obj_Domain.DS[this.selectedLangIndex].MTI);
                    //        break;
                    //    }
                    //}

                    setTimeout(() => {
                        if (this.dd_templateskins[this.obj_Domain.DS[this.selectedLangIndex].TI]) {
                            for (var i = 0; i < this.dd_templateskins[this.obj_Domain.DS[this.selectedLangIndex].TI].length; i++) {
                                if (this.dd_templateskins[this.obj_Domain.DS[this.selectedLangIndex].TI][i].label == 'black-blue') {
                                    this.obj_Domain.DS[this.selectedLangIndex].TSI = this.dd_templateskins[this.obj_Domain.DS[this.selectedLangIndex].TI][i].id;
                                    break;
                                }
                            }
                        }
                        //if (this.dd_mtemplateskins[this.obj_Domain.DS[this.selectedLangIndex].MTI]) {
                        //    for (var i = 0; i < this.dd_mtemplateskins[this.obj_Domain.DS[this.selectedLangIndex].MTI].length; i++) {
                        //        if (this.dd_mtemplateskins[this.obj_Domain.DS[this.selectedLangIndex].MTI][i].label == 'black-blue') {
                        //            this.obj_Domain.DS[this.selectedLangIndex].MTSI = this.dd_mtemplateskins[this.obj_Domain.DS[this.selectedLangIndex].MTI][i].id;
                        //            break;
                        //        }
                        //    }
                        //}
                    }, 1000)

                    //this.autoScrollTemplate();
                }
            },
            GeneratePrefixCode() {
                var that = this;
                if (that.str_houtOriPrefix != "") {
                    that.obj_Group.PC = that.str_houtOriPrefix;
                } else {

                    this.getDataApi(`/api/ag/pc`,
                        function (d, s) {
                            if (s) {
                                that.obj_Group.PC = d.D;
                            }
                        });
                }
            },
            formatEstimatePT(gameProviderId, AgentMaxPT) {
                var estimatePT = "";
                if (gameProviderId != 55 && this.dd_GPDefaultPT != null && this.dd_GPDefaultPT.length > 0) {
                    for (var d of this.dd_GPDefaultPT) {
                        if (d.GPI == gameProviderId) {
                            AgentMaxPT = parseFloat(AgentMaxPT);
                            estimatePT = 100 - d.DPT;
                            if (estimatePT > AgentMaxPT) {
                                estimatePT = AgentMaxPT;
                            } else {
                                estimatePT = estimatePT - 2;
                            }
                            estimatePT = " (" + estimatePT.toFixed(2) + " %) ";
                        }
                    }
                }
                else {
                    estimatePT = " (TBC) ";
                }
                return estimatePT;
            },
            getIURLTabIndex(id) {
                var result = 0;
                try {
                    var x = document.querySelector(id + ' .nav.nav-tabs li a.active');
                    if (x && (x.innerText == "Upload Desktop Site Logo" || x.innerText == "Upload Mobile Site Logo")) {
                        result = 1;
                        return result;
                    }
                    else {
                        result = 2;
                        return result;
                    }
                }
                catch (ex) {
                    console.log(ex);
                }
                return result;
            },
            CurrencyChange(value) {
                if (value != undefined) {
                    var that = this;
                    this.dd_currency.find(function (val, idx) {
                        if (val.id == value) {
                            that.setThousandCurrency(that.CheckIsThousandCurrency(val.label, that), that);
                            that.currencySymbol = val.label;
                        }
                    });
                } else {
                    this.obj_bankacc['FCS'] = "";
                    this.obj_bankacc['TCS'] = "";
                    this.obj_bankacc['ER'] = 1;
                    this.obj_bankacc['TER'] = 1;
                }
            },
            showAvailableBalance() {
                return (this.obj_Group.I > 0 || (this.obj_Group.PGIT != null && this.obj_Group.PGIT != ''));
            },
            ValidationGroupErrMsg(value, langKey = "") {
                if (value == "PC" && this.str_prefixError != "") {
                    return "";
                }
                if (this.bool_groupCV) {
                    var parent = "";

                    if (value.indexOf(".") >= 0) {
                        var tempKey = value.split('.');
                        parent = tempKey[0];
                        value = tempKey[1];
                    }

                    if (langKey == "") {
                        langKey = value;
                    }
                    var validateObj = parent == "" ? this.$v.obj_Group[value] : this.$v.obj_Group[parent][value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    }
                    else if ((validateObj.minLength != undefined && !validateObj.minLength) || (validateObj.maxLength != undefined && !validateObj.maxLength)) {
                        if (value == "UP") {
                            return this.getLanguage['AG']['IUPF'];
                        }
                        else {
                            return this.getLanguage["AG"]['ERR4'];
                        }
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.utilGetErrorLanguage('1008'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('1004'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.email != undefined && !validateObj.email) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.minValue != undefined && !validateObj.minValue) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.PTRangeValidation != undefined && !validateObj.PTRangeValidation) {
                        return String.format(this.getLanguage["SAPS"]["ERRBTW"], this.getLanguage["AG"][langKey], 0, this.obj_Group.MaxPT);
                    }
                    else if (validateObj.validatePassword != undefined && !validateObj.validatePassword) {
                        return this.getLanguage['AG']['IUPF'];
                    }
                }
            },
            ValidatePrefixCode(event) {
                var that = this;
                this.obj_Group.PC = event;
                var prefixCode = this.obj_Group.PC;
                if (prefixCode.length == 4) {
                    this.getDataApi('/api/ag/chk/0/' + prefixCode,
                        function (d, s) {
                            if (d.ERRC != "") {
                                //// prefix code duplicated
                                that.str_prefixError = String.format(that.utilGetErrorLanguage(d.ERRC), prefixCode);
                            }
                            else {
                                that.str_prefixError = "";
                            }
                        });
                }
            },
            validateH2p() {
                var v1 = this.obj_Group.H2PU
                var v2 = this.obj_Group.H2PMC
                var v3 = this.obj_Group.H2PSC
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateOOPTH() {
                var v1 = this.obj_Group.OOPTHMN
                var v2 = this.obj_Group.OOPTHAS
                var v3 = this.obj_Group.OOPTHSK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateOOPVI() {
                var v1 = this.obj_Group.OOPVIMN
                var v2 = this.obj_Group.OOPVIAS
                var v3 = this.obj_Group.OOPVISK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateOOPID() {
                var v1 = this.obj_Group.OOPIDMN
                var v2 = this.obj_Group.OOPIDAS
                var v3 = this.obj_Group.OOPIDSK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateEZPIDR() {
                var v1 = this.obj_Group.EZPIDRMN
                var v2 = this.obj_Group.EZPIDRAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateEZPMYR() {
                var v1 = this.obj_Group.EZPMYRMN
                var v2 = this.obj_Group.EZPMYRAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateEZPTHB() {
                var v1 = this.obj_Group.EZPTHBMN
                var v2 = this.obj_Group.EZPTHBAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateEZPVND() {
                var v1 = this.obj_Group.EZPVNDMN
                var v2 = this.obj_Group.EZPVNDAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateEZPUSD() {
                var v1 = this.obj_Group.EZPUSDMN
                var v2 = this.obj_Group.EZPUSDAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateTUPVND() {
                var v1 = this.obj_Group.TUPVNDMN
                var v2 = this.obj_Group.TUPVNDAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateTUPMYR() {
                var v1 = this.obj_Group.TUPMYRMN
                var v2 = this.obj_Group.TUPMYRAS

                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v2 != null && v2 != "") {
                    return true;
                }
                return false;
            },
            validateXFuooTH() {
                var v1 = this.obj_Group.XFTHN
                var v2 = this.obj_Group.XFTHK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateXFuooVI() {
                var v1 = this.obj_Group.XFVIN
                var v2 = this.obj_Group.XFVIK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateXFuooMYR() {
                var v1 = this.obj_Group.XFMYRN
                var v2 = this.obj_Group.XFMYRK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateXFuooUSDT() {
                var v1 = this.obj_Group.XFUSDTN
                var v2 = this.obj_Group.XFUSDTK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateXFuooIDR() {
                var v1 = this.obj_Group.XFIDRN
                var v2 = this.obj_Group.XFIDRK
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateStarsPay() {
                var v1 = this.obj_Group.SPAK
                var v2 = this.obj_Group.SPMN
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                return false;
            },
            validateSurePaySGD() {
                var v1 = this.obj_Group.SUSGDAK
                var v2 = this.obj_Group.SUSGDMN
                var v3 = this.obj_Group.SUSGDCN
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateSurePayMYR() {
                var v1 = this.obj_Group.SUMYRAK
                var v2 = this.obj_Group.SUMYRMN
                var v3 = this.obj_Group.SUMYRCN
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            validateSurePayTHB() {
                var v1 = this.obj_Group.SUTHBAK
                var v2 = this.obj_Group.SUTHBMN
                var v3 = this.obj_Group.SUTHBCN
                if (v2 != null && v2 != "") {
                    return true;
                }
                if (v1 != null && v1 != "") {
                    return true;
                }
                if (v3 != null && v3 != "") {
                    return true;
                }
                return false;
            },
            checkCurrencyID(cname) {
                var currencyCode = this.dd_currency.find(f => f.label === cname)
                var cid = currencyCode ? currencyCode.id : null;
                return this.obj_Group.CI.split(',').includes(cid);
            },
            addMyIP() {
                var WLIPS_C = window.baseIP;
                var exist = false;

                this.obj_WLIPS = {
                    WLIPS: WLIPS_C
                }
                for (var i = 0; i < this.obj_Group.WhiteListIP.length; i++) {
                    if (this.obj_Group.WhiteListIP[i].WLIPS == WLIPS_C) {
                        exist = true;
                        break;
                    }
                }
                if (exist) {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["AG"]["WL"]), 1000);
                }
                else {
                    this.obj_Group.WhiteListIP.push(this.obj_WLIPS);
                }
            },
            //addWhiteListIP() {
            //    var exist = false;

            //    if (this.obj_Group.WLIPS.trim() == "") {
            //        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"]["WL"]), 1000);
            //    }
            //    else {
            //        var WLIPS_C = this.obj_Group.WLIPS.trim();
            //        this.obj_WLIPS = {
            //            WLIPS: WLIPS_C
            //        }
            //        for (var i = 0; i < this.obj_Group.WhiteListIP.length; i++) {
            //            if (this.obj_Group.WhiteListIP[i].WLIPS == WLIPS_C) {
            //                exist = true;
            //                break;
            //            }
            //        }
            //        if (exist) {
            //            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["AG"]["WL"]), 1000);
            //        }
            //        else {
            //            this.obj_Group.WhiteListIP.push(this.obj_WLIPS);
            //            this.obj_Group.WLIPS = "";
            //        }
            //    }
            //},
            addWhiteListIP() {
                var exist = false;

                this.obj_Group.WLIPS = this.obj_Group.WLIPS.replace(/\s/g, "").toLowerCase();
                this.obj_Group.WLIPS = this.findChar(this.obj_Group.WLIPS, this.obj_Group.WLIPS.length);

                if (this.obj_Group.WLIPS.trim() == "") {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"]["WL"]), 1000);
                }
                else if (!this.validateIP(this.obj_Group.WLIPS)) {
                    this.showErrorMessage(null, this.getLanguage["ERR"]["IIPF"], 1000);
                }
                else {
                    var WLIPS_C = this.obj_Group.WLIPS.trim();
                    this.obj_WLIPS = {
                        WLIPS: WLIPS_C
                    }
                    for (var i = 0; i < this.obj_Group.WhiteListIP.length; i++) {
                        if (this.obj_Group.WhiteListIP[i].WLIPS == WLIPS_C) {
                            exist = true;
                            break;
                        }
                    }
                    if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["AG"]["WL"]), 1000);
                    }
                    else {
                        this.obj_Group.WhiteListIP.push(this.obj_WLIPS);
                        this.obj_Group.WLIPS = "";
                    }
                }
            },
            //Validate IP in IPv4 and IPv6 Format for Whitelist IP in addWhiteListIP()
            validateIP(ip) {
                return this.validateIPv4(ip) || this.validateIPv6(ip);
            },
            validateIPv4(ip) {
                const ipv4Pattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                return ipv4Pattern.test(ip);
            },
            validateIPv6(ip) {
                const ipv6Pattern = /^(?:[a-fA-F0-9]{1,4}:){7}[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,7}:|(?:[a-fA-F0-9]{1,4}:){1,6}:[a-fA-F0-9]{1,4}|(?:[a-fA-F0-9]{1,4}:){1,5}(?::[a-fA-F0-9]{1,4}){1,2}|(?:[a-fA-F0-9]{1,4}:){1,4}(?::[a-fA-F0-9]{1,4}){1,3}|(?:[a-fA-F0-9]{1,4}:){1,3}(?::[a-fA-F0-9]{1,4}){1,4}|(?:[a-fA-F0-9]{1,4}:){1,2}(?::[a-fA-F0-9]{1,4}){1,5}|[a-fA-F0-9]{1,4}:(?::[a-fA-F0-9]{1,4}){1,6}|:(?::[a-fA-F0-9]{1,4}){1,7}|::$/i;
                return ipv6Pattern.test(ip);
            },
            removeWhiteListIP(index) {
                this.$delete(this.obj_Group.WhiteListIP, index);
                this.$forceUpdate();
            },

            //domain
            changeDomainName(event, isEdit) {
                this.obj_Domain.DN = event.replace(/\s/g, "").toLowerCase();
                this.obj_Domain.DN = this.findChar(this.obj_Domain.DN, this.obj_Domain.DN.length);
            },
            findChar(str, index) {
                var allow = new RegExp(/[0-9a-z]/, 'gi');
                if (!str.charAt(str.length - 1).match(allow)) {
                    str = str.slice(0, -1);
                    return this.findChar(str, index - 1);
                }
                return str;
            },
            hasLogo() {
                if (this.obj_Domain.SL != null && this.obj_Domain.SL != '' && !this.obj_Domain.RSL && this.obj_Domain.SLBL == this.bool_holSLBL) {
                    return true;
                }
                else {
                    return false;
                }
            },
            removeLogo() {
                this.obj_Domain.RSL = true;
                this.$forceUpdate();
            },
            onFileLogoSelected(event) {
                this.selectedFile = this.validateFile(event);
                if (!this.bool_holSLBL) { // if choose local file
                    this.obj_Domain.RSL = true;
                }
            },
            hasLogoIco() {
                if (this.obj_Domain.SI != null && this.obj_Domain.SI != '' && !this.obj_Domain.RSI && this.obj_Domain.SIBL == this.bool_holSIBL) {
                    return true;
                }
                else {
                    return false;
                }
            },
            removeLogoIco() {
                this.obj_Domain.RSI = true;
                this.$forceUpdate();
            },
            onFileIcoSelected(event) {
                this.selectedFileIco = this.validateFile(event, 5, [".ico"]);
                if (!this.bool_holSIBL) { // if choose local file
                    this.obj_Domain.RSI = true;
                }
            },
            onFileMLogoSelected(event) {
                this.selectedFileMsl = this.validateFile(event);
                if (!this.bool_holMSLBL) { // if choose local file
                    this.obj_Domain.RMSL = true;
                }
            },
            TemplateChange(value, index) {
                if (value === null || value === undefined) {
                    this.obj_Domain.DS[index].TI = null;
                    this.obj_Domain.DS[index].TSI = null;
                    return;
                }

                // Check if the dropdown options for this template value are already loaded
                if (!this.dd_templateskins[value]) {
                    this.getDataApi(`/api/dd/ts/${value}`, (d, s) => {
                        if (s) {
                            // Sort options by label in ascending order
                            d.dropdownlist.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
                            d.dropdownlist.push({ id: '0', label: this.getTemplateDefaultSkinColor(this.dd_template, value) });

                            // Use Vue.set to ensure reactivity if necessary
                            this.$set(this.dd_templateskins, value, d.dropdownlist);
                        }
                    });
                }
            },
            MobileTemplateChange(value, index) {
                if (value === null || value === undefined) {
                    this.obj_Domain.DS[index].MTI = null;
                    this.obj_Domain.DS[index].MTSI = null;
                    return;
                }

                // Check if the dropdown options for this template value are already loaded
                if (!this.dd_mtemplateskins[value]) {
                    this.getDataApi(`/api/dd/ts/${value}`, (d, s) => {
                        if (s) {
                            // Sort options by label in ascending order
                            d.dropdownlist.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
                            d.dropdownlist.push({ id: '0', label: this.getTemplateDefaultSkinColor(this.dd_mtemplate, value) });

                            // Use Vue.set to ensure reactivity if necessary
                            this.$set(this.dd_mtemplateskins, value, d.dropdownlist);
                        }
                    });
                }
            },
            AlternateTemplateChange(value, index) {
                if (value === null || value === undefined) {
                    this.obj_Domain.DS[index].TIALT = null;
                    this.obj_Domain.DS[index].TSIALT = null;
                    return;
                }

                // Check if the dropdown options for this template value are already loaded
                if (!this.dd_templateskins[value]) {
                    this.getDataApi(`/api/dd/ts/${value}`, (d, s) => {
                        if (s) {
                            // Sort options by label in ascending order
                            d.dropdownlist.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
                            d.dropdownlist.push({ id: '0', label: this.getTemplateDefaultSkinColor(this.dd_template, value) });

                            // Use Vue.set to ensure reactivity if necessary
                            this.$set(this.dd_templateskins, value, d.dropdownlist);
                        }
                    });
                }
            },
            AlternateMobileTemplateChange(value, index) {
                if (value === null || value === undefined) {
                    this.obj_Domain.DS[index].MTIALT = null;
                    this.obj_Domain.DS[index].MTSIALT = null;
                    return;
                }

                // Check if the dropdown options for this template value are already loaded
                if (!this.dd_mtemplateskins[value]) {
                    this.getDataApi(`/api/dd/ts/${value}`, (d, s) => {
                        if (s) {
                            // Sort options by label in ascending order
                            d.dropdownlist.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
                            d.dropdownlist.push({ id: '0', label: this.getTemplateDefaultSkinColor(this.dd_mtemplate, value) });

                            // Use Vue.set to ensure reactivity if necessary
                            this.$set(this.dd_mtemplateskins, value, d.dropdownlist);
                        }
                    });
                }
            },
            getTemplateDefaultSkinColor(templateDD, value) {
                var defaultSkinColor = '';
                try {
                    if (templateDD) {
                        if (value) {
                            for (var i = 0; i < templateDD.length; i++) {
                                if (templateDD[i].id == value) {
                                    defaultSkinColor = templateDD[i].label2;
                                    break;
                                }
                            }
                        }
                    }
                }
                catch (e) {
                    defaultSkinColor = '';
                }

                return defaultSkinColor ? defaultSkinColor + ' (default)' : 'default';
            },
            renderTemplateName(TemplateName) {
                if (TemplateName && TemplateName in this.getLanguage['TMPE'])
                    return this.getLanguage['TMPE'][TemplateName];
                else
                    return TemplateName;
            },
            getTemplateUrl(templateId, type, type2) {
                if (type2 == 'desktop') {
                    for (var i = 0; i < this.dd_template.length; i++) {
                        if (this.dd_template[i].id == templateId && type == 'img') {
                            return 'https://afbgg.info/images/' + (this.dd_template[i].label.replaceAll(" ", "").toLowerCase()) + '-home.jpg';
                        } else if (this.dd_template[i].id == templateId && type == 'link') {
                            return 'https://uatone-' + (this.dd_template[i].label.replaceAll(" ", "").toLowerCase()) + '.afbplays.com/';
                        }
                    }
                } else if (type2 == 'mobile') {
                    for (var i = 0; i < this.dd_mtemplate.length; i++) {
                        if (this.dd_mtemplate[i].id == templateId && type == 'img') {
                            return 'https://afbgg.info/images/' + (this.dd_mtemplate[i].label.replaceAll(" ", "").toLowerCase()) + '-home.jpg';
                        } else if (this.dd_mtemplate[i].id == templateId && type == 'link') {
                            return 'https://uatone-' + (this.dd_mtemplate[i].label.replaceAll(" ", "").toLowerCase()) + '.afbplays.com/';
                        }
                    }
                }
            },
            getAFBSportsTemplateUrl(template, type) {
                if (template && type == 'desktop') {
                    return 'https://afbgg.info/images/AFBSports/Desktop/' + (template.replaceAll(" ", "")) + '.png';
                } else if (template && type == 'mobile') {
                    return 'https://afbgg.info/images/AFBSports/Mobile/' + (template.replaceAll(" ", "")) + '.png';
                }
            },
            getDefaultRobotsTxt(isPrimary) {
                if (isPrimary == 1) {
                    return "User-agent: *\nDisallow: /\n\nSitemap: https://" + (this.obj_Domain && this.obj_Domain.DN != null && this.obj_Domain.DN != "" ? this.obj_Domain.DN : '{domain name}') + "/sitemap.xml";
                }
                else {
                    return "User-agent: *\nDisallow: /\n\nSitemap: https://" + ((this.obj_ADomain && this.obj_ADomain.I > 0 && this.obj_ADomain.DN != null && this.obj_ADomain.DN != "") ? this.obj_ADomain.DN : '{domain name}') + "/sitemap.xml";
                }
            },
            resetField(type) {
                //console.log(type, this.rtKey, this.fsxmlKey, this.rtAltKey, this.fsxmlAltDKey)
                if (type == "RT") {
                    this.obj_Domain.RT = "";
                    this.rtKey = this.rtKey == 0 ? 1 : 0;
                }
                else if (type == "FSXML") {
                    this.obj_Domain.FSXML = "";
                    this.fsxmlKey = this.fsxmlKey == 0 ? 1 : 0;
                }
                else if (type == "RTAD") {
                    this.obj_ADomain.RT = "";
                    this.rtAltKey = this.rtAltKey == 0 ? 1 : 0;
                }
                else if (type == "FSXMLAD") {
                    this.obj_ADomain.FSXML = "";
                    this.fsxmlAltKey = this.fsxmlAltKey == 0 ? 1 : 0;
                }
            },
            refreshDofs(that, id) {
                that.getDataApi(`/api/dd/dn/` + id,
                    function (d, s) {
                        if (s) {
                            let dropdown = d.dropdownlist.map(x => { return { "id": x.label, "label": x.label } });
                            if (that.obj_Domain.DALT && that.obj_Domain.DALT.length > 0) {
                                that.obj_Domain.DALT.forEach((x, i, arr) => {
                                    dropdown.push({ "id": x.DN, "label": x.DN });
                                });
                            }
                            that.dd_dofs = dropdown;
                        }
                    });
            },
            tickSettingCheckbox(event, setting) {
                if (!this.bool_disableInsertDomain) {
                    if (!event.target.checked) {
                        if (setting.L == this.obj_Domain.DL) {
                            this.$fire({
                                title: (String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["DM"]["DL"])) + " " + this.getLanguage["MEM"]["CA"],
                                width: '30em',
                                showCancelButton: true,
                                confirmButtonText: this.getLanguage["GL"]["CONFIRM"],
                                cancelButtonText: this.getLanguage["CNO"]["NO"],
                                reverseButtons: true,
                                customClass: {
                                    title: 'afb-alert-title',
                                    content: 'afb-alert-content',
                                    actions: 'afb-alert-action'
                                }
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.obj_Domain.DL = null;
                                } else {
                                    event.target.checked = true;
                                    setting.TC = true;
                                }
                            });
                        }
                    } else {
                        if (!this.obj_Domain.DL) {
                            this.obj_Domain.DL = setting.L;
                        }
                    }
                }

                //setTimeout(() => {
                //    this.isTick = false;
                //    for (var i = 0; i < this.obj_Domain.DS.length; i++) {
                //        if (this.obj_Domain.DS[i].TC && setting.LE) {
                //            this.isTick = true;
                //            return;
                //        }
                //    }
                //}, 100)
            },
            displayDNSLine(dnsCSV) {
                return dnsCSV.replace(/,/g, ", ");
            },
            clearCache(d) {
                this.bool_fullLoading = true;
                var that = this;
                var dt = {
                    i: d.I,
                    agi: d.AGI
                };

                this.postDataApi(`/api/dm/cc`, dt,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    });
            },
            //main domain
            checkUseCloudFlareMainDomain(v) {
                this.obj_Domain.UCF = v.target.checked;
                this.$forceUpdate();
            },
            getCloudFlareStatus(data) {
                var that = this;
                this.getDataApi(`/api/dm/gd/${data}`,
                    function (d, s) {
                        if (s) {
                            if (d) {
                                that.obj_Domain.CFStatus = d.D.CFStatus;

                                for (var i = 0; i < d.D.DALT.length; i++) {
                                    that.obj_Domain.DALT[i].CFStatus = d.D.DALT[i].CFStatus;

                                    that.obj_Domain.DALT[i].RTD = [];
                                    if (d.D.DALT[i].RTD != "" && d.D.DALT[i].RTD != null) {
                                        var RTD_C = d.D.DALT[i].RTD;

                                        var RTD_CARRY = RTD_C.split(',');
                                        for (var j = 0; j < RTD_CARRY.length; j++) {
                                            if (j == 0) {
                                                that.obj_Domain.DALT[i].RTD = RTD_CARRY[j];
                                            }
                                            else {
                                                that.obj_Domain.DALT[i].RTD = that.obj_Domain.DALT[i].RTD + "," + RTD_CARRY[j];
                                            }
                                        }
                                    }
                                }
                                that.$forceUpdate();
                            }

                        }
                    });


            },
            ValidationDomainErrMsg(value, langKey = "", index = -1) {
                if (this.bool_groupCV) {
                    var primaryLangKey = 'DM';
                    if (langKey == "") {
                        langKey = value;
                    }

                    if (value == 'SAGI') {
                        primaryLangKey = 'AG'
                    } else if (value == 'DSN1' || value == 'DSN2') {
                        primaryLangKey = 'MEM'
                    }
                    if (index < 0) {
                        if (value == 'SAGI') {
                            if (this.sagiError) {
                                return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[primaryLangKey][langKey]);
                            }
                        }
                        else if (this.$v.obj_Domain[value] != null && this.$v.obj_Domain[value].required != undefined && !this.$v.obj_Domain[value].required) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[primaryLangKey][langKey]);
                        }
                    }
                    else {
                        if (this.$v.obj_Domain.DS.$each[index][value] != null && this.$v.obj_Domain.DS.$each[index][value].required != undefined && !this.$v.obj_Domain.DS.$each[index][value].required) {
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage[primaryLangKey][langKey]);
                        }
                    }
                }
            },
            addDomain() {
                this.bool_isEditDomain = false;
                this.bool_isDomain = true;
            },
            editDomain() {
                if (!this.bool_disableInsertDomain) {
                    this.bool_isEditDomain = true;

                    this.obj_Domain.DomainNameServer = [];
                    if (this.obj_Domain.DNS != "") {
                        var DNS_C = this.obj_Domain.DNS;
                        var DNS_CARRY = DNS_C.split(',');
                        for (var i = 0; i < DNS_CARRY.length; i++) {
                            this.obj_DNS = {
                                DNS: DNS_CARRY[i]
                            }
                            this.obj_Domain.DomainNameServer.push(this.obj_DNS);
                        }
                    }
                    if (this.obj_Domain.RT == null || this.obj_Domain.RT == '') {
                        this.obj_Domain.RT = this.getDefaultRobotsTxt(1);
                    }

                    //var that = this;
                    //this.bool_fullLoading = true;
                    //this.getDataApi(`/api/dm/gd/${this.obj_Domain.I}`,
                    //    function (d, s) {
                    //        that.bool_fullLoading = false;
                    //        if (s) {
                    //            if (d) {
                    //                that.obj_Domain.CFStatus = d.D.CFStatus;
                    //            }
                    //        }
                    //    });

                    this.bool_isDomain = true;
                }
            },
            saveDomain() {
                this.bool_groupCV = true;
                this.$v.obj_Domain.$touch();
                if (!this.$v.obj_Domain.$error) {
                    this.bool_groupCV = false;
                    this.bool_isDomain = false;
                    this.obj_Domain.DNS = "";
                    if (this.obj_Domain.DomainNameServer != null && this.obj_Domain.DomainNameServer.length > 0) {
                        for (var i = 0; i < this.obj_Domain.DomainNameServer.length; i++) {
                            if (i != 0) {
                                this.obj_Domain.DNS += ",";
                            }
                            this.obj_Domain.DNS += this.obj_Domain.DomainNameServer[i].DNS;
                        }
                    }
                    this.obj_Domain.DN = this.obj_Domain.DN.replace(/\s/g, "").toLowerCase();
                    this.obj_Domain.DN = this.findChar(this.obj_Domain.DN, this.obj_Domain.DN.length);
                }
            },
            closeDomain() {
                this.bool_isDomain = false;
            },
            closePreview() {
                this.bool_isPreview = !this.bool_isPreview;
                this.bool_CV = false;
            },
            closePreviewCD() {
                this.bool_isPreviewCD = !this.bool_isPreviewCD;
                this.bool_CV = false;
            },
            removePDomainNameServer(index) {
                if (!this.bool_disableInsertDomain) {
                    this.$delete(this.obj_Domain.DomainNameServer, index);
                    this.$forceUpdate();
                }
            },
            //alternate domain
            checkUseCloudFlare(v) {
                this.obj_ADomain.UCF = v.target.checked;
                this.$forceUpdate();
            },
            ValidationAlternateDomainErrMsg(value) {
                if (this.bool_groupCV) {
                    if (!this.$v.obj_ADomain[value].required) {
                        return String.format(this.getLanguage["ERR"]["1001"], this.getLanguage['DM']['DN']);
                    }
                }
            },
            addAlternateDomain() {
                this.obj_ADomain = {
                    "I": 0,
                    "RS": 2,
                    "AGI": this.obj_Domain.AGI,
                    "AGIT": null,
                    "DI": this.obj_Domain.I,
                    "DN": "",
                    "DNS": "",
                    "DomainNameServer": [],
                    "ADI": null,
                    "RT": this.getDefaultRobotsTxt(),
                    "CN": this.obj_Domain.DN,
                    "UCF": true,
                    "index": -1,
                };
                this.obj_Domain.RedirectTo = [];
                this.bool_isEditDomain = false;
                this.bool_showPreloadSEO_AD = true;
                this.bool_isAlternateDomain = true;
            },
            editAlternateDomain(index) {
                if (!this.bool_disableInsertDomain) {
                    this.bool_isEditDomain = true;
                    this.obj_ADomain = this.obj_Domain.DALT[index];
                    this.obj_ADomain.RF = this.obj_ADomain.DN;
                    this.obj_ADomain.index = index;
                    this.obj_ADomain.DomainNameServer = [];

                    if (this.obj_ADomain.DNS != "") {
                        var DNS_C = this.obj_ADomain.DNS;
                        var DNS_CARRY = DNS_C.split(',');
                        for (var i = 0; i < DNS_CARRY.length; i++) {
                            this.obj_DNS = {
                                DNS: DNS_CARRY[i]
                            }
                            this.obj_ADomain.DomainNameServer.push(this.obj_DNS);
                        }
                    }
                    if (this.obj_ADomain.RT == null || this.obj_ADomain.RT == '') {
                        this.obj_ADomain.RT = this.getDefaultRobotsTxt();
                    }

                    this.obj_Domain.RedirectTo = [];
                    var altdomain = this.obj_Domain.DALT[index].DN.trim().replaceAll('.', '$');
                    var that = this;
                    this.bool_fullLoading = true;
                    this.getDataApi(`/api/dm/listrules/${altdomain}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                if (d) {
                                    for (var i = 0; i < d.length; i++) {
                                        that.obj_RDT = {
                                            RF: d[i].RF,
                                            RDT: d[i].RDT,
                                        }
                                        that.obj_Domain.RedirectTo.push(that.obj_RDT);
                                    }

                                } else {
                                    that.obj_Domain.RedirectTo = [];
                                }
                            } else {
                                that.obj_Domain.RedirectTo = [];
                            }
                        });
                    //var altdomainid = this.obj_Domain.DALT[index].I;
                    //this.bool_fullLoading = true;
                    //this.getDataApi(`/api/dm/gad/${altdomainid}`,
                    //    function (d, s) {
                    //        that.bool_fullLoading = false;
                    //        if (s) {
                    //            if (d) {

                    //                that.obj_Domain.DALT[index].CFStatus = d.D.CFStatus;
                    //            }
                    //        }
                    //    });
                    this.bool_showPreloadSEO_AD = false;
                    this.bool_isAlternateDomain = true;
                }
            },
            saveAlternateDomain() {
                this.bool_groupCV = true;
                this.$v.obj_ADomain.$touch();
                if (!this.$v.obj_ADomain.$error) {
                    this.bool_groupCV = false;
                    this.bool_isAlternateDomain = false;
                    this.obj_ADomain.DNS = "";
                    if (this.obj_ADomain.DomainNameServer != null && this.obj_ADomain.DomainNameServer.length > 0) {
                        for (var i = 0; i < this.obj_ADomain.DomainNameServer.length; i++) {
                            if (i != 0) {
                                this.obj_ADomain.DNS += ",";
                            }
                            this.obj_ADomain.DNS += this.obj_ADomain.DomainNameServer[i].DNS;
                        }
                    }
                    this.obj_ADomain.DN = this.obj_ADomain.DN.replace(/\s/g, "").toLowerCase();
                    this.obj_ADomain.DN = this.findChar(this.obj_ADomain.DN, this.obj_ADomain.DN.length);
                    this.obj_ADomain.DS = this.obj_Domain.DS;
                    
                    if (this.obj_ADomain.index == -1) {
                        this.bool_fullLoading = true;
                        this.bool_groupCV = true;
                        //this.obj_Domain.DALT.push(this.obj_ADomain);
                        var that = this;
                        this.postDataApi(`/api/dm/ad/`, this.obj_ADomain,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.bool_isAMV = false;

                                    // reload agent group dropdown
                                    that.popUpAgentDetailModal(d.BD);

                                    /*that.obj_Domain.DALT.push(that.obj_ADomain);*/
                                    //that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));

                                }
                            });
                    }
                    else {
                        this.obj_Domain.DALT[this.obj_ADomain.index] = this.obj_ADomain;
                        if (this.obj_Domain.DALT[this.obj_ADomain.index].I > 0) {
                            this.bool_fullLoading = true;
                            //Redirect Rules
                            if (this.obj_Domain.RedirectTo != null && this.obj_Domain.RedirectTo.length > 0) {
                                var list_rules = [];
                                for (var i = 0; i < this.obj_Domain.RedirectTo.length; i++) {
                                    if (this.obj_Domain.RedirectTo[i].RDT != "" && this.obj_Domain.RedirectTo[i].RF != "") {
                                        var dn = this.obj_ADomain.DN.trim().replaceAll('.', '$');

                                        list_rules.push(
                                            {
                                                'RF': this.obj_Domain.RedirectTo[i].RF.trim(),
                                                'RDT': this.obj_Domain.RedirectTo[i].RDT.trim(),
                                            }
                                        );
                                    }

                                }
                                if (this.obj_ADomain.UCF) {
                                    var that = this;
                                    this.postDataApi(`/api/dm/createrules/${dn}`, list_rules,
                                        function (d, s) {
                                            that.bool_fullLoading = false;
                                            if (s) {
                                                if (d.Success) {
                                                    if (list_rules != "" && list_rules != null) {
                                                        for (var j = 0; j < list_rules.length; j++) {
                                                            if (j == 0) {
                                                                that.obj_Domain.DALT[that.obj_ADomain.index].RTD = list_rules[j].RDT;
                                                            }
                                                            else {
                                                                that.obj_Domain.DALT[that.obj_ADomain.index].RTD = that.obj_Domain.DALT[that.obj_ADomain.index].RTD + "," + list_rules[j].RDT;
                                                            }
                                                        }
                                                    }
                                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                                } else {
                                                    if (d.Message != null) {
                                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d.Message);
                                                    }
                                                    else {
                                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), that.utilGetErrorLanguage("3"));
                                                    }
                                                }
                                            }
                                        });
                                }
                                this.bool_fullLoading = false;
                            }
                            else {
                                //this.bool_fullLoading = true;
                                var dn = this.obj_ADomain.DN.trim().replaceAll('.', '$');
                                var that = this;
                                var list_rules = [];
                                if (this.obj_ADomain.UCF) {
                                    this.postDataApi(`/api/dm/createrules/${dn}`, list_rules,
                                        function (d, s) {
                                            that.bool_fullLoading = false;
                                            if (s) {
                                                if (d.Success) {
                                                    that.obj_Domain.DALT[that.obj_ADomain.index].RTD = "";
                                                    //that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                                } else {
                                                    if (d.Message != null) {
                                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), d.Message);
                                                    }
                                                    else {
                                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.TI"), that.utilGetErrorLanguage("3"));
                                                    }
                                                    
                                                }

                                            }
                                        });
                                }
                                this.bool_fullLoading = false;
                            }


                        }
                    }



                    this.dmKey = this.dmKey == 0 ? 1 : 0;
                    if (this.obj_Domain.I > 0 && this.obj_Domain.AGI > 0) {
                        this.refreshDofs(this, this.obj_Domain.AGI);
                    }
                }
            },
            closeAlternateDomain() {
                this.bool_isAlternateDomain = false;
            },
            removeAlternateDomain(index) {
                if (!this.bool_disableInsertDomain) {
                    this.$delete(this.obj_Domain.DALT, index);
                    this.dmKey = this.dmKey == 0 ? 1 : 0;
                }
            },
            redirectAltDomain() {
                var exist = false;
                if (this.obj_ADomain.RDT.trim() == "") {
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["DM"]["DN"]), 1000);
                } else {

                    var directFrom = this.obj_ADomain.DN.trim();
                    var directTo = this.obj_ADomain.RDT.trim();

                    this.obj_RDT = {
                        RF: directFrom,
                        RDT: directTo,
                    }

                    for (var i = 0; i < this.obj_Domain.RedirectTo.length; i++) {
                        if (this.obj_Domain.RedirectTo[i].RF == directFrom) {
                            exist = true;
                            break;

                        }

                    }

                    if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["DM"]["DN"]), 1000);
                    } else {
                        this.obj_Domain.RedirectTo.push(this.obj_RDT);
                        //this.obj_ADomain.RF = "";
                        this.obj_ADomain.RDT = "";

                    }

                }

            },
            removeredirectAltDomain(index) {
                this.$delete(this.obj_Domain.RedirectTo, index);
                //this.obj_ADomain.RF = "";
                this.obj_ADomain.RDT = "";
                this.$forceUpdate();
            },

            //customize registration
            setCR(data) {

                this.arry_cr = data;


                this.arry_cr.nCuzView = [];
                this.bool_DMSA = false;
                for (var x = 0; x < data.CuzView.length; x++) {
                    this.arry_cr.nCuzView.push(data.CuzView[x].CC);
                }

                if (data.LocalisedList.length > 0) {
                    this.arry_cr.E_CC = data.LocalisedList[0].CC;
                    this.arry_cr.E_PC = "";
                } else {
                    this.arry_CrOnOff.UPCODE.CV = false;
                    this.arry_cr.E_CC = "";
                    this.arry_cr.E_PC = "";
                }

                this.arry_CrOnOff = {
                    "RFWMP": { CV: false, DC: true },
                    "RWBA": { CV: false, DC: false },
                    "RWEA": { CV: false, DC: true },
                    "CDBACC": { CV: false, DC: true },
                    "CDPNO": { CV: false, DC: true },
                    "RPN": { CV: false, DC: true },
                    "REGWPHONE": { CV: false, DC: true },
                    "ULPN": { CV: false, DC: true },
                    "UPCODE": { CV: false, DC: true },
                    "DOTPV": { CV: false, DC: true },
                    "FNM": { CV: false, DC: true },
                    "HCDIHO": { CV: false, DC: true },
                    "EUN": { CV: false, DC: true },
                    "BABLBA": { CV: false, DC: true },
                    "EPWSC": { CV: false, DC: true },
                    "SM": { CV: false, DC: true },
                    "WCID": { CV: false, DC: true },
                    "LID": { CV: false, DC: true },
                    "WAID": { CV: false, DC: true },
                    "TGID": { CV: false, DC: true },
                    "ZLID": { CV: false, DC: true },
                    "SRC": { CV: false, DC: true },
                    "REM": { CV: false, DC: true },
                    "RWSAP": { CV: false, DC: true },
                    "RWC": { CV: false, DC: true },
                    "RLINE": { CV: false, DC: true },
                    "RTELE": { CV: false, DC: true },
                    "RZALO": { CV: false, DC: true },
                };

                for (const [key, value] of Object.entries(this.arry_CrOnOff)) {
                    if (value.DC) {
                        if (this.arry_cr.nCuzView.includes(key)) {
                            value.CV = true;
                            if (key == "CCAOLN" || key == "CCALPN" || key == "CCNO" || key == "DCC") {
                                this.str_CuzRegCaptchaOption = key;
                            }
                            else if (key == "MD" || key == "AD" || key == "ADP" || key == "HP" || key == "OP" || key == "EZP" || key == "TUP" || key == "CT" || key == "XFU") {
                                //debugger;
                                this.str_PreferredDepositOption = key;
                            }
                            else if (key == "DTMB" || key == "DT" || key == "MB") {
                                this.str_TournamentNavOption = key;
                            }
                            else if (key == "FPDTMB" || key == "FPDT" || key == "FPMB") {
                                this.str_ForgotPasswordLinkOption = key;
                            }

                        }
                    }
                    else {
                        if (!this.arry_cr.nCuzView.includes(key)) {
                            value.CV = true;
                        }
                    }
                }

                if (this.arry_cr.InactiveDays == -1) {
                    this.arry_cr.InactiveDays = 365;
                }

                if (this.dd_language_select.length > 0) {
                    this.selectedLangLabel = this.dd_language_select[0].id;
                }

                if (this.arry_cr.TMultiLangRegisterList != null) {
                    var rl = [];
                    var ui_list = [];
                    var pn_list = [];
                    var pw_list = [];
                    var cpw_list = [];
                    var fn_list = [];
                    var sc_list = [];
                    var sbk_list = [];
                    var anm_list = [];
                    var an_list = [];
                    var rc_list = [];
                    var em_list = [];
                    var wa_list = [];
                    var wc_list = [];
                    var ln_list = [];
                    var tg_list = [];
                    var zl_list = [];



                    rl = this.arry_cr.TMultiLangRegisterList;
                    if (rl.length > 0) {
                        rl.forEach(function (item) {
                            ui_list[item.L] = item.UI;
                            pn_list[item.L] = item.PN;
                            pw_list[item.L] = item.PW;
                            cpw_list[item.L] = item.CPW;
                            fn_list[item.L] = item.FN;
                            sc_list[item.L] = item.SC;
                            sbk_list[item.L] = item.SB;
                            anm_list[item.L] = item.ANM;
                            an_list[item.L] = item.AN;
                            rc_list[item.L] = item.RC;
                            em_list[item.L] = item.EM;
                            wa_list[item.L] = item.WA;
                            wc_list[item.L] = item.WC;
                            ln_list[item.L] = item.LN;
                            tg_list[item.L] = item.TG;
                            zl_list[item.L] = item.ZL;
                        });
                    }

                    this.array_ui = ui_list;
                    this.array_pn = pn_list;
                    this.array_pw = pw_list;
                    this.array_cpw = cpw_list;
                    this.array_fn = fn_list;
                    this.array_sc = sc_list;
                    this.array_sbk = sbk_list;
                    this.array_anm = anm_list;
                    this.array_an = an_list;
                    this.array_rc = rc_list;
                    this.array_em = em_list;
                    this.array_wa = wa_list;
                    this.array_wc = wc_list;
                    this.array_ln = ln_list;
                    this.array_tg = tg_list;
                    this.array_zl = zl_list;
                }

                this.bool_isAMV = true;
            },
            renderStyle() {
                if (this.bool_isPreview) {
                    return "pointer-events:none";
                }
            },
            updateRS(element, checked) {
                element.RS = checked ? 2 : 1;
                if (element.id == 'WSAP' && element.RS == 2) {
                    this.arry_OnOff.WAID.CV = true;
                } else if (element.id == 'WSAP' && element.RS == 1) {
                    this.arry_OnOff.WCID.CV = false;
                } else if (element.id == 'WC' && element.RS == 2) {
                    this.arry_OnOff.WCID.CV = true;
                } else if (element.id == 'WC' && element.RS == 1) {
                    this.arry_OnOff.WCID.CV = false;
                } else if (element.id == 'LINE' && element.RS == 2) {
                    this.arry_OnOff.LID.CV = true;
                } else if (element.id == 'LINE' && element.RS == 1) {
                    this.arry_OnOff.LID.CV = false;
                } else if (element.id == 'TELE' && element.RS == 2) {
                    this.arry_OnOff.TGID.CV = true;
                } else if (element.id == 'TELE' && element.RS == 1) {
                    this.arry_OnOff.TGID.CV = false;
                } else if (element.id == 'ZALO' && element.RS == 2) {
                    this.arry_OnOff.ZLID.CV = true;
                } else if (element.id == 'ZALO' && element.RS == 1) {
                    this.arry_OnOff.ZLID.CV = false;
                } else if (element.id == 'TI' && element.RS == 2) {
                    this.arry_CdOnOff.DTID_DCUZ.CV = true;
                } else if (element.id == 'TI' && element.RS == 1) {
                    this.arry_CdOnOff.DTID_DCUZ.CV = false;
                } else if (element.id == 'DT' && element.RS == 2) {
                    this.arry_CdOnOff.DDTOD_DCUZ.CV = true;
                } else if (element.id == 'DT' && element.RS == 1) {
                    this.arry_CdOnOff.DDTOD_DCUZ.CV = false;
                } else if (element.id == 'R' && element.RS == 2) {
                    this.arry_CdOnOff.DUR_DCUZ.CV = true;
                } else if (element.id == 'R' && element.RS == 1) {
                    this.arry_CdOnOff.DUR_DCUZ.CV = false;
                }
            },

            setAC(data) {
                // Get AgentCustomize Record
                this.arry_aac = data;
                this.arry_aac.nCuzView = [];
                this.bool_DMSA = false;
                this.bool_EBANS = false;
                this.bool_EMBANS = false;
                this.bool_HFLQRC = false;
                // Populate nCuzView
                data.CuzView.forEach(cuz => {
                    this.arry_aac.nCuzView.push(cuz.CC);
                });

                if (data.LocalisedList.length > 0) {
                    this.arry_aac.E_CC = data.LocalisedList[0].CC;
                    this.arry_aac.E_PC = "";
                } else {
                    this.arry_OnOff.RegistrationSetting.UPCODE.CV = false;
                    this.arry_aac.E_CC = "";
                    this.arry_aac.E_PC = "";
                }
                this.arry_OnOff = {
                    LoginSetting: {
                        "SL": { CV: true, DC: true }, //Simple Login
                        "EFPL": { CV: true, DC: true }, //Enable Forgot Password Link
                        "LD": { CV: false, DC: true }, //Login Disclaimer
                        "DMAL": { CV: false, DC: true }, //Disable Login
                        "DMAR": { CV: false, DC: true }, //Disable Register
                        "DMAD": { CV: false, DC: true }, //Disable Deposit
                        "DMAW": { CV: false, DC: true }, //Disable Withdrawal
                    },

                    RegistrationSetting: {
                        "RFWMP": { CV: false, DC: true }, //Register Form With Multiple Page
                        "RWBA": { CV: true, DC: false }, //Register Without Bank Account
                        "RWEA": { CV: false, DC: true }, //Register With Email/ RCUZ_check Duplicate Email
                        "CDBACC": { CV: true, DC: true }, //Check Duplicate Bank Account
                        "CDPNO": { CV: true, DC: true }, //Check Duplicate Phone Number
                        "HMCI": { CV: false, DC: true }, //Hide Member Contact Info
                        "RPN": { CV: false, DC: true }, //Required Phone No
                        "REGWPHONE": { CV: false, DC: true }, //Register With Phone
                        "DADIF": { CV: false, DC: true }, //Display Auto Deposit In-Front
                        "FNM": { CV: false, DC: true }, //Full Name Mandatory
                        "ULPN": { CV: false, DC: true }, //Localised Country Code
                        "UPCODE": { CV: false, DC: true }, //Enable Prefix Code
                        "HCDIHO": { CV: true, DC: true }, //Hide Currency Dropdown If Having Only One Option
                        "SRC": { CV: false, DC: true }, //Show Referral Code in Register Form
                        "BABLBA": { CV: false, DC: true }, //Block All Black Listed Bank Account
                        //"HATT": { CV: false, DC: true }, //Hide Affiliate Tiering Table
                        "SIPWM": { CV: true, DC: false }, //Show Invalid Phone Waring Message
                        "HMSB": { CV: false, DC: true }, //Hide Member Site Background
                        "DOTPV": { CV: false, DC: true }, //Disable OTP Validation
                        "EUN": { CV: false, DC: true }, //Enable UserID Numeric
                        "SM": { CV: false, DC: true }, //Social Media
                        //"PHONE": { CV: false, DC: true },
                        //"EMAIL": { CV: false, DC: true },
                        "WCID": { CV: false, DC: true }, //WeChat ID
                        "LID": { CV: false, DC: true }, //Line ID
                        "WAID": { CV: false, DC: true }, //Whatsapp
                        "TGID": { CV: false, DC: true }, //Telegram
                        "ZLID": { CV: false, DC: true }, //Zalo
                        "PP": { CV: false, DC: true },
                        "DN": { CV: false, DC: true },
                    },

                    MemberSiteSetting: {
                        "LMIAA": { CV: false, DC: false }, //Lock Member Info After Add
                        "HSCM": { CV: true, DC: false }, //Hide Side Contact Menu
                        "HSQRCM": { CV: true, DC: false }, //Hide Side QR Code Menu
                        "HQRCBL": { CV: true, DC: false }, //Hide Side QR Code Menu Before Login
                        "SQRCSM": { CV: true, DC: true }, //Show QR Code Side Menu
                        "HICSM": { CV: true, DC: false }, //Hide Info Center Side Menu
                        "HBLPU": { CV: true, DC: false }, //Hide Bet Limit POP UP
                        "DWOTT": { CV: false, DC: true }, //Transfer Amount Without 1:1000
                        "DODDS": { CV: false, DC: true }, //Display Odds Iframe at Member Site
                        "EAFBFHP": { CV: false, DC: true }, //Display AFB1188 iframe at Member Site
                        "DDNF": { CV: false, DC: false }, //Disable Default News Feed
                        "MDMIA": { CV: false, DC: true }, //Mask Downline Member Name in Affiliate
                        "HMAN": { CV: false, DC: true }, //Hide Main Affiliate Name
                        "HATT": { CV: false, DC: true }, //Hide Affiliate Tiering Table
                        "AFTTFG": { CV: false, DC: true }, //Allow Free Trial On Top 5 Ga   mes
                        "HFTGBL": { CV: false, DC: true }, //Hide Free Trial Game Before Member Login
                        "HFTGAL": { CV: false, DC: true }, //Hide Free Trial Game After Member Login
                        "DSAB": { CV: false, DC: true }, //Disable System Auto Block
                        "DDLS": { CV: false, DC: true }, //Display Daily Lucky Spin before requirement
                        "GLIF": { CV: true, DC: true }, //Enable Iframe Game Launch
                        "GLIFSW": { CV: false, DC: true }, //Open game in iframe within same browser window
                        "HL5GH": { CV: false, DC: true }, //Hide Last 5 Game History
                        "HTR": { CV: false, DC: true }, //Hide Tournament Ranking
                        "ETBN": { CV: false, DC: true }, //Enable Tournament Bottom Navigation
                        "DGPL": { CV: false, DC: true }, //Disable Game Provider Lobbies
                        "EASF": { CV: false, DC: true }, //Show Affiliate System Federation(AFS)
                        "EFV": { CV: false, DC: false }, //Enable Full Version
                        "EUL": { CV: false, DC: false }, //Enable Userful Link
                        "EGPLL": { CV: false, DC: true }, //Enable Game Provider lobby (only for Live Casino)
                        "DLGFML": { CV: false, DC: true }, //Direct Launch Live Casino Lobby from Menu
                        "HT5DG": { CV: false, DC: true }, //Hide Top 5 Demand Game
                        "HT5J": { CV: false, DC: true }, //Hide Top 5 Jackpots
                        "HT5S": { CV: false, DC: true }, //Hide Top 5 Slots
                        "HT5LC": { CV: false, DC: true }, //Hide Top 5 Live Casino
                        "HT5SES": { CV: false, DC: true }, //Hide Top 5 Sports & Esports
                    },

                    BankBackOfficeSetting: {
                        "NADBABA": { CV: false, DC: false }, //Not Allow Deposit Before Add Bank Account
                        "DDB": { CV: false, DC: false }, //No Duplicate Withdraw Bank
                        "NAABA": { CV: false, DC: false }, //Not Allow Add Bank Account
                        "NADBA": { CV: false, DC: false }, //Not Allow Delete Bank Account
                        "NBRWD": { CV: false, DC: true }, //Need Bank Receipt When Deposit
                        "OWB": { CV: false, DC: false }, //Withdraw With One Bank Account Only
                        "SSMRB": { CV: false, DC: true }, //Show Same Bank As Member Registered Bank
                        "SHBAN": { CV: false, DC: true }, //Show Half Bank Account No.
                        "HMDO": { CV: false, DC: true }, //Hide Manual Deposit Option
                        "PDO": { CV: false, DC: true }, //Preferred Deposit Option
                        "FNABAN": { CV: false, DC: true }, //Full Name As Bank Account Name
                        "CBTU": { CV: false, DC: true }, //Enable cellular balance top up
                        "EBAIN": { CV: false, DC: true }, //Enable Bank Account in Numeric
                        "RBAN": { CV: false, DC: true }, //Use Register Bank Account Name
                        "EPDN": { CV: false, DC: true }, //Exclude Deposit Notice for Sub-Agent & Outlet
                        "EPWN": { CV: false, DC: true }, //Exclude Withdrawal Notice for Sub-Agent & Outlet
                        "EPPN": { CV: false, DC: true }, //Exclude Promotion Notice for Sub-Agent & Outlet
                        "CAD": { CV: false, DC: true }, //Company Account Details
                        "AANE": { CV: false, DC: true }, // Allow alphanumeric entries
                        "AEWAS": { CV: false, DC: true }, //Allow entries with “@” symbol
                        "MAANE": { CV: false, DC: true }, // Allow alphanumeric entries
                        "MAEWAS": { CV: false, DC: true }, //Allow entries with “@” symbol
                    },

                    CryptoSetting: {
                        "ECF": { CV: false, DC: true }, //Enable Crypto Feature
                    },

                    Captchas: {
                        "DCC": { CV: false, DC: true }, //Disable Captcha (Default)
                        "CCAOLN": { CV: false, DC: true }, //Alphabets Only
                        "CCALPN": { CV: false, DC: true }, //Alphanumeric
                        "CCNO": { CV: false, DC: true }, //Numeric Only
                    },

                    PasswordOptions: {
                        "FPDTMB": { CV: false, DC: true }, // Desktop & Mobile
                        "FPDT": { CV: false, DC: true }, //Desktop
                        "FPMB": { CV: false, DC: true }, //Mobile
                    },

                    TournamentOptions: {
                        "DTMB": { CV: true, DC: false }, //Desktop and Mobile
                        "DT": { CV: false, DC: true }, //Desktop
                        "MB": { CV: false, DC: true }, //Mobile
                    },

                    PaymentOptions: {
                        "MD": { CV: false, DC: true }, //Manual Deposit
                        "AD": { CV: false, DC: true }, //Auto Deposit
                        "ADP": { CV: false, DC: true }, //Auto Deposit Plus
                        "HP": { CV: false, DC: true }, //Help2Pay
                        "OP": { CV: false, DC: true }, //Oopay
                        "EZP": { CV: false, DC: true }, //EeziePay
                        "TUP": { CV: false, DC: true }, //TruePay
                        "CT": { CV: false, DC: true }, //Crypto
                        "XFU": { CV: false, DC: true }, //XFuoo
                        "STP": { CV: false, DC: true }, //StarsPay
                        "SUREP": { CV: false, DC: true }, //SurePay
                        "P918": { CV: false, DC: true }, //P918
                        "FUP": { CV: false, DC: true }, //FuPay
                        "TMONEY": { CV: false, DC: true }, //TrueMoney
                        "SMP": { CV: false, DC: true }, //SmartPay
                        "U2P": { CV: false, DC: true }, //U2Pay
                        "LP": { CV: false, DC: true }, //LuckyPay
                        "BCP": { CV: false, DC: true }, //BCPay
                        "FPG": { CV: false, DC: true }, //FPG
                        "PGA": { CV: false, DC: true }, //PGAuto
                        "AGP": { CV: false, DC: true }, //AgogoPay
                        "UP": { CV: false, DC: true }, //UniversePay
                        "OKP": { CV: false, DC: true }, //OkaysPay
                        "MGP": { CV: false, DC: true }, //MegasPay
                        "VIP": { CV: false, DC: true }, //VIP Pay
                        "AFP": { CV: false, DC: true }, //AlfaPay
                        "ONEP": { CV: false, DC: true }, //OnePay
                        "BLEUP": { CV: false, DC: true }, //BluePay
                        "E88P": { CV: false, DC: true }, //Easy88Pay                        
                        "ECP": { CV: false, DC: true }, //ECPay
                        "ZPAY": { CV: false, DC: true }, //ZPay
                        "UPAY": { CV: false, DC: true }, //UPay
                        "DGPCNY": { CV: false, DC: true }, //DGPayCNY
                        "SUPER7VND": { CV: false, DC: true }, //SUPER7VND
                        //"PAYNGO": { CV: false, DC: true } //PayNGo
                        //"PPYP": { CV: false, DC: true }, //PapayaPay
                    },
                };

                //default value cv == true
                // if false then save to db = false

                for (const category in this.arry_OnOff) {
                    for (const key in this.arry_OnOff[category]) {
                        const setting = this.arry_OnOff[category][key];

                        //if DC set to true
                        if (setting.DC) {
                            if (this.arry_aac.nCuzView.includes(key)) {

                                setting.CV = true;

                                switch (key) {
                                    case "CCAOLN":
                                    case "CCALPN":
                                    case "CCNO":
                                    case "DCC":
                                        this.str_WebConfigCaptchaOption = key;
                                        break;
                                    case "MD":
                                    case "AD":
                                    case "ADP":
                                    case "HP":
                                    case "OP":
                                    case "EZP":
                                    case "TUP":
                                    case "CT":
                                    case "XFU":
                                    case "STP":
                                    case "SUREP":
                                    case "P918":
                                    case "FUP":
                                    case "TMONEY":
                                    case "SMP":
                                    case "U2P":
                                    case "LP":
                                    case "BCP":
                                    case "FPG":
                                    case "PGA":
                                    case "PP":
                                    case "DN":
                                    case "AGP":
                                    case "UP":
                                    case "OKP":
                                    case "MGP":
                                    case "VIP":
                                    case "AFP":
                                    case "ONEP":
                                    case "BLEUP":
                                    case "E88P":
                                    case "PPYP":
                                    case "ECP":
                                    case "ZPAY":
                                    case "UPAY":
                                    case "DGPCNY":
                                    case "SUPER7VND":
                                    //case "PAYNGO":
                                        this.str_PreferredDepositOption = key;
                                        break;
                                    case "DTMB":
                                    case "DT":
                                    case "MB":
                                        this.str_TournamentNavOption = key;
                                        break;
                                    case "FPDTMB":
                                    case "FPDT":
                                    case "FPMB":
                                        this.str_ForgotPasswordLinkOption = key;
                                        break;
                                    case "DGPL":
                                        this.getGameProviders(data.AGI);
                                        break;
                                }
                            }
                            //if database no record 
                            else {
                                setting.CV = false; //remove this maybe
                            }
                        } else { //if DC is false
                            if (!this.arry_aac.nCuzView.includes(key)) {
                                setting.CV = true;
                                //setting.CV = false;
                            }
                            else {
                                setting.CV = false;
                            }
                        }
                    }
                }

                this.selectedSOTValue = this.arry_aac.SportOddsType ? this.arry_aac.SportOddsType : 'HDP';
                this.selectedTOValue = this.arry_aac.ThemeOption ? this.arry_aac.ThemeOption : 'D';
                this.arry_aac.InactiveDays = this.arry_aac.InactiveDays === -1 ? 365 : this.arry_aac.InactiveDays;
                this.bool_DMSA = this.arry_OnOff.LoginSetting.DMAL.CV || this.arry_OnOff.LoginSetting.DMAR.CV || this.arry_OnOff.LoginSetting.DMAD.CV || this.arry_OnOff.LoginSetting.DMAW.CV;
                this.bool_EBANS = this.arry_OnOff.BankBackOfficeSetting.AANE.CV || this.arry_OnOff.BankBackOfficeSetting.AEWAS.CV;
                this.bool_EMBANS = this.arry_OnOff.BankBackOfficeSetting.MAANE.CV || this.arry_OnOff.BankBackOfficeSetting.MAEWAS.CV;                
                this.bool_HFLQRC = this.arry_OnOff.MemberSiteSetting.HQRCBL.CV || this.arry_OnOff.MemberSiteSetting.HSQRCM.CV;                
                this.bool_isAMV = true;
            },
            setCD(data) {
                this.arry_cd = data;
                this.bool_EMBANS_DC = false;

                if (data.DepositDraggeBase == null || data.DepositDraggeBase.length == 0) {
                    this.arry_cd.DepositDraggeBase = [
                        { "name": "MD", "id": "MD", "RS": 2 },
                        { "name": "AD", "id": "AD", "RS": 2 },
                        { "name": "ADP", "id": "ADP", "RS": 2 },
                        { "name": "AD3P", "id": "AD3P", "RS": 2 },
                        { "name": "HP", "id": "HP", "RS": 2 },
                        { "name": "OP", "id": "OP", "RS": 2 },
                        { "name": "EZP", "id": "EZP", "RS": 2 },
                        { "name": "TUP", "id": "TUP", "RS": 2 },
                        { "name": "CT", "id": "CT", "RS": 2 },
                        { "name": "XFU", "id": "XFU", "RS": 2 },
                        { "name": "STP", "id": "STP", "RS": 2 },
                        { "name": "SUREP", "id": "SUREP", "RS": 2 },
                        { "name": "FUP", "id": "FUP", "RS": 2 },
                        { "name": "TMONEY", "id": "TMONEY", "RS": 2 },
                        { "name": "SMP", "id": "SMP", "RS": 2 },
                        { "name": "U2P", "id": "U2P", "RS": 2 },
                        { "name": "LP", "id": "LP", "RS": 2 },
                        { "name": "BCP", "id": "BCP", "RS": 2 },
                        { "name": "FPG", "id": "FPG", "RS": 2 },
                        { "name": "PGA", "id": "PGA", "RS": 2 },
                        { "name": "PP", "id": "PP", "RS": 2 },
                        { "name": "DN", "id": "DN", "RS": 2 },
                        { "name": "AGP", "id": "AGP", "RS": 2 },
                        { "name": "P918", "id": "P918", "RS": 2 },
                        { "name": "UP", "id": "UP", "RS": 2 },
                        { "name": "OKP", "id": "OKP", "RS": 2 },
                        { "name": "MGP", "id": "MGP", "RS": 2 },
                        { "name": "VIP", "id": "VIP", "RS": 2 },
                        { "name": "AFP", "id": "AFP", "RS": 2 },
                        { "name": "ONEP", "id": "ONEP", "RS": 2 },
                        { "name": "BLEUP", "id": "BLEUP", "RS": 2 },
                        { "name": "E88P", "id": "E88P", "RS": 2 },
                        { "name": "PPYP", "id": "PPYP", "RS": 2 },
                        { "name": "ECP", "id": "ECP", "RS": 2 },
                        { "name": "ZPAY", "id": "ZPAY", "RS": 2 },
                        { "name": "UPAY", "id": "UPAY", "RS": 2 },
                        { "name": "DGPCNY", "id": "DGPCNY", "RS": 2 },
                        { "name": "SUPER7VND", "id": "SUPER7VND", "RS": 2 },
                        { "name": "PAYNGO", "id": "PAYNGO", "RS": 0 }
                    ]
                }
                this.paymentMtdSequence = "MD";
                this.showManualDeposit = true;

                if (data.VTCDepositDraggeBase.length == 0) {
                    this.arry_cd.VTCDepositDraggeBase = [
                        //{ "name": "S1", "id": "S1", "RS": 2 },
                        { "name": "DM", "id": "DM", "RS": 2 },
                        { "name": "DA", "id": "DA", "RS": 2 },
                        { "name": "MB", "id": "MB", "RS": 2 },
                        { "name": "DB", "id": "DB", "RS": 2 },
                        //{ "name": "S2", "id": "S2", "RS": 2 },
                        { "name": "TI", "id": "TI", "RS": 2 },
                        { "name": "DT", "id": "DT", "RS": 2 },
                        { "name": "R", "id": "R", "RS": 2 },
                        { "name": "PM", "id": "PM", "RS": 2 },
                        { "name": "NOTE", "id": "NOTE", "RS": 2 }
                    ]
                }
                this.manualDepositSequence = this.arry_cd.VTCDepositDraggeBase[0].id;



                this.arry_cd.nCuzView = [];
                this.bool_DMSA = false;
                for (var x = 0; x < data.CuzView.length; x++) {
                    this.arry_cd.nCuzView.push(data.CuzView[x].CC);
                }

                this.arry_CdOnOff = {
                    "DPTB_DCUZ": { CV: true, DC: true },
                    "DAB_DCUZ": { CV: true, DC: true },
                    "DTID_DCUZ": { CV: true, DC: true },
                    "DNOTE_DCUZ": { CV: false, DC: false },
                    "DQRD_DCUZ": { CV: true, DC: true },
                    "DDTOD_DCUZ": { CV: true, DC: true },
                    "DUR_DCUZ": { CV: true, DC: true },
                    "DSP_DCUZ": { CV: true, DC: true },

                    "FNM": { CV: false, DC: true },
                    //"ECF": { CV: false, DC: true },
                    "NADBABA": { CV: false, DC: false },
                    "DDB": { CV: false, DC: false },
                    "NAABA": { CV: false, DC: false },
                    "NADBA": { CV: false, DC: false },
                    "NBRWD": { CV: false, DC: true },
                    "SSMRB": { CV: false, DC: true },
                    "SHBAN": { CV: false, DC: true },
                    // "HMDO": { CV: false, DC: true},
                    // "PDO": { CV: false, DC: true},
                    // "MD": { CV: false, DC: true},
                    // "AD": { CV: false, DC: true},
                    // "ADP": { CV: false, DC: true},
                    // "HP": { CV: false, DC: true},
                    // "OP": { CV: false, DC: true},
                    // "EZP": { CV: false, DC: true},
                    // "TUP": { CV: false, DC: true},
                    // "CT": { CV: false, DC: true},
                    // "XFU": { CV: false, DC: true},
                    // "STP": { CV: false, DC: true},
                    // "SUREP": { CV: false, DC: true},
                    // "FUP": { CV: false, DC: true},
                    // "TMONEY": { CV: false, DC: true},
                    //"FNABAN": { CV: false, DC: true},
                    "CBTU": { CV: false, DC: true },
                    "E2DA": { CV: false, DC: true },
                    "EBAIN": { CV: false, DC: true },
                    "RBAN": { CV: false, DC: true },
                    "EPRL": { CV: false, DC: true },
                    "NOTEIRQ": { CV: false, DC: true },
                    "MAANE": { CV: false, DC: true }, // Allow alphanumeric entries
                    "MAEWAS": { CV: false, DC: true }, //Allow entries with “@” symbol
                };


                for (const [key, value] of Object.entries(this.arry_CdOnOff)) {
                    if (value.DC) {
                        if (this.arry_cd.nCuzView.includes(key)) {
                            value.CV = true;
                            if (key == "DUR_DCUZ" || key == "DDTOD_DCUZ" || key == "DQRD_DCUZ" || key == "DTID_DCUZ" || key == "DAB_DCUZ" || key == "DSP_DCUZ" || key == "DPTB_DCUZ") {
                                value.CV = false;
                            }

                        }
                    }
                    else {
                        if (!this.arry_cd.nCuzView.includes(key)) {
                            value.CV = true;
                        }
                    }
                }

                if (this.dd_language_select.length > 0) {
                    this.selectedLangLabel = this.dd_language_select[0].id;
                }

                if (this.arry_cd.TMultiLangDepositList != null) {
                    var da = [];
                    var cya = [];
                    var da_list = [];
                    var cya_list = [];
                    var sb_list = [];
                    var ti_list = [];
                    var dtod_list = [];
                    var ur_list = [];
                    var p_list = [];
                    var note_list = [];

                    da = this.arry_cd.TMultiLangDepositList;
                    if (da.length > 0) {
                        da.forEach(function (item) {
                            da_list[item.L] = item.DA;
                            cya_list[item.L] = item.CYA;
                            sb_list[item.L] = item.SB;
                            ti_list[item.L] = item.TI;
                            dtod_list[item.L] = item.DTOD;
                            ur_list[item.L] = item.UR;
                            p_list[item.L] = item.P;
                            note_list[item.L] = item.N;
                        });
                    }

                    this.array_da = da_list;
                    this.array_cya = cya_list;
                    this.array_sb = sb_list;
                    this.array_ti = ti_list;
                    this.array_dtod = dtod_list;
                    this.array_ur = ur_list;
                    this.array_p = p_list;
                    this.array_n = note_list;
                }

                if (!this.arry_cd.DepositBankReceipt) {
                    this.arry_cd.DepositBankReceipt = [""];
                } else {
                    this.arry_cd.DepositBankReceipt = JSON.parse(this.arry_cd.DepositBankReceipt);
                }

                // Replace any null or undefined values with empty strings
                this.arry_cd.DepositBankReceipt = this.arry_cd.DepositBankReceipt.map(item => item || "");
                this.bool_EMBANS_DC = this.arry_CdOnOff.MAANE.CV || this.arry_CdOnOff.MAEWAS.CV;

                this.bool_isAMV = true;
            },
            disableMemberSite(value) {
                this.bool_DMSA = value;
                this.arry_OnOff.LoginSetting.DMAL.CV = value;
                this.arry_OnOff.LoginSetting.DMAR.CV = value;
                this.arry_OnOff.LoginSetting.DMAD.CV = value;
                this.arry_OnOff.LoginSetting.DMAW.CV = value;
            },
            showAgentConfig(value) {
                this.agentconfig_LS = false;
                this.agentconfig_RS = false;
                this.agentconfig_MSS = false;
                this.agentconfig_BBOS = false;
                this.agentconfig_CS = false;
                switch (value) {
                    case 1:
                        this.agentconfig_LS = true;
                        break;
                    case 2:
                        this.agentconfig_RS = false; //Disable WebsiteConfig "Registration Setting"
                        break;
                    case 3:
                        this.agentconfig_MSS = true;
                        break;
                    case 4:
                        this.agentconfig_BBOS = true;
                        break;
                    case 5:
                        this.agentconfig_CS = true;
                        break;
                }
            },

            //live chat
            setLiveChat(data) {
                var that = this;
                this.obj_livechat = Object.assign(this.obj_livechat, data);
                var arry_splitLang = this.obj_livechat.L.split(',');
                this.obj_livechat.arry_holdLang = arry_splitLang;
                this.bool_obj_LCS = (this.obj_livechat["RS"] == 2 ? true : false);
                if (data.DI && data.DI > 0) {
                    this.getDataApi(`/api/dd/dlang/` + data.DI, function (d, s) {
                        if (s) {
                            that.dd_language_select = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });
                }
                else {
                    this.dd_language_select = [];
                }
                if (this.obj_livechat.I == 0)
                    this.obj_livechat.arry_holdLang = [];

                this.bool_isAMV = true;

            },
            onScriptFileSelected(event) {
                this.selectedScriptFile = this.validateFile(event, 5, [".json"]);
                this.newScriptFile = true;
            },
            ValidationLiveChatErrMsg(value, langKey = "") {
                if (this.bool_groupCV) {

                    //var validateObj = parent == "" ? this.$v.obj_Group[value] : this.$v.obj_Group[parent][value];
                    var validateObj = this.$v.obj_livechat[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["LC"][langKey]);
                    }
                }

            },

            //bank account
            SubParentGroupChange(value) {
                this.bool_fullLoading = false;
                var agi = 0;
                this.bool_cacheOptionValue = false;
                this.getMaxPT(1);
                this.searchSubBrand = null;

                if (value != "" && value != undefined) {
                    var agi = value.split("-")[1];
                    this.obj_SubGroup.AGI = agi;
                } else {
                    this.obj_SubGroup.AGI = 0;
                }
                //if (agi.length > 0) {
                //    that.GetPayoutScheme(agi[1]);
                //}
                //this.sensBtn = ((this.isSENS == 1 && agi != this.curAGI) ? true : false);
            },
            isAutoDepositChange(value) {
                if (this.bool_obj_isAutoDeposit == 0 && value != 0) {
                    this.showSuccessMessage(this.getLanguage["BANK"]["AD"], this.getLanguage["BANK"]["ADAM"]);
                }

                this.bool_obj_isAutoDeposit = value !== undefined ? value : 0;
            },
            confirmreset(dataI, dataTud) {
                this.$fire({
                    title: this.getLanguage["BTN"]["BTNRESET"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var obj = {
                            i: dataI,
                            tud: dataTud
                        };
                        this.postDataApi(`/api/bankacc/cr`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getBankAccountList();
                                    that.editBankAccount(dataI);
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            setAT_add(value) {
                if (this.obj_bankacc.I == 0) {
                    if (value == "0") { //with
                        this.bool_isW = true;
                        this.bool_isD = false;
                        this.obj_bankacc.MIND = 0
                        this.obj_bankacc.MAXD = 0
                        // this.obj_bankacc.TD = 0
                        this.obj_bankacc.ID = 0
                        this.obj_bankacc.IW = 1
                    } else if (value == "1") { // deposit
                        this.bool_isW = false;
                        this.bool_isD = true;
                        this.obj_bankacc.MINW = 0
                        this.obj_bankacc.MAXW = 0
                        this.obj_bankacc.TW = 0
                        this.obj_bankacc.ID = 1
                        this.obj_bankacc.IW = 0
                    } else if (value == "2") {
                        this.bool_isW = true;
                        this.bool_isD = true;
                        this.obj_bankacc.MINW = 0
                        this.obj_bankacc.MAXW = 0
                        this.obj_bankacc.TW = 0
                        this.obj_bankacc.MIND = 0
                        this.obj_bankacc.MAXD = 0
                        // this.obj_bankacc.TD = 0
                        this.obj_bankacc.IW = 1
                        this.obj_bankacc.ID = 1
                    }
                    this.BankChange(this.obj_bankacc.BI);
                }
            },
            setAT(ID, IW) {
                if (ID == 1 && IW == 1) {
                    return "2";
                } else if (ID == 1) {
                    return "1";
                } else if (IW == 1) {
                    return "0";
                } else {
                    return undefined;
                }
            },
            BankChange(value) {
                let isAutoDepositBank = 0;
                if (this.dd_bank != null && this.dd_bank.length > 0) {
                    for (var i = 0; i < this.dd_bank.length; i++) {
                        if (this.dd_bank[i].id == value && this.dd_bank[i].extra != "") {
                            isAutoDepositBank = parseInt(this.dd_bank[i].extra);

                            if (isAutoDepositBank > 0) {
                                this.str_autoDepositCode = this.dd_bank[i].extraCat;
                            }

                            break;
                        }
                    }
                }

                this.dd_adty = [];

                if (this.obj_bankacc["AT"] == 1 || this.obj_bankacc["AT"] == 2) {
                    this.bool_isAutoDepositBank = isAutoDepositBank;

                    switch (this.bool_isAutoDepositBank) {
                        case 1:
                            this.dd_adty.push(constAutoDepositType[0]);

                            if (this.str_autoDepositCode != "" && this.str_autoDepositCode in constAutoDepositBankApp) {
                                this.dd_adty.push(constAutoDepositBankApp[this.str_autoDepositCode][0]);
                            }
                            break;
                        case 2:
                            this.dd_adty.push(constAutoDepositType[1]);

                            if (this.str_autoDepositCode != "" && this.str_autoDepositCode in constAutoDepositBankApp) {
                                this.dd_adty.push(constAutoDepositBankApp[this.str_autoDepositCode][1]);
                            }
                            break;
                        case 3:
                            this.dd_adty.push(constAutoDepositType[0]);
                            this.dd_adty.push(constAutoDepositType[1]);

                            if (this.str_autoDepositCode != "" && this.str_autoDepositCode in constAutoDepositBankApp) {
                                this.dd_adty.push(constAutoDepositBankApp[this.str_autoDepositCode][0]);
                                this.dd_adty.push(constAutoDepositBankApp[this.str_autoDepositCode][1]);
                            }
                            break;
                    }
                }
                else
                    this.bool_isAutoDepositBank = 0;
            },
            CountryCodeChange(value) {
                if (this.obj_bankacc['I'] == 0) {
                    this.obj_bankacc.BI = null;
                }
                var that = this;
                var cc = value;
                this.getDataApi(`/api/dd/allbank/` + cc,
                    function (d, s) {
                        if (s) {
                            that.dd_bank = d.dropdownlist

                            if (that.obj_bankacc.I > 0) {
                                that.BankChange(that.obj_bankacc.BI);
                            }
                        }
                    });
            },
            onBankFileSelected(event) {
                this.obj_bankacc['QRCI'] = null;
                this.selectedBankFile = this.validateFile(event);
                this.newImg = true;
            },
            checkMinMax(type) {
                if (type == 1) {
                    if (this.obj_bankacc.MIND != 0 && this.obj_bankacc.MAXD != 0) {
                        if (parseFloat(this.obj_bankacc.MIND) > parseFloat(this.obj_bankacc.MAXD)) {
                            return this.getLanguage['BAL']['MINDERR'];
                        }
                    }
                    else {
                        return "";
                    }
                }
                else if (type == 2) {
                    if (this.obj_bankacc.MINW != 0 && this.obj_bankacc.MAXW != 0) {
                        if (parseFloat(this.obj_bankacc.MINW) > parseFloat(this.obj_bankacc.MAXW)) {
                            return this.getLanguage['BAL']['MINWERR'];
                        }
                    }
                    else {
                        return "";
                    }
                }
            },
            ValidationBankAccountErrMsg(value, langKey = "") {
                if (this.bool_groupCV) {
                    var validateObj = this.$v.obj_bankacc[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        if (value == 'MTV')
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MEM"][langKey]);
                        else
                            return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["BAL"][langKey]);
                    }
                    else if (validateObj.alphaNum != undefined && !validateObj.alphaNum) {
                        return String.format(this.getLanguage['ERR']['1008'], this.getLanguage['BAL']['BANO']);

                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    }
                }

            },
            setBankAccount(data) {
                this.obj_bankacc = Object.assign(this.obj_bankacc, data);
                this.obj_bankacc.AT = this.setAT(data.ID, data.IW);
                this.bool_isAMV = true;
                this.bool_obj_bankaccRS = (this.obj_bankacc["RS"] == 1 ? true : false);
                this.bool_obj_bankaccDC = data.FCS != null && data.FCS != "";
                //this.bool_obj_bankaccVIP = this.obj_bankacc["VIPBA"] == 1 ? true : false;
                //this.obj_bankacc.BP = "";
                this.obj_bankacc.BPC = "";

                if (this.obj_bankacc.BP != "")
                    this.obj_bankacc.BPC = this.obj_bankacc.BP;

                this.bool_obj_isAutoDeposit = this.obj_bankacc["IA"];

                if (this.obj_bankacc.IA == 0) {
                    this.obj_bankacc.IA = null;
                }
                if (this.obj_bankacc.MT != null && this.obj_bankacc.MT != '') {
                    this.obj_bankacc.MTV = this.obj_bankacc.MT.split(',');
                } else {
                    this.obj_bankacc.MTV = [];
                }
            },
            AFTTFG(isEnable) {
                this.arry_OnOff["HFTGBL"].CV = isEnable
                this.arry_OnOff["HFTGAL"].CV = isEnable
            },
            addPrefix() {
                var exist = false;
                var isValid = true;
                var clearRequired = true;
                var isEPrefix = this.arry_OnOff.RegistrationSetting.UPCODE.CV;
                var CountryCode = this.arry_aac.E_CC;
                var PrefixCode = this.arry_aac.E_PC;
                var emptyPrefix = false;

                if (CountryCode == "") {
                    clearRequired = false;
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["CCODE"]), 1000);
                }

                if (isEPrefix == true) {
                    if (PrefixCode == "") {
                        clearRequired = false;
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["PCODE"]), 1000);
                    } else {
                        if (this.arry_aac.LocalisedList.length > 0) {
                            for (var i = 0; i < this.arry_aac.LocalisedList.length; i++) {
                                if (this.arry_aac.LocalisedList[i].PC == "") {
                                    emptyPrefix = true;
                                    break;
                                }
                            }

                            if (emptyPrefix) {
                                clearRequired = false;
                                this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["EMPCODE"]), 1000);
                            }
                        }
                    }
                }

                if (clearRequired == true) {

                    var str_CC = CountryCode[0];

                    if (str_CC == "+") {
                        CountryCode = CountryCode.substr(1);
                    }

                    if (!CountryCode.match((/^[0-9]*$/))) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["CCODE"]), 1000);
                        isValid = false;
                    }

                    if (PrefixCode != "") {
                        if (!PrefixCode.match((/^[0-9]*$/))) {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["PCODE"]), 1000);
                            isValid = false;
                        }
                    }

                    if (isValid == true) {

                        for (var i = 0; i < this.arry_aac.LocalisedList.length; i++) {
                            var item = this.arry_aac.LocalisedList[i];

                            if (item.PC) {
                                if (item.PC == PrefixCode) {
                                    if (item.CC == CountryCode) {
                                        // If both PrefixCode and CountryCode match, set exist to true
                                        exist = true;
                                        break;
                                    } else {
                                        // If PrefixCode matches but CountryCode is different, set exist to false
                                        exist = false;
                                    }
                                }
                            }
                        }
                        if (exist) {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["ACO"]["CPCODE"]), 1000);
                        }
                        else {

                            var w_lz = PrefixCode.substr(1);

                            this.obj_LCC = {
                                CC: CountryCode,
                                PC: PrefixCode,
                                LZ: 0,
                                PN: CountryCode + '' + w_lz
                            }
                            this.arry_aac.LocalisedList.push(this.obj_LCC);
                        }

                    }
                }
            },
            addPrefixCr() {
                var exist = false;
                var isValid = true;
                var clearRequired = true;
                var isEPrefix = this.arry_CrOnOff.UPCODE.CV;
                var CountryCode = this.arry_cr.E_CC;
                var PrefixCode = this.arry_cr.E_PC;
                var emptyPrefix = false;

                if (CountryCode == "") {
                    clearRequired = false;
                    this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["CCODE"]), 1000);
                }

                if (isEPrefix == true) {
                    if (PrefixCode == "") {
                        clearRequired = false;
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ACO"]["PCODE"]), 1000);
                    } else {
                        if (this.arry_cr.LocalisedList.length > 0) {
                            for (var i = 0; i < this.arry_cr.LocalisedList.length; i++) {
                                if (this.arry_cr.LocalisedList[i].PC == "") {
                                    emptyPrefix = true;
                                    break;
                                }
                            }

                            if (emptyPrefix) {
                                clearRequired = false;
                                this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["EMPCODE"]), 1000);
                            }
                        }
                    }
                }

                if (clearRequired == true) {

                    var str_CC = CountryCode[0];

                    if (str_CC == "+") {
                        CountryCode = CountryCode.substr(1);
                    }

                    if (!CountryCode.match((/^[0-9]*$/))) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["CCODE"]), 1000);
                        isValid = false;
                    }

                    if (PrefixCode != "") {
                        if (!PrefixCode.match((/^[0-9]*$/))) {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["ACO"]["PCODE"]), 1000);
                            isValid = false;
                        }
                    }

                    if (isValid == true) {

                        for (var i = 0; i < this.arry_cr.LocalisedList.length; i++) {
                            var item = this.arry_cr.LocalisedList[i];

                            if (item.PC) {
                                if (item.PC == PrefixCode) {
                                    if (item.CC == CountryCode) {
                                        // If both PrefixCode and CountryCode match, set exist to true
                                        exist = true;
                                        break;
                                    } else {
                                        // If PrefixCode matches but CountryCode is different, set exist to false
                                        exist = false;
                                    }
                                }
                            }
                        }
                        if (exist) {
                            this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["ACO"]["CPCODE"]), 1000);
                        }
                        else {

                            var w_lz = PrefixCode.substr(1);

                            this.obj_LCC = {
                                CC: CountryCode,
                                PC: PrefixCode,
                                LZ: 0,
                                PN: CountryCode + '' + w_lz
                            }
                            this.arry_cr.LocalisedList.push(this.obj_LCC);
                        }

                    }
                }
            },
            tickLeadinZero(event, data, type, row) {
                var that = this;
                var index = row - 1;

                for (var i = 0; i < that.arry_aac.LocalisedList.length; i++) {
                    if (i == index) {
                        if (type > 0) {
                            that.arry_aac.LocalisedList[i].LZ = 0;
                            var w_lz = that.arry_aac.LocalisedList[i].PC.substr(1);
                            that.arry_aac.LocalisedList[i].PN = that.arry_aac.LocalisedList[i].CC + '' + w_lz;
                        } else {
                            that.arry_aac.LocalisedList[i].LZ = 1;
                            that.arry_aac.LocalisedList[i].PN = that.arry_aac.LocalisedList[i].CC + '' + that.arry_aac.LocalisedList[i].PC;
                        }
                    }
                }
            },
            tickLeadinZeroCr(event, data, type, row) {
                var that = this;
                var index = row - 1;

                for (var i = 0; i < that.arry_cr.LocalisedList.length; i++) {
                    if (i == index) {
                        if (type > 0) {
                            that.arry_cr.LocalisedList[i].LZ = 0;
                            var w_lz = that.arry_cr.LocalisedList[i].PC.substr(1);
                            that.arry_cr.LocalisedList[i].PN = that.arry_cr.LocalisedList[i].CC + '' + w_lz;

                        } else {
                            that.arry_cr.LocalisedList[i].LZ = 1;
                            that.arry_cr.LocalisedList[i].PN = that.arry_cr.LocalisedList[i].CC + '' + that.arry_cr.LocalisedList[i].PC;

                        }

                    }
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            removeLocaliseList(index) {
                this.$delete(this.arry_aac.LocalisedList, index);
                this.$forceUpdate();
            },
            removeLocaliseListCr(index) {
                this.$delete(this.arry_cr.LocalisedList, index);
                this.$forceUpdate();
            },
            checkRobotsTxt(text) {
                if (!text)
                    return this.getLanguage["DLSS"]["NA"];
                var str = text.replace(/\r?\n|\r/g, "").replaceAll(" ", "").trim().toLowerCase();
                if (str.startsWith("user-agent:*allow:"))
                    return this.getLanguage["DM"]["ALLOW"];
                else if (str.startsWith("user-agent:*disallow:"))
                    return this.getLanguage["DM"]["DISALLOW"];
                else
                    return this.getLanguage["DLSS"]["NA"];
            },
            getRobotsTxtClass(text) {
                if (!text)
                    return "";
                var str = text.replace(/\r?\n|\r/g, "").replaceAll(" ", "").trim().toLowerCase();
                if (str.startsWith("user-agent:*allow:"))
                    return "text-green";
                else if (str.startsWith("user-agent:*disallow:"))
                    return "text-red";
                else
                    return "";
            },
            switchCurrencySymbol() {
                var oldFrom = this.obj_bankacc['FCS'];
                var oldTo = this.obj_bankacc['TCS'];

                this.obj_bankacc.ER = 1;
                this.obj_bankacc.TER = 1;
                this.obj_bankacc['FCS'] = oldTo;
                this.obj_bankacc['TCS'] = oldFrom;
            },
            //Customize Deposit
            selectedDataPMI(data) {
                if (this.int_selectedPaymentMethod && data.PM === this.int_selectedPaymentMethod) {
                    return true;
                }
                return false;
            },
            checkMove(evt, originalEvent) {
                this.paymentMtdSequence = evt.draggedContext.element.id;

                if (this.paymentMtdSequence == 'MD') {
                    this.showManualDeposit = true;
                } else {
                    this.showManualDeposit = false;
                }

                //update the order of the array and the index no.
                const movedElement = this.arry_cd.DepositDraggeBase.splice(evt.draggedContext.index, 1)[0];
                this.arry_cd.DepositDraggeBase.splice(evt.relatedContext.index, 0, movedElement);


                this.arry_cd.DepositDraggeBase.forEach((element, index) => {
                    element.order = index + 1;
                });
            },
            showenLogic(element) {
                if (element.id == 'DM' && this.arr_depositSupportPaymentMethod.length <= 1) {
                    return false;
                }
                return true;
            },
            saveCustomizeDeposit(isSimple = false) {
                this.bool_fullLoading = true;
                this.bool_CV = true;

                var checkValidLocalized = true;
                var emptyPrefix = false;

                this.arry_cd['RS'] = 2;
                if (this.arry_cd.AGIT != null && this.arry_cd.AGIT.length > 0) {
                    var agi = this.arry_cd.AGIT.split("-");
                    //this.arry_aac.AGI = agi[1];
                    //this.arry_aac.AgentGroupIds = this.arry_aac
                }

                // this.arry_OnOff["CCNO"].CV = !this.arry_OnOff["CCNO"].DC;
                // this.arry_OnOff["CCALPN"].CV = !this.arry_OnOff["CCALPN"].DC;
                // this.arry_OnOff["DCC"].CV = !this.arry_OnOff["DCC"].DC;
                // if (this.arry_OnOff["FNM"].CV == false) {
                //     this.arry_OnOff["FNABAN"].CV = false;
                // }

                //if (this.str_CaptchaOption != "" && this.str_CaptchaOption != null) {
                //    this.arry_CdOnOff[this.str_CaptchaOption].CV = this.arry_CdOnOff[this.str_CaptchaOption].DC;
                //}

                // this.arry_OnOff["MD"].CV = !this.arry_OnOff["MD"].DC;
                // this.arry_OnOff["AD"].CV = !this.arry_OnOff["AD"].DC;
                // this.arry_OnOff["ADP"].CV = !this.arry_OnOff["ADP"].DC;
                // this.arry_OnOff["HP"].CV = !this.arry_OnOff["HP"].DC;
                // this.arry_OnOff["OP"].CV = !this.arry_OnOff["OP"].DC;
                // this.arry_OnOff["EZP"].CV = !this.arry_OnOff["EZP"].DC;
                // this.arry_OnOff["TUP"].CV = !this.arry_OnOff["TUP"].DC;
                // this.arry_OnOff["CT"].CV = !this.arry_OnOff["CT"].DC;
                // this.arry_OnOff["XFU"].CV = !this.arry_OnOff["XFU"].DC;
                // this.arry_OnOff["STP"].CV = !this.arry_OnOff["STP"].DC;
                // this.arry_OnOff["SUREP"].CV = !this.arry_OnOff["SUREP"].DC;
                // this.arry_OnOff["FUP"].CV = !this.arry_OnOff["FUP"].DC;
                // this.arry_OnOff["TMONEY"].CV = !this.arry_OnOff["TMONEY"].DC;


                // this.arry_OnOff["DAB_DCUZ"].CV = this.arry_OnOff["DAB_DCUZ"].CV != this.arry_OnOff["DAB_DCUZ"].DC;
                // this.arry_OnOff["DTID_DCUZ"].CV = this.arry_OnOff["DTID_DCUZ"].CV !=this.arry_OnOff["DTID_DCUZ"].DC;
                // this.arry_OnOff["DQRD_DCUZ"].CV = this.arry_OnOff["DQRD_DCUZ"].CV !=this.arry_OnOff["DQRD_DCUZ"].DC;
                // this.arry_OnOff["DDTOD_DCUZ"].CV = this.arry_OnOff["DDTOD_DCUZ"].CV !=this.arry_OnOff["DDTOD_DCUZ"].DC;
                // this.arry_OnOff["DUR_DCUZ"].CV = this.arry_OnOff["DUR_DCUZ"].CV !=this.arry_OnOff["DUR_DCUZ"].DC;

                // if (this.str_PreferredDepositOption == "" && this.arry_OnOff["PDO"].CV) {
                //     this.str_PreferredDepositOption = "MD";
                // }
                // if (!this.arry_OnOff["PDO"].CV) {
                //     this.str_PreferredDepositOption = "";
                // }
                // if (this.str_PreferredDepositOption != "" && this.str_PreferredDepositOption != null) {
                //     this.arry_OnOff[this.str_PreferredDepositOption].CV = this.arry_OnOff[this.str_PreferredDepositOption].DC;
                // }


                // if (this.str_TournamentNavOption != "" && this.str_TournamentNavOption != null) {
                //     this.arry_OnOff[this.str_TournamentNavOption].CV = this.arry_OnOff[this.str_TournamentNavOption].DC;
                // }

                var da = [];
                var cya = [];
                var sb = [];
                var dtod = [];
                var ti = [];
                var ur = [];
                var p = [];
                var n = [];

                for (const [key, value] of Object.entries(this.array_da)) {
                    if (key != "") {
                        var da_temp = {
                            L: key,
                            DA: value,
                        };
                        da.push(da_temp);
                    }
                }
                for (const [key, value] of Object.entries(this.array_cya)) {
                    if (key != "") {
                        var cya_temp = {
                            L: key,
                            CYA: value,
                        };
                        cya.push(cya_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_sb)) {
                    if (key != "") {
                        var sb_temp = {
                            L: key,
                            SB: value,
                        };
                        sb.push(sb_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_dtod)) {
                    if (key != "") {
                        var dtod_temp = {
                            L: key,
                            DTOD: value,
                        };
                        dtod.push(dtod_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_ti)) {
                    if (key != "") {
                        var ti_temp = {
                            L: key,
                            TI: value,
                        };
                        ti.push(ti_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_ur)) {
                    if (key != "") {
                        var ur_temp = {
                            L: key,
                            UR: value,
                        };
                        ur.push(ur_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_p)) {
                    if (key != "") {
                        var p_temp = {
                            L: key,
                            P: value,
                        };
                        p.push(p_temp);
                    }
                }

                for (const [key, value] of Object.entries(this.array_n)) {
                    if (key != "") {
                        var n_temp = {
                            L: key,
                            N: value,
                        };
                        n.push(n_temp);
                    }
                }

                this.arry_cd.TMultiLangDAList = da;
                this.arry_cd.TMultiLangCYAList = cya;
                this.arry_cd.TMultiLangSBList = sb;
                this.arry_cd.TMultiLangDTODList = dtod;
                this.arry_cd.TMultiLangTIList = ti;
                this.arry_cd.TMultiLangURList = ur;
                this.arry_cd.TMultiLangPList = p;
                this.arry_cd.TMultiLangNList = n;

                if (!isSimple) {
                    this.arry_cd.nCuzView = [];
                    for (const [key, value] of Object.entries(this.arry_CdOnOff)) {


                        if (key == 'DAB_DCUZ' || key == 'DTID_DCUZ' || key == 'DQRD_DCUZ' || key == 'DDTOD_DCUZ' || key == 'DUR_DCUZ' || key == 'DSP_DCUZ' || key == "DPTB_DCUZ") {
                            if (value.CV != value.DC) {
                                this.arry_cd.nCuzView.push(key);
                            }
                        } else {
                            if (value.CV == value.DC) {
                                this.arry_cd.nCuzView.push(key);
                            }
                        }
                    }
                }

                if (this.arry_cd.DepositBankReceipt != null) {
                    this.arry_cd.DepositBankReceipt = this.arry_cd.DepositBankReceipt.length > 0 ? JSON.stringify(this.arry_cd.DepositBankReceipt) : "";
                }

                this.$v.arry_cd.$touch();
                if (!this.$v.arry_cd.$error) {

                    if (this.bool_isAgentType) {
                        this.$v.arry_cd.$touch();
                        if (!this.$v.arry_cd.$error) {
                            this.bool_showCD = false;
                        }
                    }

                    this.bool_groupCV = true;

                    var that = this;
                    if (checkValidLocalized == true) {
                        this.postDataApi(`/api/dcuz/s`, this.arry_cd,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.bool_isAMV = false;
                                    // reload agent group dropdown
                                    that.popUpAgentDetailModal(d.BD);
                                    //that.$root.UserInfo.getInfoApi(that);

                                }
                            });
                    } else {
                        this.bool_fullLoading = false;
                    }
                }
                else {
                    this.bool_fullLoading = false;
                    //get the object for validating.
                    const validation = this.$v["arry_cd"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            renderTitle(id) {
                if (this.bool_isPreviewCD) {
                    return this.getLanguage["AG"]["VDCUZ"];
                }
                else {
                    return this.getLanguage["AG"][id > 0 ? "EDCUZ" : "ADCUZ"];
                }

            },
            renderStyle() {
                if (this.bool_isPreviewCD) {
                    return "pointer-events:none";
                }
            },
            addCustomizeDeposit(ci, isSimple = false) {
                var agi = (this.$route.query.agi != undefined) ? this.$route.query.agi.split("-") : "";
                this.arry_cd = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    nCuzView: null,
                    AGI: agi[1],
                    AGIT: agi[1],
                    CI: ci,
                    E_CC: "",
                    E_PC: "",
                    DepositDraggeBase: [
                        { "name": "MD", "id": "MD", "RS": 2 },
                        { "name": "AD", "id": "AD", "RS": 2 },
                        { "name": "ADP", "id": "ADP", "RS": 2 },
                        { "name": "AD3P", "id": "AD3P", "RS": 2 },
                        { "name": "HP", "id": "HP", "RS": 2 },
                        { "name": "OP", "id": "OP", "RS": 2 },
                        { "name": "EZP", "id": "EZP", "RS": 2 },
                        { "name": "TUP", "id": "TUP", "RS": 2 },
                        { "name": "CT", "id": "CT", "RS": 2 },
                        { "name": "XFU", "id": "XFU", "RS": 2 },
                        { "name": "STP", "id": "STP", "RS": 2 },
                        { "name": "SUREP", "id": "SUREP", "RS": 2 },
                        { "name": "FUP", "id": "FUP", "RS": 2 },
                        { "name": "TMONEY", "id": "TMONEY", "RS": 2 },
                        { "name": "SMP", "id": "SMP", "RS": 2 },
                        { "name": "U2P", "id": "U2P", "RS": 2 },
                        { "name": "LP", "id": "LP", "RS": 2 },
                        { "name": "BCP", "id": "BCP", "RS": 2 },
                        { "name": "FPG", "id": "FPG", "RS": 2 },
                        { "name": "PGA", "id": "PGA", "RS": 2 },
                        { "name": "PP", "id": "PP", "RS": 2 },
                        { "name": "DN", "id": "DN", "RS": 2 },
                        { "name": "AGP", "id": "AGP", "RS": 2 },
                        { "name": "P918", "id": "P918", "RS": 2 },
                        { "name": "UP", "id": "UP", "RS": 2 },
                        { "name": "OKP", "id": "OKP", "RS": 2 },
                        { "name": "MGP", "id": "MGP", "RS": 2 },
                        { "name": "VIP", "id": "VIP", "RS": 2 },
                        { "name": "AFP", "id": "AFP", "RS": 2 },
                        { "name": "ONEP", "id": "ONEP", "RS": 2 },
                        { "name": "BLEUP", "id": "BLEUP", "RS": 2 },
                        { "name": "E88P", "id": "E88P", "RS": 2 },
                        { "name": "PPYP", "id": "PPYP", "RS": 2 },                        
                        { "name": "ECP", "id": "ECP", "RS": 2 },
                        { "name": "ZPAY", "id": "ZPAY", "RS": 2 },
                        { "name": "UPAY", "id": "UPAY", "RS": 2 },
                        { "name": "DGPCNY", "id": "DGPCNY", "RS": 2 },
                        { "name": "SUPER7VND", "id": "SUPER7VND", "RS": 2 },
                        { "name": "PAYNGO", "id": "PAYNGO", "RS": 0 }
                    ],
                    VTCDepositDraggeBase: [
                        //{ "name": "S1", "id": "S1", "RS": 2 },
                        { "name": "DM", "id": "DM", "RS": 2 },
                        { "name": "DA", "id": "DA", "RS": 2 },
                        { "name": "MB", "id": "MB", "RS": 2 },
                        { "name": "DB", "id": "DB", "RS": 2 },
                        //{ "name": "S2", "id": "S2", "RS": 2 },
                        { "name": "TI", "id": "TI", "RS": 2 },
                        { "name": "DT", "id": "DT", "RS": 2 },
                        { "name": "R", "id": "R", "RS": 2 },
                        { "name": "PM", "id": "PM", "RS": 2 },
                        { "name": "NOTE", "id": "NOTE", "RS": 2 }
                    ],
                    LocalisedList: [],
                    InactiveDays: 365,
                    Rate: 0,
                    DepositBankReceipt: [],
                };

                this.arry_CdOnOff = {
                    "DPTB_DCUZ": { CV: true, DC: true },
                    "DAB_DCUZ": { CV: true, DC: true },
                    "DTID_DCUZ": { CV: true, DC: true },
                    "DNOTE_DCUZ": { CV: false, DC: false },
                    "DQRD_DCUZ": { CV: true, DC: true },
                    "DDTOD_DCUZ": { CV: true, DC: true },
                    "DUR_DCUZ": { CV: true, DC: true },
                    "DSP_DCUZ": { CV: true, DC: true },

                    //"FNM": { CV: false, DC: true },
                    //"ECF": { CV: false, DC: true },
                    "NADBABA": { CV: false, DC: false },
                    "DDB": { CV: false, DC: false },
                    "NAABA": { CV: false, DC: false },
                    "NADBA": { CV: false, DC: false },
                    "NBRWD": { CV: false, DC: true },
                    "SSMRB": { CV: false, DC: true },
                    "SHBAN": { CV: false, DC: true },
                    //"HMDO": { CV: false, DC: false },
                    // "PDO": { CV: false, DC: false },
                    // "MD": { CV: false, DC: false },
                    // "AD": { CV: false, DC: false },
                    // "ADP": { CV: false, DC: false },
                    // "HP": { CV: false, DC: false },
                    // "OP": { CV: false, DC: false },
                    // "EZP": { CV: false, DC: false },
                    // "TUP": { CV: false, DC: false },
                    // "CT": { CV: false, DC: false },
                    // "XFU": { CV: false, DC: false },
                    // "STP": { CV: false, DC: false },
                    // "SUREP": { CV: false, DC: false },
                    // "FUP": { CV: false, DC: false },
                    // "TMONEY": { CV: false, DC: false },
                    //"FNABAN": { CV: false, DC: true },
                    "CBTU": { CV: false, DC: true },
                    "E2DA": { CV: false, DC: true },
                    "EBAIN": { CV: false, DC: true },
                    "RBAN": { CV: false, DC: true },
                    "EPRL": { CV: false, DC: true },
                    "NOTEIRQ": { CV: false, DC: true },
                    "MAANE": { CV: false, DC: true }, // Allow alphanumeric entries
                    "MAEWAS": { CV: false, DC: true }, //Allow entries with “@” symbol
                };
                this.ddPaymentMethod = [
                    { "name": "MD", "id": "MD", "RS": true },
                    { "name": "AD", "id": "AD", "RS": true },
                    { "name": "ADP", "id": "ADP", "RS": true },
                    { "name": "HP", "id": "HP", "RS": true },
                    { "name": "OP", "id": "OP", "RS": true },
                    { "name": "EZP", "id": "EZP", "RS": true },
                    { "name": "TUP", "id": "TUP", "RS": true },
                    { "name": "CT", "id": "CT", "RS": true },
                    { "name": "XFU", "id": "XFU", "RS": true },
                    { "name": "STP", "id": "STP", "RS": true },
                    { "name": "SUREP", "id": "SUREP", "RS": true },
                    { "name": "FUP", "id": "FUP", "RS": true },
                    { "name": "TMONEY", "id": "TMONEY", "RS": true },
                    { "name": "SMP", "id": "SMP", "RS": true },
                    { "name": "U2P", "id": "U2P", "RS": true },
                    { "name": "LP", "id": "LP", "RS": true },
                    { "name": "BCP", "id": "BCP", "RS": true },
                    { "name": "FPG", "id": "FPG", "RS": true },
                    { "name": "PGA", "id": "PGA", "RS": true },
                    { "name": "PP", "id": "PP", "RS": true },
                    { "name": "DN", "id": "DN", "RS": true },
                    { "name": "AGP", "id": "AGP", "RS": true },
                    { "name": "P918", "id": "P918", "RS": true },
                    { "name": "UP", "id": "UP", "RS": true },
                    { "name": "OKP", "id": "OKP", "RS": true },
                    { "name": "MGP", "id": "MGP", "RS": true },
                    { "name": "VIP", "id": "VIP", "RS": true },
                    { "name": "AFP", "id": "AFP", "RS": true },
                    { "name": "ONEP", "id": "ONEP", "RS": true },
                    { "name": "BLEUP", "id": "BLEUP", "RS": true },
                    { "name": "E88P", "id": "E88P", "RS": true },
                    { "name": "PPYP", "id": "PPYP", "RS": true },                   
                    { "name": "ECP", "id": "ECP", "RS": true },
                    { "name": "ZPAY", "id": "ZPAY", "RS": true },
                    { "name": "UPAY", "id": "UPAY", "RS": true },
                    { "name": "DGPCNY", "id": "DGPCNY", "RS": true },
                    { "name": "SUPER7VND", "id": "SUPER7VND", "RS": true },
                    { "name": "PAYNGO", "id": "PAYNGO", "RS": false }
                ]

                this.obj_LCC = {
                    CC: "",
                    PC: "",
                    LZ: 0,
                    PN: ""
                };
                //this.dd_currency_cd = [];
                this.arr_DepositbankTempalte = [];
                this.arr_DepositbankbyBankTempalte = [];
                this.arr_depositSupportPaymentMethod = [];

                this.paymentMtdSequence = "MD";
                this.showManualDeposit = true;

                this.arry_cd.nCuzView = [];
                if (isSimple) {
                    this.bool_CV = false;
                }
                else {
                    this.bool_isAMV = true;
                    this.bool_CV = false;
                }

                if (this.dd_agentgroup[0].children == undefined) {
                    var at = 0;
                    at = this.dd_agentgroup[0].id.split("-")[0];
                    if (at == 3 && this.dd_agentgroup.length < 2) {
                        this.arry_cd.AGIT = this.dd_agentgroup[0].id;
                    }
                }
                this.bool_DMSA = false;
                this.searchAgent = null;

                if (this.dd_currency_cd.length == 1) {
                    this.arry_cd['CI'] = this.dd_currency_cd[0].id;
                }
            },
        },
        created() {
            this.$parent.showSubMenu = 'AGS';
            this.$parent.showActiveMenu = 'AGS.ASS';
            this.setObject();
            this.getDropdownList();
            this.setThousandCurrency(false);
            this.ShowFullAgentConfig = !this.getUserInfo.IHAC;
            this.langCode = window.localStorage.getItem('lang') || "en";

            var parameters = this.$route.query;
            if (parameters.pgit !== undefined && parameters.agt !== undefined) {
                this.addSelfService(parameters.pgit, parameters.agt)
            }
            else if (parameters.agi !== undefined && parameters.di !== undefined && parameters.lci !== undefined && parameters.acsi !== undefined && parameters.bai !== undefined && parameters.cri !== undefined) {
                this.editSelfService();
            }
            else {
                this.$router.push("/AGS/AGD");
            }

            if (this.getUserInfo.AT == 4) {
                this.loadDefaultSubBrand(0, true);
            }

            if (this.getUserInfo.AT == 0) {
                this.bool_multiTemplateOneDomain = true;
            }
        },
    }
</script>
<style>
    input[type="checkbox"]:disabled {
        color: red;
        background-color: lightgrey;
    }

    .bg-blue {
        background-color: #321fdb !important;
    }

    .text-white {
        color: white;
    }

    #webTempSetting .input-group .vue-treeselect__control {
        border-radius: 5px  !important;
    }

    /*#webTempSetting .input-group div:nth-child(1) .vue-treeselect__control {
        border-radius: 5px 0px 0px 5px !important;
    }

    #webTempSetting .input-group div:nth-child(2) .vue-treeselect__control {
        border-radius: 0px !important;
    }

    #webTempSetting div .secondborder:nth-child(2) .vue-treeselect__control {
        border-radius: 0px 5px 5px 0px !important;
    }

    #webTempSetting .input-group .form-control.form-control-sm:nth-child(1) {
        border-radius: 5px 0px 0px 5px !important;
    }

    #webTempSetting .input-group .form-control.form-control-sm:nth-child(3) {
        border-radius: 0px 5px 5px 0px !important;
    }*/
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/AgentSetting/AgentSelfService.vue